window.pricesJson = [
    {
        "technique_ref": "100111",
        "code": "A",
        "section_1": 250,
        "price_1": 0.182,
        "price_col_1": 0.154,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.154,
        "price_col_2": 0.11199999999999999,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.13299999999999998,
        "price_col_3": 0.08399999999999999,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.11199999999999999,
        "price_col_4": 0.06999999999999999,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.098,
        "price_col_5": 0.055999999999999994,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "A",
        "code": "A",
        "technique_name": "A (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.154,
        "price_col_1": 0.112,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.126,
        "price_col_2": 0.084,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.112,
        "price_col_3": 0.077,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.105,
        "price_col_4": 0.07,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.091,
        "price_col_5": 0.056,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.084,
        "price_col_6": 0.049,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100112",
        "code": "B",
        "section_1": 250,
        "price_1": 0.308,
        "price_col_1": 0.196,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.252,
        "price_col_2": 0.154,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.20299999999999999,
        "price_col_3": 0.119,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.161,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.126,
        "price_col_5": 0.08399999999999999,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "B",
        "code": "B",
        "technique_name": "B (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.252,
        "price_col_1": 0.154,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.196,
        "price_col_2": 0.126,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.175,
        "price_col_3": 0.105,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.147,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.119,
        "price_col_5": 0.084,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.112,
        "price_col_6": 0.07,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100113",
        "code": "C",
        "section_1": 250,
        "price_1": 0.392,
        "price_col_1": 0.22399999999999998,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.322,
        "price_col_2": 0.182,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.252,
        "price_col_3": 0.147,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.21,
        "price_col_4": 0.126,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.175,
        "price_col_5": 0.11199999999999999,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "C",
        "code": "C",
        "technique_name": "C (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.308,
        "price_col_1": 0.182,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.252,
        "price_col_2": 0.14,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.21,
        "price_col_3": 0.126,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.196,
        "price_col_4": 0.112,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.168,
        "price_col_5": 0.105,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.161,
        "price_col_6": 0.084,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100114",
        "code": "D",
        "section_1": 250,
        "price_1": 0.48999999999999994,
        "price_col_1": 0.252,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.40599999999999997,
        "price_col_2": 0.21,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.322,
        "price_col_3": 0.175,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.259,
        "price_col_4": 0.154,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.217,
        "price_col_5": 0.13999999999999999,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "D",
        "code": "D",
        "technique_name": "D (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.364,
        "price_col_1": 0.196,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.308,
        "price_col_2": 0.168,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.266,
        "price_col_3": 0.154,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.252,
        "price_col_4": 0.14,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.21,
        "price_col_5": 0.126,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.196,
        "price_col_6": 0.119,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100115",
        "code": "E",
        "section_1": 250,
        "price_1": 0.588,
        "price_col_1": 0.27999999999999997,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.48999999999999994,
        "price_col_2": 0.238,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.39899999999999997,
        "price_col_3": 0.20299999999999999,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.32899999999999996,
        "price_col_4": 0.182,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.27299999999999996,
        "price_col_5": 0.16799999999999998,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "E",
        "code": "E",
        "technique_name": "E (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.42,
        "price_col_1": 0.224,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.378,
        "price_col_2": 0.196,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.35,
        "price_col_3": 0.182,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.308,
        "price_col_4": 0.168,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.266,
        "price_col_5": 0.154,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.252,
        "price_col_6": 0.14,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100116",
        "code": "F",
        "section_1": 250,
        "price_1": 0.6859999999999999,
        "price_col_1": 0.308,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.588,
        "price_col_2": 0.26599999999999996,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.49699999999999994,
        "price_col_3": 0.23099999999999998,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.42,
        "price_col_4": 0.21,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.357,
        "price_col_5": 0.196,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 45,
        "min_unit": null
    },
    {
        "technique_ref": "F",
        "code": "F",
        "technique_name": "F (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.532,
        "price_col_1": 0.252,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.504,
        "price_col_2": 0.224,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.364,
        "price_col_3": 0.196,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.322,
        "price_col_4": 0.168,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.294,
        "price_col_5": 0.14,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.28,
        "price_col_6": 0.098,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100117",
        "code": "G",
        "section_1": 250,
        "price_1": 0.7979999999999999,
        "price_col_1": 0.33599999999999997,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.7,
        "price_col_2": 0.294,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.609,
        "price_col_3": 0.259,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.5319999999999999,
        "price_col_4": 0.238,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.476,
        "price_col_5": 0.22399999999999998,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 45,
        "min_unit": null
    },
    {
        "technique_ref": "G",
        "code": "G",
        "technique_name": "G (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.7,
        "price_col_1": 0.294,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.602,
        "price_col_2": 0.252,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.56,
        "price_col_3": 0.238,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.518,
        "price_col_4": 0.224,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.462,
        "price_col_5": 0.21,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.448,
        "price_col_6": 0.196,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100118",
        "code": "H",
        "section_1": 250,
        "price_1": 0.952,
        "price_col_1": 0.364,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.84,
        "price_col_2": 0.322,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.728,
        "price_col_3": 0.287,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.644,
        "price_col_4": 0.26599999999999996,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.588,
        "price_col_5": 0.252,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 50,
        "min_unit": null
    },
    {
        "technique_ref": "H",
        "code": "H",
        "technique_name": "H (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.84,
        "price_col_1": 0.322,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.728,
        "price_col_2": 0.28,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.7,
        "price_col_3": 0.266,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.644,
        "price_col_4": 0.252,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.588,
        "price_col_5": 0.238,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.56,
        "price_col_6": 0.224,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100119",
        "code": "I",
        "section_1": 250,
        "price_1": 1.1199999999999999,
        "price_col_1": 0.392,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.9799999999999999,
        "price_col_2": 0.35,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.854,
        "price_col_3": 0.315,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.756,
        "price_col_4": 0.294,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.6719999999999999,
        "price_col_5": 0.27999999999999997,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 50,
        "min_unit": null
    },
    {
        "technique_ref": "I",
        "code": "I",
        "technique_name": "I (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.952,
        "price_col_1": 0.336,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.868,
        "price_col_2": 0.308,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.812,
        "price_col_3": 0.294,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.756,
        "price_col_4": 0.28,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.672,
        "price_col_5": 0.266,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.644,
        "price_col_6": 0.252,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100120",
        "code": "J",
        "section_1": 250,
        "price_1": 1.26,
        "price_col_1": 0.42,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.1199999999999999,
        "price_col_2": 0.378,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.9799999999999999,
        "price_col_3": 0.34299999999999997,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.868,
        "price_col_4": 0.322,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.77,
        "price_col_5": 0.308,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 60,
        "min_unit": null
    },
    {
        "technique_ref": "J",
        "code": "J",
        "technique_name": "J (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 84,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.19,
        "price_col_1": 0.35,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.008,
        "price_col_2": 0.322,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.91,
        "price_col_3": 0.294,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.854,
        "price_col_4": 0.252,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.784,
        "price_col_5": 0.224,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.728,
        "price_col_6": 0.21,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100123",
        "code": "K",
        "section_1": 250,
        "price_1": 1.54,
        "price_col_1": 0.44799999999999995,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.4,
        "price_col_2": 0.40599999999999997,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 1.232,
        "price_col_3": 0.371,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 1.0919999999999999,
        "price_col_4": 0.35,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.9799999999999999,
        "price_col_5": 0.33599999999999997,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 60,
        "min_unit": null
    },
    {
        "technique_ref": "K",
        "code": "K",
        "technique_name": "K (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 84,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.47,
        "price_col_1": 0.364,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.26,
        "price_col_2": 0.336,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 1.19,
        "price_col_3": 0.308,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 1.092,
        "price_col_4": 0.266,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.98,
        "price_col_5": 0.238,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.952,
        "price_col_6": 0.224,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100211",
        "code": "A",
        "section_1": 250,
        "price_1": 0.182,
        "price_col_1": 0.154,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.154,
        "price_col_2": 0.11199999999999999,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.13299999999999998,
        "price_col_3": 0.08399999999999999,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.11199999999999999,
        "price_col_4": 0.06999999999999999,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.098,
        "price_col_5": 0.055999999999999994,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "100212",
        "code": "B",
        "section_1": 250,
        "price_1": 0.308,
        "price_col_1": 0.196,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.252,
        "price_col_2": 0.154,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.20299999999999999,
        "price_col_3": 0.119,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.161,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.126,
        "price_col_5": 0.08399999999999999,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "100213",
        "code": "C",
        "section_1": 250,
        "price_1": 0.392,
        "price_col_1": 0.22399999999999998,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.322,
        "price_col_2": 0.182,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.252,
        "price_col_3": 0.147,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.21,
        "price_col_4": 0.126,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.175,
        "price_col_5": 0.11199999999999999,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "100214",
        "code": "D",
        "section_1": 250,
        "price_1": 0.48999999999999994,
        "price_col_1": 0.252,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.40599999999999997,
        "price_col_2": 0.21,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.322,
        "price_col_3": 0.175,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.259,
        "price_col_4": 0.154,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.217,
        "price_col_5": 0.13999999999999999,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "100215",
        "code": "E",
        "section_1": 250,
        "price_1": 0.588,
        "price_col_1": 0.27999999999999997,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.48999999999999994,
        "price_col_2": 0.238,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.39899999999999997,
        "price_col_3": 0.20299999999999999,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.32899999999999996,
        "price_col_4": 0.182,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.27299999999999996,
        "price_col_5": 0.16799999999999998,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "100216",
        "code": "F",
        "section_1": 250,
        "price_1": 0.6859999999999999,
        "price_col_1": 0.308,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.588,
        "price_col_2": 0.26599999999999996,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.49699999999999994,
        "price_col_3": 0.23099999999999998,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.42,
        "price_col_4": 0.21,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.357,
        "price_col_5": 0.196,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 45,
        "min_unit": null
    },
    {
        "technique_ref": "100217",
        "code": "G",
        "section_1": 250,
        "price_1": 0.7979999999999999,
        "price_col_1": 0.33599999999999997,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.7,
        "price_col_2": 0.294,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.609,
        "price_col_3": 0.259,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.5319999999999999,
        "price_col_4": 0.238,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.476,
        "price_col_5": 0.22399999999999998,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 45,
        "min_unit": null
    },
    {
        "technique_ref": "100218",
        "code": "H",
        "section_1": 250,
        "price_1": 0.952,
        "price_col_1": 0.364,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.84,
        "price_col_2": 0.322,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.728,
        "price_col_3": 0.287,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.644,
        "price_col_4": 0.26599999999999996,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.588,
        "price_col_5": 0.252,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 50,
        "min_unit": null
    },
    {
        "technique_ref": "100219",
        "code": "I",
        "section_1": 250,
        "price_1": 1.1199999999999999,
        "price_col_1": 0.392,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.9799999999999999,
        "price_col_2": 0.35,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.854,
        "price_col_3": 0.315,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.756,
        "price_col_4": 0.294,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.6719999999999999,
        "price_col_5": 0.27999999999999997,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 50,
        "min_unit": null
    },
    {
        "technique_ref": "100220",
        "code": "J",
        "section_1": 250,
        "price_1": 1.26,
        "price_col_1": 0.42,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.1199999999999999,
        "price_col_2": 0.378,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.9799999999999999,
        "price_col_3": 0.34299999999999997,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.868,
        "price_col_4": 0.322,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.77,
        "price_col_5": 0.308,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 60,
        "min_unit": null
    },
    {
        "technique_ref": "100221",
        "code": "K",
        "section_1": 250,
        "price_1": 1.54,
        "price_col_1": 0.44799999999999995,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.4,
        "price_col_2": 0.40599999999999997,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 1.232,
        "price_col_3": 0.371,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 1.0919999999999999,
        "price_col_4": 0.35,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.9799999999999999,
        "price_col_5": 0.33599999999999997,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 60,
        "min_unit": null
    },
    {
        "technique_ref": "100400",
        "code": "L1",
        "section_1": 250,
        "price_1": 0.5599999999999999,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.48999999999999994,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.42,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.35,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.308,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 30,
        "min_unit": null
    },
    {
        "technique_ref": "L1",
        "code": "L1",
        "technique_name": "L1 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 42,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.49,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.42,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.35,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.308,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100500",
        "code": "P",
        "section_1": 250,
        "price_1": 0.392,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.364,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.33599999999999997,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.308,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.27999999999999997,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 45,
        "min_unit": 0.75
    },
    {
        "technique_ref": "P",
        "code": "P",
        "technique_name": "P (Roly)",
        "cliche": 14,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": true,
        "roly_stitches": 1000,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.336,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.308,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 200,
        "price_3": 0.266,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.238,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.21,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.196,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100600",
        "code": "N",
        "section_1": 250,
        "price_1": 1.19,
        "price_col_1": 0.48999999999999994,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.9799999999999999,
        "price_col_2": 0.42,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.8119999999999999,
        "price_col_3": 0.33599999999999997,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.644,
        "price_col_4": 0.26599999999999996,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.588,
        "price_col_5": 0.22399999999999998,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 45,
        "min_unit": 0.45
    },
    {
        "technique_ref": "N",
        "code": "N",
        "technique_name": "N (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.91,
        "price_col_1": 0.308,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.728,
        "price_col_2": 0.252,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.56,
        "price_col_3": 0.21,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.49,
        "price_col_4": 0.168,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100700",
        "code": "M",
        "section_1": 1,
        "price_1": 1.26,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.1199999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.9099999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.77,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 224,
        "cliche_repetition": 84,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "M",
        "code": "M",
        "technique_name": "M (Roly)",
        "cliche": 224,
        "cliche_repetition": 84,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.12,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.98,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.77,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.63,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100800",
        "code": "O",
        "section_1": 1,
        "price_1": 0.013999999999999999,
        "price_col_1": 0,
        "price_cm_1": 0.013999999999999999,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 30,
        "min_unit": 0.45
    },
    {
        "technique_ref": "O",
        "code": "O",
        "section_1": 1,
        "price_1": 0.013999999999999999,
        "price_col_1": 0,
        "price_cm_1": 0.013999999999999999,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 30,
        "min_unit": 0.45,
        "technique_name": "Unknown (Generic Code O)"
    },
    {
        "technique_ref": "100815",
        "code": "Q",
        "section_1": 250,
        "price_1": 1.68,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.54,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 1.3299999999999998,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 1.26,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 1.19,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 50,
        "min_unit": null
    },
    {
        "technique_ref": "Q",
        "code": "Q",
        "technique_name": "Q (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 70,
        "min_unit": 0.56,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": true,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.47,
        "price_col_1": 1.61,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.33,
        "price_col_2": 1.47,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 1.26,
        "price_col_3": 1.4,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 1.19,
        "price_col_4": 1.33,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100816",
        "code": "Q",
        "section_1": 250,
        "price_1": 1.75,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.6099999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 1.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 1.3299999999999998,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 1.26,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 50,
        "min_unit": null
    },
    {
        "technique_ref": "100819",
        "code": "R",
        "section_1": 1,
        "price_1": 2.8,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 51,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0.0036399999999999996,
        "section_3": 100,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0.0033599999999999997,
        "section_4": 300,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0.0028,
        "section_5": 500,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0.0023799999999999997,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 30,
        "min_unit": 0.55
    },
    {
        "technique_ref": "R",
        "code": "R",
        "technique_name": "R (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 42,
        "min_unit": 0.56,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": true,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 100,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 51,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0.0168,
        "section_3": 100,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0.014,
        "section_4": 300,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0.0112,
        "section_5": 500,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0.0112,
        "section_6": 1000,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0.0098,
        "section_7": 3000,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0.007,
        "section_8": 5000,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0.0056,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100820",
        "code": "R",
        "section_1": 1,
        "price_1": 1.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 51,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0.0196,
        "section_3": 100,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0.0168,
        "section_4": 300,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0.013999999999999999,
        "section_5": 500,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0.012599999999999998,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 30,
        "min_unit": 0.55
    },
    {
        "technique_ref": "101007",
        "code": "B D5M",
        "section_1": 250,
        "price_1": 0.308,
        "price_col_1": 0.196,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.252,
        "price_col_2": 0.154,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.20299999999999999,
        "price_col_3": 0.119,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.161,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.11059999999999999,
        "price_col_5": 0.07419999999999999,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "101008",
        "code": "A D10M",
        "section_1": 250,
        "price_1": 0.182,
        "price_col_1": 0.154,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.154,
        "price_col_2": 0.11199999999999999,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.13299999999999998,
        "price_col_3": 0.08399999999999999,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.11199999999999999,
        "price_col_4": 0.06999999999999999,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.098,
        "price_col_5": 0.055999999999999994,
        "price_cm_5": 0,
        "section_6": 100000,
        "price_6": 0.08679999999999999,
        "price_col_6": 0.049,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "101200",
        "code": "T",
        "section_1": 150,
        "price_1": 0.5599999999999999,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.48999999999999994,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.42,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.35,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2000,
        "price_5": 0.308,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.252,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.21,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 70,
        "cliche_repetition": 0,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "T",
        "code": "T",
        "technique_name": "T (Roly)",
        "cliche": 70,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 50,
        "price_1": 0.56,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.49,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.42,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.35,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.308,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.252,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 5000,
        "price_7": 0.21,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "101201",
        "code": "U",
        "section_1": 150,
        "price_1": 0.63,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.5599999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.48999999999999994,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.42,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2000,
        "price_5": 0.378,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.33599999999999997,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.27999999999999997,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 7000,
        "price_col_8": 0.27999999999999997,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 70,
        "cliche_repetition": 0,
        "min": 45,
        "min_unit": null
    },
    {
        "technique_ref": "U",
        "code": "U",
        "technique_name": "U (Roly)",
        "cliche": 70,
        "cliche_repetition": 0,
        "min": 63,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 50,
        "price_1": 0.63,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.56,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.49,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.42,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.378,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.336,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 5000,
        "price_7": 0.28,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "102001",
        "code": "V1",
        "section_1": 250,
        "price_1": 0.63,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.518,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.42,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.35,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.294,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.252,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.22399999999999998,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "V1",
        "code": "V1",
        "technique_name": "V1 (Roly)",
        "cliche": 42,
        "cliche_repetition": 35,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 5,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 100,
        "price_1": 1.26,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.092,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.036,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.938,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.868,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.784,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.728,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "102002",
        "code": "V2",
        "section_1": 250,
        "price_1": 0.77,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.6579999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.5459999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.476,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.42,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.378,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.35,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 50,
        "min_unit": null
    },
    {
        "technique_ref": "V2",
        "code": "V2",
        "technique_name": "V2 (Roly)",
        "cliche": 42,
        "cliche_repetition": 35,
        "min": 70,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 10,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 100,
        "price_1": 1.456,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.302,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.246,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 1.47,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 1.036,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.98,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.924,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "102003",
        "code": "V3",
        "section_1": 250,
        "price_1": 0.9099999999999999,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.784,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.6859999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.616,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.5599999999999999,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.518,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.48999999999999994,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 60,
        "min_unit": null
    },
    {
        "technique_ref": "V3",
        "code": "V3",
        "technique_name": "V3 (Roly)",
        "cliche": 42,
        "cliche_repetition": 35,
        "min": 84,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 15,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 100,
        "price_1": 1.736,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.54,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.47,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 1.414,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 1.358,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 1.344,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 1.26,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "102004",
        "code": "V4",
        "section_1": 250,
        "price_1": 1.0499999999999998,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.9239999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.826,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.756,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.7,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.6579999999999999,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.63,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 70,
        "min_unit": null
    },
    {
        "technique_ref": "V4",
        "code": "V4",
        "technique_name": "V4 (Roly)",
        "cliche": 42,
        "cliche_repetition": 35,
        "min": 98,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 20,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 100,
        "price_1": 1.19,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.778,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.638,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 1.582,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 1.512,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 1.414,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 1.358,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "103001",
        "code": "W1",
        "section_1": 250,
        "price_1": 0.77,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.63,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.5319999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.44799999999999995,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.392,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.35,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.308,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "W1",
        "code": "W1",
        "technique_name": "W1 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 5,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.588,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.518,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.448,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.392,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.378,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.336,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.308,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "103002",
        "code": "W2",
        "section_1": 250,
        "price_1": 0.8119999999999999,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.6719999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.574,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.48999999999999994,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.434,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.392,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.35,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "W2",
        "code": "W2",
        "technique_name": "W2 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 10,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.658,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.588,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.518,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.462,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.42,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.378,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.336,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "103063",
        "code": "W3",
        "section_1": 250,
        "price_1": 0.868,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.728,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.63,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.5599999999999999,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.48999999999999994,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.434,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.392,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "W3",
        "code": "W3",
        "technique_name": "W3 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 25,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.728,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.658,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.588,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.532,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.49,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.434,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.392,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "103064",
        "code": "W4",
        "section_1": 250,
        "price_1": 0.952,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.8119999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.6859999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.602,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.5459999999999999,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.48999999999999994,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.434,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "W4",
        "code": "W4",
        "technique_name": "W4 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 50,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.868,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.742,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.672,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.602,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.546,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.476,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.434,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "103065",
        "code": "W5",
        "section_1": 250,
        "price_1": 1.008,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.84,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.714,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.63,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.574,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.5319999999999999,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.504,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "W5",
        "code": "W5",
        "technique_name": "W5 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 100,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.022,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.91,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.77,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.7,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.574,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.532,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.504,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "103006",
        "code": "W6",
        "section_1": 250,
        "price_1": 1.0639999999999998,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.9239999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.7979999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.714,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.6579999999999999,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.602,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.574,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "W6",
        "code": "W6",
        "technique_name": "W6 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 150,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.05,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.924,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.84,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.77,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.658,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.602,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.574,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "103007",
        "code": "W7",
        "section_1": 250,
        "price_1": 1.1199999999999999,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.9799999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.854,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.77,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.714,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.6719999999999999,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.644,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "W7",
        "code": "W7",
        "technique_name": "W7 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 200,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.12,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.994,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.91,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.84,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.742,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.7,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.672,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "103008",
        "code": "W8",
        "section_1": 250,
        "price_1": 1.176,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.036,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.9099999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.84,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.784,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.742,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.714,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "W8",
        "code": "W8",
        "technique_name": "W8 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 250,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.19,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.064,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.98,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.91,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.812,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.77,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.728,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "103009",
        "code": "W9",
        "section_1": 250,
        "price_1": 1.246,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.1059999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.9799999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.9099999999999999,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.854,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.8119999999999999,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.784,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "W9",
        "code": "W9",
        "technique_name": "W9 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 300,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.26,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.134,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.05,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.98,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.882,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.84,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.91,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "103099",
        "code": "",
        "section_1": 100000,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900001",
        "code": "SOMBREROS - SE1",
        "section_1": 500,
        "price_1": 0.378,
        "price_col_1": 0.182,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0.364,
        "price_col_2": 0.154,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0.357,
        "price_col_3": 0.126,
        "price_cm_3": 0,
        "section_4": 100000,
        "price_4": 0.34299999999999997,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900002",
        "code": "",
        "section_1": 100000,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900003",
        "code": "",
        "section_1": 100000,
        "price_1": 19.599999999999998,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 45.5,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900004",
        "code": "",
        "section_1": 100000,
        "price_1": 41.3,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 45.5,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900005",
        "code": "",
        "section_1": 250,
        "price_1": 0,
        "price_col_1": 0.055999999999999994,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0,
        "price_col_2": 0.055999999999999994,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0,
        "price_col_3": 0.055999999999999994,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0,
        "price_col_4": 0.027999999999999997,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0,
        "price_col_5": 0.027999999999999997,
        "price_cm_5": 0,
        "section_6": 100000,
        "price_6": 0,
        "price_col_6": 0.020999999999999998,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 24.5,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900006",
        "code": "",
        "section_1": 500,
        "price_1": 0,
        "price_col_1": 0.40599999999999997,
        "price_cm_1": 0,
        "section_2": 1000,
        "price_2": 0,
        "price_col_2": 0.252,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0,
        "price_col_3": 0.16799999999999998,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0,
        "price_col_4": 0.126,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0,
        "price_col_5": 0.098,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900009",
        "code": "",
        "section_1": 500,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100000,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900010",
        "code": "",
        "section_1": 500,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0.952,
        "section_4": 100000,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900012",
        "code": "",
        "section_1": 500,
        "price_1": 0.40599999999999997,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1000,
        "price_2": 0.252,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.16799999999999998,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.126,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.098,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900007",
        "code": "",
        "section_1": 500,
        "price_1": 0,
        "price_col_1": 0.308,
        "price_cm_1": 0,
        "section_2": 1000,
        "price_2": 0,
        "price_col_2": 0.182,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0,
        "price_col_3": 0.11199999999999999,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0,
        "price_col_4": 0.06999999999999999,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0,
        "price_col_5": 0.055999999999999994,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900008",
        "code": "",
        "section_1": 250,
        "price_1": 0,
        "price_col_1": 0.40599999999999997,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0,
        "price_col_2": 0.238,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0,
        "price_col_3": 0.154,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0,
        "price_col_4": 0.11199999999999999,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0,
        "price_col_5": 0.08399999999999999,
        "price_cm_5": 0,
        "section_6": 100000,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "102099",
        "code": "",
        "section_1": 500,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900013",
        "code": "",
        "section_1": 500,
        "price_1": 0.0112,
        "price_col_1": 0,
        "price_cm_1": 0.0112,
        "section_2": 500,
        "price_2": 0.0098,
        "price_col_2": 0,
        "price_cm_2": 0.0098,
        "section_3": 2000,
        "price_3": 0.0084,
        "price_col_3": 0,
        "price_cm_3": 0.0084,
        "section_4": 5000,
        "price_4": 0.006999999999999999,
        "price_col_4": 0,
        "price_cm_4": 0.006999999999999999,
        "section_5": 100000,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900014",
        "code": "",
        "section_1": 100000,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900016",
        "code": "",
        "section_1": 100000,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900015",
        "code": "",
        "section_1": 500,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0.0322,
        "section_2": 2000,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0.030799999999999998,
        "section_3": 5000,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0.025199999999999997,
        "section_4": 100000,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0.0238,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "100115DP",
        "code": "E",
        "section_1": 250,
        "price_1": 0.588,
        "price_col_1": 0.27999999999999997,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.48999999999999994,
        "price_col_2": 0.238,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.39899999999999997,
        "price_col_3": 0.20299999999999999,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.32899999999999996,
        "price_col_4": 0.182,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.27299999999999996,
        "price_col_5": 0.16799999999999998,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "100402",
        "code": "L2",
        "section_1": 250,
        "price_1": 0.7,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.63,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.5599999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.48999999999999994,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.392,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "L2",
        "code": "L2",
        "technique_name": "L2 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.63,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.56,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.49,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.42,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "900011",
        "code": "SOMBREROS - SE2",
        "section_1": 500,
        "price_1": 0.518,
        "price_col_1": 0.182,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0.48999999999999994,
        "price_col_2": 0.154,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0.476,
        "price_col_3": 0.126,
        "price_cm_3": 0,
        "section_4": 100000,
        "price_4": 0.44799999999999995,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900020",
        "code": "",
        "section_1": 100000,
        "price_1": 52.5,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900021",
        "code": "",
        "section_1": 100000,
        "price_1": 66.5,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "900022",
        "code": "",
        "section_1": 100000,
        "price_1": 22.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "100215DP",
        "code": "E",
        "section_1": 500,
        "price_1": 0.588,
        "price_col_1": 0.44799999999999995,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0.504,
        "price_col_2": 0.392,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0.434,
        "price_col_3": 0.33599999999999997,
        "price_cm_3": 0,
        "section_4": 100000,
        "price_4": 0.364,
        "price_col_4": 0.27999999999999997,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 60,
        "min_unit": null
    },
    {
        "technique_ref": "900111",
        "code": "SUBLIMACION",
        "section_1": 500,
        "price_1": 0.756,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0.728,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0.7,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100000,
        "price_4": 0.6579999999999999,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "100403",
        "code": "L3",
        "section_1": 250,
        "price_1": 1.0499999999999998,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.9099999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.77,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.63,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 10000,
        "price_5": 0.518,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 50,
        "min_unit": null
    },
    {
        "technique_ref": "L3",
        "code": "L3",
        "technique_name": "L3 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 70,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.036,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.896,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.77,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.728,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "183506",
        "code": "L SPECIAL",
        "section_1": 500,
        "price_1": 0.126,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0.11199999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0.098,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100000,
        "price_4": 0.08399999999999999,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "183507",
        "code": "L BIMOX",
        "section_1": 500,
        "price_1": 0.22399999999999998,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0.16799999999999998,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0.161,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100000,
        "price_4": 0.13999999999999999,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "101017",
        "code": "B D10M",
        "section_1": 250,
        "price_1": 0.308,
        "price_col_1": 0.196,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.252,
        "price_col_2": 0.154,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.20299999999999999,
        "price_col_3": 0.119,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.161,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.126,
        "price_col_5": 0.08399999999999999,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.11059999999999999,
        "price_col_6": 0.07419999999999999,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "101018",
        "code": "C D5M",
        "section_1": 250,
        "price_1": 0.392,
        "price_col_1": 0.22399999999999998,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.322,
        "price_col_2": 0.182,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.252,
        "price_col_3": 0.147,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.21,
        "price_col_4": 0.126,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.175,
        "price_col_5": 0.098,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "100216DP",
        "code": "F",
        "section_1": 500,
        "price_1": 0.728,
        "price_col_1": 0.5319999999999999,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0.616,
        "price_col_2": 0.44799999999999995,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0.504,
        "price_col_3": 0.392,
        "price_cm_3": 0,
        "section_4": 100000,
        "price_4": 0.44799999999999995,
        "price_col_4": 0.33599999999999997,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "103010",
        "code": "W10",
        "section_1": 250,
        "price_1": 1.3159999999999998,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.176,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 1.0499999999999998,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.9799999999999999,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.9239999999999999,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.8819999999999999,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.854,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "W10",
        "code": "W10",
        "technique_name": "W10 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 350,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.33,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.204,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.12,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 1.05,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 1.008,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.952,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.952,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "103011",
        "code": "W11",
        "section_1": 250,
        "price_1": 1.386,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.246,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 1.1199999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 1.0499999999999998,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.9939999999999999,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.952,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.9239999999999999,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "W11",
        "code": "W11",
        "technique_name": "W11 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 400,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.54,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.386,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.26,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 1.19,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 1.148,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 1.05,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 1.008,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100835",
        "code": "SUBLIMACION CIN",
        "section_1": 500,
        "price_1": 0.6859999999999999,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0.6719999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0.6579999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100000,
        "price_4": 0.63,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "100993",
        "code": "NON-WOVEN",
        "section_1": 500,
        "price_1": 0.40599999999999997,
        "price_col_1": 0.22399999999999998,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0.392,
        "price_col_2": 0.196,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0.378,
        "price_col_3": 0.16799999999999998,
        "price_cm_3": 0,
        "section_4": 100000,
        "price_4": 0.364,
        "price_col_4": 0.13999999999999999,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "100994",
        "code": "POLIESTER",
        "section_1": 500,
        "price_1": 0.476,
        "price_col_1": 0.22399999999999998,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0.46199999999999997,
        "price_col_2": 0.196,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0.44799999999999995,
        "price_col_3": 0.16799999999999998,
        "price_cm_3": 0,
        "section_4": 100000,
        "price_4": 0.434,
        "price_col_4": 0.13999999999999999,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "104032",
        "code": "IMPRESION PROPI",
        "section_1": 100000,
        "price_1": 41.3,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 60,
        "min_unit": null
    },
    {
        "technique_ref": "104033",
        "code": "SIN MONTAJE",
        "section_1": 100000,
        "price_1": 41.3,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 60,
        "min_unit": null
    },
    {
        "technique_ref": "183470",
        "code": "POLIESTER 1",
        "section_1": 100000,
        "price_1": 22.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 60,
        "min_unit": null
    },
    {
        "technique_ref": "100996",
        "code": "CORCHO",
        "section_1": 500,
        "price_1": 0.7979999999999999,
        "price_col_1": 0.182,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0.756,
        "price_col_2": 0.154,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0.728,
        "price_col_3": 0.126,
        "price_cm_3": 0,
        "section_4": 100000,
        "price_4": 0.6859999999999999,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "100995",
        "code": "ALGODON",
        "section_1": 500,
        "price_1": 0.5599999999999999,
        "price_col_1": 0.22399999999999998,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0.5319999999999999,
        "price_col_2": 0.196,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0.518,
        "price_col_3": 0.16799999999999998,
        "price_cm_3": 0,
        "section_4": 100000,
        "price_4": 0.504,
        "price_col_4": 0.13999999999999999,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "100238",
        "code": "H",
        "section_1": 250,
        "price_1": 0.952,
        "price_col_1": 0.364,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.84,
        "price_col_2": 0.322,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.728,
        "price_col_3": 0.287,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.644,
        "price_col_4": 0.26599999999999996,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.588,
        "price_col_5": 0.252,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 77,
        "cliche_repetition": 77,
        "min": 50,
        "min_unit": null
    },
    {
        "technique_ref": "100121",
        "code": null,
        "section_1": 500,
        "price_1": 0.22399999999999998,
        "price_col_1": 0.13999999999999999,
        "price_cm_1": null,
        "section_2": 2000,
        "price_2": 0.16799999999999998,
        "price_col_2": 0.11199999999999999,
        "price_cm_2": null,
        "section_3": 5000,
        "price_3": 0.1134,
        "price_col_3": 0.0686,
        "price_cm_3": null,
        "section_4": 10000,
        "price_4": 0.098,
        "price_col_4": null,
        "price_cm_4": null,
        "section_5": null,
        "price_5": null,
        "price_col_5": null,
        "price_cm_5": null,
        "section_6": null,
        "price_6": null,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": null,
        "price_7": null,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": null,
        "cliche_repetition": null,
        "min": null,
        "min_unit": null
    },
    {
        "technique_ref": "100998",
        "code": null,
        "section_1": 500,
        "price_1": 0,
        "price_col_1": 0.16799999999999998,
        "price_cm_1": null,
        "section_2": 2000,
        "price_2": 0,
        "price_col_2": 0.13999999999999999,
        "price_cm_2": null,
        "section_3": 5000,
        "price_3": 0,
        "price_col_3": 0.11199999999999999,
        "price_cm_3": null,
        "section_4": 10000,
        "price_4": null,
        "price_col_4": 0.08399999999999999,
        "price_cm_4": null,
        "section_5": null,
        "price_5": null,
        "price_col_5": null,
        "price_cm_5": null,
        "section_6": null,
        "price_6": null,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": null,
        "price_7": null,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": null,
        "cliche_repetition": null,
        "min": null,
        "min_unit": null
    },
    {
        "technique_ref": "103003",
        "code": null,
        "section_1": 250,
        "price_1": 0.7,
        "price_col_1": null,
        "price_cm_1": null,
        "section_2": 500,
        "price_2": 0.63,
        "price_col_2": null,
        "price_cm_2": null,
        "section_3": 1000,
        "price_3": 0.5599999999999999,
        "price_col_3": null,
        "price_cm_3": null,
        "section_4": 2500,
        "price_4": 0.504,
        "price_col_4": null,
        "price_cm_4": null,
        "section_5": 5000,
        "price_5": 0.46199999999999997,
        "price_col_5": null,
        "price_cm_5": null,
        "section_6": 10000,
        "price_6": 0.364,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": 100000,
        "price_7": 0.308,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": null,
        "cliche_repetition": null,
        "min": null,
        "min_unit": null
    },
    {
        "technique_ref": "103004",
        "code": null,
        "section_1": 250,
        "price_1": 0.84,
        "price_col_1": null,
        "price_cm_1": null,
        "section_2": 500,
        "price_2": 0.7,
        "price_col_2": null,
        "price_cm_2": null,
        "section_3": 1000,
        "price_3": 0.63,
        "price_col_3": 0,
        "price_cm_3": null,
        "section_4": 2500,
        "price_4": 0.588,
        "price_col_4": null,
        "price_cm_4": null,
        "section_5": 5000,
        "price_5": 0.5459999999999999,
        "price_col_5": 0,
        "price_cm_5": null,
        "section_6": 10000,
        "price_6": 0.44799999999999995,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": 100000,
        "price_7": 0.392,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": null,
        "cliche_repetition": null,
        "min": null,
        "min_unit": null
    },
    {
        "technique_ref": "103005",
        "code": null,
        "section_1": 250,
        "price_1": 1.0499999999999998,
        "price_col_1": null,
        "price_cm_1": null,
        "section_2": 500,
        "price_2": 0.77,
        "price_col_2": null,
        "price_cm_2": null,
        "section_3": 1000,
        "price_3": 0.714,
        "price_col_3": null,
        "price_cm_3": null,
        "section_4": 2500,
        "price_4": 0.6719999999999999,
        "price_col_4": null,
        "price_cm_4": null,
        "section_5": 5000,
        "price_5": 0.63,
        "price_col_5": null,
        "price_cm_5": null,
        "section_6": 10000,
        "price_6": 0.5319999999999999,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": 100000,
        "price_7": 0.48999999999999994,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": null,
        "cliche_repetition": null,
        "min": null,
        "min_unit": null
    },
    {
        "technique_ref": "103059",
        "code": null,
        "section_1": 250,
        "price_1": 1.19,
        "price_col_1": null,
        "price_cm_1": null,
        "section_2": 500,
        "price_2": 0.9099999999999999,
        "price_col_2": null,
        "price_cm_2": null,
        "section_3": 1000,
        "price_3": 0.854,
        "price_col_3": null,
        "price_cm_3": null,
        "section_4": 2500,
        "price_4": 0.8119999999999999,
        "price_col_4": null,
        "price_cm_4": null,
        "section_5": 5000,
        "price_5": 0.77,
        "price_col_5": null,
        "price_cm_5": null,
        "section_6": 10000,
        "price_6": 0.6719999999999999,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": 100000,
        "price_7": 0.63,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": null,
        "cliche_repetition": null,
        "min": null,
        "min_unit": null
    },
    {
        "technique_ref": "103060",
        "code": null,
        "section_1": 250,
        "price_1": 1.3299999999999998,
        "price_col_1": null,
        "price_cm_1": null,
        "section_2": 500,
        "price_2": 1.0499999999999998,
        "price_col_2": null,
        "price_cm_2": null,
        "section_3": 1000,
        "price_3": 0.9939999999999999,
        "price_col_3": null,
        "price_cm_3": null,
        "section_4": 2500,
        "price_4": 0.952,
        "price_col_4": null,
        "price_cm_4": null,
        "section_5": 5000,
        "price_5": 0.9099999999999999,
        "price_col_5": null,
        "price_cm_5": null,
        "section_6": 10000,
        "price_6": 0.8119999999999999,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": 100000,
        "price_7": 0.77,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": null,
        "cliche_repetition": null,
        "min": null,
        "min_unit": null
    },
    {
        "technique_ref": "103061",
        "code": null,
        "section_1": 250,
        "price_1": 1.47,
        "price_col_1": null,
        "price_cm_1": null,
        "section_2": 500,
        "price_2": 1.19,
        "price_col_2": null,
        "price_cm_2": null,
        "section_3": 1000,
        "price_3": 1.134,
        "price_col_3": null,
        "price_cm_3": null,
        "section_4": 2500,
        "price_4": 1.0919999999999999,
        "price_col_4": null,
        "price_cm_4": null,
        "section_5": 5000,
        "price_5": 1.0499999999999998,
        "price_col_5": null,
        "price_cm_5": null,
        "section_6": 10000,
        "price_6": 0.952,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": 100000,
        "price_7": 0.9099999999999999,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": null,
        "cliche_repetition": null,
        "min": null,
        "min_unit": null
    },
    {
        "technique_ref": "103062",
        "code": null,
        "section_1": 250,
        "price_1": 1.6099999999999999,
        "price_col_1": null,
        "price_cm_1": null,
        "section_2": 500,
        "price_2": 1.3299999999999998,
        "price_col_2": null,
        "price_cm_2": null,
        "section_3": 1000,
        "price_3": 1.274,
        "price_col_3": null,
        "price_cm_3": null,
        "section_4": 2500,
        "price_4": 1.232,
        "price_col_4": null,
        "price_cm_4": null,
        "section_5": 5000,
        "price_5": 1.19,
        "price_col_5": null,
        "price_cm_5": null,
        "section_6": 10000,
        "price_6": 1.0919999999999999,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": 100000,
        "price_7": 1.0499999999999998,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": null,
        "cliche_repetition": null,
        "min": null,
        "min_unit": null
    },
    {
        "technique_ref": "183468",
        "code": null,
        "section_1": 100000,
        "price_1": 52.5,
        "price_col_1": 52.5,
        "price_cm_1": null,
        "section_2": null,
        "price_2": null,
        "price_col_2": null,
        "price_cm_2": null,
        "section_3": null,
        "price_3": null,
        "price_col_3": null,
        "price_cm_3": null,
        "section_4": null,
        "price_4": null,
        "price_col_4": null,
        "price_cm_4": null,
        "section_5": null,
        "price_5": null,
        "price_col_5": null,
        "price_cm_5": null,
        "section_6": null,
        "price_6": null,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": null,
        "price_7": null,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": null,
        "cliche_repetition": null,
        "min": null,
        "min_unit": null
    },
    {
        "technique_ref": "183469",
        "code": null,
        "section_1": 100000,
        "price_1": 66.5,
        "price_col_1": 66.5,
        "price_cm_1": null,
        "section_2": null,
        "price_2": null,
        "price_col_2": null,
        "price_cm_2": null,
        "section_3": null,
        "price_3": null,
        "price_col_3": null,
        "price_cm_3": null,
        "section_4": null,
        "price_4": null,
        "price_col_4": null,
        "price_cm_4": null,
        "section_5": null,
        "price_5": null,
        "price_col_5": null,
        "price_cm_5": null,
        "section_6": null,
        "price_6": null,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": null,
        "price_7": null,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": null,
        "cliche_repetition": null,
        "min": null,
        "min_unit": null
    },
    {
        "technique_ref": "183471",
        "code": null,
        "section_1": 100000,
        "price_1": 62.99999999999999,
        "price_col_1": 62.99999999999999,
        "price_cm_1": null,
        "section_2": null,
        "price_2": null,
        "price_col_2": null,
        "price_cm_2": null,
        "section_3": null,
        "price_3": null,
        "price_col_3": null,
        "price_cm_3": null,
        "section_4": null,
        "price_4": null,
        "price_col_4": null,
        "price_cm_4": null,
        "section_5": null,
        "price_5": null,
        "price_col_5": null,
        "price_cm_5": null,
        "section_6": null,
        "price_6": null,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": null,
        "price_7": null,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": null,
        "cliche_repetition": null,
        "min": null,
        "min_unit": null
    },
    {
        "technique_ref": "183505",
        "code": null,
        "section_1": 500,
        "price_1": 0.182,
        "price_col_1": null,
        "price_cm_1": null,
        "section_2": 2000,
        "price_2": 0.16799999999999998,
        "price_col_2": null,
        "price_cm_2": null,
        "section_3": 5000,
        "price_3": 0.154,
        "price_col_3": null,
        "price_cm_3": null,
        "section_4": 10000,
        "price_4": 0.13299999999999998,
        "price_col_4": null,
        "price_cm_4": null,
        "section_5": null,
        "price_5": null,
        "price_col_5": null,
        "price_cm_5": null,
        "section_6": null,
        "price_6": null,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": null,
        "price_7": null,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": null,
        "cliche_repetition": null,
        "min": null,
        "min_unit": null
    },
    {
        "technique_ref": "100834",
        "code": null,
        "section_1": 500,
        "price_1": 0.714,
        "price_col_1": null,
        "price_cm_1": null,
        "section_2": 2000,
        "price_2": 0.7,
        "price_col_2": null,
        "price_cm_2": null,
        "section_3": 5000,
        "price_3": 0.6719999999999999,
        "price_col_3": null,
        "price_cm_3": null,
        "section_4": 100000,
        "price_4": 0.6579999999999999,
        "price_col_4": null,
        "price_cm_4": null,
        "section_5": null,
        "price_5": null,
        "price_col_5": null,
        "price_cm_5": null,
        "section_6": null,
        "price_6": null,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": null,
        "price_7": null,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "100991",
        "code": null,
        "section_1": 500,
        "price_1": 0.518,
        "price_col_1": 0.22399999999999998,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0.504,
        "price_col_2": 0.196,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0.48999999999999994,
        "price_col_3": 0.16799999999999998,
        "price_cm_3": 0,
        "section_4": 10000,
        "price_4": 0.476,
        "price_col_4": 0.13999999999999999,
        "price_cm_4": null,
        "section_5": null,
        "price_5": null,
        "price_col_5": null,
        "price_cm_5": null,
        "section_6": null,
        "price_6": null,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": null,
        "price_7": null,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "104001",
        "code": "WR1",
        "section_1": 250,
        "price_1": 1.0499999999999998,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.8819999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.784,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.728,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.6719999999999999,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.63,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.588,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "WR1",
        "code": "WR1",
        "technique_name": "WR1 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 5,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.952,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.826,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.714,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.644,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.574,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.49,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.434,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "104002",
        "code": "WR2",
        "section_1": 250,
        "price_1": 1.0779999999999998,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.9099999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.8119999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.756,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.7,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.6579999999999999,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.616,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "WR2",
        "code": "WR2",
        "technique_name": "WR2 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 10,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.022,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.91,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.798,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.728,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.658,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.588,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.532,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "104006",
        "code": "WR6",
        "section_1": 250,
        "price_1": 1.204,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.0639999999999998,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.9659999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.8959999999999999,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.84,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.7979999999999999,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.77,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "WR6",
        "code": "WR6",
        "technique_name": "WR6 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 150,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.26,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.162,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.036,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.966,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.91,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.868,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.812,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "104007",
        "code": "WR7",
        "section_1": 250,
        "price_1": 1.246,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.1059999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 1.022,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.952,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.8959999999999999,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.854,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.826,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "WR7",
        "code": "WR7",
        "technique_name": "WR7 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 200,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.344,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.246,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.092,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 1.05,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.994,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.952,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.882,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "104008",
        "code": "WR8",
        "section_1": 250,
        "price_1": 1.302,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.162,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 1.0779999999999998,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 1.008,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.952,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.9099999999999999,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.8819999999999999,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "WR8",
        "code": "WR8",
        "technique_name": "WR8 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 250,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.428,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.33,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.176,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 1.134,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 1.078,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 1.008,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.938,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "104009",
        "code": "WR9",
        "section_1": 250,
        "price_1": 1.3719999999999999,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.232,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 1.148,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 1.0779999999999998,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 1.022,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.9799999999999999,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.952,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "WR9",
        "code": "WR9",
        "technique_name": "WR9 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 300,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.512,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.414,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.246,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 1.218,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 1.162,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 1.078,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.994,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "104010",
        "code": "WR10",
        "section_1": 250,
        "price_1": 1.428,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.288,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 1.204,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 1.134,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 1.0779999999999998,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 1.036,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 1.008,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "104003",
        "code": "WR3",
        "section_1": 250,
        "price_1": 1.1059999999999999,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.952,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.854,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.784,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.728,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.6859999999999999,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.644,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "WR3",
        "code": "WR3",
        "technique_name": "WR3 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 25,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.036,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.938,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.84,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.77,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.7,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.602,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.574,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "104004",
        "code": "WR4",
        "section_1": 250,
        "price_1": 1.134,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.9799999999999999,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.8819999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.8119999999999999,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.756,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.714,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.6859999999999999,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "WR4",
        "code": "WR4",
        "technique_name": "WR4 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 50,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.162,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.008,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.91,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.812,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.728,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.644,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.616,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "104005",
        "code": "WR5",
        "section_1": 250,
        "price_1": 1.162,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.022,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.9239999999999999,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 2500,
        "price_4": 0.854,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.7979999999999999,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.756,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100000,
        "price_7": 0.728,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "WR5",
        "code": "WR5",
        "technique_name": "WR5 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 100,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.204,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.078,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.952,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.854,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.77,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.686,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.658,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100412",
        "code": "B",
        "section_1": 250,
        "price_1": 0.308,
        "price_col_1": 0.196,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.252,
        "price_col_2": 0.154,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.20299999999999999,
        "price_col_3": 0.119,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.161,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.126,
        "price_col_5": 0.08399999999999999,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "100413",
        "code": "C",
        "section_1": 250,
        "price_1": 0.392,
        "price_col_1": 0.22399999999999998,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.322,
        "price_col_2": 0.182,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.252,
        "price_col_3": 0.147,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.21,
        "price_col_4": 0.126,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.175,
        "price_col_5": 0.11199999999999999,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "100414",
        "code": "D",
        "section_1": 250,
        "price_1": 0.48999999999999994,
        "price_col_1": 0.252,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.40599999999999997,
        "price_col_2": 0.21,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.322,
        "price_col_3": 0.175,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.259,
        "price_col_4": 0.154,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.217,
        "price_col_5": 0.13999999999999999,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "100418",
        "code": "H",
        "section_1": 250,
        "price_1": 0.952,
        "price_col_1": 0.364,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.84,
        "price_col_2": 0.322,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.728,
        "price_col_3": 0.287,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.644,
        "price_col_4": 0.26599999999999996,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.588,
        "price_col_5": 0.252,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 50,
        "min_unit": null
    },
    {
        "technique_ref": "100419",
        "code": "I",
        "section_1": 500,
        "price_1": 0.9799999999999999,
        "price_col_1": 0.35,
        "price_cm_1": 0,
        "section_2": 2000,
        "price_2": 0.854,
        "price_col_2": 0.315,
        "price_cm_2": 0,
        "section_3": 5000,
        "price_3": 0.756,
        "price_col_3": 0.294,
        "price_cm_3": 0,
        "section_4": 100000,
        "price_4": 0.6719999999999999,
        "price_col_4": 0.27999999999999997,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 50,
        "min_unit": null
    },
    {
        "technique_ref": "100420",
        "code": "J",
        "section_1": 250,
        "price_1": 1.26,
        "price_col_1": 0.42,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.1199999999999999,
        "price_col_2": 0.378,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.9799999999999999,
        "price_col_3": 0.34299999999999997,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.868,
        "price_col_4": 0.322,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.77,
        "price_col_5": 0.308,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 60,
        "min_unit": null
    },
    {
        "technique_ref": "100226",
        "code": "F",
        "section_1": 250,
        "price_1": 0.6859999999999999,
        "price_col_1": 0.308,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.588,
        "price_col_2": 0.26599999999999996,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.49699999999999994,
        "price_col_3": 0.23099999999999998,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.42,
        "price_col_4": 0.21,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.357,
        "price_col_5": 0.196,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 45,
        "min_unit": null
    },
    {
        "technique_ref": "100227",
        "code": "G",
        "section_1": 250,
        "price_1": 0.7979999999999999,
        "price_col_1": 0.33599999999999997,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.7,
        "price_col_2": 0.294,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.609,
        "price_col_3": 0.259,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.5319999999999999,
        "price_col_4": 0.238,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.476,
        "price_col_5": 0.22399999999999998,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 45,
        "min_unit": null
    },
    {
        "technique_ref": "100228",
        "code": "H",
        "section_1": 250,
        "price_1": 0.952,
        "price_col_1": 0.364,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.84,
        "price_col_2": 0.322,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.728,
        "price_col_3": 0.287,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.644,
        "price_col_4": 0.26599999999999996,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.588,
        "price_col_5": 0.252,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 50,
        "min_unit": null
    },
    {
        "technique_ref": "100315",
        "code": "E",
        "section_1": 250,
        "price_1": 0.588,
        "price_col_1": 0.27999999999999997,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.48999999999999994,
        "price_col_2": 0.238,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.39899999999999997,
        "price_col_3": 0.20299999999999999,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.32899999999999996,
        "price_col_4": 0.182,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.27299999999999996,
        "price_col_5": 0.16799999999999998,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "100135",
        "code": "E",
        "section_1": 250,
        "price_1": 0.588,
        "price_col_1": 0.27999999999999997,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.48999999999999994,
        "price_col_2": 0.238,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.39899999999999997,
        "price_col_3": 0.20299999999999999,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.32899999999999996,
        "price_col_4": 0.182,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.27299999999999996,
        "price_col_5": 0.16799999999999998,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "100316",
        "code": "F",
        "section_1": 250,
        "price_1": 0.6859999999999999,
        "price_col_1": 0.308,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.588,
        "price_col_2": 0.26599999999999996,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.49699999999999994,
        "price_col_3": 0.23099999999999998,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.42,
        "price_col_4": 0.21,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.357,
        "price_col_5": 0.196,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 45,
        "min_unit": null
    },
    {
        "technique_ref": "100136",
        "code": "F",
        "section_1": 250,
        "price_1": 0.6859999999999999,
        "price_col_1": 0.308,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.588,
        "price_col_2": 0.26599999999999996,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.49699999999999994,
        "price_col_3": 0.23099999999999998,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.42,
        "price_col_4": 0.21,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.357,
        "price_col_5": 0.196,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 45,
        "min_unit": null
    },
    {
        "technique_ref": "100137",
        "code": "G",
        "section_1": 250,
        "price_1": 0.7979999999999999,
        "price_col_1": 0.33599999999999997,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.7,
        "price_col_2": 0.294,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.609,
        "price_col_3": 0.259,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.5319999999999999,
        "price_col_4": 0.238,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.476,
        "price_col_5": 0.22399999999999998,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 45,
        "min_unit": null
    },
    {
        "technique_ref": "100317",
        "code": "G",
        "section_1": 250,
        "price_1": 0.7979999999999999,
        "price_col_1": 0.33599999999999997,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.7,
        "price_col_2": 0.294,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.609,
        "price_col_3": 0.259,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.5319999999999999,
        "price_col_4": 0.238,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.476,
        "price_col_5": 0.22399999999999998,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 45,
        "min_unit": null
    },
    {
        "technique_ref": "100318",
        "code": "H",
        "section_1": 250,
        "price_1": 0.952,
        "price_col_1": 0.364,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.84,
        "price_col_2": 0.322,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.728,
        "price_col_3": 0.287,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.644,
        "price_col_4": 0.26599999999999996,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.588,
        "price_col_5": 0.252,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 50,
        "min_unit": null
    },
    {
        "technique_ref": "100132",
        "code": "B",
        "section_1": 250,
        "price_1": 0.308,
        "price_col_1": 0.196,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.252,
        "price_col_2": 0.154,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.20299999999999999,
        "price_col_3": 0.119,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.161,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.126,
        "price_col_5": 0.08399999999999999,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "100133",
        "code": "C",
        "section_1": 250,
        "price_1": 0.392,
        "price_col_1": 0.22399999999999998,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.322,
        "price_col_2": 0.182,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.252,
        "price_col_3": 0.147,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.21,
        "price_col_4": 0.126,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.175,
        "price_col_5": 0.11199999999999999,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 35,
        "min_unit": null
    },
    {
        "technique_ref": "100134",
        "code": "D",
        "section_1": 250,
        "price_1": 0.48999999999999994,
        "price_col_1": 0.252,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.40599999999999997,
        "price_col_2": 0.21,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.322,
        "price_col_3": 0.175,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.259,
        "price_col_4": 0.154,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.217,
        "price_col_5": 0.13999999999999999,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "100415",
        "code": "E",
        "section_1": 250,
        "price_1": 0.588,
        "price_col_1": 0.27999999999999997,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.48999999999999994,
        "price_col_2": 0.238,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.39899999999999997,
        "price_col_3": 0.20299999999999999,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.32899999999999996,
        "price_col_4": 0.182,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.27299999999999996,
        "price_col_5": 0.16799999999999998,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 40,
        "min_unit": null
    },
    {
        "technique_ref": "100416",
        "code": "F",
        "section_1": 250,
        "price_1": 0.6859999999999999,
        "price_col_1": 0.308,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.588,
        "price_col_2": 0.26599999999999996,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.49699999999999994,
        "price_col_3": 0.23099999999999998,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.42,
        "price_col_4": 0.21,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.357,
        "price_col_5": 0.196,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 45,
        "min_unit": null
    },
    {
        "technique_ref": "100417",
        "code": "G",
        "section_1": 250,
        "price_1": 0.7979999999999999,
        "price_col_1": 0.33599999999999997,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.7,
        "price_col_2": 0.294,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.609,
        "price_col_3": 0.259,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.5319999999999999,
        "price_col_4": 0.238,
        "price_cm_4": 0,
        "section_5": 100000,
        "price_5": 0.476,
        "price_col_5": 0.22399999999999998,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 45,
        "min_unit": null
    },
    {
        "technique_ref": "100602",
        "code": "N1",
        "section_1": 250,
        "price_1": 1.3299999999999998,
        "price_col_1": 0.48999999999999994,
        "price_cm_1": null,
        "section_2": 500,
        "price_2": 1.1199999999999999,
        "price_col_2": 0.42,
        "price_cm_2": null,
        "section_3": 2000,
        "price_3": 0.9239999999999999,
        "price_col_3": 0.33599999999999997,
        "price_cm_3": null,
        "section_4": 5000,
        "price_4": 0.756,
        "price_col_4": 0.26599999999999996,
        "price_cm_4": null,
        "section_5": 10000,
        "price_5": 0.7,
        "price_col_5": 0.22399999999999998,
        "price_cm_5": null,
        "section_6": null,
        "price_6": null,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": null,
        "price_7": null,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 45,
        "min_unit": 0.45
    },
    {
        "technique_ref": "N1",
        "code": "N1",
        "technique_name": "N1 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.26,
        "price_col_1": 0.28,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.05,
        "price_col_2": 0.238,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.812,
        "price_col_3": 0.196,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.658,
        "price_col_4": 0.168,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "100901",
        "code": "DTF1",
        "section_1": 1,
        "price_1": 0,
        "price_col_1": null,
        "price_cm_1": 0.0047599999999999995,
        "section_2": 250,
        "price_2": 0,
        "price_col_2": null,
        "price_cm_2": 0.0042,
        "section_3": 500,
        "price_3": 0,
        "price_col_3": null,
        "price_cm_3": 0.00378,
        "section_4": 1000,
        "price_4": 0,
        "price_col_4": null,
        "price_cm_4": 0.0034999999999999996,
        "section_5": 2500,
        "price_5": 0,
        "price_col_5": null,
        "price_cm_5": 0.0029399999999999995,
        "section_6": 5000,
        "price_6": 0,
        "price_col_6": null,
        "price_cm_6": 0.0023799999999999997,
        "section_7": null,
        "price_7": null,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 30,
        "min_unit": 0.45
    },
    {
        "technique_ref": "100902",
        "code": "DTF2",
        "section_1": 1,
        "price_1": 0,
        "price_col_1": null,
        "price_cm_1": 0.0047599999999999995,
        "section_2": 250,
        "price_2": 0,
        "price_col_2": null,
        "price_cm_2": 0.0042,
        "section_3": 500,
        "price_3": 0,
        "price_col_3": null,
        "price_cm_3": 0.00378,
        "section_4": 1000,
        "price_4": 0,
        "price_col_4": null,
        "price_cm_4": 0.0034999999999999996,
        "section_5": 2500,
        "price_5": 0,
        "price_col_5": null,
        "price_cm_5": 0.0029399999999999995,
        "section_6": 5000,
        "price_6": 0,
        "price_col_6": null,
        "price_cm_6": 0.0023799999999999997,
        "section_7": null,
        "price_7": null,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 30,
        "min_unit": 0.65
    },
    {
        "technique_ref": "100903",
        "code": "DTF3",
        "section_1": 1,
        "price_1": 0,
        "price_col_1": null,
        "price_cm_1": 0.0047599999999999995,
        "section_2": 250,
        "price_2": 0,
        "price_col_2": null,
        "price_cm_2": 0.0042,
        "section_3": 500,
        "price_3": 0,
        "price_col_3": null,
        "price_cm_3": 0.00378,
        "section_4": 1000,
        "price_4": 0,
        "price_col_4": null,
        "price_cm_4": 0.0034999999999999996,
        "section_5": 2500,
        "price_5": 0,
        "price_col_5": null,
        "price_cm_5": 0.0029399999999999995,
        "section_6": 5000,
        "price_6": 0,
        "price_col_6": null,
        "price_cm_6": 0.0023799999999999997,
        "section_7": null,
        "price_7": null,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 30,
        "min_unit": 0.65
    },
    {
        "technique_ref": "100237",
        "code": null,
        "section_1": 1,
        "price_1": 0.7979999999999999,
        "price_col_1": 0.33599999999999997,
        "price_cm_1": null,
        "section_2": 250,
        "price_2": 0.7,
        "price_col_2": 0.294,
        "price_cm_2": null,
        "section_3": 500,
        "price_3": 0.609,
        "price_col_3": 0.259,
        "price_cm_3": null,
        "section_4": 2000,
        "price_4": 0.5319999999999999,
        "price_col_4": 0.238,
        "price_cm_4": null,
        "section_5": 5000,
        "price_5": 0.476,
        "price_col_5": 0.22399999999999998,
        "price_cm_5": null,
        "section_6": null,
        "price_6": null,
        "price_col_6": null,
        "price_cm_6": null,
        "section_7": null,
        "price_7": null,
        "price_col_7": null,
        "price_cm_7": null,
        "section_8": null,
        "price_8": null,
        "price_col_8": null,
        "price_cm_8": null,
        "section_9": null,
        "price_9": null,
        "price_col_9": null,
        "price_cm_9": null,
        "section_10": null,
        "price_10": null,
        "price_col_10": null,
        "price_cm_10": null,
        "cliche": 77,
        "cliche_repetition": null,
        "min": 50,
        "min_unit": null
    },
    {
        "technique_ref": "BP",
        "code": "BP",
        "name": "Impresión en Botón",
        "technique_name": "Impresión en Botón",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.182,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.182,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.182,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.182,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.182,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.182,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.182,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.182,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.182,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.182,
        "price_col_10": 0
    },
    {
        "technique_ref": "DI",
        "code": "DI",
        "name": "Inlays",
        "technique_name": "Inlays",
        "cliche": 35,
        "cliche_repetition": 21,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.392,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.294,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.294,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.294,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.126,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.126,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.126,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.126,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.126,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.126,
        "price_col_10": 0
    },
    {
        "technique_ref": "DL",
        "code": "DL",
        "name": "Etiqueta Digital",
        "technique_name": "Etiqueta Digital",
        "cliche": 35,
        "cliche_repetition": 21,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.784,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.518,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.518,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.518,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.26599999999999996,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.26599999999999996,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.26599999999999996,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.26599999999999996,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.26599999999999996,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.26599999999999996,
        "price_col_10": 0
    },
    {
        "technique_ref": "DO1",
        "code": "DO1",
        "name": "Gota de Resina",
        "technique_name": "Gota de Resina",
        "cliche": 49,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 2.296,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.47,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.8119999999999999,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.6859999999999999,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.588,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.504,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.46199999999999997,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.44799999999999995,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.42,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.42,
        "price_col_10": 0
    },
    {
        "technique_ref": "DPT",
        "code": "DPT",
        "name": "Impresión Digital Textil",
        "technique_name": "Impresión Digital Textil",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.013999999999999999,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.013999999999999999,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.013999999999999999,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.013999999999999999,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.013999999999999999,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.013999999999999999,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.013999999999999999,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.013999999999999999,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.013999999999999999,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.013999999999999999,
        "price_col_10": 0
    },
    {
        "technique_ref": "L0",
        "code": "L0",
        "name": "Grabado Láser",
        "technique_name": "Grabado Láser",
        "cliche": 28,
        "cliche_repetition": 14,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.0014,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.0014,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.0014,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.0014,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.0014,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.0014,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.0014,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.0014,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.0014,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.0014,
        "price_col_10": 0
    },
    {
        "technique_ref": "L4",
        "code": "L4",
        "name": "Grabado Láser",
        "technique_name": "Grabado Láser",
        "cliche": 28,
        "cliche_repetition": 14,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.694,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.1199999999999999,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.9659999999999999,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.6579999999999999,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.644,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.5319999999999999,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.48999999999999994,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.392,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.392,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.392,
        "price_col_10": 0
    },
    {
        "technique_ref": "L5",
        "code": "L5",
        "name": "Grabado Láser",
        "technique_name": "Grabado Láser",
        "cliche": 28,
        "cliche_repetition": 14,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.8199999999999998,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.19,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 1.022,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.6859999999999999,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.6719999999999999,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.5459999999999999,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.518,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.434,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.434,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.434,
        "price_col_10": 0
    },
    {
        "technique_ref": "L6",
        "code": "L6",
        "name": "Grabado Láser",
        "technique_name": "Grabado Láser",
        "cliche": 28,
        "cliche_repetition": 14,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 2.1279999999999997,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.442,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 1.26,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.756,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.742,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.602,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.588,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.476,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.476,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.476,
        "price_col_10": 0
    },
    {
        "technique_ref": "L7",
        "code": "L7",
        "name": "Grabado Láser",
        "technique_name": "Grabado Láser",
        "cliche": 28,
        "cliche_repetition": 14,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 2.3939999999999997,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.638,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 1.428,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 1.022,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 1.008,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.854,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.7,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.63,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.616,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.602,
        "price_col_10": 0
    },
    {
        "technique_ref": "LC",
        "code": "LC",
        "name": "Grabado Láser",
        "technique_name": "Grabado Láser",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.63,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.5599999999999999,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.434,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.40599999999999997,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.392,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.322,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.308,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.294,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.27999999999999997,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.26599999999999996,
        "price_col_10": 0
    },
    {
        "technique_ref": "LY",
        "code": "LY",
        "name": "Grabado Láser",
        "technique_name": "Grabado Láser",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.63,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.5599999999999999,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.434,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.40599999999999997,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.392,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.322,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.308,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.294,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.27999999999999997,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.26599999999999996,
        "price_col_10": 0
    },
    {
        "technique_ref": "P0",
        "code": "P0",
        "name": "Tampografía",
        "technique_name": "Tampografía",
        "cliche": 42,
        "cliche_repetition": 16.799999999999997,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.0014,
        "price_col_1": 0.0014,
        "section_2": 50,
        "price_2": 0.0014,
        "price_col_2": 0.0014,
        "section_3": 100,
        "price_3": 0.0014,
        "price_col_3": 0.0014,
        "section_4": 250,
        "price_4": 0.0014,
        "price_col_4": 0.0014,
        "section_5": 500,
        "price_5": 0.0014,
        "price_col_5": 0.0014,
        "section_6": 1000,
        "price_6": 0.0014,
        "price_col_6": 0.0014,
        "section_7": 2500,
        "price_7": 0.0014,
        "price_col_7": 0.0014,
        "section_8": 5000,
        "price_8": 0.0014,
        "price_col_8": 0.0014,
        "section_9": 10000,
        "price_9": 0.0014,
        "price_col_9": 0.0014,
        "section_10": 20000,
        "price_10": 0.0014,
        "price_col_10": 0.0014
    },
    {
        "technique_ref": "P1",
        "code": "P1",
        "technique_name": "P1 (Roly)",
        "cliche": 14,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": true,
        "roly_stitches": 1000,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.378,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.35,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 200,
        "price_3": 0.308,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.28,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.266,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.238,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "P2",
        "code": "P2",
        "name": "Tampografía",
        "technique_name": "Tampografía",
        "cliche": 42,
        "cliche_repetition": 16.799999999999997,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.644,
        "price_col_1": 0.434,
        "section_2": 50,
        "price_2": 0.574,
        "price_col_2": 0.378,
        "section_3": 100,
        "price_3": 0.26599999999999996,
        "price_col_3": 0.16799999999999998,
        "section_4": 250,
        "price_4": 0.196,
        "price_col_4": 0.098,
        "section_5": 500,
        "price_5": 0.13999999999999999,
        "price_col_5": 0.098,
        "section_6": 1000,
        "price_6": 0.11199999999999999,
        "price_col_6": 0.06999999999999999,
        "section_7": 2500,
        "price_7": 0.11199999999999999,
        "price_col_7": 0.06999999999999999,
        "section_8": 5000,
        "price_8": 0.098,
        "price_col_8": 0.055999999999999994,
        "section_9": 10000,
        "price_9": 0.06999999999999999,
        "price_col_9": 0.041999999999999996,
        "section_10": 20000,
        "price_10": 0.06999999999999999,
        "price_col_10": 0.041999999999999996
    },
    {
        "technique_ref": "P3",
        "code": "P3",
        "name": "Tampografía",
        "technique_name": "Tampografía",
        "cliche": 42,
        "cliche_repetition": 16.799999999999997,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.9239999999999999,
        "price_col_1": 0.616,
        "section_2": 50,
        "price_2": 0.6719999999999999,
        "price_col_2": 0.44799999999999995,
        "section_3": 100,
        "price_3": 0.364,
        "price_col_3": 0.22399999999999998,
        "section_4": 250,
        "price_4": 0.252,
        "price_col_4": 0.13999999999999999,
        "section_5": 500,
        "price_5": 0.21,
        "price_col_5": 0.13999999999999999,
        "section_6": 1000,
        "price_6": 0.16799999999999998,
        "price_col_6": 0.098,
        "section_7": 2500,
        "price_7": 0.154,
        "price_col_7": 0.098,
        "section_8": 5000,
        "price_8": 0.126,
        "price_col_8": 0.06999999999999999,
        "section_9": 10000,
        "price_9": 0.08399999999999999,
        "price_col_9": 0.055999999999999994,
        "section_10": 20000,
        "price_10": 0.08399999999999999,
        "price_col_10": 0.055999999999999994
    },
    {
        "technique_ref": "P4",
        "code": "P4",
        "name": "Tampografía",
        "technique_name": "Tampografía",
        "cliche": 42,
        "cliche_repetition": 16.799999999999997,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.0639999999999998,
        "price_col_1": 0.714,
        "section_2": 50,
        "price_2": 0.714,
        "price_col_2": 0.476,
        "section_3": 100,
        "price_3": 0.434,
        "price_col_3": 0.26599999999999996,
        "section_4": 250,
        "price_4": 0.378,
        "price_col_4": 0.22399999999999998,
        "section_5": 500,
        "price_5": 0.33599999999999997,
        "price_col_5": 0.21,
        "section_6": 1000,
        "price_6": 0.22399999999999998,
        "price_col_6": 0.126,
        "section_7": 2500,
        "price_7": 0.182,
        "price_col_7": 0.098,
        "section_8": 5000,
        "price_8": 0.154,
        "price_col_8": 0.08399999999999999,
        "section_9": 10000,
        "price_9": 0.13999999999999999,
        "price_col_9": 0.06999999999999999,
        "section_10": 20000,
        "price_10": 0.126,
        "price_col_10": 0.06999999999999999
    },
    {
        "technique_ref": "P5",
        "code": "P5",
        "name": "Tampografía",
        "technique_name": "Tampografía",
        "cliche": 42,
        "cliche_repetition": 16.799999999999997,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.26,
        "price_col_1": 0.784,
        "section_2": 50,
        "price_2": 0.826,
        "price_col_2": 0.5599999999999999,
        "section_3": 100,
        "price_3": 0.518,
        "price_col_3": 0.33599999999999997,
        "section_4": 250,
        "price_4": 0.434,
        "price_col_4": 0.26599999999999996,
        "section_5": 500,
        "price_5": 0.392,
        "price_col_5": 0.238,
        "section_6": 1000,
        "price_6": 0.308,
        "price_col_6": 0.154,
        "section_7": 2500,
        "price_7": 0.252,
        "price_col_7": 0.126,
        "section_8": 5000,
        "price_8": 0.21,
        "price_col_8": 0.098,
        "section_9": 10000,
        "price_9": 0.182,
        "price_col_9": 0.08399999999999999,
        "section_10": 20000,
        "price_10": 0.16799999999999998,
        "price_col_10": 0.08399999999999999
    },
    {
        "technique_ref": "P6",
        "code": "P6",
        "name": "Tampografía",
        "technique_name": "Tampografía",
        "cliche": 42,
        "cliche_repetition": 16.799999999999997,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.3439999999999999,
        "price_col_1": 0.784,
        "section_2": 50,
        "price_2": 1.0779999999999998,
        "price_col_2": 0.616,
        "section_3": 100,
        "price_3": 0.728,
        "price_col_3": 0.476,
        "section_4": 250,
        "price_4": 0.63,
        "price_col_4": 0.40599999999999997,
        "section_5": 500,
        "price_5": 0.5459999999999999,
        "price_col_5": 0.35,
        "section_6": 1000,
        "price_6": 0.44799999999999995,
        "price_col_6": 0.26599999999999996,
        "section_7": 2500,
        "price_7": 0.42,
        "price_col_7": 0.238,
        "section_8": 5000,
        "price_8": 0.308,
        "price_col_8": 0.182,
        "section_9": 10000,
        "price_9": 0.308,
        "price_col_9": 0.182,
        "section_10": 20000,
        "price_10": 0.308,
        "price_col_10": 0.182
    },
    {
        "technique_ref": "P7",
        "code": "P7",
        "name": "Tampografía",
        "technique_name": "Tampografía",
        "cliche": 42,
        "cliche_repetition": 16.799999999999997,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.442,
        "price_col_1": 0.8959999999999999,
        "section_2": 50,
        "price_2": 1.1199999999999999,
        "price_col_2": 0.7,
        "section_3": 100,
        "price_3": 0.7979999999999999,
        "price_col_3": 0.5319999999999999,
        "section_4": 250,
        "price_4": 0.6859999999999999,
        "price_col_4": 0.46199999999999997,
        "section_5": 500,
        "price_5": 0.588,
        "price_col_5": 0.40599999999999997,
        "section_6": 1000,
        "price_6": 0.476,
        "price_col_6": 0.308,
        "section_7": 2500,
        "price_7": 0.42,
        "price_col_7": 0.294,
        "section_8": 5000,
        "price_8": 0.308,
        "price_col_8": 0.196,
        "section_9": 10000,
        "price_9": 0.294,
        "price_col_9": 0.196,
        "section_10": 20000,
        "price_10": 0.294,
        "price_col_10": 0.196
    },
    {
        "technique_ref": "PD0",
        "code": "PD0",
        "name": "Print digital",
        "technique_name": "Print digital",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.0014,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.0014,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.0014,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.0014,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.0014,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.0014,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.0014,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.0014,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.0014,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.0014,
        "price_col_10": 0
    },
    {
        "technique_ref": "PD1",
        "code": "PD1",
        "name": "Print digital",
        "technique_name": "Print digital",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.616,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.504,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.378,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.33599999999999997,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.308,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.196,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.154,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.154,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.154,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.154,
        "price_col_10": 0
    },
    {
        "technique_ref": "PD2",
        "code": "PD2",
        "name": "Print digital",
        "technique_name": "Print digital",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.6719999999999999,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.5459999999999999,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.42,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.378,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.35,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.22399999999999998,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.182,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.182,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.182,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.182,
        "price_col_10": 0
    },
    {
        "technique_ref": "PD3",
        "code": "PD3",
        "name": "Print digital",
        "technique_name": "Print digital",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.756,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.588,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.5459999999999999,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.46199999999999997,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.44799999999999995,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.322,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.294,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.294,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.294,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.294,
        "price_col_10": 0
    },
    {
        "technique_ref": "PD4",
        "code": "PD4",
        "name": "Print digital",
        "technique_name": "Print digital",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.232,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.036,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.644,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.5599999999999999,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.518,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.364,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.33599999999999997,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.33599999999999997,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.33599999999999997,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.33599999999999997,
        "price_col_10": 0
    },
    {
        "technique_ref": "PD5",
        "code": "PD5",
        "name": "Print digital",
        "technique_name": "Print digital",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.288,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.0919999999999999,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.9239999999999999,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.63,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.588,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.44799999999999995,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.42,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.42,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.42,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.42,
        "price_col_10": 0
    },
    {
        "technique_ref": "PD6",
        "code": "PD6",
        "name": "Print digital",
        "technique_name": "Print digital",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.456,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.19,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 1.0919999999999999,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.9939999999999999,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.9239999999999999,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.7979999999999999,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.756,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.742,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.728,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.714,
        "price_col_10": 0
    },
    {
        "technique_ref": "PD7",
        "code": "PD7",
        "name": "Print digital",
        "technique_name": "Print digital",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.708,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.428,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 1.3159999999999998,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 1.232,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 1.1199999999999999,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.9799999999999999,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.8959999999999999,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.8819999999999999,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.868,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.854,
        "price_col_10": 0
    },
    {
        "technique_ref": "PDT",
        "code": "PDT",
        "name": "Impresión Digital Textil",
        "technique_name": "Impresión Digital Textil",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 4.186,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 4.186,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 4.186,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 4.186,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 4.186,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 4.186,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 4.186,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 4.186,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 4.186,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 4.186,
        "price_col_10": 0
    },
    {
        "technique_ref": "RD0",
        "code": "RD0",
        "name": "Impresión360 \/ Digital",
        "technique_name": "Impresión360 \/ Digital",
        "cliche": 49,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.0014,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.0014,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.0014,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.0014,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.0014,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.0014,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.0014,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.0014,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.0014,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.0014,
        "price_col_10": 0
    },
    {
        "technique_ref": "RD1",
        "code": "RD1",
        "name": "Impresión360 \/ Digital",
        "technique_name": "Impresión360 \/ Digital",
        "cliche": 49,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.022,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.854,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.784,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.714,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.6579999999999999,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.602,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.5459999999999999,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.5459999999999999,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.5459999999999999,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.5459999999999999,
        "price_col_10": 0
    },
    {
        "technique_ref": "RD2",
        "code": "RD2",
        "name": "Impresión360 \/ Digital",
        "technique_name": "Impresión360 \/ Digital",
        "cliche": 49,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.274,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.0639999999999998,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.9659999999999999,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.8959999999999999,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.826,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.756,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.6719999999999999,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.6719999999999999,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.6719999999999999,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.6719999999999999,
        "price_col_10": 0
    },
    {
        "technique_ref": "RD3",
        "code": "RD3",
        "name": "Impresión360 \/ Digital",
        "technique_name": "Impresión360 \/ Digital",
        "cliche": 49,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.652,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.386,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 1.26,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 1.162,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 1.0639999999999998,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.9659999999999999,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.868,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.868,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.868,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.868,
        "price_col_10": 0
    },
    {
        "technique_ref": "RL",
        "code": "RL",
        "name": "Round Laser printing",
        "technique_name": "Round Laser printing",
        "cliche": 28,
        "cliche_repetition": 17.5,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.3439999999999999,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.854,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.728,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.434,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.434,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.364,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.33599999999999997,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.308,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.308,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.308,
        "price_col_10": 0
    },
    {
        "technique_ref": "RS0",
        "code": "RS0",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.0014,
        "price_col_1": 0.0014,
        "section_2": 50,
        "price_2": 0.0014,
        "price_col_2": 0.0014,
        "section_3": 100,
        "price_3": 0.0014,
        "price_col_3": 0.0014,
        "section_4": 250,
        "price_4": 0.0014,
        "price_col_4": 0.0014,
        "section_5": 500,
        "price_5": 0.0014,
        "price_col_5": 0.0014,
        "section_6": 1000,
        "price_6": 0.0014,
        "price_col_6": 0.0014,
        "section_7": 2500,
        "price_7": 0.0014,
        "price_col_7": 0.0014,
        "section_8": 5000,
        "price_8": 0.0014,
        "price_col_8": 0.0014,
        "section_9": 10000,
        "price_9": 0.0014,
        "price_col_9": 0.0014,
        "section_10": 20000,
        "price_10": 0.0014,
        "price_col_10": 0.0014
    },
    {
        "technique_ref": "RS1",
        "code": "RS1",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 49,
        "cliche_repetition": 35,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.504,
        "price_col_1": 0.378,
        "section_2": 50,
        "price_2": 0.434,
        "price_col_2": 0.322,
        "section_3": 100,
        "price_3": 0.196,
        "price_col_3": 0.154,
        "section_4": 250,
        "price_4": 0.16799999999999998,
        "price_col_4": 0.126,
        "section_5": 500,
        "price_5": 0.126,
        "price_col_5": 0.098,
        "section_6": 1000,
        "price_6": 0.11199999999999999,
        "price_col_6": 0.098,
        "section_7": 2500,
        "price_7": 0.11199999999999999,
        "price_col_7": 0.08399999999999999,
        "section_8": 5000,
        "price_8": 0.098,
        "price_col_8": 0.06999999999999999,
        "section_9": 10000,
        "price_9": 0.06999999999999999,
        "price_col_9": 0.055999999999999994,
        "section_10": 20000,
        "price_10": 0.06999999999999999,
        "price_col_10": 0.055999999999999994
    },
    {
        "technique_ref": "RS2",
        "code": "RS2",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 49,
        "cliche_repetition": 35,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.602,
        "price_col_1": 0.44799999999999995,
        "section_2": 50,
        "price_2": 0.5459999999999999,
        "price_col_2": 0.40599999999999997,
        "section_3": 100,
        "price_3": 0.252,
        "price_col_3": 0.196,
        "section_4": 250,
        "price_4": 0.182,
        "price_col_4": 0.13999999999999999,
        "section_5": 500,
        "price_5": 0.154,
        "price_col_5": 0.11199999999999999,
        "section_6": 1000,
        "price_6": 0.126,
        "price_col_6": 0.098,
        "section_7": 2500,
        "price_7": 0.11199999999999999,
        "price_col_7": 0.098,
        "section_8": 5000,
        "price_8": 0.098,
        "price_col_8": 0.06999999999999999,
        "section_9": 10000,
        "price_9": 0.06999999999999999,
        "price_col_9": 0.055999999999999994,
        "section_10": 20000,
        "price_10": 0.06999999999999999,
        "price_col_10": 0.055999999999999994
    },
    {
        "technique_ref": "RS3",
        "code": "RS3",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 49,
        "cliche_repetition": 35,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.854,
        "price_col_1": 0.644,
        "section_2": 50,
        "price_2": 0.826,
        "price_col_2": 0.63,
        "section_3": 100,
        "price_3": 0.46199999999999997,
        "price_col_3": 0.35,
        "section_4": 250,
        "price_4": 0.35,
        "price_col_4": 0.26599999999999996,
        "section_5": 500,
        "price_5": 0.238,
        "price_col_5": 0.182,
        "section_6": 1000,
        "price_6": 0.182,
        "price_col_6": 0.13999999999999999,
        "section_7": 2500,
        "price_7": 0.182,
        "price_col_7": 0.13999999999999999,
        "section_8": 5000,
        "price_8": 0.126,
        "price_col_8": 0.098,
        "section_9": 10000,
        "price_9": 0.126,
        "price_col_9": 0.098,
        "section_10": 20000,
        "price_10": 0.126,
        "price_col_10": 0.098
    },
    {
        "technique_ref": "RS4",
        "code": "RS4",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 49,
        "cliche_repetition": 35,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.0779999999999998,
        "price_col_1": 0.8119999999999999,
        "section_2": 50,
        "price_2": 0.854,
        "price_col_2": 0.644,
        "section_3": 100,
        "price_3": 0.48999999999999994,
        "price_col_3": 0.364,
        "section_4": 250,
        "price_4": 0.378,
        "price_col_4": 0.27999999999999997,
        "section_5": 500,
        "price_5": 0.26599999999999996,
        "price_col_5": 0.196,
        "section_6": 1000,
        "price_6": 0.21,
        "price_col_6": 0.154,
        "section_7": 2500,
        "price_7": 0.21,
        "price_col_7": 0.154,
        "section_8": 5000,
        "price_8": 0.154,
        "price_col_8": 0.126,
        "section_9": 10000,
        "price_9": 0.154,
        "price_col_9": 0.126,
        "section_10": 20000,
        "price_10": 0.154,
        "price_col_10": 0.126
    },
    {
        "technique_ref": "RS5",
        "code": "RS5",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 49,
        "cliche_repetition": 35,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.302,
        "price_col_1": 0.9799999999999999,
        "section_2": 50,
        "price_2": 1.0499999999999998,
        "price_col_2": 0.7979999999999999,
        "section_3": 100,
        "price_3": 0.504,
        "price_col_3": 0.392,
        "section_4": 250,
        "price_4": 0.40599999999999997,
        "price_col_4": 0.308,
        "section_5": 500,
        "price_5": 0.294,
        "price_col_5": 0.22399999999999998,
        "section_6": 1000,
        "price_6": 0.238,
        "price_col_6": 0.182,
        "section_7": 2500,
        "price_7": 0.238,
        "price_col_7": 0.182,
        "section_8": 5000,
        "price_8": 0.182,
        "price_col_8": 0.13999999999999999,
        "section_9": 10000,
        "price_9": 0.182,
        "price_col_9": 0.13999999999999999,
        "section_10": 20000,
        "price_10": 0.182,
        "price_col_10": 0.13999999999999999
    },
    {
        "technique_ref": "RS6",
        "code": "RS6",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 49,
        "cliche_repetition": 35,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.386,
        "price_col_1": 1.0499999999999998,
        "section_2": 50,
        "price_2": 1.134,
        "price_col_2": 0.854,
        "section_3": 100,
        "price_3": 0.5459999999999999,
        "price_col_3": 0.40599999999999997,
        "section_4": 250,
        "price_4": 0.42,
        "price_col_4": 0.322,
        "section_5": 500,
        "price_5": 0.35,
        "price_col_5": 0.26599999999999996,
        "section_6": 1000,
        "price_6": 0.26599999999999996,
        "price_col_6": 0.196,
        "section_7": 2500,
        "price_7": 0.26599999999999996,
        "price_col_7": 0.196,
        "section_8": 5000,
        "price_8": 0.21,
        "price_col_8": 0.154,
        "section_9": 10000,
        "price_9": 0.21,
        "price_col_9": 0.154,
        "section_10": 20000,
        "price_10": 0.21,
        "price_col_10": 0.154
    },
    {
        "technique_ref": "RS7",
        "code": "RS7",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 49,
        "cliche_repetition": 35,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.498,
        "price_col_1": 1.134,
        "section_2": 50,
        "price_2": 1.218,
        "price_col_2": 0.9099999999999999,
        "section_3": 100,
        "price_3": 0.588,
        "price_col_3": 0.44799999999999995,
        "section_4": 250,
        "price_4": 0.46199999999999997,
        "price_col_4": 0.35,
        "section_5": 500,
        "price_5": 0.364,
        "price_col_5": 0.27999999999999997,
        "section_6": 1000,
        "price_6": 0.27999999999999997,
        "price_col_6": 0.21,
        "section_7": 2500,
        "price_7": 0.27999999999999997,
        "price_col_7": 0.21,
        "section_8": 5000,
        "price_8": 0.22399999999999998,
        "price_col_8": 0.16799999999999998,
        "section_9": 10000,
        "price_9": 0.22399999999999998,
        "price_col_9": 0.16799999999999998,
        "section_10": 20000,
        "price_10": 0.22399999999999998,
        "price_col_10": 0.16799999999999998
    },
    {
        "technique_ref": "S0",
        "code": "S0",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 42,
        "cliche_repetition": 23.799999999999997,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.0014,
        "price_col_1": 0.0014,
        "section_2": 50,
        "price_2": 0.0014,
        "price_col_2": 0.0014,
        "section_3": 100,
        "price_3": 0.0014,
        "price_col_3": 0.0014,
        "section_4": 250,
        "price_4": 0.0014,
        "price_col_4": 0.0014,
        "section_5": 500,
        "price_5": 0.0014,
        "price_col_5": 0.0014,
        "section_6": 1000,
        "price_6": 0.0014,
        "price_col_6": 0.0014,
        "section_7": 2500,
        "price_7": 0.0014,
        "price_col_7": 0.0014,
        "section_8": 5000,
        "price_8": 0.0014,
        "price_col_8": 0.0014,
        "section_9": 10000,
        "price_9": 0.0014,
        "price_col_9": 0.0014,
        "section_10": 20000,
        "price_10": 0.0014,
        "price_col_10": 0.0014
    },
    {
        "technique_ref": "S1",
        "code": "S1",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.3579999999999999,
        "price_col_1": 0.9659999999999999,
        "section_2": 50,
        "price_2": 0.9939999999999999,
        "price_col_2": 0.7,
        "section_3": 100,
        "price_3": 0.8119999999999999,
        "price_col_3": 0.44799999999999995,
        "section_4": 250,
        "price_4": 0.6859999999999999,
        "price_col_4": 0.378,
        "section_5": 500,
        "price_5": 0.5459999999999999,
        "price_col_5": 0.308,
        "section_6": 1000,
        "price_6": 0.392,
        "price_col_6": 0.238,
        "section_7": 2500,
        "price_7": 0.35,
        "price_col_7": 0.238,
        "section_8": 5000,
        "price_8": 0.33599999999999997,
        "price_col_8": 0.238,
        "section_9": 10000,
        "price_9": 0.308,
        "price_col_9": 0.238,
        "section_10": 20000,
        "price_10": 0.294,
        "price_col_10": 0.238
    },
    {
        "technique_ref": "S2",
        "code": "S2",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.442,
        "price_col_1": 0.9799999999999999,
        "section_2": 50,
        "price_2": 1.0919999999999999,
        "price_col_2": 0.8119999999999999,
        "section_3": 100,
        "price_3": 0.938,
        "price_col_3": 0.476,
        "section_4": 250,
        "price_4": 0.742,
        "price_col_4": 0.392,
        "section_5": 500,
        "price_5": 0.63,
        "price_col_5": 0.322,
        "section_6": 1000,
        "price_6": 0.44799999999999995,
        "price_col_6": 0.27999999999999997,
        "section_7": 2500,
        "price_7": 0.392,
        "price_col_7": 0.26599999999999996,
        "section_8": 5000,
        "price_8": 0.378,
        "price_col_8": 0.26599999999999996,
        "section_9": 10000,
        "price_9": 0.33599999999999997,
        "price_col_9": 0.26599999999999996,
        "section_10": 20000,
        "price_10": 0.322,
        "price_col_10": 0.26599999999999996
    },
    {
        "technique_ref": "S3",
        "code": "S3",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.54,
        "price_col_1": 1.0779999999999998,
        "section_2": 50,
        "price_2": 1.176,
        "price_col_2": 0.8119999999999999,
        "section_3": 100,
        "price_3": 0.9799999999999999,
        "price_col_3": 0.476,
        "section_4": 250,
        "price_4": 0.756,
        "price_col_4": 0.364,
        "section_5": 500,
        "price_5": 0.644,
        "price_col_5": 0.322,
        "section_6": 1000,
        "price_6": 0.5459999999999999,
        "price_col_6": 0.27999999999999997,
        "section_7": 2500,
        "price_7": 0.48999999999999994,
        "price_col_7": 0.26599999999999996,
        "section_8": 5000,
        "price_8": 0.42,
        "price_col_8": 0.26599999999999996,
        "section_9": 10000,
        "price_9": 0.40599999999999997,
        "price_col_9": 0.26599999999999996,
        "section_10": 20000,
        "price_10": 0.392,
        "price_col_10": 0.26599999999999996
    },
    {
        "technique_ref": "S4",
        "code": "S4",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.638,
        "price_col_1": 1.1059999999999999,
        "section_2": 50,
        "price_2": 1.274,
        "price_col_2": 0.84,
        "section_3": 100,
        "price_3": 1.176,
        "price_col_3": 0.518,
        "section_4": 250,
        "price_4": 1.036,
        "price_col_4": 0.392,
        "section_5": 500,
        "price_5": 0.8819999999999999,
        "price_col_5": 0.322,
        "section_6": 1000,
        "price_6": 0.784,
        "price_col_6": 0.27999999999999997,
        "section_7": 2500,
        "price_7": 0.6719999999999999,
        "price_col_7": 0.26599999999999996,
        "section_8": 5000,
        "price_8": 0.616,
        "price_col_8": 0.26599999999999996,
        "section_9": 10000,
        "price_9": 0.616,
        "price_col_9": 0.26599999999999996,
        "section_10": 20000,
        "price_10": 0.616,
        "price_col_10": 0.26599999999999996
    },
    {
        "technique_ref": "S5",
        "code": "S5",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.89,
        "price_col_1": 1.218,
        "section_2": 50,
        "price_2": 1.554,
        "price_col_2": 0.84,
        "section_3": 100,
        "price_3": 1.19,
        "price_col_3": 0.476,
        "section_4": 250,
        "price_4": 1.0779999999999998,
        "price_col_4": 0.392,
        "section_5": 500,
        "price_5": 0.9239999999999999,
        "price_col_5": 0.322,
        "section_6": 1000,
        "price_6": 0.826,
        "price_col_6": 0.27999999999999997,
        "section_7": 2500,
        "price_7": 0.756,
        "price_col_7": 0.27999999999999997,
        "section_8": 5000,
        "price_8": 0.7,
        "price_col_8": 0.27999999999999997,
        "section_9": 10000,
        "price_9": 0.7,
        "price_col_9": 0.27999999999999997,
        "section_10": 20000,
        "price_10": 0.7,
        "price_col_10": 0.27999999999999997
    },
    {
        "technique_ref": "S6",
        "code": "S6",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 2.114,
        "price_col_1": 1.3579999999999999,
        "section_2": 50,
        "price_2": 1.75,
        "price_col_2": 0.868,
        "section_3": 100,
        "price_3": 1.3299999999999998,
        "price_col_3": 0.574,
        "section_4": 250,
        "price_4": 1.19,
        "price_col_4": 0.476,
        "section_5": 500,
        "price_5": 1.0499999999999998,
        "price_col_5": 0.392,
        "section_6": 1000,
        "price_6": 0.9239999999999999,
        "price_col_6": 0.33599999999999997,
        "section_7": 2500,
        "price_7": 0.84,
        "price_col_7": 0.33599999999999997,
        "section_8": 5000,
        "price_8": 0.7979999999999999,
        "price_col_8": 0.33599999999999997,
        "section_9": 10000,
        "price_9": 0.7979999999999999,
        "price_col_9": 0.33599999999999997,
        "section_10": 20000,
        "price_10": 0.7979999999999999,
        "price_col_10": 0.33599999999999997
    },
    {
        "technique_ref": "S7",
        "code": "S7",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.3299999999999998,
        "price_col_1": 1.176,
        "section_2": 50,
        "price_2": 1.0499999999999998,
        "price_col_2": 0.784,
        "section_3": 100,
        "price_3": 0.8819999999999999,
        "price_col_3": 0.5319999999999999,
        "section_4": 250,
        "price_4": 0.8119999999999999,
        "price_col_4": 0.40599999999999997,
        "section_5": 500,
        "price_5": 0.7,
        "price_col_5": 0.322,
        "section_6": 1000,
        "price_6": 0.504,
        "price_col_6": 0.27999999999999997,
        "section_7": 2500,
        "price_7": 0.46199999999999997,
        "price_col_7": 0.21,
        "section_8": 5000,
        "price_8": 0.40599999999999997,
        "price_col_8": 0.21,
        "section_9": 10000,
        "price_9": 0.40599999999999997,
        "price_col_9": 0.21,
        "section_10": 20000,
        "price_10": 0.40599999999999997,
        "price_col_10": 0.21
    },
    {
        "technique_ref": "ST",
        "code": "ST",
        "name": "Screenprint textile",
        "technique_name": "Screenprint textile",
        "cliche": 28,
        "cliche_repetition": 21,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.134,
        "price_col_1": 0.35,
        "section_2": 50,
        "price_2": 0.77,
        "price_col_2": 0.21,
        "section_3": 100,
        "price_3": 0.5599999999999999,
        "price_col_3": 0.182,
        "section_4": 250,
        "price_4": 0.40599999999999997,
        "price_col_4": 0.16799999999999998,
        "section_5": 500,
        "price_5": 0.35,
        "price_col_5": 0.16799999999999998,
        "section_6": 1000,
        "price_6": 0.322,
        "price_col_6": 0.154,
        "section_7": 2500,
        "price_7": 0.308,
        "price_col_7": 0.126,
        "section_8": 5000,
        "price_8": 0.27999999999999997,
        "price_col_8": 0.126,
        "section_9": 10000,
        "price_9": 0.26599999999999996,
        "price_col_9": 0.11199999999999999,
        "section_10": 20000,
        "price_10": 0.22399999999999998,
        "price_col_10": 0.11199999999999999
    },
    {
        "technique_ref": "ST0",
        "code": "ST0",
        "name": "Screenprint textile",
        "technique_name": "Screenprint textile",
        "cliche": 28,
        "cliche_repetition": 21,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.0014,
        "price_col_1": 0.0014,
        "section_2": 50,
        "price_2": 0.0014,
        "price_col_2": 0.0014,
        "section_3": 100,
        "price_3": 0.0014,
        "price_col_3": 0.0014,
        "section_4": 250,
        "price_4": 0.0014,
        "price_col_4": 0.0014,
        "section_5": 500,
        "price_5": 0.0014,
        "price_col_5": 0.0014,
        "section_6": 1000,
        "price_6": 0.0014,
        "price_col_6": 0.0014,
        "section_7": 2500,
        "price_7": 0.0014,
        "price_col_7": 0.0014,
        "section_8": 5000,
        "price_8": 0.0014,
        "price_col_8": 0.0014,
        "section_9": 10000,
        "price_9": 0.0014,
        "price_col_9": 0.0014,
        "section_10": 20000,
        "price_10": 0.0014,
        "price_col_10": 0.0014
    },
    {
        "technique_ref": "ST1",
        "code": "ST1",
        "name": "Screenprint textile",
        "technique_name": "Screenprint textile",
        "cliche": 28,
        "cliche_repetition": 21,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.826,
        "price_col_1": 0.48999999999999994,
        "section_2": 50,
        "price_2": 0.5459999999999999,
        "price_col_2": 0.392,
        "section_3": 100,
        "price_3": 0.40599999999999997,
        "price_col_3": 0.35,
        "section_4": 250,
        "price_4": 0.378,
        "price_col_4": 0.252,
        "section_5": 500,
        "price_5": 0.35,
        "price_col_5": 0.21,
        "section_6": 1000,
        "price_6": 0.294,
        "price_col_6": 0.16799999999999998,
        "section_7": 2500,
        "price_7": 0.26599999999999996,
        "price_col_7": 0.126,
        "section_8": 5000,
        "price_8": 0.252,
        "price_col_8": 0.11199999999999999,
        "section_9": 10000,
        "price_9": 0.238,
        "price_col_9": 0.098,
        "section_10": 20000,
        "price_10": 0.238,
        "price_col_10": 0.098
    },
    {
        "technique_ref": "ST2",
        "code": "ST2",
        "name": "Screenprint textile",
        "technique_name": "Screenprint textile",
        "cliche": 28,
        "cliche_repetition": 21,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.54,
        "price_col_1": 0.46199999999999997,
        "section_2": 50,
        "price_2": 1.036,
        "price_col_2": 0.27999999999999997,
        "section_3": 100,
        "price_3": 0.6719999999999999,
        "price_col_3": 0.26599999999999996,
        "section_4": 250,
        "price_4": 0.48999999999999994,
        "price_col_4": 0.238,
        "section_5": 500,
        "price_5": 0.44799999999999995,
        "price_col_5": 0.238,
        "section_6": 1000,
        "price_6": 0.392,
        "price_col_6": 0.196,
        "section_7": 2500,
        "price_7": 0.364,
        "price_col_7": 0.16799999999999998,
        "section_8": 5000,
        "price_8": 0.322,
        "price_col_8": 0.16799999999999998,
        "section_9": 10000,
        "price_9": 0.322,
        "price_col_9": 0.16799999999999998,
        "section_10": 20000,
        "price_10": 0.322,
        "price_col_10": 0.16799999999999998
    },
    {
        "technique_ref": "T1",
        "code": "T1",
        "name": "Transfer",
        "technique_name": "Transfer",
        "cliche": 44.8,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 2.1839999999999997,
        "price_col_1": 1.036,
        "section_2": 50,
        "price_2": 1.9739999999999998,
        "price_col_2": 0.9099999999999999,
        "section_3": 100,
        "price_3": 1.666,
        "price_col_3": 0.756,
        "section_4": 250,
        "price_4": 1.456,
        "price_col_4": 0.616,
        "section_5": 500,
        "price_5": 0.9799999999999999,
        "price_col_5": 0.392,
        "section_6": 1000,
        "price_6": 0.84,
        "price_col_6": 0.27999999999999997,
        "section_7": 2500,
        "price_7": 0.7,
        "price_col_7": 0.238,
        "section_8": 5000,
        "price_8": 0.6579999999999999,
        "price_col_8": 0.22399999999999998,
        "section_9": 10000,
        "price_9": 0.6579999999999999,
        "price_col_9": 0.22399999999999998,
        "section_10": 20000,
        "price_10": 0.6579999999999999,
        "price_col_10": 0.22399999999999998
    },
    {
        "technique_ref": "TC",
        "code": "TC",
        "name": "Transfer",
        "technique_name": "Transfer",
        "cliche": 70,
        "cliche_repetition": 42,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 3.01,
        "price_col_1": 0.938,
        "section_2": 50,
        "price_2": 2.2819999999999996,
        "price_col_2": 0.48999999999999994,
        "section_3": 100,
        "price_3": 2.114,
        "price_col_3": 0.476,
        "section_4": 250,
        "price_4": 2.016,
        "price_col_4": 0.46199999999999997,
        "section_5": 500,
        "price_5": 1.9739999999999998,
        "price_col_5": 0.42,
        "section_6": 1000,
        "price_6": 1.918,
        "price_col_6": 0.33599999999999997,
        "section_7": 2500,
        "price_7": 1.89,
        "price_col_7": 0.294,
        "section_8": 5000,
        "price_8": 1.8479999999999999,
        "price_col_8": 0.26599999999999996,
        "section_9": 10000,
        "price_9": 1.8339999999999999,
        "price_col_9": 0.26599999999999996,
        "section_10": 20000,
        "price_10": 1.8199999999999998,
        "price_col_10": 0.26599999999999996
    },
    {
        "technique_ref": "TD",
        "code": "TD",
        "name": "Transfer",
        "technique_name": "Transfer",
        "cliche": 50.4,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.476,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.46199999999999997,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.44799999999999995,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.44799999999999995,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.434,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.42,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.42,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.40599999999999997,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.40599999999999997,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.392,
        "price_col_10": 0
    },
    {
        "technique_ref": "TD1",
        "code": "TD1",
        "name": "Transfer",
        "technique_name": "Transfer",
        "cliche": 50.4,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.476,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.46199999999999997,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.44799999999999995,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.44799999999999995,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.434,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.42,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.42,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.40599999999999997,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.40599999999999997,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.392,
        "price_col_10": 0
    },
    {
        "technique_ref": "TDT",
        "code": "TDT",
        "name": "Transfer",
        "technique_name": "Transfer",
        "cliche": 35,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.19,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.162,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 1.134,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 1.1199999999999999,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 1.0919999999999999,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 1.0779999999999998,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 1.0499999999999998,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 1.036,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 1.008,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.9939999999999999,
        "price_col_10": 0
    },
    {
        "technique_ref": "TR",
        "code": "TR",
        "name": "Transfer",
        "technique_name": "Transfer",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 2.4779999999999998,
        "price_col_1": 2.4779999999999998,
        "section_2": 50,
        "price_2": 2.2119999999999997,
        "price_col_2": 2.2119999999999997,
        "section_3": 100,
        "price_3": 1.8059999999999998,
        "price_col_3": 1.8059999999999998,
        "section_4": 250,
        "price_4": 1.638,
        "price_col_4": 1.638,
        "section_5": 500,
        "price_5": 1.148,
        "price_col_5": 1.148,
        "section_6": 1000,
        "price_6": 1.148,
        "price_col_6": 1.148,
        "section_7": 2500,
        "price_7": 0.784,
        "price_col_7": 0.784,
        "section_8": 5000,
        "price_8": 0.784,
        "price_col_8": 0.784,
        "section_9": 10000,
        "price_9": 0.784,
        "price_col_9": 0.784,
        "section_10": 20000,
        "price_10": 0.784,
        "price_col_10": 0.784
    },
    {
        "technique_ref": "TS",
        "code": "TS",
        "name": "Transfer",
        "technique_name": "Transfer",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.7779999999999998,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.512,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 1.1199999999999999,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 1.022,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.9659999999999999,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.952,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.8959999999999999,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.8959999999999999,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.8959999999999999,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.8959999999999999,
        "price_col_10": 0
    },
    {
        "technique_ref": "TS1",
        "code": "TS1",
        "name": "Transfer",
        "technique_name": "Transfer",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.5459999999999999,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.476,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.378,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.33599999999999997,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.322,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.322,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.308,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.308,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.308,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.308,
        "price_col_10": 0
    },
    {
        "technique_ref": "TS2",
        "code": "TS2",
        "name": "Transfer",
        "technique_name": "Transfer",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 0.6859999999999999,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 0.588,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.46199999999999997,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.42,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.40599999999999997,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.392,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.378,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.378,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.378,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.378,
        "price_col_10": 0
    },
    {
        "technique_ref": "TS3",
        "code": "TS3",
        "name": "Transfer",
        "technique_name": "Transfer",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.442,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.218,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 0.9099999999999999,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 0.84,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.784,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.77,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.728,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.728,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.728,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.728,
        "price_col_10": 0
    },
    {
        "technique_ref": "TS4",
        "code": "TS4",
        "name": "Transfer",
        "technique_name": "Transfer",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.7919999999999998,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.526,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 1.134,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 1.036,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.9799999999999999,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.9659999999999999,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.9099999999999999,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.9099999999999999,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.9099999999999999,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.9099999999999999,
        "price_col_10": 0
    },
    {
        "technique_ref": "TSM",
        "code": "TSM",
        "name": "Transfer",
        "technique_name": "Transfer",
        "cliche": 42,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.7919999999999998,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.526,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 1.134,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 1.036,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 0.9799999999999999,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 0.9659999999999999,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 0.9099999999999999,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 0.9099999999999999,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 0.9099999999999999,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 0.9099999999999999,
        "price_col_10": 0
    },
    {
        "technique_ref": "TST",
        "code": "TST",
        "name": "Transfer",
        "technique_name": "Transfer",
        "cliche": 50.4,
        "cliche_repetition": 30.799999999999997,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 2.17,
        "price_col_1": 0,
        "section_2": 50,
        "price_2": 1.8339999999999999,
        "price_col_2": 0,
        "section_3": 100,
        "price_3": 1.442,
        "price_col_3": 0,
        "section_4": 250,
        "price_4": 1.302,
        "price_col_4": 0,
        "section_5": 500,
        "price_5": 1.246,
        "price_col_5": 0,
        "section_6": 1000,
        "price_6": 1.19,
        "price_col_6": 0,
        "section_7": 2500,
        "price_7": 1.162,
        "price_col_7": 0,
        "section_8": 5000,
        "price_8": 1.134,
        "price_col_8": 0,
        "section_9": 10000,
        "price_9": 1.1059999999999999,
        "price_col_9": 0,
        "section_10": 20000,
        "price_10": 1.0499999999999998,
        "price_col_10": 0
    },
    {
        "technique_ref": "TT",
        "code": "TT",
        "name": "Transfer",
        "technique_name": "Transfer",
        "cliche": 35,
        "cliche_repetition": 28,
        "min": null,
        "min_unit": null,
        "section_1": 1,
        "price_1": 1.386,
        "price_col_1": 0.63,
        "section_2": 50,
        "price_2": 1.232,
        "price_col_2": 0.574,
        "section_3": 100,
        "price_3": 1.008,
        "price_col_3": 0.48999999999999994,
        "section_4": 250,
        "price_4": 0.7979999999999999,
        "price_col_4": 0.44799999999999995,
        "section_5": 500,
        "price_5": 0.6719999999999999,
        "price_col_5": 0.33599999999999997,
        "section_6": 1000,
        "price_6": 0.574,
        "price_col_6": 0.238,
        "section_7": 2500,
        "price_7": 0.5319999999999999,
        "price_col_7": 0.21,
        "section_8": 5000,
        "price_8": 0.476,
        "price_col_8": 0.196,
        "section_9": 10000,
        "price_9": 0.44799999999999995,
        "price_col_9": 0.196,
        "section_10": 20000,
        "price_10": 0.44799999999999995,
        "price_col_10": 0.196
    },
    {
        "technique_ref": "CIFRA_A",
        "code": "CIFRA_A",
        "name": "Tampografía (A)",
        "technique_name": "Tampografía (A)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "cifra_code": "A",
        "cifra_type": "Colores",
        "cifra_source_id": "594e929f-a709-4824-8056-73ff4f13ad35",
        "section_1": 1,
        "price_1": 0.14,
        "price_col_1": 0.196,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.14,
        "price_col_2": 0.196,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.14,
        "price_col_3": 0.196,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.14,
        "price_col_4": 0.196,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.119,
        "price_col_5": 0.077,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.119,
        "price_col_6": 0.077,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.119,
        "price_col_7": 0.077,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.119,
        "price_col_8": 0.077,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.098,
        "price_col_9": 0.07,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.098,
        "price_col_10": 0.07,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.098,
        "price_col_11": 0.07,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.098,
        "price_col_12": 0.07,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.084,
        "price_col_13": 0.056,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.084,
        "price_col_14": 0.056,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.084,
        "price_col_15": 0.056,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.084,
        "price_col_16": 0.056,
        "price_cm_16": 0
    },
    {
        "technique_ref": "594e929f-a709-4824-8056-73ff4f13ad35",
        "code": "594e929f-a709-4824-8056-73ff4f13ad35",
        "name": "Tampografía (A)",
        "technique_name": "Tampografía (A)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "cifra_code": "A",
        "cifra_type": "Colores",
        "cifra_source_id": "594e929f-a709-4824-8056-73ff4f13ad35",
        "section_1": 1,
        "price_1": 0.14,
        "price_col_1": 0.196,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.14,
        "price_col_2": 0.196,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.14,
        "price_col_3": 0.196,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.14,
        "price_col_4": 0.196,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.119,
        "price_col_5": 0.077,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.119,
        "price_col_6": 0.077,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.119,
        "price_col_7": 0.077,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.119,
        "price_col_8": 0.077,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.098,
        "price_col_9": 0.07,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.098,
        "price_col_10": 0.07,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.098,
        "price_col_11": 0.07,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.098,
        "price_col_12": 0.07,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.084,
        "price_col_13": 0.056,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.084,
        "price_col_14": 0.056,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.084,
        "price_col_15": 0.056,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.084,
        "price_col_16": 0.056,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_ADHESIVO",
        "code": "CIFRA_ADHESIVO",
        "name": "Adhesivo",
        "technique_name": "Adhesivo",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "cifra_code": "ADHESIVO",
        "cifra_type": "Area",
        "cifra_source_id": "9b67ba46-ef29-408b-b2a1-26daea0948c6",
        "section_1": 100,
        "price_1": 0.644,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.644,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.644,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.644,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 0.42,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0.42,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 0.42,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 0.42,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.392,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.392,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.392,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.392,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.378,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.378,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.378,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.378,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.364,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.364,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.364,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.364,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "9b67ba46-ef29-408b-b2a1-26daea0948c6",
        "code": "9b67ba46-ef29-408b-b2a1-26daea0948c6",
        "name": "Adhesivo",
        "technique_name": "Adhesivo",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "cifra_code": "ADHESIVO",
        "cifra_type": "Area",
        "cifra_source_id": "9b67ba46-ef29-408b-b2a1-26daea0948c6",
        "section_1": 100,
        "price_1": 0.644,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.644,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.644,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.644,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 0.42,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0.42,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 0.42,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 0.42,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.392,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.392,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.392,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.392,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.378,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.378,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.378,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.378,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.364,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.364,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.364,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.364,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_ALP_2_IMAN",
        "code": "CIFRA_ALP_2_IMAN",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALP_2_IMAN",
        "cifra_type": "Area",
        "cifra_source_id": "35344c8b-8ae0-4e1f-9f00-01939122a4b9",
        "section_1": 300,
        "price_1": 0.77,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.77,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.77,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.77,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.63,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.63,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.63,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.63,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.532,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.532,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.532,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.532,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.462,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.462,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.462,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.462,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.448,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.448,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.448,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.448,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "35344c8b-8ae0-4e1f-9f00-01939122a4b9",
        "code": "35344c8b-8ae0-4e1f-9f00-01939122a4b9",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALP_2_IMAN",
        "cifra_type": "Area",
        "cifra_source_id": "35344c8b-8ae0-4e1f-9f00-01939122a4b9",
        "section_1": 300,
        "price_1": 0.77,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.77,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.77,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.77,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.63,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.63,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.63,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.63,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.532,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.532,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.532,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.532,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.462,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.462,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.462,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.462,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.448,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.448,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.448,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.448,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_ALP_3_IMAN",
        "code": "CIFRA_ALP_3_IMAN",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALP_3_IMAN",
        "cifra_type": "Area",
        "cifra_source_id": "f2a18a09-c05e-47b3-b9b9-548c517966f7",
        "section_1": 300,
        "price_1": 0.826,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.826,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.826,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.826,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.644,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.644,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.644,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.644,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.546,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.546,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.546,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.546,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.49,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.49,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.49,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.49,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.476,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.476,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.476,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.476,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "f2a18a09-c05e-47b3-b9b9-548c517966f7",
        "code": "f2a18a09-c05e-47b3-b9b9-548c517966f7",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALP_3_IMAN",
        "cifra_type": "Area",
        "cifra_source_id": "f2a18a09-c05e-47b3-b9b9-548c517966f7",
        "section_1": 300,
        "price_1": 0.826,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.826,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.826,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.826,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.644,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.644,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.644,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.644,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.546,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.546,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.546,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.546,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.49,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.49,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.49,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.49,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.476,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.476,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.476,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.476,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_ALP_IMAN",
        "code": "CIFRA_ALP_IMAN",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALP_IMAN",
        "cifra_type": "Area",
        "cifra_source_id": "c397d1cd-01bc-4d83-8e3e-bbc3b755516f",
        "section_1": 300,
        "price_1": 0.301,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.301,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.301,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.301,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.259,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.259,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.259,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.259,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.245,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.245,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.245,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.245,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.231,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.231,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.231,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.231,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.203,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.203,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.203,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.203,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "c397d1cd-01bc-4d83-8e3e-bbc3b755516f",
        "code": "c397d1cd-01bc-4d83-8e3e-bbc3b755516f",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALP_IMAN",
        "cifra_type": "Area",
        "cifra_source_id": "c397d1cd-01bc-4d83-8e3e-bbc3b755516f",
        "section_1": 300,
        "price_1": 0.301,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.301,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.301,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.301,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.259,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.259,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.259,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.259,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.245,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.245,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.245,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.245,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.231,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.231,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.231,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.231,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.203,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.203,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.203,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.203,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_ALSO",
        "code": "CIFRA_ALSO",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALSO",
        "cifra_type": "Area",
        "cifra_source_id": "046ed51f-b912-459b-b5a6-3e27df61ec21",
        "section_1": 300,
        "price_1": 1.134,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 1.134,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 1.134,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 1.134,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.924,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.924,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.924,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.924,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.714,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.714,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.714,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.714,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "046ed51f-b912-459b-b5a6-3e27df61ec21",
        "code": "046ed51f-b912-459b-b5a6-3e27df61ec21",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALSO",
        "cifra_type": "Area",
        "cifra_source_id": "046ed51f-b912-459b-b5a6-3e27df61ec21",
        "section_1": 300,
        "price_1": 1.134,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 1.134,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 1.134,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 1.134,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.924,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.924,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.924,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.924,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.714,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.714,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.714,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.714,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_ALSO_MAXI",
        "code": "CIFRA_ALSO_MAXI",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALSO_MAXI",
        "cifra_type": "Area",
        "cifra_source_id": "a4c8f782-bfcd-4547-ad9c-ea984dc7b797",
        "section_1": 300,
        "price_1": 1.204,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 1.204,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 1.204,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 1.204,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.994,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.994,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.994,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.994,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.784,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.784,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.784,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.784,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "a4c8f782-bfcd-4547-ad9c-ea984dc7b797",
        "code": "a4c8f782-bfcd-4547-ad9c-ea984dc7b797",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALSO_MAXI",
        "cifra_type": "Area",
        "cifra_source_id": "a4c8f782-bfcd-4547-ad9c-ea984dc7b797",
        "section_1": 300,
        "price_1": 1.204,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 1.204,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 1.204,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 1.204,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.994,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.994,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.994,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.994,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.784,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.784,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.784,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.784,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_ALSO_MENU",
        "code": "CIFRA_ALSO_MENU",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALSO_MENU",
        "cifra_type": "Area",
        "cifra_source_id": "0b73ab0f-0970-48eb-891d-67a920d0249d",
        "section_1": 300,
        "price_1": 0.9324,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.9324,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.9324,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.9324,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.812,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.812,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.812,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.812,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.742,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.742,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.742,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.742,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "0b73ab0f-0970-48eb-891d-67a920d0249d",
        "code": "0b73ab0f-0970-48eb-891d-67a920d0249d",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALSO_MENU",
        "cifra_type": "Area",
        "cifra_source_id": "0b73ab0f-0970-48eb-891d-67a920d0249d",
        "section_1": 300,
        "price_1": 0.9324,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.9324,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.9324,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.9324,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.812,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.812,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.812,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.812,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.742,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.742,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.742,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.742,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_ALSO_MINI",
        "code": "CIFRA_ALSO_MINI",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALSO_MINI",
        "cifra_type": "Area",
        "cifra_source_id": "fa156898-37a1-495b-9bfe-01fced06bd3a",
        "section_1": 300,
        "price_1": 0.56,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.56,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.56,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.56,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.49,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.49,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.49,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.49,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.448,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.448,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.448,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.448,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.4312,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.4312,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.4312,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.4312,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.399,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.399,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.399,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.399,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "fa156898-37a1-495b-9bfe-01fced06bd3a",
        "code": "fa156898-37a1-495b-9bfe-01fced06bd3a",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALSO_MINI",
        "cifra_type": "Area",
        "cifra_source_id": "fa156898-37a1-495b-9bfe-01fced06bd3a",
        "section_1": 300,
        "price_1": 0.56,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.56,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.56,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.56,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.49,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.49,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.49,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.49,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.448,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.448,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.448,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.448,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.4312,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.4312,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.4312,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.4312,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.399,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.399,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.399,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.399,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_ALSO_VERTICAL",
        "code": "CIFRA_ALSO_VERTICAL",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALSO_VERTICAL",
        "cifra_type": "Area",
        "cifra_source_id": "4d228264-8eaa-4341-b690-ea184e62f460",
        "section_1": 500,
        "price_1": 0.511,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.511,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.511,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.511,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.273,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.273,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 1000,
        "price_7": 0.273,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.273,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 3000,
        "price_9": 0.231,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 3000,
        "price_10": 0.231,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 3000,
        "price_11": 0.231,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 3000,
        "price_12": 0.231,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.21,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.21,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.21,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.21,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "4d228264-8eaa-4341-b690-ea184e62f460",
        "code": "4d228264-8eaa-4341-b690-ea184e62f460",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ALSO_VERTICAL",
        "cifra_type": "Area",
        "cifra_source_id": "4d228264-8eaa-4341-b690-ea184e62f460",
        "section_1": 500,
        "price_1": 0.511,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.511,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.511,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.511,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.273,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.273,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 1000,
        "price_7": 0.273,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.273,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 3000,
        "price_9": 0.231,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 3000,
        "price_10": 0.231,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 3000,
        "price_11": 0.231,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 3000,
        "price_12": 0.231,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.21,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.21,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.21,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.21,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_B",
        "code": "CIFRA_B",
        "name": "Tampografía (B)",
        "technique_name": "Tampografía (B)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "cifra_code": "B",
        "cifra_type": "Colores",
        "cifra_source_id": "83d128be-b190-446b-bf31-f7fee61591c9",
        "section_1": 1,
        "price_1": 0.224,
        "price_col_1": 0.154,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.224,
        "price_col_2": 0.154,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.224,
        "price_col_3": 0.154,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.224,
        "price_col_4": 0.154,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.182,
        "price_col_5": 0.098,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.182,
        "price_col_6": 0.098,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.182,
        "price_col_7": 0.098,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.182,
        "price_col_8": 0.098,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.14,
        "price_col_9": 0.084,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.14,
        "price_col_10": 0.084,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.14,
        "price_col_11": 0.084,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.14,
        "price_col_12": 0.084,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.112,
        "price_col_13": 0.077,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.112,
        "price_col_14": 0.077,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.112,
        "price_col_15": 0.077,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.112,
        "price_col_16": 0.077,
        "price_cm_16": 0
    },
    {
        "technique_ref": "83d128be-b190-446b-bf31-f7fee61591c9",
        "code": "83d128be-b190-446b-bf31-f7fee61591c9",
        "name": "Tampografía (B)",
        "technique_name": "Tampografía (B)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "cifra_code": "B",
        "cifra_type": "Colores",
        "cifra_source_id": "83d128be-b190-446b-bf31-f7fee61591c9",
        "section_1": 1,
        "price_1": 0.224,
        "price_col_1": 0.154,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.224,
        "price_col_2": 0.154,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.224,
        "price_col_3": 0.154,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.224,
        "price_col_4": 0.154,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.182,
        "price_col_5": 0.098,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.182,
        "price_col_6": 0.098,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.182,
        "price_col_7": 0.098,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.182,
        "price_col_8": 0.098,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.14,
        "price_col_9": 0.084,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.14,
        "price_col_10": 0.084,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.14,
        "price_col_11": 0.084,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.14,
        "price_col_12": 0.084,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.112,
        "price_col_13": 0.077,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.112,
        "price_col_14": 0.077,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.112,
        "price_col_15": 0.077,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.112,
        "price_col_16": 0.077,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_B_D",
        "code": "CIFRA_B_D",
        "name": "Grabación bolígrafo y libreta a un color",
        "technique_name": "Grabación bolígrafo y libreta a un color",
        "cliche": 84,
        "cliche_repetition": 21,
        "min": 84,
        "min_unit": null,
        "cifra_code": "B_D",
        "cifra_type": "Area",
        "cifra_source_id": "8c789d82-bd14-4071-95b1-37a8b97020dd",
        "section_1": 1,
        "price_1": 0.588,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.588,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.588,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.588,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.476,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.476,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.476,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.476,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.392,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.392,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.392,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.392,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.322,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.322,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.322,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.322,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "8c789d82-bd14-4071-95b1-37a8b97020dd",
        "code": "8c789d82-bd14-4071-95b1-37a8b97020dd",
        "name": "Grabación bolígrafo y libreta a un color",
        "technique_name": "Grabación bolígrafo y libreta a un color",
        "cliche": 84,
        "cliche_repetition": 21,
        "min": 84,
        "min_unit": null,
        "cifra_code": "B_D",
        "cifra_type": "Area",
        "cifra_source_id": "8c789d82-bd14-4071-95b1-37a8b97020dd",
        "section_1": 1,
        "price_1": 0.588,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.588,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.588,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.588,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.476,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.476,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.476,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.476,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.392,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.392,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.392,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.392,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.322,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.322,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.322,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.322,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_B_E",
        "code": "CIFRA_B_E",
        "name": "Grabación bolígrafo y libreta a un color",
        "technique_name": "Grabación bolígrafo y libreta a un color",
        "cliche": 84,
        "cliche_repetition": 21,
        "min": 84,
        "min_unit": null,
        "cifra_code": "B_E",
        "cifra_type": "Area",
        "cifra_source_id": "ca33e261-ea8b-40d9-96b5-4746811995fe",
        "section_1": 1,
        "price_1": 0.658,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.658,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.658,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.658,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.546,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.546,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.546,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.546,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.448,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.448,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.448,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.448,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.378,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.378,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.378,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.378,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "ca33e261-ea8b-40d9-96b5-4746811995fe",
        "code": "ca33e261-ea8b-40d9-96b5-4746811995fe",
        "name": "Grabación bolígrafo y libreta a un color",
        "technique_name": "Grabación bolígrafo y libreta a un color",
        "cliche": 84,
        "cliche_repetition": 21,
        "min": 84,
        "min_unit": null,
        "cifra_code": "B_E",
        "cifra_type": "Area",
        "cifra_source_id": "ca33e261-ea8b-40d9-96b5-4746811995fe",
        "section_1": 1,
        "price_1": 0.658,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.658,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.658,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.658,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.546,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.546,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.546,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.546,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.448,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.448,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.448,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.448,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.378,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.378,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.378,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.378,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_B_F",
        "code": "CIFRA_B_F",
        "name": "Grabación bolígrafo y libreta a un color distinta grabación",
        "technique_name": "Grabación bolígrafo y libreta a un color distinta grabación",
        "cliche": 84,
        "cliche_repetition": 21,
        "min": 98,
        "min_unit": null,
        "cifra_code": "B_F",
        "cifra_type": "Area",
        "cifra_source_id": "616ddaaf-9ecb-450f-868c-ace93bf9b8d8",
        "section_1": 1,
        "price_1": 0.77,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.77,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.77,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.77,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.644,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.644,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.644,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.644,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.532,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.532,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.532,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.532,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.448,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.448,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.448,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.448,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "616ddaaf-9ecb-450f-868c-ace93bf9b8d8",
        "code": "616ddaaf-9ecb-450f-868c-ace93bf9b8d8",
        "name": "Grabación bolígrafo y libreta a un color distinta grabación",
        "technique_name": "Grabación bolígrafo y libreta a un color distinta grabación",
        "cliche": 84,
        "cliche_repetition": 21,
        "min": 98,
        "min_unit": null,
        "cifra_code": "B_F",
        "cifra_type": "Area",
        "cifra_source_id": "616ddaaf-9ecb-450f-868c-ace93bf9b8d8",
        "section_1": 1,
        "price_1": 0.77,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.77,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.77,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.77,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.644,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.644,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.644,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.644,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.532,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.532,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.532,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.532,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.448,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.448,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.448,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.448,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_B_HEX",
        "code": "CIFRA_B_HEX",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 126,
        "min_unit": null,
        "cifra_code": "B_HEX",
        "cifra_type": "Area",
        "cifra_source_id": "91e1877c-4b54-44a3-945f-37375bdbdbb6",
        "section_1": 300,
        "price_1": 1.344,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 1.344,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 1.344,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 1.344,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.008,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.008,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.008,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.008,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.686,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.686,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.686,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.686,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "91e1877c-4b54-44a3-945f-37375bdbdbb6",
        "code": "91e1877c-4b54-44a3-945f-37375bdbdbb6",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 126,
        "min_unit": null,
        "cifra_code": "B_HEX",
        "cifra_type": "Area",
        "cifra_source_id": "91e1877c-4b54-44a3-945f-37375bdbdbb6",
        "section_1": 300,
        "price_1": 1.344,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 1.344,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 1.344,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 1.344,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.008,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.008,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.008,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.008,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.686,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.686,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.686,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.686,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_BOL",
        "code": "CIFRA_BOL",
        "name": "Grabación a todo color",
        "technique_name": "Grabación a todo color",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "BOL",
        "cifra_type": "Area",
        "cifra_source_id": "e43ba3cd-3c2d-49f0-bf02-d972d5c28c0f",
        "section_1": 250,
        "price_1": 0.385,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.385,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.385,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.385,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.3605,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.3605,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.3605,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.3605,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.35,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.35,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.35,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.35,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.329,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.329,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.329,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.329,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.3465,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.3465,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.3465,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.3465,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.315,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.315,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.315,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.315,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "e43ba3cd-3c2d-49f0-bf02-d972d5c28c0f",
        "code": "e43ba3cd-3c2d-49f0-bf02-d972d5c28c0f",
        "name": "Grabación a todo color",
        "technique_name": "Grabación a todo color",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "BOL",
        "cifra_type": "Area",
        "cifra_source_id": "e43ba3cd-3c2d-49f0-bf02-d972d5c28c0f",
        "section_1": 250,
        "price_1": 0.385,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.385,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.385,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.385,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.3605,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.3605,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.3605,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.3605,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.35,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.35,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.35,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.35,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.329,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.329,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.329,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.329,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.3465,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.3465,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.3465,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.3465,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.315,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.315,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.315,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.315,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_BORDADO",
        "code": "CIFRA_BORDADO",
        "name": "Bordado",
        "technique_name": "Bordado",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "BORDADO",
        "cifra_type": "Area",
        "cifra_source_id": "9880bf8e-96b9-489b-990a-1770b6da5139"
    },
    {
        "technique_ref": "9880bf8e-96b9-489b-990a-1770b6da5139",
        "code": "9880bf8e-96b9-489b-990a-1770b6da5139",
        "name": "Bordado",
        "technique_name": "Bordado",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "BORDADO",
        "cifra_type": "Area",
        "cifra_source_id": "9880bf8e-96b9-489b-990a-1770b6da5139"
    },
    {
        "technique_ref": "CIFRA_BORDADO_20X20",
        "code": "CIFRA_BORDADO_20X20",
        "name": "Grabación bordado a todo color",
        "technique_name": "Grabación bordado a todo color",
        "cliche": 73.5,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "BORDADO_20X20",
        "cifra_type": "Area",
        "cifra_source_id": "cb28bb31-9f41-4d5f-8db2-ddebc6c7cb89",
        "section_1": 1,
        "price_1": 5.6,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 5.6,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 5.6,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 5.6,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 50,
        "price_5": 5.6,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 50,
        "price_6": 5.6,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 50,
        "price_7": 5.6,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 50,
        "price_8": 5.6,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 100,
        "price_9": 5.6,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 100,
        "price_10": 5.6,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 100,
        "price_11": 5.6,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 100,
        "price_12": 5.6,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 200,
        "price_13": 5.432,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 200,
        "price_14": 5.432,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 200,
        "price_15": 5.432,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 200,
        "price_16": 5.432,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 300,
        "price_17": 5.432,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 300,
        "price_18": 5.432,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 300,
        "price_19": 5.432,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 300,
        "price_20": 5.432,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 500,
        "price_21": 5.25,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 500,
        "price_22": 5.25,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 500,
        "price_23": 5.25,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 500,
        "price_24": 5.25,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "cb28bb31-9f41-4d5f-8db2-ddebc6c7cb89",
        "code": "cb28bb31-9f41-4d5f-8db2-ddebc6c7cb89",
        "name": "Grabación bordado a todo color",
        "technique_name": "Grabación bordado a todo color",
        "cliche": 73.5,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "BORDADO_20X20",
        "cifra_type": "Area",
        "cifra_source_id": "cb28bb31-9f41-4d5f-8db2-ddebc6c7cb89",
        "section_1": 1,
        "price_1": 5.6,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 5.6,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 5.6,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 5.6,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 50,
        "price_5": 5.6,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 50,
        "price_6": 5.6,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 50,
        "price_7": 5.6,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 50,
        "price_8": 5.6,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 100,
        "price_9": 5.6,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 100,
        "price_10": 5.6,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 100,
        "price_11": 5.6,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 100,
        "price_12": 5.6,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 200,
        "price_13": 5.432,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 200,
        "price_14": 5.432,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 200,
        "price_15": 5.432,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 200,
        "price_16": 5.432,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 300,
        "price_17": 5.432,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 300,
        "price_18": 5.432,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 300,
        "price_19": 5.432,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 300,
        "price_20": 5.432,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 500,
        "price_21": 5.25,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 500,
        "price_22": 5.25,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 500,
        "price_23": 5.25,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 500,
        "price_24": 5.25,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_BORDADO_6X4",
        "code": "CIFRA_BORDADO_6X4",
        "name": "Grabación bordado a todo color",
        "technique_name": "Grabación bordado a todo color",
        "cliche": 73.5,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "BORDADO_6X4",
        "cifra_type": "Area",
        "cifra_source_id": "6f4e39d6-7d22-4c27-8096-720aff470345",
        "section_1": 1,
        "price_1": 2.24,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 2.24,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 2.24,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 2.24,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 50,
        "price_5": 2.24,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 50,
        "price_6": 2.24,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 50,
        "price_7": 2.24,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 50,
        "price_8": 2.24,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 100,
        "price_9": 2.24,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 100,
        "price_10": 2.24,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 100,
        "price_11": 2.24,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 100,
        "price_12": 2.24,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 200,
        "price_13": 2.17,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 200,
        "price_14": 2.17,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 200,
        "price_15": 2.17,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 200,
        "price_16": 2.17,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 300,
        "price_17": 2.17,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 300,
        "price_18": 2.17,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 300,
        "price_19": 2.17,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 300,
        "price_20": 2.17,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 500,
        "price_21": 2.1,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 500,
        "price_22": 2.1,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 500,
        "price_23": 2.1,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 500,
        "price_24": 2.1,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "6f4e39d6-7d22-4c27-8096-720aff470345",
        "code": "6f4e39d6-7d22-4c27-8096-720aff470345",
        "name": "Grabación bordado a todo color",
        "technique_name": "Grabación bordado a todo color",
        "cliche": 73.5,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "BORDADO_6X4",
        "cifra_type": "Area",
        "cifra_source_id": "6f4e39d6-7d22-4c27-8096-720aff470345",
        "section_1": 1,
        "price_1": 2.24,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 2.24,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 2.24,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 2.24,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 50,
        "price_5": 2.24,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 50,
        "price_6": 2.24,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 50,
        "price_7": 2.24,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 50,
        "price_8": 2.24,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 100,
        "price_9": 2.24,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 100,
        "price_10": 2.24,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 100,
        "price_11": 2.24,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 100,
        "price_12": 2.24,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 200,
        "price_13": 2.17,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 200,
        "price_14": 2.17,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 200,
        "price_15": 2.17,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 200,
        "price_16": 2.17,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 300,
        "price_17": 2.17,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 300,
        "price_18": 2.17,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 300,
        "price_19": 2.17,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 300,
        "price_20": 2.17,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 500,
        "price_21": 2.1,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 500,
        "price_22": 2.1,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 500,
        "price_23": 2.1,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 500,
        "price_24": 2.1,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_BORDADO_PECHO_ESPALD",
        "code": "CIFRA_BORDADO_PECHO_ESPALD",
        "name": "Grabación bordado a todo color",
        "technique_name": "Grabación bordado a todo color",
        "cliche": 147,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "BORDADO_PECHO_ESPALD",
        "cifra_type": "Area",
        "cifra_source_id": "b508724b-8082-4804-98d4-d2f33857f29e",
        "section_1": 1,
        "price_1": 7.84,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 7.84,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 7.84,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 7.84,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 50,
        "price_5": 7.84,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 50,
        "price_6": 7.84,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 50,
        "price_7": 7.84,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 50,
        "price_8": 7.84,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 100,
        "price_9": 7.84,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 100,
        "price_10": 7.84,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 100,
        "price_11": 7.84,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 100,
        "price_12": 7.84,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 200,
        "price_13": 7.602,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 200,
        "price_14": 7.602,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 200,
        "price_15": 7.602,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 200,
        "price_16": 7.602,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 300,
        "price_17": 7.602,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 300,
        "price_18": 7.602,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 300,
        "price_19": 7.602,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 300,
        "price_20": 7.602,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 500,
        "price_21": 7.35,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 500,
        "price_22": 7.35,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 500,
        "price_23": 7.35,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 500,
        "price_24": 7.35,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "b508724b-8082-4804-98d4-d2f33857f29e",
        "code": "b508724b-8082-4804-98d4-d2f33857f29e",
        "name": "Grabación bordado a todo color",
        "technique_name": "Grabación bordado a todo color",
        "cliche": 147,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "BORDADO_PECHO_ESPALD",
        "cifra_type": "Area",
        "cifra_source_id": "b508724b-8082-4804-98d4-d2f33857f29e",
        "section_1": 1,
        "price_1": 7.84,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 7.84,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 7.84,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 7.84,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 50,
        "price_5": 7.84,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 50,
        "price_6": 7.84,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 50,
        "price_7": 7.84,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 50,
        "price_8": 7.84,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 100,
        "price_9": 7.84,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 100,
        "price_10": 7.84,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 100,
        "price_11": 7.84,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 100,
        "price_12": 7.84,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 200,
        "price_13": 7.602,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 200,
        "price_14": 7.602,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 200,
        "price_15": 7.602,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 200,
        "price_16": 7.602,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 300,
        "price_17": 7.602,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 300,
        "price_18": 7.602,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 300,
        "price_19": 7.602,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 300,
        "price_20": 7.602,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 500,
        "price_21": 7.35,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 500,
        "price_22": 7.35,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 500,
        "price_23": 7.35,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 500,
        "price_24": 7.35,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_C",
        "code": "CIFRA_C",
        "name": "Tampografía (C)",
        "technique_name": "Tampografía (C)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "cifra_code": "C",
        "cifra_type": "Colores",
        "cifra_source_id": "8796df8e-7863-4e16-ada9-61417a8bb2b1",
        "section_1": 1,
        "price_1": 0.28,
        "price_col_1": 0.224,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.28,
        "price_col_2": 0.224,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.28,
        "price_col_3": 0.224,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.28,
        "price_col_4": 0.224,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.252,
        "price_col_5": 0.126,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.252,
        "price_col_6": 0.126,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.252,
        "price_col_7": 0.126,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.252,
        "price_col_8": 0.126,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.21,
        "price_col_9": 0.112,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.21,
        "price_col_10": 0.112,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.21,
        "price_col_11": 0.112,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.21,
        "price_col_12": 0.112,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.168,
        "price_col_13": 0.098,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.168,
        "price_col_14": 0.098,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.168,
        "price_col_15": 0.098,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.168,
        "price_col_16": 0.098,
        "price_cm_16": 0
    },
    {
        "technique_ref": "8796df8e-7863-4e16-ada9-61417a8bb2b1",
        "code": "8796df8e-7863-4e16-ada9-61417a8bb2b1",
        "name": "Tampografía (C)",
        "technique_name": "Tampografía (C)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "cifra_code": "C",
        "cifra_type": "Colores",
        "cifra_source_id": "8796df8e-7863-4e16-ada9-61417a8bb2b1",
        "section_1": 1,
        "price_1": 0.28,
        "price_col_1": 0.224,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.28,
        "price_col_2": 0.224,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.28,
        "price_col_3": 0.224,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.28,
        "price_col_4": 0.224,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.252,
        "price_col_5": 0.126,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.252,
        "price_col_6": 0.126,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.252,
        "price_col_7": 0.126,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.252,
        "price_col_8": 0.126,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.21,
        "price_col_9": 0.112,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.21,
        "price_col_10": 0.112,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.21,
        "price_col_11": 0.112,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.21,
        "price_col_12": 0.112,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.168,
        "price_col_13": 0.098,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.168,
        "price_col_14": 0.098,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.168,
        "price_col_15": 0.098,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.168,
        "price_col_16": 0.098,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_C_F",
        "code": "CIFRA_C_F",
        "name": "Grabación estuche y roller",
        "technique_name": "Grabación estuche y roller",
        "cliche": 84,
        "cliche_repetition": 42,
        "min": 91,
        "min_unit": null,
        "cifra_code": "C_F",
        "cifra_type": "Area",
        "cifra_source_id": "fb643d48-5e52-423f-9889-5eb487a8abb0",
        "section_1": 1,
        "price_1": 0.826,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.826,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.826,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.826,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.714,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.714,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.714,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.714,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.602,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.602,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.602,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.602,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.504,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.504,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.504,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.504,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "fb643d48-5e52-423f-9889-5eb487a8abb0",
        "code": "fb643d48-5e52-423f-9889-5eb487a8abb0",
        "name": "Grabación estuche y roller",
        "technique_name": "Grabación estuche y roller",
        "cliche": 84,
        "cliche_repetition": 42,
        "min": 91,
        "min_unit": null,
        "cifra_code": "C_F",
        "cifra_type": "Area",
        "cifra_source_id": "fb643d48-5e52-423f-9889-5eb487a8abb0",
        "section_1": 1,
        "price_1": 0.826,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.826,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.826,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.826,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.714,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.714,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.714,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.714,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.602,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.602,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.602,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.602,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.504,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.504,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.504,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.504,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_CONSULTAR",
        "code": "CIFRA_CONSULTAR",
        "name": "Consultar grabación",
        "technique_name": "Consultar grabación",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CONSULTAR",
        "cifra_type": "Colores",
        "cifra_source_id": "4ad45fb8-6b62-4e39-9a12-e994879a34d9"
    },
    {
        "technique_ref": "4ad45fb8-6b62-4e39-9a12-e994879a34d9",
        "code": "4ad45fb8-6b62-4e39-9a12-e994879a34d9",
        "name": "Consultar grabación",
        "technique_name": "Consultar grabación",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CONSULTAR",
        "cifra_type": "Colores",
        "cifra_source_id": "4ad45fb8-6b62-4e39-9a12-e994879a34d9"
    },
    {
        "technique_ref": "CIFRA_CORBATA_ETIQUETA",
        "code": "CIFRA_CORBATA_ETIQUETA",
        "name": "Corbata etiqueta",
        "technique_name": "Corbata etiqueta",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CORBATA_ETIQUETA",
        "cifra_type": "Area",
        "cifra_source_id": "801df451-d6a0-4f95-afa8-60038f10fe23"
    },
    {
        "technique_ref": "801df451-d6a0-4f95-afa8-60038f10fe23",
        "code": "801df451-d6a0-4f95-afa8-60038f10fe23",
        "name": "Corbata etiqueta",
        "technique_name": "Corbata etiqueta",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CORBATA_ETIQUETA",
        "cifra_type": "Area",
        "cifra_source_id": "801df451-d6a0-4f95-afa8-60038f10fe23"
    },
    {
        "technique_ref": "CIFRA_CORBATA_PD",
        "code": "CIFRA_CORBATA_PD",
        "name": "Corbata PD",
        "technique_name": "Corbata PD",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CORBATA_PD",
        "cifra_type": "Area",
        "cifra_source_id": "9c207b22-846e-480d-9347-d279da05d162",
        "section_1": 100,
        "price_1": 10.15,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 10.15,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 10.15,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 10.15,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 7.07,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 7.07,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 7.07,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 7.07,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 6.146,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 6.146,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 6.146,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 6.146,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 4.865,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 4.865,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 4.865,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 4.865,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "9c207b22-846e-480d-9347-d279da05d162",
        "code": "9c207b22-846e-480d-9347-d279da05d162",
        "name": "Corbata PD",
        "technique_name": "Corbata PD",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CORBATA_PD",
        "cifra_type": "Area",
        "cifra_source_id": "9c207b22-846e-480d-9347-d279da05d162",
        "section_1": 100,
        "price_1": 10.15,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 10.15,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 10.15,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 10.15,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 7.07,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 7.07,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 7.07,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 7.07,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 6.146,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 6.146,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 6.146,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 6.146,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 4.865,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 4.865,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 4.865,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 4.865,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_CORBATA_PDS",
        "code": "CIFRA_CORBATA_PDS",
        "name": "Corbata realizada en seda, incluye hasta 3 colores",
        "technique_name": "Corbata realizada en seda, incluye hasta 3 colores",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CORBATA_PDS",
        "cifra_type": "Area",
        "cifra_source_id": "ad649931-b6ab-4d30-9ba7-b975bfa97d7b",
        "section_1": 50,
        "price_1": 22.05,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 22.05,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 50,
        "price_3": 22.05,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 22.05,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 18.914,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 18.914,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 18.914,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 18.914,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 300,
        "price_9": 15.82,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 300,
        "price_10": 15.82,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 300,
        "price_11": 15.82,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 300,
        "price_12": 15.82,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 14.84,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 14.84,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 14.84,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 14.84,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 13.965,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 13.965,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 13.965,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 13.965,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "ad649931-b6ab-4d30-9ba7-b975bfa97d7b",
        "code": "ad649931-b6ab-4d30-9ba7-b975bfa97d7b",
        "name": "Corbata realizada en seda, incluye hasta 3 colores",
        "technique_name": "Corbata realizada en seda, incluye hasta 3 colores",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CORBATA_PDS",
        "cifra_type": "Area",
        "cifra_source_id": "ad649931-b6ab-4d30-9ba7-b975bfa97d7b",
        "section_1": 50,
        "price_1": 22.05,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 22.05,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 50,
        "price_3": 22.05,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 22.05,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 18.914,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 18.914,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 18.914,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 18.914,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 300,
        "price_9": 15.82,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 300,
        "price_10": 15.82,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 300,
        "price_11": 15.82,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 300,
        "price_12": 15.82,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 14.84,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 14.84,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 14.84,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 14.84,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 13.965,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 13.965,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 13.965,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 13.965,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_CORBATAPD20_PD36",
        "code": "CIFRA_CORBATAPD20_PD36",
        "name": "Corbata PD-20\/36",
        "technique_name": "Corbata PD-20\/36",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CORBATAPD20_PD36",
        "cifra_type": "Area",
        "cifra_source_id": "abb6a338-19ac-4e9b-a91e-fcbdfe5fea38",
        "section_1": 100,
        "price_1": 10.15,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 10.15,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 10.15,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 10.15,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 7.07,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 7.07,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 7.07,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 7.07,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 6.146,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 6.146,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 6.146,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 6.146,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 4.865,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 4.865,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 4.865,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 4.865,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "abb6a338-19ac-4e9b-a91e-fcbdfe5fea38",
        "code": "abb6a338-19ac-4e9b-a91e-fcbdfe5fea38",
        "name": "Corbata PD-20\/36",
        "technique_name": "Corbata PD-20\/36",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CORBATAPD20_PD36",
        "cifra_type": "Area",
        "cifra_source_id": "abb6a338-19ac-4e9b-a91e-fcbdfe5fea38",
        "section_1": 100,
        "price_1": 10.15,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 10.15,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 10.15,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 10.15,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 7.07,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 7.07,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 7.07,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 7.07,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 6.146,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 6.146,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 6.146,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 6.146,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 4.865,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 4.865,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 4.865,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 4.865,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_CPT",
        "code": "CIFRA_CPT",
        "name": "Grabación a todo color",
        "technique_name": "Grabación a todo color",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CPT",
        "cifra_type": "Area",
        "cifra_source_id": "70548178-cc30-4633-a1df-dc9cb7449319",
        "section_1": 300,
        "price_1": 1.582,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 1.582,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 1.582,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 1.582,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.134,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.134,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.134,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.134,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.728,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.728,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.728,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.728,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "70548178-cc30-4633-a1df-dc9cb7449319",
        "code": "70548178-cc30-4633-a1df-dc9cb7449319",
        "name": "Grabación a todo color",
        "technique_name": "Grabación a todo color",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CPT",
        "cifra_type": "Area",
        "cifra_source_id": "70548178-cc30-4633-a1df-dc9cb7449319",
        "section_1": 300,
        "price_1": 1.582,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 1.582,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 1.582,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 1.582,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.134,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.134,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.134,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.134,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.728,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.728,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.728,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.728,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_CPT_02",
        "code": "CIFRA_CPT_02",
        "name": "Grabación a todo color",
        "technique_name": "Grabación a todo color",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CPT_02",
        "cifra_type": "Area",
        "cifra_source_id": "1168af5b-28e5-4b9c-afca-34b2d544a907",
        "section_1": 300,
        "price_1": 1.722,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 1.722,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 1.722,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 1.722,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.169,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.169,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.169,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.169,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.868,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.868,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.868,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.868,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "1168af5b-28e5-4b9c-afca-34b2d544a907",
        "code": "1168af5b-28e5-4b9c-afca-34b2d544a907",
        "name": "Grabación a todo color",
        "technique_name": "Grabación a todo color",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CPT_02",
        "cifra_type": "Area",
        "cifra_source_id": "1168af5b-28e5-4b9c-afca-34b2d544a907",
        "section_1": 300,
        "price_1": 1.722,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 1.722,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 1.722,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 1.722,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.169,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.169,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.169,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.169,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.868,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.868,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.868,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.868,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_CUATRICROMIA",
        "code": "CIFRA_CUATRICROMIA",
        "name": "CUATRICROMIA",
        "technique_name": "CUATRICROMIA",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CUATRICROMIA",
        "cifra_type": "Area",
        "cifra_source_id": "95b6fde0-d62f-46bd-8c4b-09c316e622be"
    },
    {
        "technique_ref": "95b6fde0-d62f-46bd-8c4b-09c316e622be",
        "code": "95b6fde0-d62f-46bd-8c4b-09c316e622be",
        "name": "CUATRICROMIA",
        "technique_name": "CUATRICROMIA",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "CUATRICROMIA",
        "cifra_type": "Area",
        "cifra_source_id": "95b6fde0-d62f-46bd-8c4b-09c316e622be"
    },
    {
        "technique_ref": "CIFRA_D",
        "code": "CIFRA_D",
        "name": "Tampografía (D)",
        "technique_name": "Tampografía (D)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "cifra_code": "D",
        "cifra_type": "Colores",
        "cifra_source_id": "58c83680-f7a4-497d-90bd-b3cdc5e4fc96",
        "section_1": 1,
        "price_1": 0.364,
        "price_col_1": 0.308,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.364,
        "price_col_2": 0.308,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.364,
        "price_col_3": 0.308,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.364,
        "price_col_4": 0.308,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.294,
        "price_col_5": 0.154,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.294,
        "price_col_6": 0.154,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.294,
        "price_col_7": 0.154,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.294,
        "price_col_8": 0.154,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.252,
        "price_col_9": 0.14,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.252,
        "price_col_10": 0.14,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.252,
        "price_col_11": 0.14,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.252,
        "price_col_12": 0.14,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.21,
        "price_col_13": 0.126,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.21,
        "price_col_14": 0.126,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.21,
        "price_col_15": 0.126,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.21,
        "price_col_16": 0.126,
        "price_cm_16": 0
    },
    {
        "technique_ref": "58c83680-f7a4-497d-90bd-b3cdc5e4fc96",
        "code": "58c83680-f7a4-497d-90bd-b3cdc5e4fc96",
        "name": "Tampografía (D)",
        "technique_name": "Tampografía (D)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "cifra_code": "D",
        "cifra_type": "Colores",
        "cifra_source_id": "58c83680-f7a4-497d-90bd-b3cdc5e4fc96",
        "section_1": 1,
        "price_1": 0.364,
        "price_col_1": 0.308,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.364,
        "price_col_2": 0.308,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.364,
        "price_col_3": 0.308,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.364,
        "price_col_4": 0.308,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.294,
        "price_col_5": 0.154,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.294,
        "price_col_6": 0.154,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.294,
        "price_col_7": 0.154,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.294,
        "price_col_8": 0.154,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.252,
        "price_col_9": 0.14,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.252,
        "price_col_10": 0.14,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.252,
        "price_col_11": 0.14,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.252,
        "price_col_12": 0.14,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.21,
        "price_col_13": 0.126,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.21,
        "price_col_14": 0.126,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.21,
        "price_col_15": 0.126,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.21,
        "price_col_16": 0.126,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_DIGITAL",
        "code": "CIFRA_DIGITAL",
        "name": "Digital",
        "technique_name": "Digital",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL",
        "cifra_type": "Area",
        "cifra_source_id": "768bdb83-db97-465c-aae5-4596ed221b6b"
    },
    {
        "technique_ref": "768bdb83-db97-465c-aae5-4596ed221b6b",
        "code": "768bdb83-db97-465c-aae5-4596ed221b6b",
        "name": "Digital",
        "technique_name": "Digital",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL",
        "cifra_type": "Area",
        "cifra_source_id": "768bdb83-db97-465c-aae5-4596ed221b6b"
    },
    {
        "technique_ref": "CIFRA_DIGITAL_10",
        "code": "CIFRA_DIGITAL_10",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_10",
        "cifra_type": "Area",
        "cifra_source_id": "ba02d1df-a5cc-4568-9a4e-534d87663325",
        "section_1": 1,
        "price_1": 0.784,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.784,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.784,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.784,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.784,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.784,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.784,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.784,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.672,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.672,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.672,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.672,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.56,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.56,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.56,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.56,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.476,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.476,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.476,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.476,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 0.42,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 0.42,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 0.42,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 0.42,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.392,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.392,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.392,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.392,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.364,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.364,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.364,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.364,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "ba02d1df-a5cc-4568-9a4e-534d87663325",
        "code": "ba02d1df-a5cc-4568-9a4e-534d87663325",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_10",
        "cifra_type": "Area",
        "cifra_source_id": "ba02d1df-a5cc-4568-9a4e-534d87663325",
        "section_1": 1,
        "price_1": 0.784,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.784,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.784,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.784,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.784,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.784,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.784,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.784,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.672,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.672,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.672,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.672,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.56,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.56,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.56,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.56,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.476,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.476,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.476,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.476,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 0.42,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 0.42,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 0.42,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 0.42,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.392,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.392,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.392,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.392,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.364,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.364,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.364,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.364,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "CIFRA_DIGITAL_100",
        "code": "CIFRA_DIGITAL_100",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_100",
        "cifra_type": "Area",
        "cifra_source_id": "002c0263-b73a-43c2-ae21-02dfdc2b02af",
        "section_1": 1,
        "price_1": 1.204,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.204,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.204,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.204,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.204,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.204,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.204,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.204,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.924,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.924,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.924,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.924,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.84,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.84,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.84,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.84,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.798,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.798,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.798,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.798,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 0.728,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 0.728,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 0.728,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 0.728,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.63,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.63,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.63,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.63,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.49,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.49,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.49,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.49,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "002c0263-b73a-43c2-ae21-02dfdc2b02af",
        "code": "002c0263-b73a-43c2-ae21-02dfdc2b02af",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_100",
        "cifra_type": "Area",
        "cifra_source_id": "002c0263-b73a-43c2-ae21-02dfdc2b02af",
        "section_1": 1,
        "price_1": 1.204,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.204,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.204,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.204,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.204,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.204,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.204,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.204,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.924,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.924,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.924,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.924,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.84,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.84,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.84,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.84,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.798,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.798,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.798,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.798,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 0.728,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 0.728,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 0.728,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 0.728,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.63,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.63,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.63,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.63,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.49,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.49,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.49,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.49,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "CIFRA_DIGITAL_100CM_1",
        "code": "CIFRA_DIGITAL_100CM_1",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_100CM_1",
        "cifra_type": "Area",
        "cifra_source_id": "4a24211f-cbbf-4d39-960f-ef6524bb2811",
        "section_1": 1,
        "price_1": 2.408,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 2.408,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 2.408,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 2.408,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 2.408,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 2.408,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 2.408,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 2.408,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.848,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.848,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.848,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.848,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.68,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.68,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.68,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.68,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.596,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.596,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.596,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.596,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 1.456,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 1.456,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 1.456,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 1.456,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 1.26,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 1.26,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 1.26,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 1.26,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.98,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.98,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.98,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.98,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "4a24211f-cbbf-4d39-960f-ef6524bb2811",
        "code": "4a24211f-cbbf-4d39-960f-ef6524bb2811",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_100CM_1",
        "cifra_type": "Area",
        "cifra_source_id": "4a24211f-cbbf-4d39-960f-ef6524bb2811",
        "section_1": 1,
        "price_1": 2.408,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 2.408,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 2.408,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 2.408,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 2.408,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 2.408,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 2.408,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 2.408,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.848,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.848,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.848,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.848,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.68,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.68,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.68,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.68,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.596,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.596,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.596,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.596,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 1.456,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 1.456,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 1.456,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 1.456,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 1.26,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 1.26,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 1.26,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 1.26,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.98,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.98,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.98,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.98,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "CIFRA_DIGITAL_100CM_2",
        "code": "CIFRA_DIGITAL_100CM_2",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_100CM_2",
        "cifra_type": "Colores",
        "cifra_source_id": "bf858de9-03f2-45cd-8ce9-8b9bbbfe070d",
        "section_1": 1,
        "price_1": 1.848,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.848,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.848,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.848,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 1.54,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.54,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 1.54,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 1.54,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.484,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.484,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.484,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.484,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.316,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.316,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.316,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.316,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2500,
        "price_17": 1.148,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2500,
        "price_18": 1.148,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2500,
        "price_19": 1.148,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2500,
        "price_20": 1.148,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 1.064,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 1.064,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 1.064,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 1.064,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 10000,
        "price_25": 0.896,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 10000,
        "price_26": 0.896,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 10000,
        "price_27": 0.896,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 10000,
        "price_28": 0.896,
        "price_col_28": 0,
        "price_cm_28": 0
    },
    {
        "technique_ref": "bf858de9-03f2-45cd-8ce9-8b9bbbfe070d",
        "code": "bf858de9-03f2-45cd-8ce9-8b9bbbfe070d",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_100CM_2",
        "cifra_type": "Colores",
        "cifra_source_id": "bf858de9-03f2-45cd-8ce9-8b9bbbfe070d",
        "section_1": 1,
        "price_1": 1.848,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.848,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.848,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.848,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 1.54,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.54,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 1.54,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 1.54,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.484,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.484,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.484,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.484,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.316,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.316,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.316,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.316,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2500,
        "price_17": 1.148,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2500,
        "price_18": 1.148,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2500,
        "price_19": 1.148,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2500,
        "price_20": 1.148,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 1.064,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 1.064,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 1.064,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 1.064,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 10000,
        "price_25": 0.896,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 10000,
        "price_26": 0.896,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 10000,
        "price_27": 0.896,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 10000,
        "price_28": 0.896,
        "price_col_28": 0,
        "price_cm_28": 0
    },
    {
        "technique_ref": "CIFRA_DIGITAL_150",
        "code": "CIFRA_DIGITAL_150",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_150",
        "cifra_type": "Area",
        "cifra_source_id": "a07497cc-f458-4339-8dd0-e4dce52743bc",
        "section_1": 1,
        "price_1": 1.288,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.288,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.288,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.288,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.288,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.288,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.288,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.288,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.05,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.05,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.05,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.05,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.966,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.966,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.966,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.966,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.938,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.938,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.938,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.938,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 0.868,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 0.868,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 0.868,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 0.868,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.77,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.77,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.77,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.77,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.7,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.7,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.7,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.7,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "a07497cc-f458-4339-8dd0-e4dce52743bc",
        "code": "a07497cc-f458-4339-8dd0-e4dce52743bc",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_150",
        "cifra_type": "Area",
        "cifra_source_id": "a07497cc-f458-4339-8dd0-e4dce52743bc",
        "section_1": 1,
        "price_1": 1.288,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.288,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.288,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.288,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.288,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.288,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.288,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.288,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.05,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.05,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.05,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.05,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.966,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.966,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.966,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.966,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.938,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.938,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.938,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.938,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 0.868,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 0.868,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 0.868,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 0.868,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.77,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.77,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.77,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.77,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.7,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.7,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.7,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.7,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "CIFRA_DIGITAL_25",
        "code": "CIFRA_DIGITAL_25",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_25",
        "cifra_type": "Area",
        "cifra_source_id": "ce9a9708-b83a-4088-9a0f-9fb5cd1ea117",
        "section_1": 1,
        "price_1": 0.868,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.868,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.868,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.868,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.868,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.868,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.868,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.868,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.756,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.756,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.756,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.756,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.63,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.63,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.63,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.63,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.532,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.532,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.532,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.532,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 0.518,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 0.518,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 0.518,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 0.518,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.49,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.49,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.49,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.49,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.42,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.42,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.42,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.42,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "ce9a9708-b83a-4088-9a0f-9fb5cd1ea117",
        "code": "ce9a9708-b83a-4088-9a0f-9fb5cd1ea117",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_25",
        "cifra_type": "Area",
        "cifra_source_id": "ce9a9708-b83a-4088-9a0f-9fb5cd1ea117",
        "section_1": 1,
        "price_1": 0.868,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.868,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.868,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.868,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.868,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.868,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.868,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.868,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.756,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.756,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.756,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.756,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.63,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.63,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.63,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.63,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.532,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.532,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.532,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.532,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 0.518,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 0.518,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 0.518,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 0.518,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.49,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.49,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.49,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.49,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.42,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.42,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.42,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.42,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "CIFRA_DIGITAL_250",
        "code": "CIFRA_DIGITAL_250",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_250",
        "cifra_type": "Area",
        "cifra_source_id": "bddaaa2b-38d8-482f-a78c-c46f1ad3b285",
        "section_1": 1,
        "price_1": 1.442,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.442,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.442,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.442,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.442,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.442,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.442,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.442,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.288,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.288,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.288,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.288,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.994,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.994,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.994,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.994,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.952,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.952,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.952,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.952,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 0.896,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 0.896,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 0.896,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 0.896,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.798,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.798,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.798,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.798,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.728,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.728,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.728,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.728,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "bddaaa2b-38d8-482f-a78c-c46f1ad3b285",
        "code": "bddaaa2b-38d8-482f-a78c-c46f1ad3b285",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_250",
        "cifra_type": "Area",
        "cifra_source_id": "bddaaa2b-38d8-482f-a78c-c46f1ad3b285",
        "section_1": 1,
        "price_1": 1.442,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.442,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.442,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.442,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.442,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.442,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.442,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.442,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.288,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.288,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.288,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.288,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.994,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.994,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.994,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.994,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.952,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.952,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.952,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.952,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 0.896,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 0.896,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 0.896,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 0.896,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.798,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.798,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.798,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.798,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.728,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.728,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.728,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.728,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "CIFRA_DIGITAL_300",
        "code": "CIFRA_DIGITAL_300",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_300",
        "cifra_type": "Area",
        "cifra_source_id": "f6ab2a6b-13f9-473b-8e60-6df1d2fa5b1b",
        "section_1": 1,
        "price_1": 1.666,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.666,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.666,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.666,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.666,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.666,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.666,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.666,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.316,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.316,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.316,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.316,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.232,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.232,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.232,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.232,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.204,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.204,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.204,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.204,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 1.134,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 1.134,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 1.134,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 1.134,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 1.008,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 1.008,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 1.008,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 1.008,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.952,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.952,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.952,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.952,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "f6ab2a6b-13f9-473b-8e60-6df1d2fa5b1b",
        "code": "f6ab2a6b-13f9-473b-8e60-6df1d2fa5b1b",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_300",
        "cifra_type": "Area",
        "cifra_source_id": "f6ab2a6b-13f9-473b-8e60-6df1d2fa5b1b",
        "section_1": 1,
        "price_1": 1.666,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.666,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.666,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.666,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.666,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.666,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.666,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.666,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.316,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.316,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.316,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.316,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.232,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.232,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.232,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.232,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.204,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.204,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.204,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.204,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 1.134,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 1.134,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 1.134,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 1.134,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 1.008,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 1.008,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 1.008,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 1.008,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.952,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.952,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.952,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.952,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "CIFRA_DIGITAL_5",
        "code": "CIFRA_DIGITAL_5",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_5",
        "cifra_type": "Area",
        "cifra_source_id": "4bbb92ab-e880-436d-8bb9-02bdc9375ebd",
        "section_1": 1,
        "price_1": 0.742,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.742,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.742,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.742,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.742,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.742,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.742,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.742,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.63,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.63,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.63,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.63,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.504,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.504,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.504,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.504,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.42,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.42,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.42,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.42,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 0.364,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 0.364,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 0.364,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 0.364,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.322,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.322,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.322,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.322,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.308,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.308,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.308,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.308,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "4bbb92ab-e880-436d-8bb9-02bdc9375ebd",
        "code": "4bbb92ab-e880-436d-8bb9-02bdc9375ebd",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_5",
        "cifra_type": "Area",
        "cifra_source_id": "4bbb92ab-e880-436d-8bb9-02bdc9375ebd",
        "section_1": 1,
        "price_1": 0.742,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.742,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.742,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.742,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.742,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.742,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.742,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.742,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.63,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.63,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.63,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.63,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.504,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.504,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.504,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.504,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.42,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.42,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.42,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.42,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 0.364,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 0.364,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 0.364,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 0.364,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.322,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.322,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.322,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.322,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.308,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.308,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.308,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.308,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "CIFRA_DIGITAL_50",
        "code": "CIFRA_DIGITAL_50",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_50",
        "cifra_type": "Area",
        "cifra_source_id": "bfd9a9d3-d7b2-4940-bfaf-9717f33c6cb4",
        "section_1": 1,
        "price_1": 0.952,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.952,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.952,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.952,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.952,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.952,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.952,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.952,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.812,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.812,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.812,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.812,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.756,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.756,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.756,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.756,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.728,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.728,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.728,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.728,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 0.658,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 0.658,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 0.658,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 0.658,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.56,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.56,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.56,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.56,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.42,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.42,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.42,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.42,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "bfd9a9d3-d7b2-4940-bfaf-9717f33c6cb4",
        "code": "bfd9a9d3-d7b2-4940-bfaf-9717f33c6cb4",
        "name": "Full color",
        "technique_name": "Full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null,
        "cifra_code": "DIGITAL_50",
        "cifra_type": "Area",
        "cifra_source_id": "bfd9a9d3-d7b2-4940-bfaf-9717f33c6cb4",
        "section_1": 1,
        "price_1": 0.952,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.952,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.952,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.952,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.952,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.952,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.952,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.952,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.812,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.812,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.812,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.812,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.756,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.756,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.756,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.756,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.728,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.728,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.728,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.728,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2500,
        "price_21": 0.658,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2500,
        "price_22": 0.658,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2500,
        "price_23": 0.658,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2500,
        "price_24": 0.658,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.56,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.56,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.56,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.56,
        "price_col_28": 0,
        "price_cm_28": 0,
        "section_29": 10000,
        "price_29": 0.42,
        "price_col_29": 0,
        "price_cm_29": 0,
        "section_30": 10000,
        "price_30": 0.42,
        "price_col_30": 0,
        "price_cm_30": 0,
        "section_31": 10000,
        "price_31": 0.42,
        "price_col_31": 0,
        "price_cm_31": 0,
        "section_32": 10000,
        "price_32": 0.42,
        "price_col_32": 0,
        "price_cm_32": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY",
        "code": "CIFRA_DISPLAY",
        "name": "Display",
        "technique_name": "Display",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY",
        "cifra_type": "Area",
        "cifra_source_id": "89801ea2-44fc-4fee-8150-06fd001dbb50"
    },
    {
        "technique_ref": "89801ea2-44fc-4fee-8150-06fd001dbb50",
        "code": "89801ea2-44fc-4fee-8150-06fd001dbb50",
        "name": "Display",
        "technique_name": "Display",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY",
        "cifra_type": "Area",
        "cifra_source_id": "89801ea2-44fc-4fee-8150-06fd001dbb50"
    },
    {
        "technique_ref": "CIFRA_DISPLAY_BANDERA",
        "code": "CIFRA_DISPLAY_BANDERA",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_BANDERA",
        "cifra_type": "Area",
        "cifra_source_id": "3e59eb92-811a-4f38-9292-5b8514a83486",
        "section_1": 0,
        "price_1": 91,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 91,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 91,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 91,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "3e59eb92-811a-4f38-9292-5b8514a83486",
        "code": "3e59eb92-811a-4f38-9292-5b8514a83486",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_BANDERA",
        "cifra_type": "Area",
        "cifra_source_id": "3e59eb92-811a-4f38-9292-5b8514a83486",
        "section_1": 0,
        "price_1": 91,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 91,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 91,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 91,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_BANDERA2",
        "code": "CIFRA_DISPLAY_BANDERA2",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_BANDERA2",
        "cifra_type": "Area",
        "cifra_source_id": "4d7c7f5e-feee-4d8f-8526-2b4457e0ea7d",
        "section_1": 0,
        "price_1": 126,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 126,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 126,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 126,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "4d7c7f5e-feee-4d8f-8526-2b4457e0ea7d",
        "code": "4d7c7f5e-feee-4d8f-8526-2b4457e0ea7d",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_BANDERA2",
        "cifra_type": "Area",
        "cifra_source_id": "4d7c7f5e-feee-4d8f-8526-2b4457e0ea7d",
        "section_1": 0,
        "price_1": 126,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 126,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 126,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 126,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_113",
        "code": "CIFRA_DISPLAY_H_113",
        "name": "Impresión en textil",
        "technique_name": "Impresión en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_113",
        "cifra_type": "Area",
        "cifra_source_id": "386200e5-4304-4690-8eeb-f81348a8efb9",
        "section_1": 1,
        "price_1": 434,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 434,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 434,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 434,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "386200e5-4304-4690-8eeb-f81348a8efb9",
        "code": "386200e5-4304-4690-8eeb-f81348a8efb9",
        "name": "Impresión en textil",
        "technique_name": "Impresión en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_113",
        "cifra_type": "Area",
        "cifra_source_id": "386200e5-4304-4690-8eeb-f81348a8efb9",
        "section_1": 1,
        "price_1": 434,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 434,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 434,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 434,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_113_1",
        "code": "CIFRA_DISPLAY_H_113_1",
        "name": "Impresión en textil",
        "technique_name": "Impresión en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_113_1",
        "cifra_type": "Area",
        "cifra_source_id": "93eed34a-b67a-4abb-93ec-8d49f36f3def",
        "section_1": 1,
        "price_1": 469,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 469,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 469,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 469,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "93eed34a-b67a-4abb-93ec-8d49f36f3def",
        "code": "93eed34a-b67a-4abb-93ec-8d49f36f3def",
        "name": "Impresión en textil",
        "technique_name": "Impresión en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_113_1",
        "cifra_type": "Area",
        "cifra_source_id": "93eed34a-b67a-4abb-93ec-8d49f36f3def",
        "section_1": 1,
        "price_1": 469,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 469,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 469,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 469,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_120",
        "code": "CIFRA_DISPLAY_H_120",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_120",
        "cifra_type": "Area",
        "cifra_source_id": "f598918a-cf83-4089-9ce9-38695b6006af",
        "section_1": 1,
        "price_1": 39.2,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 39.2,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 39.2,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 39.2,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "f598918a-cf83-4089-9ce9-38695b6006af",
        "code": "f598918a-cf83-4089-9ce9-38695b6006af",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_120",
        "cifra_type": "Area",
        "cifra_source_id": "f598918a-cf83-4089-9ce9-38695b6006af",
        "section_1": 1,
        "price_1": 39.2,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 39.2,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 39.2,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 39.2,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_121",
        "code": "CIFRA_DISPLAY_H_121",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_121",
        "cifra_type": "Area",
        "cifra_source_id": "4f206fc6-5f4d-4bc6-a4e5-173be1ad4a97",
        "section_1": 1,
        "price_1": 35,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 35,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 35,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 35,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "4f206fc6-5f4d-4bc6-a4e5-173be1ad4a97",
        "code": "4f206fc6-5f4d-4bc6-a4e5-173be1ad4a97",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_121",
        "cifra_type": "Area",
        "cifra_source_id": "4f206fc6-5f4d-4bc6-a4e5-173be1ad4a97",
        "section_1": 1,
        "price_1": 35,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 35,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 35,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 35,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_122",
        "code": "CIFRA_DISPLAY_H_122",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_122",
        "cifra_type": "Area",
        "cifra_source_id": "495ebca6-c1bb-47c9-9ef6-76e7fe3ca02e",
        "section_1": 1,
        "price_1": 16.8,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 16.8,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 16.8,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 16.8,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "495ebca6-c1bb-47c9-9ef6-76e7fe3ca02e",
        "code": "495ebca6-c1bb-47c9-9ef6-76e7fe3ca02e",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_122",
        "cifra_type": "Area",
        "cifra_source_id": "495ebca6-c1bb-47c9-9ef6-76e7fe3ca02e",
        "section_1": 1,
        "price_1": 16.8,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 16.8,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 16.8,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 16.8,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_130",
        "code": "CIFRA_DISPLAY_H_130",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_130",
        "cifra_type": "Area",
        "cifra_source_id": "7db230d3-7704-4a73-a0fd-070b77f01e7f",
        "section_1": 0,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5,
        "price_5": 11.9,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5,
        "price_6": 11.9,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 5,
        "price_7": 11.9,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5,
        "price_8": 11.9,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "7db230d3-7704-4a73-a0fd-070b77f01e7f",
        "code": "7db230d3-7704-4a73-a0fd-070b77f01e7f",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_130",
        "cifra_type": "Area",
        "cifra_source_id": "7db230d3-7704-4a73-a0fd-070b77f01e7f",
        "section_1": 0,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 0,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 0,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 0,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 5,
        "price_5": 11.9,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5,
        "price_6": 11.9,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 5,
        "price_7": 11.9,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5,
        "price_8": 11.9,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_131",
        "code": "CIFRA_DISPLAY_H_131",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_131",
        "cifra_type": "Area",
        "cifra_source_id": "a58f61c7-5a43-4291-83e1-ac96b7879522",
        "section_1": 5,
        "price_1": 13.3,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 5,
        "price_2": 13.3,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 5,
        "price_3": 13.3,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5,
        "price_4": 13.3,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "a58f61c7-5a43-4291-83e1-ac96b7879522",
        "code": "a58f61c7-5a43-4291-83e1-ac96b7879522",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_131",
        "cifra_type": "Area",
        "cifra_source_id": "a58f61c7-5a43-4291-83e1-ac96b7879522",
        "section_1": 5,
        "price_1": 13.3,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 5,
        "price_2": 13.3,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 5,
        "price_3": 13.3,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5,
        "price_4": 13.3,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_132",
        "code": "CIFRA_DISPLAY_H_132",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_132",
        "cifra_type": "Area",
        "cifra_source_id": "dad70a15-f4ab-4d7d-a3ef-8c8fb1a1879a",
        "section_1": 5,
        "price_1": 16.31,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 5,
        "price_2": 16.31,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 5,
        "price_3": 16.31,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5,
        "price_4": 16.31,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "dad70a15-f4ab-4d7d-a3ef-8c8fb1a1879a",
        "code": "dad70a15-f4ab-4d7d-a3ef-8c8fb1a1879a",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_132",
        "cifra_type": "Area",
        "cifra_source_id": "dad70a15-f4ab-4d7d-a3ef-8c8fb1a1879a",
        "section_1": 5,
        "price_1": 16.31,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 5,
        "price_2": 16.31,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 5,
        "price_3": 16.31,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5,
        "price_4": 16.31,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_133",
        "code": "CIFRA_DISPLAY_H_133",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_133",
        "cifra_type": "Area",
        "cifra_source_id": "a6f99646-8c98-4407-a16a-797e49ca5f13",
        "section_1": 5,
        "price_1": 16.8,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 5,
        "price_2": 16.8,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 5,
        "price_3": 16.8,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5,
        "price_4": 16.8,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "a6f99646-8c98-4407-a16a-797e49ca5f13",
        "code": "a6f99646-8c98-4407-a16a-797e49ca5f13",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_133",
        "cifra_type": "Area",
        "cifra_source_id": "a6f99646-8c98-4407-a16a-797e49ca5f13",
        "section_1": 5,
        "price_1": 16.8,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 5,
        "price_2": 16.8,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 5,
        "price_3": 16.8,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5,
        "price_4": 16.8,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_134",
        "code": "CIFRA_DISPLAY_H_134",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_134",
        "cifra_type": "Area",
        "cifra_source_id": "81d3016c-0782-4f8e-948f-9b74044fe091",
        "section_1": 5,
        "price_1": 20.3,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 5,
        "price_2": 20.3,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 5,
        "price_3": 20.3,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5,
        "price_4": 20.3,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "81d3016c-0782-4f8e-948f-9b74044fe091",
        "code": "81d3016c-0782-4f8e-948f-9b74044fe091",
        "name": "Impresión papel muppy",
        "technique_name": "Impresión papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_134",
        "cifra_type": "Area",
        "cifra_source_id": "81d3016c-0782-4f8e-948f-9b74044fe091",
        "section_1": 5,
        "price_1": 20.3,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 5,
        "price_2": 20.3,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 5,
        "price_3": 20.3,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5,
        "price_4": 20.3,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_192",
        "code": "CIFRA_DISPLAY_H_192",
        "name": "Impresión a todo color en textil",
        "technique_name": "Impresión a todo color en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_192",
        "cifra_type": "Area",
        "cifra_source_id": "14eaa62c-7bba-478b-8f26-5f5ad06e3b17",
        "section_1": 1,
        "price_1": 336,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 336,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 336,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 336,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "14eaa62c-7bba-478b-8f26-5f5ad06e3b17",
        "code": "14eaa62c-7bba-478b-8f26-5f5ad06e3b17",
        "name": "Impresión a todo color en textil",
        "technique_name": "Impresión a todo color en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_192",
        "cifra_type": "Area",
        "cifra_source_id": "14eaa62c-7bba-478b-8f26-5f5ad06e3b17",
        "section_1": 1,
        "price_1": 336,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 336,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 336,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 336,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_218",
        "code": "CIFRA_DISPLAY_H_218",
        "name": "Impresión en textil",
        "technique_name": "Impresión en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_218",
        "cifra_type": "Area",
        "cifra_source_id": "89dda24d-e08a-451e-8957-ca522be9576f",
        "section_1": 1,
        "price_1": 260.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 260.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 260.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 260.4,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "89dda24d-e08a-451e-8957-ca522be9576f",
        "code": "89dda24d-e08a-451e-8957-ca522be9576f",
        "name": "Impresión en textil",
        "technique_name": "Impresión en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_218",
        "cifra_type": "Area",
        "cifra_source_id": "89dda24d-e08a-451e-8957-ca522be9576f",
        "section_1": 1,
        "price_1": 260.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 260.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 260.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 260.4,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_218_1",
        "code": "CIFRA_DISPLAY_H_218_1",
        "name": "Impresión en textil",
        "technique_name": "Impresión en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_218_1",
        "cifra_type": "Area",
        "cifra_source_id": "87c9399b-fe1e-45d1-9786-41a65c4c21df",
        "section_1": 1,
        "price_1": 357,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 357,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 357,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 357,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "87c9399b-fe1e-45d1-9786-41a65c4c21df",
        "code": "87c9399b-fe1e-45d1-9786-41a65c4c21df",
        "name": "Impresión en textil",
        "technique_name": "Impresión en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_218_1",
        "cifra_type": "Area",
        "cifra_source_id": "87c9399b-fe1e-45d1-9786-41a65c4c21df",
        "section_1": 1,
        "price_1": 357,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 357,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 357,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 357,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_219",
        "code": "CIFRA_DISPLAY_H_219",
        "name": "Impresión en textil",
        "technique_name": "Impresión en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_219",
        "cifra_type": "Area",
        "cifra_source_id": "31f854e2-d4e7-4721-a2a1-e352d780bf86",
        "section_1": 1,
        "price_1": 357,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 357,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 357,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 357,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "31f854e2-d4e7-4721-a2a1-e352d780bf86",
        "code": "31f854e2-d4e7-4721-a2a1-e352d780bf86",
        "name": "Impresión en textil",
        "technique_name": "Impresión en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_219",
        "cifra_type": "Area",
        "cifra_source_id": "31f854e2-d4e7-4721-a2a1-e352d780bf86",
        "section_1": 1,
        "price_1": 357,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 357,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 357,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 357,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_219_1",
        "code": "CIFRA_DISPLAY_H_219_1",
        "name": "Impresión en textil",
        "technique_name": "Impresión en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_219_1",
        "cifra_type": "Area",
        "cifra_source_id": "0f1eb38d-3e92-4567-84b1-b9f805987137",
        "section_1": 1,
        "price_1": 428.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 428.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 428.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 428.4,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "0f1eb38d-3e92-4567-84b1-b9f805987137",
        "code": "0f1eb38d-3e92-4567-84b1-b9f805987137",
        "name": "Impresión en textil",
        "technique_name": "Impresión en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_219_1",
        "cifra_type": "Area",
        "cifra_source_id": "0f1eb38d-3e92-4567-84b1-b9f805987137",
        "section_1": 1,
        "price_1": 428.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 428.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 428.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 428.4,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_240",
        "code": "CIFRA_DISPLAY_H_240",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_240",
        "cifra_type": "Area",
        "cifra_source_id": "28a5e322-ca31-4a1f-b621-d8ab6f212565",
        "section_1": 1,
        "price_1": 68.6,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 68.6,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 68.6,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 68.6,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "28a5e322-ca31-4a1f-b621-d8ab6f212565",
        "code": "28a5e322-ca31-4a1f-b621-d8ab6f212565",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_240",
        "cifra_type": "Area",
        "cifra_source_id": "28a5e322-ca31-4a1f-b621-d8ab6f212565",
        "section_1": 1,
        "price_1": 68.6,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 68.6,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 68.6,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 68.6,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_245",
        "code": "CIFRA_DISPLAY_H_245",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_245",
        "cifra_type": "Area",
        "cifra_source_id": "42d13842-4090-4c81-8726-0ec59560fc23",
        "section_1": 1,
        "price_1": 72.8,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 72.8,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 72.8,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 72.8,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "42d13842-4090-4c81-8726-0ec59560fc23",
        "code": "42d13842-4090-4c81-8726-0ec59560fc23",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_245",
        "cifra_type": "Area",
        "cifra_source_id": "42d13842-4090-4c81-8726-0ec59560fc23",
        "section_1": 1,
        "price_1": 72.8,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 72.8,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 72.8,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 72.8,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_268",
        "code": "CIFRA_DISPLAY_H_268",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_268",
        "cifra_type": "Colores",
        "cifra_source_id": "a4afaebc-9733-4e6c-b6d1-62fc8aa43698",
        "section_1": 1,
        "price_1": 30.8,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 30.8,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 30.8,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 30.8,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 30.8,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 30.8,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 30.8,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 30.8,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 30.8,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 30.8,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 30.8,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 30.8,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 30.8,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 30.8,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 30.8,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 30.8,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "a4afaebc-9733-4e6c-b6d1-62fc8aa43698",
        "code": "a4afaebc-9733-4e6c-b6d1-62fc8aa43698",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_268",
        "cifra_type": "Colores",
        "cifra_source_id": "a4afaebc-9733-4e6c-b6d1-62fc8aa43698",
        "section_1": 1,
        "price_1": 30.8,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 30.8,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 30.8,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 30.8,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 30.8,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 30.8,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 30.8,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 30.8,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 30.8,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 30.8,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 30.8,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 30.8,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 30.8,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 30.8,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 30.8,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 30.8,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_269",
        "code": "CIFRA_DISPLAY_H_269",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_269",
        "cifra_type": "Area",
        "cifra_source_id": "becb6658-4448-4d80-9fe3-69cce28b46f2",
        "section_1": 1,
        "price_1": 78.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 78.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 78.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 78.4,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "becb6658-4448-4d80-9fe3-69cce28b46f2",
        "code": "becb6658-4448-4d80-9fe3-69cce28b46f2",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_269",
        "cifra_type": "Area",
        "cifra_source_id": "becb6658-4448-4d80-9fe3-69cce28b46f2",
        "section_1": 1,
        "price_1": 78.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 78.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 78.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 78.4,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_303",
        "code": "CIFRA_DISPLAY_H_303",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_303",
        "cifra_type": "Area",
        "cifra_source_id": "f6a9b3bc-c3ea-4eee-b7fa-d5a026cdecb4",
        "section_1": 1,
        "price_1": 106.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 106.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 106.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 106.4,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "f6a9b3bc-c3ea-4eee-b7fa-d5a026cdecb4",
        "code": "f6a9b3bc-c3ea-4eee-b7fa-d5a026cdecb4",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_303",
        "cifra_type": "Area",
        "cifra_source_id": "f6a9b3bc-c3ea-4eee-b7fa-d5a026cdecb4",
        "section_1": 1,
        "price_1": 106.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 106.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 106.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 106.4,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_304",
        "code": "CIFRA_DISPLAY_H_304",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_304",
        "cifra_type": "Area",
        "cifra_source_id": "5b2f8609-5167-4a04-b23b-5445ec10a7a3",
        "section_1": 1,
        "price_1": 168,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 168,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 168,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 168,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "5b2f8609-5167-4a04-b23b-5445ec10a7a3",
        "code": "5b2f8609-5167-4a04-b23b-5445ec10a7a3",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_304",
        "cifra_type": "Area",
        "cifra_source_id": "5b2f8609-5167-4a04-b23b-5445ec10a7a3",
        "section_1": 1,
        "price_1": 168,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 168,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 168,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 168,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_305",
        "code": "CIFRA_DISPLAY_H_305",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_305",
        "cifra_type": "Area",
        "cifra_source_id": "c97e4e7f-690a-451e-a6ee-2d40d398fab0",
        "section_1": 1,
        "price_1": 238,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 238,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 238,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 238,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "c97e4e7f-690a-451e-a6ee-2d40d398fab0",
        "code": "c97e4e7f-690a-451e-a6ee-2d40d398fab0",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_305",
        "cifra_type": "Area",
        "cifra_source_id": "c97e4e7f-690a-451e-a6ee-2d40d398fab0",
        "section_1": 1,
        "price_1": 238,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 238,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 238,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 238,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_H_306",
        "code": "CIFRA_DISPLAY_H_306",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_306",
        "cifra_type": "Area",
        "cifra_source_id": "2b3e9247-eb0f-47d2-87b3-9634322126dc",
        "section_1": 1,
        "price_1": 336,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 336,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 336,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 336,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "2b3e9247-eb0f-47d2-87b3-9634322126dc",
        "code": "2b3e9247-eb0f-47d2-87b3-9634322126dc",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_H_306",
        "cifra_type": "Area",
        "cifra_source_id": "2b3e9247-eb0f-47d2-87b3-9634322126dc",
        "section_1": 1,
        "price_1": 336,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 336,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 336,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 336,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_LONA",
        "code": "CIFRA_DISPLAY_LONA",
        "name": "Impresión en lona",
        "technique_name": "Impresión en lona",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_LONA",
        "cifra_type": "Area",
        "cifra_source_id": "14645cc0-26a8-4744-af19-dff96f8f2e31",
        "section_1": 1,
        "price_1": 30.8,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 30.8,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 30.8,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 30.8,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "14645cc0-26a8-4744-af19-dff96f8f2e31",
        "code": "14645cc0-26a8-4744-af19-dff96f8f2e31",
        "name": "Impresión en lona",
        "technique_name": "Impresión en lona",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_LONA",
        "cifra_type": "Area",
        "cifra_source_id": "14645cc0-26a8-4744-af19-dff96f8f2e31",
        "section_1": 1,
        "price_1": 30.8,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 30.8,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 30.8,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 30.8,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_LONA_DBL",
        "code": "CIFRA_DISPLAY_LONA_DBL",
        "name": "Impresión en lona doble",
        "technique_name": "Impresión en lona doble",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_LONA_DBL",
        "cifra_type": "Area",
        "cifra_source_id": "f2dbbb84-c037-4de0-a539-654011e3cf03",
        "section_1": 1,
        "price_1": 75.6,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 75.6,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 75.6,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 75.6,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "f2dbbb84-c037-4de0-a539-654011e3cf03",
        "code": "f2dbbb84-c037-4de0-a539-654011e3cf03",
        "name": "Impresión en lona doble",
        "technique_name": "Impresión en lona doble",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_LONA_DBL",
        "cifra_type": "Area",
        "cifra_source_id": "f2dbbb84-c037-4de0-a539-654011e3cf03",
        "section_1": 1,
        "price_1": 75.6,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 75.6,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 75.6,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 75.6,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_MARCO",
        "code": "CIFRA_DISPLAY_MARCO",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_MARCO",
        "cifra_type": "Area",
        "cifra_source_id": "8048cec6-0e89-4efd-83e3-3f242711b84d",
        "section_1": 1,
        "price_1": 56,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 56,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 56,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 56,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "8048cec6-0e89-4efd-83e3-3f242711b84d",
        "code": "8048cec6-0e89-4efd-83e3-3f242711b84d",
        "name": "Impresión poliéster",
        "technique_name": "Impresión poliéster",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_MARCO",
        "cifra_type": "Area",
        "cifra_source_id": "8048cec6-0e89-4efd-83e3-3f242711b84d",
        "section_1": 1,
        "price_1": 56,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 56,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 56,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 56,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_MUPPY",
        "code": "CIFRA_DISPLAY_MUPPY",
        "name": "Impresión en papel muppy",
        "technique_name": "Impresión en papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_MUPPY",
        "cifra_type": "Area",
        "cifra_source_id": "2484c050-bdcc-4de8-8a02-f83708305e57",
        "section_1": 1,
        "price_1": 11.9,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 11.9,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 11.9,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 11.9,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "2484c050-bdcc-4de8-8a02-f83708305e57",
        "code": "2484c050-bdcc-4de8-8a02-f83708305e57",
        "name": "Impresión en papel muppy",
        "technique_name": "Impresión en papel muppy",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_MUPPY",
        "cifra_type": "Area",
        "cifra_source_id": "2484c050-bdcc-4de8-8a02-f83708305e57",
        "section_1": 1,
        "price_1": 11.9,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 11.9,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 11.9,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 11.9,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_MUPPY_DBL",
        "code": "CIFRA_DISPLAY_MUPPY_DBL",
        "name": "Impresión en papel muppy doble",
        "technique_name": "Impresión en papel muppy doble",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_MUPPY_DBL",
        "cifra_type": "Area",
        "cifra_source_id": "1186ec8c-fd4e-4a35-b5c8-6862088ce0ab",
        "section_1": 1,
        "price_1": 42,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 42,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 42,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 42,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "1186ec8c-fd4e-4a35-b5c8-6862088ce0ab",
        "code": "1186ec8c-fd4e-4a35-b5c8-6862088ce0ab",
        "name": "Impresión en papel muppy doble",
        "technique_name": "Impresión en papel muppy doble",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_MUPPY_DBL",
        "cifra_type": "Area",
        "cifra_source_id": "1186ec8c-fd4e-4a35-b5c8-6862088ce0ab",
        "section_1": 1,
        "price_1": 42,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 42,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 42,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 42,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_POLIPROP",
        "code": "CIFRA_DISPLAY_POLIPROP",
        "name": "Impresión en polipropileno",
        "technique_name": "Impresión en polipropileno",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_POLIPROP",
        "cifra_type": "Area",
        "cifra_source_id": "86d1ae4e-206b-4dec-b54e-535feb063f24",
        "section_1": 1,
        "price_1": 31.5,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 31.5,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 31.5,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 31.5,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "86d1ae4e-206b-4dec-b54e-535feb063f24",
        "code": "86d1ae4e-206b-4dec-b54e-535feb063f24",
        "name": "Impresión en polipropileno",
        "technique_name": "Impresión en polipropileno",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_POLIPROP",
        "cifra_type": "Area",
        "cifra_source_id": "86d1ae4e-206b-4dec-b54e-535feb063f24",
        "section_1": 1,
        "price_1": 31.5,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 31.5,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 31.5,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 31.5,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_POLIPROP_DBL",
        "code": "CIFRA_DISPLAY_POLIPROP_DBL",
        "name": "Impresión en polipropileno doble",
        "technique_name": "Impresión en polipropileno doble",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_POLIPROP_DBL",
        "cifra_type": "Area",
        "cifra_source_id": "73bd9d3d-3dfe-406a-9ec0-bc6fa99931c9",
        "section_1": 1,
        "price_1": 84,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 84,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 84,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 84,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "73bd9d3d-3dfe-406a-9ec0-bc6fa99931c9",
        "code": "73bd9d3d-3dfe-406a-9ec0-bc6fa99931c9",
        "name": "Impresión en polipropileno doble",
        "technique_name": "Impresión en polipropileno doble",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_POLIPROP_DBL",
        "cifra_type": "Area",
        "cifra_source_id": "73bd9d3d-3dfe-406a-9ec0-bc6fa99931c9",
        "section_1": 1,
        "price_1": 84,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 84,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 84,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 84,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_TEXTIL",
        "code": "CIFRA_DISPLAY_TEXTIL",
        "name": "Impresión en textil",
        "technique_name": "Impresión en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_TEXTIL",
        "cifra_type": "Area",
        "cifra_source_id": "c0a6da02-83b7-4492-a486-1b2adfe89d4a",
        "section_1": 1,
        "price_1": 260.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 260.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 260.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 260.4,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "c0a6da02-83b7-4492-a486-1b2adfe89d4a",
        "code": "c0a6da02-83b7-4492-a486-1b2adfe89d4a",
        "name": "Impresión en textil",
        "technique_name": "Impresión en textil",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_TEXTIL",
        "cifra_type": "Area",
        "cifra_source_id": "c0a6da02-83b7-4492-a486-1b2adfe89d4a",
        "section_1": 1,
        "price_1": 260.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 260.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 260.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 260.4,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_VINILO",
        "code": "CIFRA_DISPLAY_VINILO",
        "name": "Impresión en vinilo",
        "technique_name": "Impresión en vinilo",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_VINILO",
        "cifra_type": "Area",
        "cifra_source_id": "e93102bf-52f6-4bc1-9728-d5e9a22ef309",
        "section_1": 1,
        "price_1": 4.9,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 4.9,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 4.9,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 4.9,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "e93102bf-52f6-4bc1-9728-d5e9a22ef309",
        "code": "e93102bf-52f6-4bc1-9728-d5e9a22ef309",
        "name": "Impresión en vinilo",
        "technique_name": "Impresión en vinilo",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_VINILO",
        "cifra_type": "Area",
        "cifra_source_id": "e93102bf-52f6-4bc1-9728-d5e9a22ef309",
        "section_1": 1,
        "price_1": 4.9,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 4.9,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 4.9,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 4.9,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DISPLAY_VINILO_H138",
        "code": "CIFRA_DISPLAY_VINILO_H138",
        "name": "Impresión en vinilo H-138",
        "technique_name": "Impresión en vinilo H-138",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_VINILO_H138",
        "cifra_type": "Area",
        "cifra_source_id": "925ea7c3-82a7-439f-8164-6b6f953c34e5",
        "section_1": 1,
        "price_1": 84,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 84,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 84,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 84,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "925ea7c3-82a7-439f-8164-6b6f953c34e5",
        "code": "925ea7c3-82a7-439f-8164-6b6f953c34e5",
        "name": "Impresión en vinilo H-138",
        "technique_name": "Impresión en vinilo H-138",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DISPLAY_VINILO_H138",
        "cifra_type": "Area",
        "cifra_source_id": "925ea7c3-82a7-439f-8164-6b6f953c34e5",
        "section_1": 1,
        "price_1": 84,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 84,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 84,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 84,
        "price_col_4": 0,
        "price_cm_4": 0
    },
    {
        "technique_ref": "CIFRA_DOMING",
        "code": "CIFRA_DOMING",
        "name": "Grabación gota de resina",
        "technique_name": "Grabación gota de resina",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 70,
        "min_unit": null,
        "cifra_code": "DOMING",
        "cifra_type": "Area",
        "cifra_source_id": "d5e8a783-a1a2-4b2f-b05f-11cd2664f15d",
        "section_1": 1,
        "price_1": 0.658,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.658,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.658,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.658,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 0.602,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0.602,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 0.602,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 0.602,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 0.56,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 0.56,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 0.56,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 0.56,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.518,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.518,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.518,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.518,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2500,
        "price_17": 0.476,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2500,
        "price_18": 0.476,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2500,
        "price_19": 0.476,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2500,
        "price_20": 0.476,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.308,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.308,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.308,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.308,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "d5e8a783-a1a2-4b2f-b05f-11cd2664f15d",
        "code": "d5e8a783-a1a2-4b2f-b05f-11cd2664f15d",
        "name": "Grabación gota de resina",
        "technique_name": "Grabación gota de resina",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 70,
        "min_unit": null,
        "cifra_code": "DOMING",
        "cifra_type": "Area",
        "cifra_source_id": "d5e8a783-a1a2-4b2f-b05f-11cd2664f15d",
        "section_1": 1,
        "price_1": 0.658,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.658,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.658,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.658,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 0.602,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0.602,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 0.602,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 0.602,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 0.56,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 0.56,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 0.56,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 0.56,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.518,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.518,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.518,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.518,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2500,
        "price_17": 0.476,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2500,
        "price_18": 0.476,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2500,
        "price_19": 0.476,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2500,
        "price_20": 0.476,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.308,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.308,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.308,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.308,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_DTF",
        "code": "CIFRA_DTF",
        "name": "Grabación DTF",
        "technique_name": "Grabación DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF",
        "cifra_type": "Area",
        "cifra_source_id": "c287524f-3a88-4a9b-b73a-120d25626576"
    },
    {
        "technique_ref": "c287524f-3a88-4a9b-b73a-120d25626576",
        "code": "c287524f-3a88-4a9b-b73a-120d25626576",
        "name": "Grabación DTF",
        "technique_name": "Grabación DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF",
        "cifra_type": "Area",
        "cifra_source_id": "c287524f-3a88-4a9b-b73a-120d25626576"
    },
    {
        "technique_ref": "CIFRA_DTF_10X10",
        "code": "CIFRA_DTF_10X10",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_10X10",
        "cifra_type": "Area",
        "cifra_source_id": "234d9dbe-762d-4ea3-9877-197d786d5dd3",
        "section_1": 1,
        "price_1": 1.05,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.05,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.05,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.05,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.05,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.05,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.05,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.05,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.994,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.994,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.994,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.994,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.966,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.966,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.966,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.966,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.938,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.938,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.938,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.938,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "234d9dbe-762d-4ea3-9877-197d786d5dd3",
        "code": "234d9dbe-762d-4ea3-9877-197d786d5dd3",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_10X10",
        "cifra_type": "Area",
        "cifra_source_id": "234d9dbe-762d-4ea3-9877-197d786d5dd3",
        "section_1": 1,
        "price_1": 1.05,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.05,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.05,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.05,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.05,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.05,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.05,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.05,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.994,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.994,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.994,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.994,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.966,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.966,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.966,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.966,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.938,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.938,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.938,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.938,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_DTF_15X15",
        "code": "CIFRA_DTF_15X15",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_15X15",
        "cifra_type": "Area",
        "cifra_source_id": "41dc6fff-02c5-460d-8118-1c915ba6534f",
        "section_1": 1,
        "price_1": 1.148,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.148,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.148,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.148,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.148,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.148,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.148,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.148,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.064,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.064,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.064,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.064,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.036,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.036,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.036,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.036,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.008,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.008,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.008,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.008,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "41dc6fff-02c5-460d-8118-1c915ba6534f",
        "code": "41dc6fff-02c5-460d-8118-1c915ba6534f",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_15X15",
        "cifra_type": "Area",
        "cifra_source_id": "41dc6fff-02c5-460d-8118-1c915ba6534f",
        "section_1": 1,
        "price_1": 1.148,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.148,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.148,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.148,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.148,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.148,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.148,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.148,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.064,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.064,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.064,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.064,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.036,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.036,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.036,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.036,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.008,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.008,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.008,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.008,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_DTF_20X18",
        "code": "CIFRA_DTF_20X18",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_20X18",
        "cifra_type": "Area",
        "cifra_source_id": "866c2787-b84e-40eb-b921-b45b23d8d28f",
        "section_1": 1,
        "price_1": 1.218,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.218,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.218,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.218,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.218,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.218,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.218,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.218,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.176,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.176,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.176,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.176,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.148,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.148,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.148,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.148,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.12,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.12,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.12,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.12,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "866c2787-b84e-40eb-b921-b45b23d8d28f",
        "code": "866c2787-b84e-40eb-b921-b45b23d8d28f",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_20X18",
        "cifra_type": "Area",
        "cifra_source_id": "866c2787-b84e-40eb-b921-b45b23d8d28f",
        "section_1": 1,
        "price_1": 1.218,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.218,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.218,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.218,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.218,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.218,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.218,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.218,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.176,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.176,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.176,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.176,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.148,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.148,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.148,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.148,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.12,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.12,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.12,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.12,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_DTF_30X20",
        "code": "CIFRA_DTF_30X20",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_30X20",
        "cifra_type": "Area",
        "cifra_source_id": "56d99085-7c81-48fd-a428-97ada8626c49",
        "section_1": 1,
        "price_1": 1.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.4,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.4,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.4,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.4,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.4,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.372,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.372,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.372,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.372,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.344,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.344,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.344,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.344,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.316,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.316,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.316,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.316,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "56d99085-7c81-48fd-a428-97ada8626c49",
        "code": "56d99085-7c81-48fd-a428-97ada8626c49",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_30X20",
        "cifra_type": "Area",
        "cifra_source_id": "56d99085-7c81-48fd-a428-97ada8626c49",
        "section_1": 1,
        "price_1": 1.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.4,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.4,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.4,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.4,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.4,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.372,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.372,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.372,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.372,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.344,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.344,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.344,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.344,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.316,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.316,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.316,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.316,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_DTF_32X26",
        "code": "CIFRA_DTF_32X26",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_32X26",
        "cifra_type": "Area",
        "cifra_source_id": "b33aa0af-9939-4213-bbdd-3397f1d21ab2",
        "section_1": 1,
        "price_1": 1.61,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.61,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.61,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.61,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.61,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.61,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.61,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.61,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.582,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.582,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.582,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.582,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.554,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.554,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.554,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.554,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.54,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.54,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.54,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.54,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "b33aa0af-9939-4213-bbdd-3397f1d21ab2",
        "code": "b33aa0af-9939-4213-bbdd-3397f1d21ab2",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_32X26",
        "cifra_type": "Area",
        "cifra_source_id": "b33aa0af-9939-4213-bbdd-3397f1d21ab2",
        "section_1": 1,
        "price_1": 1.61,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.61,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.61,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.61,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.61,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.61,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.61,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.61,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.582,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.582,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.582,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.582,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.554,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.554,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.554,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.554,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.54,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.54,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.54,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.54,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_DTF_4X4",
        "code": "CIFRA_DTF_4X4",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_4X4",
        "cifra_type": "Area",
        "cifra_source_id": "a6f1f0b4-0e3e-4340-aa9b-0ca83a12593e",
        "section_1": 1,
        "price_1": 0.686,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.686,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.686,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.686,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 0.644,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0.644,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 0.644,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 0.644,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 0.602,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 0.602,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 0.602,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 0.602,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.588,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.588,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.588,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.588,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "a6f1f0b4-0e3e-4340-aa9b-0ca83a12593e",
        "code": "a6f1f0b4-0e3e-4340-aa9b-0ca83a12593e",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_4X4",
        "cifra_type": "Area",
        "cifra_source_id": "a6f1f0b4-0e3e-4340-aa9b-0ca83a12593e",
        "section_1": 1,
        "price_1": 0.686,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.686,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.686,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.686,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 0.644,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0.644,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 0.644,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 0.644,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 0.602,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 0.602,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 0.602,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 0.602,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.588,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.588,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.588,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.588,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_DTF_4X4_1",
        "code": "CIFRA_DTF_4X4_1",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_4X4_1",
        "cifra_type": "Area",
        "cifra_source_id": "58169f41-d411-435a-a88d-4d9f77f4a087",
        "section_1": 1,
        "price_1": 1.372,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.372,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.372,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.372,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 1.288,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.288,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 1.288,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 1.288,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.484,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.484,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.484,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.484,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.176,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.176,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.176,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.176,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "58169f41-d411-435a-a88d-4d9f77f4a087",
        "code": "58169f41-d411-435a-a88d-4d9f77f4a087",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_4X4_1",
        "cifra_type": "Area",
        "cifra_source_id": "58169f41-d411-435a-a88d-4d9f77f4a087",
        "section_1": 1,
        "price_1": 1.372,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.372,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.372,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.372,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 1.288,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.288,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 1.288,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 1.288,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.484,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.484,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.484,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.484,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.176,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.176,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.176,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.176,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_DTF_4X4_2",
        "code": "CIFRA_DTF_4X4_2",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_4X4_2",
        "cifra_type": "Area",
        "cifra_source_id": "f52d7d23-15de-4afc-b44c-5b6d6179f7ad",
        "section_1": 1,
        "price_1": 1.372,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.372,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.372,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.372,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 1.288,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.288,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 1.288,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 1.288,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.484,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.484,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.484,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.484,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.176,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.176,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.176,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.176,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "f52d7d23-15de-4afc-b44c-5b6d6179f7ad",
        "code": "f52d7d23-15de-4afc-b44c-5b6d6179f7ad",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_4X4_2",
        "cifra_type": "Area",
        "cifra_source_id": "f52d7d23-15de-4afc-b44c-5b6d6179f7ad",
        "section_1": 1,
        "price_1": 1.372,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.372,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.372,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.372,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 1.288,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.288,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 1.288,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 1.288,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.484,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.484,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.484,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.484,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.176,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.176,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.176,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.176,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_DTF_6X6",
        "code": "CIFRA_DTF_6X6",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_6X6",
        "cifra_type": "Area",
        "cifra_source_id": "430fa36b-c3cb-446e-afb7-52626fe6d4e0",
        "section_1": 1,
        "price_1": 0.742,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.742,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.742,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.742,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.742,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.742,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.742,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.742,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.672,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.672,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.672,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.672,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.644,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.644,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.644,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.644,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.63,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.63,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.63,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.63,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "430fa36b-c3cb-446e-afb7-52626fe6d4e0",
        "code": "430fa36b-c3cb-446e-afb7-52626fe6d4e0",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_6X6",
        "cifra_type": "Area",
        "cifra_source_id": "430fa36b-c3cb-446e-afb7-52626fe6d4e0",
        "section_1": 1,
        "price_1": 0.742,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.742,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.742,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.742,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.742,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.742,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.742,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.742,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.672,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.672,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.672,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.672,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.644,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.644,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.644,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.644,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.63,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.63,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.63,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.63,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_DTF_6X6_1",
        "code": "CIFRA_DTF_6X6_1",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_6X6_1",
        "cifra_type": "Area",
        "cifra_source_id": "7546cd52-aa9c-4752-8526-c0b3c04c9d0d",
        "section_1": 1,
        "price_1": 1.484,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.484,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.484,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.484,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.484,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.484,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.484,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.484,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.344,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.344,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.344,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.344,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.288,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.288,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.288,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.288,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.26,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.26,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.26,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.26,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "7546cd52-aa9c-4752-8526-c0b3c04c9d0d",
        "code": "7546cd52-aa9c-4752-8526-c0b3c04c9d0d",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_6X6_1",
        "cifra_type": "Area",
        "cifra_source_id": "7546cd52-aa9c-4752-8526-c0b3c04c9d0d",
        "section_1": 1,
        "price_1": 1.484,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.484,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.484,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.484,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.484,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.484,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.484,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.484,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.344,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.344,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.344,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.344,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.288,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.288,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.288,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.288,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.26,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.26,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.26,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.26,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_DTF_6X6_2",
        "code": "CIFRA_DTF_6X6_2",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_6X6_2",
        "cifra_type": "Area",
        "cifra_source_id": "22fee35f-224d-4e38-8c7e-c0d8b91ee548",
        "section_1": 1,
        "price_1": 1.484,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.484,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.484,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.484,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.484,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.484,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.484,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.484,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.344,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.344,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.344,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.344,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.288,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.288,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.288,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.288,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.26,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.26,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.26,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.26,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "22fee35f-224d-4e38-8c7e-c0d8b91ee548",
        "code": "22fee35f-224d-4e38-8c7e-c0d8b91ee548",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_6X6_2",
        "cifra_type": "Area",
        "cifra_source_id": "22fee35f-224d-4e38-8c7e-c0d8b91ee548",
        "section_1": 1,
        "price_1": 1.484,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.484,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.484,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.484,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.484,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.484,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.484,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.484,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 1.344,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 1.344,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 1.344,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 1.344,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.288,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.288,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.288,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.288,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 1.26,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 1.26,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 1.26,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 1.26,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_DTF_8X8",
        "code": "CIFRA_DTF_8X8",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_8X8",
        "cifra_type": "Area",
        "cifra_source_id": "573145d8-d794-4f9c-99f2-cec8cd0ee46b",
        "section_1": 1,
        "price_1": 0.952,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.952,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.952,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.952,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.952,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.952,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.952,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.952,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.924,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.924,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.924,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.924,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.868,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.868,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.868,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.868,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.84,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.84,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.84,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.84,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "573145d8-d794-4f9c-99f2-cec8cd0ee46b",
        "code": "573145d8-d794-4f9c-99f2-cec8cd0ee46b",
        "name": "Transfer full color DTF",
        "technique_name": "Transfer full color DTF",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "DTF_8X8",
        "cifra_type": "Area",
        "cifra_source_id": "573145d8-d794-4f9c-99f2-cec8cd0ee46b",
        "section_1": 1,
        "price_1": 0.952,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.952,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.952,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.952,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.952,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.952,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.952,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.952,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.924,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.924,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.924,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.924,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.868,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.868,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.868,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.868,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.84,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.84,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.84,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.84,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_E",
        "code": "CIFRA_E",
        "name": "Serigrafía (E)",
        "technique_name": "Serigrafía (E)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "cifra_code": "E",
        "cifra_type": "Colores",
        "cifra_source_id": "ef3739ec-8163-494a-905f-f09b8ea42d69",
        "section_1": 1,
        "price_1": 0.434,
        "price_col_1": 0.308,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.434,
        "price_col_2": 0.308,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.434,
        "price_col_3": 0.308,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.434,
        "price_col_4": 0.308,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.364,
        "price_col_5": 0.21,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.364,
        "price_col_6": 0.21,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.364,
        "price_col_7": 0.21,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.364,
        "price_col_8": 0.21,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.308,
        "price_col_9": 0.182,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.308,
        "price_col_10": 0.182,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.308,
        "price_col_11": 0.182,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.308,
        "price_col_12": 0.182,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.266,
        "price_col_13": 0.168,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.266,
        "price_col_14": 0.168,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.266,
        "price_col_15": 0.168,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.266,
        "price_col_16": 0.168,
        "price_cm_16": 0
    },
    {
        "technique_ref": "ef3739ec-8163-494a-905f-f09b8ea42d69",
        "code": "ef3739ec-8163-494a-905f-f09b8ea42d69",
        "name": "Serigrafía (E)",
        "technique_name": "Serigrafía (E)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "cifra_code": "E",
        "cifra_type": "Colores",
        "cifra_source_id": "ef3739ec-8163-494a-905f-f09b8ea42d69",
        "section_1": 1,
        "price_1": 0.434,
        "price_col_1": 0.308,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.434,
        "price_col_2": 0.308,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.434,
        "price_col_3": 0.308,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.434,
        "price_col_4": 0.308,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.364,
        "price_col_5": 0.21,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.364,
        "price_col_6": 0.21,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.364,
        "price_col_7": 0.21,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.364,
        "price_col_8": 0.21,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.308,
        "price_col_9": 0.182,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.308,
        "price_col_10": 0.182,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.308,
        "price_col_11": 0.182,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.308,
        "price_col_12": 0.182,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.266,
        "price_col_13": 0.168,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.266,
        "price_col_14": 0.168,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.266,
        "price_col_15": 0.168,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.266,
        "price_col_16": 0.168,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_E_ASTERISCO",
        "code": "CIFRA_E_ASTERISCO",
        "name": "Serigrafía (E*)",
        "technique_name": "Serigrafía (E*)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "cifra_code": "E_ASTERISCO",
        "cifra_type": "Colores",
        "cifra_source_id": "316ea5a8-3d96-4dac-a626-a4bc522f038d",
        "section_1": 1,
        "price_1": 0.462,
        "price_col_1": 0.266,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.462,
        "price_col_2": 0.266,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.462,
        "price_col_3": 0.266,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.462,
        "price_col_4": 0.266,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.378,
        "price_col_5": 0.238,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.378,
        "price_col_6": 0.238,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.378,
        "price_col_7": 0.238,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.378,
        "price_col_8": 0.238,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.322,
        "price_col_9": 0.196,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.322,
        "price_col_10": 0.196,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.322,
        "price_col_11": 0.196,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.322,
        "price_col_12": 0.196,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.308,
        "price_col_13": 0.182,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.308,
        "price_col_14": 0.182,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.308,
        "price_col_15": 0.182,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.308,
        "price_col_16": 0.182,
        "price_cm_16": 0
    },
    {
        "technique_ref": "316ea5a8-3d96-4dac-a626-a4bc522f038d",
        "code": "316ea5a8-3d96-4dac-a626-a4bc522f038d",
        "name": "Serigrafía (E*)",
        "technique_name": "Serigrafía (E*)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "cifra_code": "E_ASTERISCO",
        "cifra_type": "Colores",
        "cifra_source_id": "316ea5a8-3d96-4dac-a626-a4bc522f038d",
        "section_1": 1,
        "price_1": 0.462,
        "price_col_1": 0.266,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.462,
        "price_col_2": 0.266,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.462,
        "price_col_3": 0.266,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.462,
        "price_col_4": 0.266,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.378,
        "price_col_5": 0.238,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.378,
        "price_col_6": 0.238,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.378,
        "price_col_7": 0.238,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.378,
        "price_col_8": 0.238,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.322,
        "price_col_9": 0.196,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.322,
        "price_col_10": 0.196,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.322,
        "price_col_11": 0.196,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.322,
        "price_col_12": 0.196,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.308,
        "price_col_13": 0.182,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.308,
        "price_col_14": 0.182,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.308,
        "price_col_15": 0.182,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.308,
        "price_col_16": 0.182,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_E_ASTERISCO_1",
        "code": "CIFRA_E_ASTERISCO_1",
        "name": "Serigrafía (E*)",
        "technique_name": "Serigrafía (E*)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "E_ASTERISCO_1",
        "cifra_type": "Colores",
        "cifra_source_id": "3bbefd8b-2852-4288-89bc-9b087b2ffed3",
        "section_1": 1,
        "price_1": 0.462,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.462,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.462,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.462,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.378,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.378,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.378,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.378,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.322,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.322,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.322,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.322,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.308,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.308,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.308,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.308,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "3bbefd8b-2852-4288-89bc-9b087b2ffed3",
        "code": "3bbefd8b-2852-4288-89bc-9b087b2ffed3",
        "name": "Serigrafía (E*)",
        "technique_name": "Serigrafía (E*)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "E_ASTERISCO_1",
        "cifra_type": "Colores",
        "cifra_source_id": "3bbefd8b-2852-4288-89bc-9b087b2ffed3",
        "section_1": 1,
        "price_1": 0.462,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.462,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.462,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.462,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.378,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.378,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.378,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.378,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.322,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.322,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.322,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.322,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.308,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.308,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.308,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.308,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_E_E",
        "code": "CIFRA_E_E",
        "name": "Grabación 2 posiciones",
        "technique_name": "Grabación 2 posiciones",
        "cliche": 84,
        "cliche_repetition": 0,
        "min": 112,
        "min_unit": null,
        "cifra_code": "E_E",
        "cifra_type": "Colores",
        "cifra_source_id": "2a11ad51-cbe9-47ae-83f6-ad39a5c3784d",
        "section_1": 1,
        "price_1": 0.868,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.868,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.868,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.868,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.728,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.728,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.728,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.728,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.616,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.616,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.616,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.616,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.532,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.532,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.532,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.532,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "2a11ad51-cbe9-47ae-83f6-ad39a5c3784d",
        "code": "2a11ad51-cbe9-47ae-83f6-ad39a5c3784d",
        "name": "Grabación 2 posiciones",
        "technique_name": "Grabación 2 posiciones",
        "cliche": 84,
        "cliche_repetition": 0,
        "min": 112,
        "min_unit": null,
        "cifra_code": "E_E",
        "cifra_type": "Colores",
        "cifra_source_id": "2a11ad51-cbe9-47ae-83f6-ad39a5c3784d",
        "section_1": 1,
        "price_1": 0.868,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.868,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.868,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.868,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.728,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.728,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.728,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.728,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.616,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.616,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.616,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.616,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.532,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.532,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.532,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.532,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_EL",
        "code": "CIFRA_EL",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "EL",
        "cifra_type": "Area",
        "cifra_source_id": "cf24fdb1-a821-4955-9ba6-239a4e671323",
        "section_1": 300,
        "price_1": 0.3374,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.3374,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.3374,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.3374,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.2674,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.2674,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.2674,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.2674,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.2114,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.2114,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.2114,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.2114,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.1834,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.1834,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.1834,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.1834,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 4000,
        "price_17": 0.1694,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 4000,
        "price_18": 0.1694,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 4000,
        "price_19": 0.1694,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 4000,
        "price_20": 0.1694,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.1554,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.1554,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.1554,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.1554,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "cf24fdb1-a821-4955-9ba6-239a4e671323",
        "code": "cf24fdb1-a821-4955-9ba6-239a4e671323",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "EL",
        "cifra_type": "Area",
        "cifra_source_id": "cf24fdb1-a821-4955-9ba6-239a4e671323",
        "section_1": 300,
        "price_1": 0.3374,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.3374,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.3374,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.3374,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.2674,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.2674,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.2674,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.2674,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.2114,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.2114,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.2114,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.2114,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.1834,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.1834,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.1834,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.1834,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 4000,
        "price_17": 0.1694,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 4000,
        "price_18": 0.1694,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 4000,
        "price_19": 0.1694,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 4000,
        "price_20": 0.1694,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.1554,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.1554,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.1554,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.1554,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_EL_002",
        "code": "CIFRA_EL_002",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "EL_002",
        "cifra_type": "Area",
        "cifra_source_id": "13181c7c-1ee2-401e-9dc5-a3f21f8fa391",
        "section_1": 300,
        "price_1": 0.441,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.441,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.441,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.441,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.3486,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.3486,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.3486,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.3486,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.266,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.266,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.266,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.266,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.259,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.259,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.259,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.259,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 4000,
        "price_17": 0.2485,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 4000,
        "price_18": 0.2485,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 4000,
        "price_19": 0.2485,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 4000,
        "price_20": 0.2485,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.238,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.238,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.238,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.238,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "13181c7c-1ee2-401e-9dc5-a3f21f8fa391",
        "code": "13181c7c-1ee2-401e-9dc5-a3f21f8fa391",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "EL_002",
        "cifra_type": "Area",
        "cifra_source_id": "13181c7c-1ee2-401e-9dc5-a3f21f8fa391",
        "section_1": 300,
        "price_1": 0.441,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.441,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.441,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.441,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.3486,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.3486,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.3486,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.3486,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.266,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.266,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.266,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.266,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.259,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.259,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.259,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.259,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 4000,
        "price_17": 0.2485,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 4000,
        "price_18": 0.2485,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 4000,
        "price_19": 0.2485,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 4000,
        "price_20": 0.2485,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.238,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.238,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.238,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.238,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_EP_01",
        "code": "CIFRA_EP_01",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "EP_01",
        "cifra_type": "Area",
        "cifra_source_id": "a5079eb8-d299-43a5-b207-44700a855ef8",
        "section_1": 200,
        "price_1": 0.63,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 200,
        "price_2": 0.63,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 200,
        "price_3": 0.63,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 200,
        "price_4": 0.63,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 400,
        "price_5": 0.4186,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 400,
        "price_6": 0.4186,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 400,
        "price_7": 0.4186,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 400,
        "price_8": 0.4186,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 600,
        "price_9": 0.4004,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 600,
        "price_10": 0.4004,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 600,
        "price_11": 0.4004,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 600,
        "price_12": 0.4004,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 800,
        "price_13": 0.3822,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 800,
        "price_14": 0.3822,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 800,
        "price_15": 0.3822,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 800,
        "price_16": 0.3822,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.364,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.364,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.364,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.364,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "a5079eb8-d299-43a5-b207-44700a855ef8",
        "code": "a5079eb8-d299-43a5-b207-44700a855ef8",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "EP_01",
        "cifra_type": "Area",
        "cifra_source_id": "a5079eb8-d299-43a5-b207-44700a855ef8",
        "section_1": 200,
        "price_1": 0.63,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 200,
        "price_2": 0.63,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 200,
        "price_3": 0.63,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 200,
        "price_4": 0.63,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 400,
        "price_5": 0.4186,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 400,
        "price_6": 0.4186,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 400,
        "price_7": 0.4186,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 400,
        "price_8": 0.4186,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 600,
        "price_9": 0.4004,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 600,
        "price_10": 0.4004,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 600,
        "price_11": 0.4004,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 600,
        "price_12": 0.4004,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 800,
        "price_13": 0.3822,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 800,
        "price_14": 0.3822,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 800,
        "price_15": 0.3822,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 800,
        "price_16": 0.3822,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.364,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.364,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.364,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.364,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_EP_02",
        "code": "CIFRA_EP_02",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "EP_02",
        "cifra_type": "Colores",
        "cifra_source_id": "2214a406-6705-4912-bd1a-404c918fafb1",
        "section_1": 200,
        "price_1": 0.56,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 200,
        "price_2": 0.56,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 200,
        "price_3": 0.56,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 200,
        "price_4": 0.56,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 400,
        "price_5": 0.3486,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 400,
        "price_6": 0.3486,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 400,
        "price_7": 0.3486,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 400,
        "price_8": 0.3486,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 600,
        "price_9": 0.3304,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 600,
        "price_10": 0.3304,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 600,
        "price_11": 0.3304,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 600,
        "price_12": 0.3304,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 800,
        "price_13": 0.3122,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 800,
        "price_14": 0.3122,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 800,
        "price_15": 0.3122,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 800,
        "price_16": 0.3122,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.294,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.294,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.294,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.294,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "2214a406-6705-4912-bd1a-404c918fafb1",
        "code": "2214a406-6705-4912-bd1a-404c918fafb1",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "EP_02",
        "cifra_type": "Colores",
        "cifra_source_id": "2214a406-6705-4912-bd1a-404c918fafb1",
        "section_1": 200,
        "price_1": 0.56,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 200,
        "price_2": 0.56,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 200,
        "price_3": 0.56,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 200,
        "price_4": 0.56,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 400,
        "price_5": 0.3486,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 400,
        "price_6": 0.3486,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 400,
        "price_7": 0.3486,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 400,
        "price_8": 0.3486,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 600,
        "price_9": 0.3304,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 600,
        "price_10": 0.3304,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 600,
        "price_11": 0.3304,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 600,
        "price_12": 0.3304,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 800,
        "price_13": 0.3122,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 800,
        "price_14": 0.3122,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 800,
        "price_15": 0.3122,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 800,
        "price_16": 0.3122,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.294,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.294,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.294,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.294,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_EP_03",
        "code": "CIFRA_EP_03",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "EP_03",
        "cifra_type": "Colores",
        "cifra_source_id": "43d0be38-fd14-4281-bebc-622855266637",
        "section_1": 200,
        "price_1": 0.581,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 200,
        "price_2": 0.581,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 200,
        "price_3": 0.581,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 200,
        "price_4": 0.581,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 400,
        "price_5": 0.385,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 400,
        "price_6": 0.385,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 400,
        "price_7": 0.385,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 400,
        "price_8": 0.385,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 600,
        "price_9": 0.3598,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 600,
        "price_10": 0.3598,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 600,
        "price_11": 0.3598,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 600,
        "price_12": 0.3598,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 800,
        "price_13": 0.343,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 800,
        "price_14": 0.343,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 800,
        "price_15": 0.343,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 800,
        "price_16": 0.343,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.322,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.322,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.322,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.322,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "43d0be38-fd14-4281-bebc-622855266637",
        "code": "43d0be38-fd14-4281-bebc-622855266637",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "EP_03",
        "cifra_type": "Colores",
        "cifra_source_id": "43d0be38-fd14-4281-bebc-622855266637",
        "section_1": 200,
        "price_1": 0.581,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 200,
        "price_2": 0.581,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 200,
        "price_3": 0.581,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 200,
        "price_4": 0.581,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 400,
        "price_5": 0.385,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 400,
        "price_6": 0.385,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 400,
        "price_7": 0.385,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 400,
        "price_8": 0.385,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 600,
        "price_9": 0.3598,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 600,
        "price_10": 0.3598,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 600,
        "price_11": 0.3598,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 600,
        "price_12": 0.3598,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 800,
        "price_13": 0.343,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 800,
        "price_14": 0.343,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 800,
        "price_15": 0.343,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 800,
        "price_16": 0.343,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.322,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.322,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.322,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.322,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_EPR",
        "code": "CIFRA_EPR",
        "name": "Grabación a todo color",
        "technique_name": "Grabación a todo color",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "EPR",
        "cifra_type": "Area",
        "cifra_source_id": "a0bd2229-ad44-4ab2-82ba-a6abf272d93d",
        "section_1": 300,
        "price_1": 0.623,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.623,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.623,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.623,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.525,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.525,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.525,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.525,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.49,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.49,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.49,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.49,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.455,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.455,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.455,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.455,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 4000,
        "price_17": 0.434,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 4000,
        "price_18": 0.434,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 4000,
        "price_19": 0.434,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 4000,
        "price_20": 0.434,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.42,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.42,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.42,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.42,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "a0bd2229-ad44-4ab2-82ba-a6abf272d93d",
        "code": "a0bd2229-ad44-4ab2-82ba-a6abf272d93d",
        "name": "Grabación a todo color",
        "technique_name": "Grabación a todo color",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "EPR",
        "cifra_type": "Area",
        "cifra_source_id": "a0bd2229-ad44-4ab2-82ba-a6abf272d93d",
        "section_1": 300,
        "price_1": 0.623,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.623,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.623,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.623,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.525,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.525,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.525,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.525,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.49,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.49,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.49,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.49,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.455,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.455,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.455,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.455,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 4000,
        "price_17": 0.434,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 4000,
        "price_18": 0.434,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 4000,
        "price_19": 0.434,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 4000,
        "price_20": 0.434,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.42,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.42,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.42,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.42,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_F",
        "code": "CIFRA_F",
        "name": "Serigrafía (F)",
        "technique_name": "Serigrafía (F)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "F",
        "cifra_type": "Colores",
        "cifra_source_id": "a5ae0d0c-6f48-4c71-bca3-3e67bfe07402",
        "section_1": 1,
        "price_1": 0.546,
        "price_col_1": 0.392,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.546,
        "price_col_2": 0.392,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.546,
        "price_col_3": 0.392,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.546,
        "price_col_4": 0.392,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.462,
        "price_col_5": 0.28,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.462,
        "price_col_6": 0.28,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.462,
        "price_col_7": 0.28,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.462,
        "price_col_8": 0.28,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.392,
        "price_col_9": 0.259,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.392,
        "price_col_10": 0.259,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.392,
        "price_col_11": 0.259,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.392,
        "price_col_12": 0.259,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.336,
        "price_col_13": 0.21,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.336,
        "price_col_14": 0.21,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.336,
        "price_col_15": 0.21,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.336,
        "price_col_16": 0.21,
        "price_cm_16": 0
    },
    {
        "technique_ref": "a5ae0d0c-6f48-4c71-bca3-3e67bfe07402",
        "code": "a5ae0d0c-6f48-4c71-bca3-3e67bfe07402",
        "name": "Serigrafía (F)",
        "technique_name": "Serigrafía (F)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "F",
        "cifra_type": "Colores",
        "cifra_source_id": "a5ae0d0c-6f48-4c71-bca3-3e67bfe07402",
        "section_1": 1,
        "price_1": 0.546,
        "price_col_1": 0.392,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.546,
        "price_col_2": 0.392,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.546,
        "price_col_3": 0.392,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.546,
        "price_col_4": 0.392,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.462,
        "price_col_5": 0.28,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.462,
        "price_col_6": 0.28,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.462,
        "price_col_7": 0.28,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.462,
        "price_col_8": 0.28,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.392,
        "price_col_9": 0.259,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.392,
        "price_col_10": 0.259,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.392,
        "price_col_11": 0.259,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.392,
        "price_col_12": 0.259,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.336,
        "price_col_13": 0.21,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.336,
        "price_col_14": 0.21,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.336,
        "price_col_15": 0.21,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.336,
        "price_col_16": 0.21,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_F_F",
        "code": "CIFRA_F_F",
        "name": "Serigrafía dos posiciones diferentes",
        "technique_name": "Serigrafía dos posiciones diferentes",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "F_F",
        "cifra_type": "Colores",
        "cifra_source_id": "0f5ef8fe-c925-4a82-8a70-f30ce466d365",
        "section_1": 1,
        "price_1": 1.092,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.092,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.092,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.092,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.924,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.924,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.924,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.924,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.784,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.784,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.784,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.784,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.672,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.672,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.672,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.672,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "0f5ef8fe-c925-4a82-8a70-f30ce466d365",
        "code": "0f5ef8fe-c925-4a82-8a70-f30ce466d365",
        "name": "Serigrafía dos posiciones diferentes",
        "technique_name": "Serigrafía dos posiciones diferentes",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "F_F",
        "cifra_type": "Colores",
        "cifra_source_id": "0f5ef8fe-c925-4a82-8a70-f30ce466d365",
        "section_1": 1,
        "price_1": 1.092,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.092,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.092,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.092,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.924,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.924,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.924,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.924,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.784,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.784,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.784,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.784,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.672,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.672,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.672,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.672,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_F_F_F",
        "code": "CIFRA_F_F_F",
        "name": "Serigrafía 1 color dos posiciones iguales",
        "technique_name": "Serigrafía 1 color dos posiciones iguales",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "F_F_F",
        "cifra_type": "Colores",
        "cifra_source_id": "f249254f-a880-4bd4-96e8-b4080a29e3fd",
        "section_1": 1,
        "price_1": 1.092,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.092,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.092,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.092,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.924,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.924,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.924,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.924,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.784,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.784,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.784,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.784,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.672,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.672,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.672,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.672,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "f249254f-a880-4bd4-96e8-b4080a29e3fd",
        "code": "f249254f-a880-4bd4-96e8-b4080a29e3fd",
        "name": "Serigrafía 1 color dos posiciones iguales",
        "technique_name": "Serigrafía 1 color dos posiciones iguales",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "F_F_F",
        "cifra_type": "Colores",
        "cifra_source_id": "f249254f-a880-4bd4-96e8-b4080a29e3fd",
        "section_1": 1,
        "price_1": 1.092,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.092,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.092,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.092,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.924,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.924,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.924,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.924,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.784,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.784,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.784,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.784,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.672,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.672,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.672,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.672,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_G",
        "code": "CIFRA_G",
        "name": "Serigrafía (G)",
        "technique_name": "Serigrafía (G)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "G",
        "cifra_type": "Colores",
        "cifra_source_id": "227e939c-6e4d-49ca-b70b-c565fd1846a3",
        "section_1": 1,
        "price_1": 0.672,
        "price_col_1": 0.56,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.672,
        "price_col_2": 0.56,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.672,
        "price_col_3": 0.56,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.672,
        "price_col_4": 0.56,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.602,
        "price_col_5": 0.266,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.602,
        "price_col_6": 0.266,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.602,
        "price_col_7": 0.266,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.602,
        "price_col_8": 0.266,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.518,
        "price_col_9": 0.238,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.518,
        "price_col_10": 0.238,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.518,
        "price_col_11": 0.238,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.518,
        "price_col_12": 0.238,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.462,
        "price_col_13": 0.21,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.462,
        "price_col_14": 0.21,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.462,
        "price_col_15": 0.21,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.462,
        "price_col_16": 0.21,
        "price_cm_16": 0
    },
    {
        "technique_ref": "227e939c-6e4d-49ca-b70b-c565fd1846a3",
        "code": "227e939c-6e4d-49ca-b70b-c565fd1846a3",
        "name": "Serigrafía (G)",
        "technique_name": "Serigrafía (G)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "G",
        "cifra_type": "Colores",
        "cifra_source_id": "227e939c-6e4d-49ca-b70b-c565fd1846a3",
        "section_1": 1,
        "price_1": 0.672,
        "price_col_1": 0.56,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.672,
        "price_col_2": 0.56,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.672,
        "price_col_3": 0.56,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.672,
        "price_col_4": 0.56,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.602,
        "price_col_5": 0.266,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.602,
        "price_col_6": 0.266,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.602,
        "price_col_7": 0.266,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.602,
        "price_col_8": 0.266,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.518,
        "price_col_9": 0.238,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.518,
        "price_col_10": 0.238,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.518,
        "price_col_11": 0.238,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.518,
        "price_col_12": 0.238,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.462,
        "price_col_13": 0.21,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.462,
        "price_col_14": 0.21,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.462,
        "price_col_15": 0.21,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.462,
        "price_col_16": 0.21,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_G_D",
        "code": "CIFRA_G_D",
        "name": "Grabación lanyard + medalla a 1 color",
        "technique_name": "Grabación lanyard + medalla a 1 color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "G_D",
        "cifra_type": "Area",
        "cifra_source_id": "4a4b9723-d607-4846-86dc-624b1bba12d6",
        "section_1": 1,
        "price_1": 1.036,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.036,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.036,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.036,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.896,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.896,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.896,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.896,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.77,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.77,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.77,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.77,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.672,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.672,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.672,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.672,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "4a4b9723-d607-4846-86dc-624b1bba12d6",
        "code": "4a4b9723-d607-4846-86dc-624b1bba12d6",
        "name": "Grabación lanyard + medalla a 1 color",
        "technique_name": "Grabación lanyard + medalla a 1 color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "G_D",
        "cifra_type": "Area",
        "cifra_source_id": "4a4b9723-d607-4846-86dc-624b1bba12d6",
        "section_1": 1,
        "price_1": 1.036,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.036,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.036,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.036,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.896,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.896,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.896,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.896,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.77,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.77,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.77,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.77,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.672,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.672,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.672,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.672,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_G_G",
        "code": "CIFRA_G_G",
        "name": "Serigrafía 2 posiciones diferentes",
        "technique_name": "Serigrafía 2 posiciones diferentes",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "G_G",
        "cifra_type": "Colores",
        "cifra_source_id": "fd125170-666c-49d6-9ee0-2af9b773aee0",
        "section_1": 1,
        "price_1": 1.344,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.344,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.344,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.344,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.204,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.204,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.204,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.204,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 1.036,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 1.036,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 1.036,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 1.036,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.924,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.924,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.924,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.924,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "fd125170-666c-49d6-9ee0-2af9b773aee0",
        "code": "fd125170-666c-49d6-9ee0-2af9b773aee0",
        "name": "Serigrafía 2 posiciones diferentes",
        "technique_name": "Serigrafía 2 posiciones diferentes",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "G_G",
        "cifra_type": "Colores",
        "cifra_source_id": "fd125170-666c-49d6-9ee0-2af9b773aee0",
        "section_1": 1,
        "price_1": 1.344,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.344,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.344,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.344,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.204,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.204,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.204,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.204,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 1.036,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 1.036,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 1.036,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 1.036,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.924,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.924,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.924,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.924,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_G_G_G",
        "code": "CIFRA_G_G_G",
        "name": "Serigrafía 2 posiciones iguales",
        "technique_name": "Serigrafía 2 posiciones iguales",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "G_G_G",
        "cifra_type": "Colores",
        "cifra_source_id": "684649a0-6e48-48a2-9e31-8d64c2e87ebb",
        "section_1": 1,
        "price_1": 1.344,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.344,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.344,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.344,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.204,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.204,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.204,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.204,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 1.036,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 1.036,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 1.036,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 1.036,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.924,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.924,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.924,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.924,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "684649a0-6e48-48a2-9e31-8d64c2e87ebb",
        "code": "684649a0-6e48-48a2-9e31-8d64c2e87ebb",
        "name": "Serigrafía 2 posiciones iguales",
        "technique_name": "Serigrafía 2 posiciones iguales",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "G_G_G",
        "cifra_type": "Colores",
        "cifra_source_id": "684649a0-6e48-48a2-9e31-8d64c2e87ebb",
        "section_1": 1,
        "price_1": 1.344,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.344,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.344,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.344,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.204,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.204,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.204,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.204,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 1.036,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 1.036,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 1.036,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 1.036,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.924,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.924,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.924,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.924,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_H",
        "code": "CIFRA_H",
        "name": "Serigrafía (H)",
        "technique_name": "Serigrafía (H)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "H",
        "cifra_type": "Colores",
        "cifra_source_id": "70720649-709b-49d2-b00a-0f2410848ac5",
        "section_1": 1,
        "price_1": 0.812,
        "price_col_1": 0.378,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.812,
        "price_col_2": 0.378,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.812,
        "price_col_3": 0.378,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.812,
        "price_col_4": 0.378,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.7,
        "price_col_5": 0.294,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.7,
        "price_col_6": 0.294,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.7,
        "price_col_7": 0.294,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.7,
        "price_col_8": 0.294,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.644,
        "price_col_9": 0.28,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.644,
        "price_col_10": 0.28,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.644,
        "price_col_11": 0.28,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.644,
        "price_col_12": 0.28,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.56,
        "price_col_13": 0.266,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.56,
        "price_col_14": 0.266,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.56,
        "price_col_15": 0.266,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.56,
        "price_col_16": 0.266,
        "price_cm_16": 0
    },
    {
        "technique_ref": "70720649-709b-49d2-b00a-0f2410848ac5",
        "code": "70720649-709b-49d2-b00a-0f2410848ac5",
        "name": "Serigrafía (H)",
        "technique_name": "Serigrafía (H)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "H",
        "cifra_type": "Colores",
        "cifra_source_id": "70720649-709b-49d2-b00a-0f2410848ac5",
        "section_1": 1,
        "price_1": 0.812,
        "price_col_1": 0.378,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.812,
        "price_col_2": 0.378,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.812,
        "price_col_3": 0.378,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.812,
        "price_col_4": 0.378,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.7,
        "price_col_5": 0.294,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.7,
        "price_col_6": 0.294,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.7,
        "price_col_7": 0.294,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.7,
        "price_col_8": 0.294,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.644,
        "price_col_9": 0.28,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.644,
        "price_col_10": 0.28,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.644,
        "price_col_11": 0.28,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.644,
        "price_col_12": 0.28,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.56,
        "price_col_13": 0.266,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.56,
        "price_col_14": 0.266,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.56,
        "price_col_15": 0.266,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.56,
        "price_col_16": 0.266,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_H_004",
        "code": "CIFRA_H_004",
        "name": "Grabación a todo color",
        "technique_name": "Grabación a todo color",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "H_004",
        "cifra_type": "Area",
        "cifra_source_id": "e1908cd7-85e2-4ccf-9b81-ae4494361eea",
        "section_1": 300,
        "price_1": 0.406,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.406,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.406,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.406,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.378,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.378,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.378,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.378,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.308,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.308,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.308,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.308,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.266,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.266,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.266,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.266,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.238,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.238,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.238,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.238,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "e1908cd7-85e2-4ccf-9b81-ae4494361eea",
        "code": "e1908cd7-85e2-4ccf-9b81-ae4494361eea",
        "name": "Grabación a todo color",
        "technique_name": "Grabación a todo color",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "H_004",
        "cifra_type": "Area",
        "cifra_source_id": "e1908cd7-85e2-4ccf-9b81-ae4494361eea",
        "section_1": 300,
        "price_1": 0.406,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.406,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.406,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.406,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.378,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.378,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.378,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.378,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.308,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.308,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.308,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.308,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.266,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.266,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.266,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.266,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.238,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.238,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.238,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.238,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_H_H",
        "code": "CIFRA_H_H",
        "name": "Grabación un color dos grabaciones iguales",
        "technique_name": "Grabación un color dos grabaciones iguales",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "H_H",
        "cifra_type": "Colores",
        "cifra_source_id": "38363aab-f8db-46bf-82c0-5f55bbc293e4",
        "section_1": 1,
        "price_1": 1.624,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.624,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.624,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.624,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.4,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.4,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.4,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.4,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 1.288,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 1.288,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 1.288,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 1.288,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 1.12,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 1.12,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 1.12,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 1.12,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "38363aab-f8db-46bf-82c0-5f55bbc293e4",
        "code": "38363aab-f8db-46bf-82c0-5f55bbc293e4",
        "name": "Grabación un color dos grabaciones iguales",
        "technique_name": "Grabación un color dos grabaciones iguales",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "H_H",
        "cifra_type": "Colores",
        "cifra_source_id": "38363aab-f8db-46bf-82c0-5f55bbc293e4",
        "section_1": 1,
        "price_1": 1.624,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.624,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.624,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.624,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.4,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.4,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.4,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.4,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 1.288,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 1.288,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 1.288,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 1.288,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 1.12,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 1.12,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 1.12,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 1.12,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_H_H_H",
        "code": "CIFRA_H_H_H",
        "name": "Grabación un color dos grabaciones diferentes",
        "technique_name": "Grabación un color dos grabaciones diferentes",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "H_H_H",
        "cifra_type": "Colores",
        "cifra_source_id": "e14f3dd9-28dc-45de-8251-2e9df92b2842",
        "section_1": 1,
        "price_1": 1.624,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.624,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.624,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.624,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.4,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.4,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.4,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.4,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 1.288,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 1.288,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 1.288,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 1.288,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 1.12,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 1.12,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 1.12,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 1.12,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "e14f3dd9-28dc-45de-8251-2e9df92b2842",
        "code": "e14f3dd9-28dc-45de-8251-2e9df92b2842",
        "name": "Grabación un color dos grabaciones diferentes",
        "technique_name": "Grabación un color dos grabaciones diferentes",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "H_H_H",
        "cifra_type": "Colores",
        "cifra_source_id": "e14f3dd9-28dc-45de-8251-2e9df92b2842",
        "section_1": 1,
        "price_1": 1.624,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.624,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.624,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.624,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.4,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.4,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.4,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.4,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 1.288,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 1.288,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 1.288,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 1.288,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 1.12,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 1.12,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 1.12,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 1.12,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_I",
        "code": "CIFRA_I",
        "name": "Serigrafía (I)",
        "technique_name": "Serigrafía (I)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "I",
        "cifra_type": "Colores",
        "cifra_source_id": "43723210-c182-4104-9d67-3dd84a39402d",
        "section_1": 1,
        "price_1": 0.98,
        "price_col_1": 0.966,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.98,
        "price_col_2": 0.966,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.98,
        "price_col_3": 0.966,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.98,
        "price_col_4": 0.966,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.91,
        "price_col_5": 0.448,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.91,
        "price_col_6": 0.448,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.91,
        "price_col_7": 0.448,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.91,
        "price_col_8": 0.448,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.756,
        "price_col_9": 0.392,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.756,
        "price_col_10": 0.392,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.756,
        "price_col_11": 0.392,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.756,
        "price_col_12": 0.392,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.658,
        "price_col_13": 0.364,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.658,
        "price_col_14": 0.364,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.658,
        "price_col_15": 0.364,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.658,
        "price_col_16": 0.364,
        "price_cm_16": 0
    },
    {
        "technique_ref": "43723210-c182-4104-9d67-3dd84a39402d",
        "code": "43723210-c182-4104-9d67-3dd84a39402d",
        "name": "Serigrafía (I)",
        "technique_name": "Serigrafía (I)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "I",
        "cifra_type": "Colores",
        "cifra_source_id": "43723210-c182-4104-9d67-3dd84a39402d",
        "section_1": 1,
        "price_1": 0.98,
        "price_col_1": 0.966,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.98,
        "price_col_2": 0.966,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.98,
        "price_col_3": 0.966,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.98,
        "price_col_4": 0.966,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.91,
        "price_col_5": 0.448,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.91,
        "price_col_6": 0.448,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.91,
        "price_col_7": 0.448,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.91,
        "price_col_8": 0.448,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.756,
        "price_col_9": 0.392,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.756,
        "price_col_10": 0.392,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.756,
        "price_col_11": 0.392,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.756,
        "price_col_12": 0.392,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.658,
        "price_col_13": 0.364,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.658,
        "price_col_14": 0.364,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.658,
        "price_col_15": 0.364,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.658,
        "price_col_16": 0.364,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_I_INT",
        "code": "CIFRA_I_INT",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "I_INT",
        "cifra_type": "Area",
        "cifra_source_id": "4d440997-6504-474e-9b46-548eb5789a4a",
        "section_1": 300,
        "price_1": 0.392,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.392,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.392,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.392,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.329,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.329,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.329,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.329,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.315,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.315,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.315,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.315,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.308,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.308,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.308,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.308,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.301,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.301,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.301,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.301,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.287,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.287,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.287,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.287,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "4d440997-6504-474e-9b46-548eb5789a4a",
        "code": "4d440997-6504-474e-9b46-548eb5789a4a",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "I_INT",
        "cifra_type": "Area",
        "cifra_source_id": "4d440997-6504-474e-9b46-548eb5789a4a",
        "section_1": 300,
        "price_1": 0.392,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.392,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.392,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.392,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.329,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.329,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.329,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.329,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.315,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.315,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.315,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.315,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.308,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.308,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.308,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.308,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.301,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.301,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.301,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.301,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.287,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.287,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.287,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.287,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_ICA_ICO",
        "code": "CIFRA_ICA_ICO",
        "name": "Incluye impresión a todo color",
        "technique_name": "Incluye impresión a todo color",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ICA_ICO",
        "cifra_type": "Area",
        "cifra_source_id": "264c5724-e106-484d-abc6-713c75cd66d2",
        "section_1": 300,
        "price_1": 0.455,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.455,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.455,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.455,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.343,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.343,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.343,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.343,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.315,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.315,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.315,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.315,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.28,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.28,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.28,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.28,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.273,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.273,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.273,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.273,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.252,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.252,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.252,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.252,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "264c5724-e106-484d-abc6-713c75cd66d2",
        "code": "264c5724-e106-484d-abc6-713c75cd66d2",
        "name": "Incluye impresión a todo color",
        "technique_name": "Incluye impresión a todo color",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ICA_ICO",
        "cifra_type": "Area",
        "cifra_source_id": "264c5724-e106-484d-abc6-713c75cd66d2",
        "section_1": 300,
        "price_1": 0.455,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.455,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.455,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.455,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.343,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.343,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.343,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.343,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.315,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.315,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.315,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.315,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.28,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.28,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.28,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.28,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.273,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.273,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.273,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.273,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.252,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.252,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.252,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.252,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_ICIR_6",
        "code": "CIFRA_ICIR_6",
        "name": "Serigrafía (I)",
        "technique_name": "Serigrafía (I)",
        "cliche": 70,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ICIR_6",
        "cifra_type": "Area",
        "cifra_source_id": "07373963-04dc-4afe-b662-f5bf58028df6",
        "section_1": 300,
        "price_1": 0.399,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.399,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.399,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.399,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.287,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.287,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.287,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.287,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.266,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.266,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.266,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.266,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.259,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.259,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.259,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.259,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.238,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.238,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.238,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.238,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.217,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.217,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.217,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.217,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "07373963-04dc-4afe-b662-f5bf58028df6",
        "code": "07373963-04dc-4afe-b662-f5bf58028df6",
        "name": "Serigrafía (I)",
        "technique_name": "Serigrafía (I)",
        "cliche": 70,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ICIR_6",
        "cifra_type": "Area",
        "cifra_source_id": "07373963-04dc-4afe-b662-f5bf58028df6",
        "section_1": 300,
        "price_1": 0.399,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.399,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.399,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.399,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.287,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.287,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.287,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.287,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.266,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.266,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.266,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.266,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.259,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.259,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.259,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.259,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.238,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.238,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.238,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.238,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.217,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.217,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.217,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.217,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_ICU_G",
        "code": "CIFRA_ICU_G",
        "name": "Imán cuadrado, mínimo 300 und",
        "technique_name": "Imán cuadrado, mínimo 300 und",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ICU_G",
        "cifra_type": "Area",
        "cifra_source_id": "543220c0-41c4-45d9-a84e-30a4c24a401d",
        "section_1": 300,
        "price_1": 0.4158,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.4158,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.4158,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.4158,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.3038,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.3038,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.3038,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.3038,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.2758,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.2758,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.2758,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.2758,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.2618,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.2618,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.2618,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.2618,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.2478,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.2478,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.2478,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.2478,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.2268,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.2268,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.2268,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.2268,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "543220c0-41c4-45d9-a84e-30a4c24a401d",
        "code": "543220c0-41c4-45d9-a84e-30a4c24a401d",
        "name": "Imán cuadrado, mínimo 300 und",
        "technique_name": "Imán cuadrado, mínimo 300 und",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "ICU_G",
        "cifra_type": "Area",
        "cifra_source_id": "543220c0-41c4-45d9-a84e-30a4c24a401d",
        "section_1": 300,
        "price_1": 0.4158,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.4158,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.4158,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.4158,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.3038,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.3038,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.3038,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.3038,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.2758,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.2758,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.2758,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.2758,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.2618,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.2618,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.2618,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.2618,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.2478,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.2478,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.2478,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.2478,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.2268,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.2268,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.2268,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.2268,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_IESP",
        "code": "CIFRA_IESP",
        "name": "Grabación offset a todo color",
        "technique_name": "Grabación offset a todo color",
        "cliche": 102.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "IESP",
        "cifra_type": "Area",
        "cifra_source_id": "dccd7ac2-5cc0-4ee6-a05f-eb72361d5410",
        "section_1": 300,
        "price_1": 0.9338,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.9338,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.9338,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.9338,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.7098,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.7098,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.7098,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.7098,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.4578,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.4578,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.4578,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.4578,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.4438,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.4438,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.4438,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.4438,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.4158,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.4158,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.4158,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.4158,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.4018,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.4018,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.4018,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.4018,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "dccd7ac2-5cc0-4ee6-a05f-eb72361d5410",
        "code": "dccd7ac2-5cc0-4ee6-a05f-eb72361d5410",
        "name": "Grabación offset a todo color",
        "technique_name": "Grabación offset a todo color",
        "cliche": 102.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "IESP",
        "cifra_type": "Area",
        "cifra_source_id": "dccd7ac2-5cc0-4ee6-a05f-eb72361d5410",
        "section_1": 300,
        "price_1": 0.9338,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.9338,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.9338,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.9338,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.7098,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.7098,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.7098,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.7098,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.4578,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.4578,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.4578,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.4578,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.4438,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.4438,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.4438,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.4438,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.4158,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.4158,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.4158,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.4158,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.4018,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.4018,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.4018,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.4018,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_IFAL",
        "code": "CIFRA_IFAL",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "IFAL",
        "cifra_type": "Area",
        "cifra_source_id": "306db0eb-22bd-4dea-b035-96bb37e0e5da",
        "section_1": 300,
        "price_1": 0.357,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.357,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.357,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.357,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.315,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.315,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.315,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.315,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.287,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.287,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.287,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.287,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.273,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.273,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.273,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.273,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.266,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.266,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.266,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.266,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "306db0eb-22bd-4dea-b035-96bb37e0e5da",
        "code": "306db0eb-22bd-4dea-b035-96bb37e0e5da",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "IFAL",
        "cifra_type": "Area",
        "cifra_source_id": "306db0eb-22bd-4dea-b035-96bb37e0e5da",
        "section_1": 300,
        "price_1": 0.357,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.357,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.357,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.357,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.315,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.315,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.315,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.315,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.287,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.287,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.287,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.287,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.273,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.273,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.273,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.273,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.266,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.266,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.266,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.266,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_IG",
        "code": "CIFRA_IG",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "IG",
        "cifra_type": "Area",
        "cifra_source_id": "28ffbd16-a2cf-45be-a07d-f9ee180d1bc6",
        "section_1": 300,
        "price_1": 0.455,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.455,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.455,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.455,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.343,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.343,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.343,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.343,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.315,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.315,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.315,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.315,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.28,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.28,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.28,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.28,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.273,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.273,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.273,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.273,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.252,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.252,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.252,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.252,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "28ffbd16-a2cf-45be-a07d-f9ee180d1bc6",
        "code": "28ffbd16-a2cf-45be-a07d-f9ee180d1bc6",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "IG",
        "cifra_type": "Area",
        "cifra_source_id": "28ffbd16-a2cf-45be-a07d-f9ee180d1bc6",
        "section_1": 300,
        "price_1": 0.455,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.455,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.455,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.455,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.343,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.343,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.343,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.343,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.315,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.315,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.315,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.315,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.28,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.28,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.28,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.28,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.273,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.273,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.273,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.273,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.252,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.252,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.252,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.252,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_IMAX",
        "code": "CIFRA_IMAX",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "IMAX",
        "cifra_type": "Area",
        "cifra_source_id": "c675c2f0-1a09-4da9-96d1-a4ecd83c7bf4",
        "section_1": 300,
        "price_1": 0.504,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.504,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.504,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.504,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.455,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.455,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.455,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.455,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.413,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.413,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.413,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.413,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.385,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.385,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.385,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.385,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.357,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.357,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.357,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.357,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.343,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.343,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.343,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.343,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "c675c2f0-1a09-4da9-96d1-a4ecd83c7bf4",
        "code": "c675c2f0-1a09-4da9-96d1-a4ecd83c7bf4",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "IMAX",
        "cifra_type": "Area",
        "cifra_source_id": "c675c2f0-1a09-4da9-96d1-a4ecd83c7bf4",
        "section_1": 300,
        "price_1": 0.504,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.504,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.504,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.504,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.455,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.455,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.455,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.455,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.413,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.413,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.413,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.413,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.385,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.385,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.385,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.385,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.357,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.357,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.357,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.357,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.343,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.343,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.343,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.343,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_KRF_01_03",
        "code": "CIFRA_KRF_01_03",
        "name": "Incluye impresión a todo color en ambas caras",
        "technique_name": "Incluye impresión a todo color en ambas caras",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "KRF_01_03",
        "cifra_type": "Area",
        "cifra_source_id": "a5b0b2c6-a590-4a92-997d-275404f5c414",
        "section_1": 250,
        "price_1": 0.3486,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.3486,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.3486,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.3486,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.2226,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.2226,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.2226,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.2226,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.147,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.147,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.147,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.147,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "a5b0b2c6-a590-4a92-997d-275404f5c414",
        "code": "a5b0b2c6-a590-4a92-997d-275404f5c414",
        "name": "Incluye impresión a todo color en ambas caras",
        "technique_name": "Incluye impresión a todo color en ambas caras",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "KRF_01_03",
        "cifra_type": "Area",
        "cifra_source_id": "a5b0b2c6-a590-4a92-997d-275404f5c414",
        "section_1": 250,
        "price_1": 0.3486,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.3486,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.3486,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.3486,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.2226,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.2226,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.2226,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.2226,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.147,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.147,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.147,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.147,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_KRF_02",
        "code": "CIFRA_KRF_02",
        "name": "Incluye impresión a todo color en ambas caras",
        "technique_name": "Incluye impresión a todo color en ambas caras",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "KRF_02",
        "cifra_type": "Area",
        "cifra_source_id": "b79e75a0-0be8-4ece-84fa-60147bb195d0",
        "section_1": 250,
        "price_1": 0.3178,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.3178,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.3178,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.3178,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.1862,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.1862,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.1862,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.1862,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.112,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.112,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.112,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.112,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "b79e75a0-0be8-4ece-84fa-60147bb195d0",
        "code": "b79e75a0-0be8-4ece-84fa-60147bb195d0",
        "name": "Incluye impresión a todo color en ambas caras",
        "technique_name": "Incluye impresión a todo color en ambas caras",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "KRF_02",
        "cifra_type": "Area",
        "cifra_source_id": "b79e75a0-0be8-4ece-84fa-60147bb195d0",
        "section_1": 250,
        "price_1": 0.3178,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.3178,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.3178,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.3178,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.1862,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.1862,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.1862,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.1862,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.112,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.112,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.112,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.112,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_KRF_04",
        "code": "CIFRA_KRF_04",
        "name": "Incluye impresión a todo color en ambas caras",
        "technique_name": "Incluye impresión a todo color en ambas caras",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "KRF_04",
        "cifra_type": "Area",
        "cifra_source_id": "829cf3ab-f701-4510-a09d-b64000747d8a",
        "section_1": 250,
        "price_1": 0.3066,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.3066,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.3066,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.3066,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.2142,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.2142,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.2142,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.2142,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.1372,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.1372,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.1372,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.1372,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "829cf3ab-f701-4510-a09d-b64000747d8a",
        "code": "829cf3ab-f701-4510-a09d-b64000747d8a",
        "name": "Incluye impresión a todo color en ambas caras",
        "technique_name": "Incluye impresión a todo color en ambas caras",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "KRF_04",
        "cifra_type": "Area",
        "cifra_source_id": "829cf3ab-f701-4510-a09d-b64000747d8a",
        "section_1": 250,
        "price_1": 0.3066,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.3066,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.3066,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.3066,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.2142,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.2142,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.2142,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.2142,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.1372,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.1372,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.1372,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.1372,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_L",
        "code": "CIFRA_L",
        "name": "Laser YAG (L)",
        "technique_name": "Laser YAG (L)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 49,
        "min_unit": null,
        "cifra_code": "L",
        "cifra_type": "Area",
        "cifra_source_id": "958e36ee-eee5-4940-8bab-7885bf73e2c0",
        "section_1": 1,
        "price_1": 0.462,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.462,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.462,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.462,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.406,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.406,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.406,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.406,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.336,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.336,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.336,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.336,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.266,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.266,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.266,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.266,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "958e36ee-eee5-4940-8bab-7885bf73e2c0",
        "code": "958e36ee-eee5-4940-8bab-7885bf73e2c0",
        "name": "Laser YAG (L)",
        "technique_name": "Laser YAG (L)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 49,
        "min_unit": null,
        "cifra_code": "L",
        "cifra_type": "Area",
        "cifra_source_id": "958e36ee-eee5-4940-8bab-7885bf73e2c0",
        "section_1": 1,
        "price_1": 0.462,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.462,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.462,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.462,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.406,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.406,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.406,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.406,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.336,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.336,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.336,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.336,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.266,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.266,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.266,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.266,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_L_L",
        "code": "CIFRA_L_L",
        "name": "Laser LCO1 dos caras iguales",
        "technique_name": "Laser LCO1 dos caras iguales",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 49,
        "min_unit": null,
        "cifra_code": "L_L",
        "cifra_type": "Area",
        "cifra_source_id": "62efa06b-d747-48e2-8e09-a4e223cff6d0",
        "section_1": 1,
        "price_1": 0.924,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.924,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.924,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.924,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.812,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.812,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.812,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.812,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.7,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.7,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.7,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.7,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.56,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.56,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.56,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.56,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "62efa06b-d747-48e2-8e09-a4e223cff6d0",
        "code": "62efa06b-d747-48e2-8e09-a4e223cff6d0",
        "name": "Laser LCO1 dos caras iguales",
        "technique_name": "Laser LCO1 dos caras iguales",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 49,
        "min_unit": null,
        "cifra_code": "L_L",
        "cifra_type": "Area",
        "cifra_source_id": "62efa06b-d747-48e2-8e09-a4e223cff6d0",
        "section_1": 1,
        "price_1": 0.924,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.924,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.924,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.924,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.812,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.812,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.812,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.812,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.7,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.7,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.7,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.7,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.56,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.56,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.56,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.56,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_L_L_L",
        "code": "CIFRA_L_L_L",
        "name": "Laser CO2, dos posiciones diferentes",
        "technique_name": "Laser CO2, dos posiciones diferentes",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 49,
        "min_unit": null,
        "cifra_code": "L_L_L",
        "cifra_type": "Area",
        "cifra_source_id": "35057708-8df1-4f3e-bdf1-16f83bcf3a33",
        "section_1": 1,
        "price_1": 1.26,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.26,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.26,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.26,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.232,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.232,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.232,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.232,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 200,
        "price_9": 1.204,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 200,
        "price_10": 1.204,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 200,
        "price_11": 1.204,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 200,
        "price_12": 1.204,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "35057708-8df1-4f3e-bdf1-16f83bcf3a33",
        "code": "35057708-8df1-4f3e-bdf1-16f83bcf3a33",
        "name": "Laser CO2, dos posiciones diferentes",
        "technique_name": "Laser CO2, dos posiciones diferentes",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 49,
        "min_unit": null,
        "cifra_code": "L_L_L",
        "cifra_type": "Area",
        "cifra_source_id": "35057708-8df1-4f3e-bdf1-16f83bcf3a33",
        "section_1": 1,
        "price_1": 1.26,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.26,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.26,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.26,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.232,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.232,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.232,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.232,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 200,
        "price_9": 1.204,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 200,
        "price_10": 1.204,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 200,
        "price_11": 1.204,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 200,
        "price_12": 1.204,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_LASER_360",
        "code": "CIFRA_LASER_360",
        "name": "Láser 360º",
        "technique_name": "Láser 360º",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 77,
        "min_unit": null,
        "cifra_code": "LASER_360",
        "cifra_type": "Area",
        "cifra_source_id": "e7eb19b8-3701-415e-823d-ce01ac865001",
        "section_1": 1,
        "price_1": 1.05,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.05,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.05,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.05,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.98,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.98,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.98,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.98,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.91,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.91,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.91,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.91,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.868,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.868,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.868,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.868,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "e7eb19b8-3701-415e-823d-ce01ac865001",
        "code": "e7eb19b8-3701-415e-823d-ce01ac865001",
        "name": "Láser 360º",
        "technique_name": "Láser 360º",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 77,
        "min_unit": null,
        "cifra_code": "LASER_360",
        "cifra_type": "Area",
        "cifra_source_id": "e7eb19b8-3701-415e-823d-ce01ac865001",
        "section_1": 1,
        "price_1": 1.05,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.05,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.05,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.05,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.98,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.98,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.98,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.98,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.91,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.91,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.91,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.91,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.868,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.868,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.868,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.868,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_LCO1",
        "code": "CIFRA_LCO1",
        "name": "Laser LCO1",
        "technique_name": "Laser LCO1",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "LCO1",
        "cifra_type": "Area",
        "cifra_source_id": "c3f57ea8-40c3-4771-888c-da2c766f7ae3",
        "section_1": 1,
        "price_1": 0.462,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.462,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.462,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.462,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.406,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.406,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.406,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.406,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.35,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.35,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.35,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.35,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.28,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.28,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.28,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.28,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "c3f57ea8-40c3-4771-888c-da2c766f7ae3",
        "code": "c3f57ea8-40c3-4771-888c-da2c766f7ae3",
        "name": "Laser LCO1",
        "technique_name": "Laser LCO1",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "LCO1",
        "cifra_type": "Area",
        "cifra_source_id": "c3f57ea8-40c3-4771-888c-da2c766f7ae3",
        "section_1": 1,
        "price_1": 0.462,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.462,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.462,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.462,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.406,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.406,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.406,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.406,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.35,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.35,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.35,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.35,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.28,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.28,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.28,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.28,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_LCO2",
        "code": "CIFRA_LCO2",
        "name": "Laser CO2 (LCO2)",
        "technique_name": "Laser CO2 (LCO2)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "LCO2",
        "cifra_type": "Area",
        "cifra_source_id": "58780420-f34f-44bf-be81-aff089e6678e",
        "section_1": 1,
        "price_1": 0.63,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.63,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.63,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.63,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.616,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.616,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.616,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.616,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 200,
        "price_9": 0.602,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 200,
        "price_10": 0.602,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 200,
        "price_11": 0.602,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 200,
        "price_12": 0.602,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "58780420-f34f-44bf-be81-aff089e6678e",
        "code": "58780420-f34f-44bf-be81-aff089e6678e",
        "name": "Laser CO2 (LCO2)",
        "technique_name": "Laser CO2 (LCO2)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "LCO2",
        "cifra_type": "Area",
        "cifra_source_id": "58780420-f34f-44bf-be81-aff089e6678e",
        "section_1": 1,
        "price_1": 0.63,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.63,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.63,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.63,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.616,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.616,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.616,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.616,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 200,
        "price_9": 0.602,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 200,
        "price_10": 0.602,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 200,
        "price_11": 0.602,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 200,
        "price_12": 0.602,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_LL001",
        "code": "CIFRA_LL001",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "LL001",
        "cifra_type": "Area",
        "cifra_source_id": "1abe6c49-8c9a-4267-b990-15e650ce2924",
        "section_1": 300,
        "price_1": 0.336,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.336,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.336,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.336,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.322,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.322,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.322,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.322,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.294,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.294,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.294,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.294,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "1abe6c49-8c9a-4267-b990-15e650ce2924",
        "code": "1abe6c49-8c9a-4267-b990-15e650ce2924",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "LL001",
        "cifra_type": "Area",
        "cifra_source_id": "1abe6c49-8c9a-4267-b990-15e650ce2924",
        "section_1": 300,
        "price_1": 0.336,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.336,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.336,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.336,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.322,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.322,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.322,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.322,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.294,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.294,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.294,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.294,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_LL002",
        "code": "CIFRA_LL002",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "LL002",
        "cifra_type": "Area",
        "cifra_source_id": "40410e41-5eb1-4142-96d7-8f9e092af2c5",
        "section_1": 300,
        "price_1": 0.49,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.49,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.49,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.49,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.476,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.476,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.476,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.476,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.462,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.462,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.462,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.462,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "40410e41-5eb1-4142-96d7-8f9e092af2c5",
        "code": "40410e41-5eb1-4142-96d7-8f9e092af2c5",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "LL002",
        "cifra_type": "Area",
        "cifra_source_id": "40410e41-5eb1-4142-96d7-8f9e092af2c5",
        "section_1": 300,
        "price_1": 0.49,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.49,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.49,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.49,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.476,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.476,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.476,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.476,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.462,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.462,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.462,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.462,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_LL003",
        "code": "CIFRA_LL003",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "LL003",
        "cifra_type": "Area",
        "cifra_source_id": "953ae564-84fe-4c9c-ad64-f2f4e47064ce",
        "section_1": 300,
        "price_1": 0.924,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.924,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.924,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.924,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.896,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.896,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.896,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.896,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.868,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.868,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.868,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.868,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.854,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.854,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.854,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.854,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.84,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.84,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.84,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.84,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "953ae564-84fe-4c9c-ad64-f2f4e47064ce",
        "code": "953ae564-84fe-4c9c-ad64-f2f4e47064ce",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "LL003",
        "cifra_type": "Area",
        "cifra_source_id": "953ae564-84fe-4c9c-ad64-f2f4e47064ce",
        "section_1": 300,
        "price_1": 0.924,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.924,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.924,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.924,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.896,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.896,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.896,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.896,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.868,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.868,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.868,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.868,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.854,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.854,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.854,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.854,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.84,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.84,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.84,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.84,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_LL004",
        "code": "CIFRA_LL004",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "LL004",
        "cifra_type": "Area",
        "cifra_source_id": "d8d55141-c5cf-4b59-9c99-bb748f359d12",
        "section_1": 300,
        "price_1": 0.882,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.882,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.882,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.882,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.854,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.854,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.854,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.854,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.826,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.826,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.826,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.826,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "d8d55141-c5cf-4b59-9c99-bb748f359d12",
        "code": "d8d55141-c5cf-4b59-9c99-bb748f359d12",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "LL004",
        "cifra_type": "Area",
        "cifra_source_id": "d8d55141-c5cf-4b59-9c99-bb748f359d12",
        "section_1": 300,
        "price_1": 0.882,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.882,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.882,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.882,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.854,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.854,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.854,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.854,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.826,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.826,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.826,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.826,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_LL011",
        "code": "CIFRA_LL011",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "LL011",
        "cifra_type": "Area",
        "cifra_source_id": "914e71c0-63c4-43ed-a0c5-a88b6e519bc2",
        "section_1": 300,
        "price_1": 0.616,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.616,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.616,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.616,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.602,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.602,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.602,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.602,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.56,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.56,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.56,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.56,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "914e71c0-63c4-43ed-a0c5-a88b6e519bc2",
        "code": "914e71c0-63c4-43ed-a0c5-a88b6e519bc2",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "LL011",
        "cifra_type": "Area",
        "cifra_source_id": "914e71c0-63c4-43ed-a0c5-a88b6e519bc2",
        "section_1": 300,
        "price_1": 0.616,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.616,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.616,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.616,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.602,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.602,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.602,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.602,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.56,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.56,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.56,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.56,
        "price_col_12": 0,
        "price_cm_12": 0
    },
    {
        "technique_ref": "CIFRA_LL031",
        "code": "CIFRA_LL031",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "LL031",
        "cifra_type": "Area",
        "cifra_source_id": "4dc559ec-27a1-420b-aee1-1d780767345e",
        "section_1": 300,
        "price_1": 0.644,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.644,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.644,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.644,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.623,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.623,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.623,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.623,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 750,
        "price_9": 0.609,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 750,
        "price_10": 0.609,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 750,
        "price_11": 0.609,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 750,
        "price_12": 0.609,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.602,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.602,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.602,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.602,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "4dc559ec-27a1-420b-aee1-1d780767345e",
        "code": "4dc559ec-27a1-420b-aee1-1d780767345e",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "LL031",
        "cifra_type": "Area",
        "cifra_source_id": "4dc559ec-27a1-420b-aee1-1d780767345e",
        "section_1": 300,
        "price_1": 0.644,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.644,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.644,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.644,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.623,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.623,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.623,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.623,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 750,
        "price_9": 0.609,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 750,
        "price_10": 0.609,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 750,
        "price_11": 0.609,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 750,
        "price_12": 0.609,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.602,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.602,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.602,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.602,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_MAL_IMAN",
        "code": "CIFRA_MAL_IMAN",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "MAL_IMAN",
        "cifra_type": "Area",
        "cifra_source_id": "3fccd770-7596-4d10-970d-ce6c709b19a3",
        "section_1": 300,
        "price_1": 0.329,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.329,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.329,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.329,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.287,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.287,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.287,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.287,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.273,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.273,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.273,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.273,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.259,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.259,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.259,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.259,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.245,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.245,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.245,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.245,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "3fccd770-7596-4d10-970d-ce6c709b19a3",
        "code": "3fccd770-7596-4d10-970d-ce6c709b19a3",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "MAL_IMAN",
        "cifra_type": "Area",
        "cifra_source_id": "3fccd770-7596-4d10-970d-ce6c709b19a3",
        "section_1": 300,
        "price_1": 0.329,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.329,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.329,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.329,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.287,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.287,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.287,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.287,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.273,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.273,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.273,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.273,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.259,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.259,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.259,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.259,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.245,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.245,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.245,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.245,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_MP_001",
        "code": "CIFRA_MP_001",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "MP_001",
        "cifra_type": "Area",
        "cifra_source_id": "5f20002d-bdc2-4e70-8002-092c26265cc3",
        "section_1": 500,
        "price_1": 0.3325,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.3325,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.3325,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.3325,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.2905,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.2905,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 1000,
        "price_7": 0.2905,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.2905,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.28,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.28,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.28,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.28,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.2625,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.2625,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.2625,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.2625,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.252,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.252,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.252,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.252,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "5f20002d-bdc2-4e70-8002-092c26265cc3",
        "code": "5f20002d-bdc2-4e70-8002-092c26265cc3",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "MP_001",
        "cifra_type": "Area",
        "cifra_source_id": "5f20002d-bdc2-4e70-8002-092c26265cc3",
        "section_1": 500,
        "price_1": 0.3325,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.3325,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.3325,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.3325,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.2905,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.2905,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 1000,
        "price_7": 0.2905,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.2905,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.28,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.28,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.28,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.28,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.2625,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.2625,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.2625,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.2625,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.252,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.252,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.252,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.252,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_MP_005",
        "code": "CIFRA_MP_005",
        "name": "Cuatricromia",
        "technique_name": "Cuatricromia",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "MP_005",
        "cifra_type": "Area",
        "cifra_source_id": "33036091-ff82-47af-bb04-533186c4b014",
        "section_1": 300,
        "price_1": 0.5642,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.5642,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.5642,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.5642,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.476,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.476,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.476,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.476,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.392,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.392,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.392,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.392,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.35,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.35,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.35,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.35,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.336,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.336,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.336,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.336,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.3248,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.3248,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.3248,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.3248,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "33036091-ff82-47af-bb04-533186c4b014",
        "code": "33036091-ff82-47af-bb04-533186c4b014",
        "name": "Cuatricromia",
        "technique_name": "Cuatricromia",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "MP_005",
        "cifra_type": "Area",
        "cifra_source_id": "33036091-ff82-47af-bb04-533186c4b014",
        "section_1": 300,
        "price_1": 0.5642,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.5642,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.5642,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.5642,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.476,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.476,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.476,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.476,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.392,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.392,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.392,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.392,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.35,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.35,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.35,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.35,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.336,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.336,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.336,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.336,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.3248,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.3248,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.3248,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.3248,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_MULTI",
        "code": "CIFRA_MULTI",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "MULTI",
        "cifra_type": "Area",
        "cifra_source_id": "65b00619-8e0b-4a34-bf84-91f1336307e7",
        "section_1": 300,
        "price_1": 0.6174,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.6174,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.6174,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.6174,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.4914,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.4914,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.4914,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.4914,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.3794,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.3794,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.3794,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.3794,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.364,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.364,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.364,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.364,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 4000,
        "price_17": 0.357,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 4000,
        "price_18": 0.357,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 4000,
        "price_19": 0.357,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 4000,
        "price_20": 0.357,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.3514,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.3514,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.3514,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.3514,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "65b00619-8e0b-4a34-bf84-91f1336307e7",
        "code": "65b00619-8e0b-4a34-bf84-91f1336307e7",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "MULTI",
        "cifra_type": "Area",
        "cifra_source_id": "65b00619-8e0b-4a34-bf84-91f1336307e7",
        "section_1": 300,
        "price_1": 0.6174,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.6174,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.6174,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.6174,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.4914,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.4914,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.4914,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.4914,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.3794,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.3794,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.3794,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.3794,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.364,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.364,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.364,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.364,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 4000,
        "price_17": 0.357,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 4000,
        "price_18": 0.357,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 4000,
        "price_19": 0.357,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 4000,
        "price_20": 0.357,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.3514,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.3514,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.3514,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.3514,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_MUN_TD",
        "code": "CIFRA_MUN_TD",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "MUN_TD",
        "cifra_type": "Area",
        "cifra_source_id": "b0143bf4-2d92-4012-9a0e-8eee9dee4712",
        "section_1": 500,
        "price_1": 0.49,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.49,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.49,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.49,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.42,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.42,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 1000,
        "price_7": 0.42,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.42,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.392,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.392,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.392,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.392,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.357,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.357,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.357,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.357,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "b0143bf4-2d92-4012-9a0e-8eee9dee4712",
        "code": "b0143bf4-2d92-4012-9a0e-8eee9dee4712",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "MUN_TD",
        "cifra_type": "Area",
        "cifra_source_id": "b0143bf4-2d92-4012-9a0e-8eee9dee4712",
        "section_1": 500,
        "price_1": 0.49,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.49,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.49,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.49,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.42,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.42,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 1000,
        "price_7": 0.42,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.42,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.392,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.392,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.392,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.392,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.357,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.357,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.357,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.357,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_N_012_2TINTA",
        "code": "CIFRA_N_012_2TINTA",
        "name": "Incluye grabación 2 colores",
        "technique_name": "Incluye grabación 2 colores",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_012_2TINTA",
        "cifra_type": "Area",
        "cifra_source_id": "0e6ff618-cb89-4187-85ea-6c9b76116573",
        "section_1": 250,
        "price_1": 4.41,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 4.41,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 4.41,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 4.41,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 4.256,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 4.256,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 4.256,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 4.256,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 3.696,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 3.696,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 3.696,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 3.696,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 3.528,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 3.528,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 3.528,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 3.528,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "0e6ff618-cb89-4187-85ea-6c9b76116573",
        "code": "0e6ff618-cb89-4187-85ea-6c9b76116573",
        "name": "Incluye grabación 2 colores",
        "technique_name": "Incluye grabación 2 colores",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_012_2TINTA",
        "cifra_type": "Area",
        "cifra_source_id": "0e6ff618-cb89-4187-85ea-6c9b76116573",
        "section_1": 250,
        "price_1": 4.41,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 4.41,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 4.41,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 4.41,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 4.256,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 4.256,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 4.256,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 4.256,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 3.696,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 3.696,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 3.696,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 3.696,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 3.528,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 3.528,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 3.528,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 3.528,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_N_012CUATRICROMIA",
        "code": "CIFRA_N_012CUATRICROMIA",
        "name": "Impresión a todo color",
        "technique_name": "Impresión a todo color",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_012CUATRICROMIA",
        "cifra_type": "Area",
        "cifra_source_id": "f2708e5f-cd33-4610-80dd-7c03427e33b8",
        "section_1": 250,
        "price_1": 4.578,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 4.578,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 4.578,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 4.578,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 4.466,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 4.466,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 4.466,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 4.466,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 4.046,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 4.046,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 4.046,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 4.046,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 3.71,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 3.71,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 3.71,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 3.71,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "f2708e5f-cd33-4610-80dd-7c03427e33b8",
        "code": "f2708e5f-cd33-4610-80dd-7c03427e33b8",
        "name": "Impresión a todo color",
        "technique_name": "Impresión a todo color",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_012CUATRICROMIA",
        "cifra_type": "Area",
        "cifra_source_id": "f2708e5f-cd33-4610-80dd-7c03427e33b8",
        "section_1": 250,
        "price_1": 4.578,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 4.578,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 4.578,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 4.578,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 4.466,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 4.466,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 4.466,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 4.466,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 4.046,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 4.046,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 4.046,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 4.046,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 3.71,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 3.71,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 3.71,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 3.71,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_N_013_1TINTA",
        "code": "CIFRA_N_013_1TINTA",
        "name": "Incluye grabación 1 tinta",
        "technique_name": "Incluye grabación 1 tinta",
        "cliche": 30.8,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_013_1TINTA",
        "cifra_type": "Area",
        "cifra_source_id": "1477a25a-5c70-4032-b792-a9e5faae73c1",
        "section_1": 250,
        "price_1": 1.274,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.274,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 1.274,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.274,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.924,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.924,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.924,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.924,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.742,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.742,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.742,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.742,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.644,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.644,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.644,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.644,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "1477a25a-5c70-4032-b792-a9e5faae73c1",
        "code": "1477a25a-5c70-4032-b792-a9e5faae73c1",
        "name": "Incluye grabación 1 tinta",
        "technique_name": "Incluye grabación 1 tinta",
        "cliche": 30.8,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_013_1TINTA",
        "cifra_type": "Area",
        "cifra_source_id": "1477a25a-5c70-4032-b792-a9e5faae73c1",
        "section_1": 250,
        "price_1": 1.274,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.274,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 1.274,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.274,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.924,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.924,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.924,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.924,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.742,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.742,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.742,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.742,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.644,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.644,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.644,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.644,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_N_013_FULLCOLOR",
        "code": "CIFRA_N_013_FULLCOLOR",
        "name": "Incluye grabación a todo color",
        "technique_name": "Incluye grabación a todo color",
        "cliche": 30.8,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_013_FULLCOLOR",
        "cifra_type": "Area",
        "cifra_source_id": "85ef6ff6-a5ad-4cf2-bfbf-65565a2583d6",
        "section_1": 250,
        "price_1": 1.806,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.806,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 1.806,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.806,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.078,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.078,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.078,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.078,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.938,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.938,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.938,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.938,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.742,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.742,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.742,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.742,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "85ef6ff6-a5ad-4cf2-bfbf-65565a2583d6",
        "code": "85ef6ff6-a5ad-4cf2-bfbf-65565a2583d6",
        "name": "Incluye grabación a todo color",
        "technique_name": "Incluye grabación a todo color",
        "cliche": 30.8,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_013_FULLCOLOR",
        "cifra_type": "Area",
        "cifra_source_id": "85ef6ff6-a5ad-4cf2-bfbf-65565a2583d6",
        "section_1": 250,
        "price_1": 1.806,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.806,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 1.806,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.806,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.078,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.078,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.078,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.078,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.938,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.938,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.938,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.938,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.742,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.742,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.742,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.742,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_N_014_1TINTA",
        "code": "CIFRA_N_014_1TINTA",
        "name": "Incluye grabación una tinta",
        "technique_name": "Incluye grabación una tinta",
        "cliche": 30.8,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_014_1TINTA",
        "cifra_type": "Area",
        "cifra_source_id": "4bbad94a-9616-47f3-9e1e-d0effc64538a",
        "section_1": 250,
        "price_1": 1.428,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.428,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 1.428,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.428,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.12,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.12,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.12,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.12,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 1.036,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 1.036,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 1.036,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 1.036,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.938,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.938,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.938,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.938,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "4bbad94a-9616-47f3-9e1e-d0effc64538a",
        "code": "4bbad94a-9616-47f3-9e1e-d0effc64538a",
        "name": "Incluye grabación una tinta",
        "technique_name": "Incluye grabación una tinta",
        "cliche": 30.8,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_014_1TINTA",
        "cifra_type": "Area",
        "cifra_source_id": "4bbad94a-9616-47f3-9e1e-d0effc64538a",
        "section_1": 250,
        "price_1": 1.428,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.428,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 1.428,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.428,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.12,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.12,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.12,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.12,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 1.036,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 1.036,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 1.036,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 1.036,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.938,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.938,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.938,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.938,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_N_014FULLCOLOR",
        "code": "CIFRA_N_014FULLCOLOR",
        "name": "Incluye grabación a todo color",
        "technique_name": "Incluye grabación a todo color",
        "cliche": 30.8,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_014FULLCOLOR",
        "cifra_type": "Area",
        "cifra_source_id": "8f3763e0-6f63-4ed7-9707-5633d2d40567",
        "section_1": 250,
        "price_1": 2.24,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 2.24,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 2.24,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.24,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.722,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.722,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.722,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.722,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 1.652,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 1.652,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 1.652,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 1.652,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 1.582,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 1.582,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 1.582,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 1.582,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "8f3763e0-6f63-4ed7-9707-5633d2d40567",
        "code": "8f3763e0-6f63-4ed7-9707-5633d2d40567",
        "name": "Incluye grabación a todo color",
        "technique_name": "Incluye grabación a todo color",
        "cliche": 30.8,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_014FULLCOLOR",
        "cifra_type": "Area",
        "cifra_source_id": "8f3763e0-6f63-4ed7-9707-5633d2d40567",
        "section_1": 250,
        "price_1": 2.24,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 2.24,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 2.24,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.24,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.722,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.722,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.722,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.722,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 1.652,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 1.652,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 1.652,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 1.652,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 1.582,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 1.582,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 1.582,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 1.582,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_N_820_830",
        "code": "CIFRA_N_820_830",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_820_830",
        "cifra_type": "Area",
        "cifra_source_id": "ecccff29-e275-40e2-a186-8c5e2e340445",
        "section_1": 250,
        "price_1": 1.904,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.904,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 1.904,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.904,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.274,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.274,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.274,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.274,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 1.092,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 1.092,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 1.092,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 1.092,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.938,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.938,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.938,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.938,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.826,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.826,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.826,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.826,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.714,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.714,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.714,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.714,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "ecccff29-e275-40e2-a186-8c5e2e340445",
        "code": "ecccff29-e275-40e2-a186-8c5e2e340445",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_820_830",
        "cifra_type": "Area",
        "cifra_source_id": "ecccff29-e275-40e2-a186-8c5e2e340445",
        "section_1": 250,
        "price_1": 1.904,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.904,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 1.904,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.904,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.274,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.274,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.274,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.274,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 1.092,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 1.092,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 1.092,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 1.092,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.938,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.938,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.938,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.938,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.826,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.826,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.826,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.826,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.714,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.714,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.714,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.714,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_N_821_831",
        "code": "CIFRA_N_821_831",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_821_831",
        "cifra_type": "Area",
        "cifra_source_id": "cced181a-69ab-4272-bb9b-52c6daae54fe",
        "section_1": 250,
        "price_1": 2.184,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 2.184,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 2.184,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.184,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.61,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.61,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.61,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.61,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 1.316,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 1.316,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 1.316,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 1.316,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 1.022,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 1.022,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 1.022,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 1.022,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.994,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.994,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.994,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.994,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.896,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.896,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.896,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.896,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "cced181a-69ab-4272-bb9b-52c6daae54fe",
        "code": "cced181a-69ab-4272-bb9b-52c6daae54fe",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_821_831",
        "cifra_type": "Area",
        "cifra_source_id": "cced181a-69ab-4272-bb9b-52c6daae54fe",
        "section_1": 250,
        "price_1": 2.184,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 2.184,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 2.184,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.184,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.61,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.61,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.61,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.61,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 1.316,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 1.316,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 1.316,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 1.316,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 1.022,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 1.022,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 1.022,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 1.022,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 0.994,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 0.994,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 0.994,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 0.994,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.896,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.896,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.896,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.896,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_N_822_832",
        "code": "CIFRA_N_822_832",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_822_832",
        "cifra_type": "Area",
        "cifra_source_id": "2c6fdb23-0875-467a-89ab-9baabbc327d3",
        "section_1": 250,
        "price_1": 2.366,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 2.366,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 2.366,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.366,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.68,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.68,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.68,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.68,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 1.4,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 1.4,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 1.4,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 1.4,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 1.176,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 1.176,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 1.176,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 1.176,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 1.008,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 1.008,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 1.008,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 1.008,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.952,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.952,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.952,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.952,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "2c6fdb23-0875-467a-89ab-9baabbc327d3",
        "code": "2c6fdb23-0875-467a-89ab-9baabbc327d3",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "N_822_832",
        "cifra_type": "Area",
        "cifra_source_id": "2c6fdb23-0875-467a-89ab-9baabbc327d3",
        "section_1": 250,
        "price_1": 2.366,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 2.366,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 2.366,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.366,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.68,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.68,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.68,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.68,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 1.4,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 1.4,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 1.4,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 1.4,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 1.176,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 1.176,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 1.176,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 1.176,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 3000,
        "price_17": 1.008,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 3000,
        "price_18": 1.008,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 3000,
        "price_19": 1.008,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 3000,
        "price_20": 1.008,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.952,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.952,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.952,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.952,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_NT_001",
        "code": "CIFRA_NT_001",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "NT_001",
        "cifra_type": "Area",
        "cifra_source_id": "2f65df74-50ff-420b-a9c6-e5ba6acf8be8",
        "section_1": 500,
        "price_1": 0.4018,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.4018,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.4018,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.4018,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.336,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.336,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 1000,
        "price_7": 0.336,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.336,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.315,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.315,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.315,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.315,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.308,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.308,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.308,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.308,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.294,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.294,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.294,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.294,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "2f65df74-50ff-420b-a9c6-e5ba6acf8be8",
        "code": "2f65df74-50ff-420b-a9c6-e5ba6acf8be8",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "NT_001",
        "cifra_type": "Area",
        "cifra_source_id": "2f65df74-50ff-420b-a9c6-e5ba6acf8be8",
        "section_1": 500,
        "price_1": 0.4018,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.4018,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.4018,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.4018,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.336,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.336,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 1000,
        "price_7": 0.336,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.336,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.315,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.315,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.315,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.315,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.308,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.308,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.308,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.308,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.294,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.294,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.294,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.294,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_NT_002",
        "code": "CIFRA_NT_002",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "NT_002",
        "cifra_type": "Area",
        "cifra_source_id": "80dffd5f-d128-474b-8481-5c15136444c2",
        "section_1": 500,
        "price_1": 0.714,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.714,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.714,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.714,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.595,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.595,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 1000,
        "price_7": 0.595,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.595,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.497,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.497,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.497,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.497,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.469,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.469,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.469,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.469,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.441,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.441,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.441,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.441,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "80dffd5f-d128-474b-8481-5c15136444c2",
        "code": "80dffd5f-d128-474b-8481-5c15136444c2",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "NT_002",
        "cifra_type": "Area",
        "cifra_source_id": "80dffd5f-d128-474b-8481-5c15136444c2",
        "section_1": 500,
        "price_1": 0.714,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.714,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.714,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.714,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.595,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.595,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 1000,
        "price_7": 0.595,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.595,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.497,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.497,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.497,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.497,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.469,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.469,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.469,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.469,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.441,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.441,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.441,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.441,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_PA_55X55",
        "code": "CIFRA_PA_55X55",
        "name": "Pañuelo poliéster, este precio incluye grabación 6 colores",
        "technique_name": "Pañuelo poliéster, este precio incluye grabación 6 colores",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PA_55X55",
        "cifra_type": "Colores",
        "cifra_source_id": "f4d4f472-a570-471d-bb89-908dcf10ed4b",
        "section_1": 100,
        "price_1": 6.048,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 6.048,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 6.048,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 6.048,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 5.53,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 5.53,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 5.53,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 5.53,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 5.32,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 5.32,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 5.32,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 5.32,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 5.04,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 5.04,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 5.04,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 5.04,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "f4d4f472-a570-471d-bb89-908dcf10ed4b",
        "code": "f4d4f472-a570-471d-bb89-908dcf10ed4b",
        "name": "Pañuelo poliéster, este precio incluye grabación 6 colores",
        "technique_name": "Pañuelo poliéster, este precio incluye grabación 6 colores",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PA_55X55",
        "cifra_type": "Colores",
        "cifra_source_id": "f4d4f472-a570-471d-bb89-908dcf10ed4b",
        "section_1": 100,
        "price_1": 6.048,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 6.048,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 6.048,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 6.048,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 5.53,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 5.53,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 5.53,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 5.53,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 5.32,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 5.32,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 5.32,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 5.32,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 5.04,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 5.04,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 5.04,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 5.04,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_PA_70X70",
        "code": "CIFRA_PA_70X70",
        "name": "Pañuelo poliéster, este precio incluye grabación 6 colores",
        "technique_name": "Pañuelo poliéster, este precio incluye grabación 6 colores",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PA_70X70",
        "cifra_type": "Colores",
        "cifra_source_id": "f8364a72-2512-4c23-96b2-2e50fae9164a",
        "section_1": 100,
        "price_1": 7.49,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 7.49,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 7.49,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 7.49,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 6.72,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 6.72,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 6.72,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 6.72,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 6.44,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 6.44,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 6.44,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 6.44,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 5.46,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 5.46,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 5.46,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 5.46,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "f8364a72-2512-4c23-96b2-2e50fae9164a",
        "code": "f8364a72-2512-4c23-96b2-2e50fae9164a",
        "name": "Pañuelo poliéster, este precio incluye grabación 6 colores",
        "technique_name": "Pañuelo poliéster, este precio incluye grabación 6 colores",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PA_70X70",
        "cifra_type": "Colores",
        "cifra_source_id": "f8364a72-2512-4c23-96b2-2e50fae9164a",
        "section_1": 100,
        "price_1": 7.49,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 7.49,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 7.49,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 7.49,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 6.72,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 6.72,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 6.72,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 6.72,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 6.44,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 6.44,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 6.44,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 6.44,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 5.46,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 5.46,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 5.46,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 5.46,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_PA_90X90",
        "code": "CIFRA_PA_90X90",
        "name": "Pañuelo poliéster, este precio incluye grabación 6 colores",
        "technique_name": "Pañuelo poliéster, este precio incluye grabación 6 colores",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PA_90X90",
        "cifra_type": "Colores",
        "cifra_source_id": "9b6297e1-b79f-40b9-9635-242a0c1c0cf8",
        "section_1": 100,
        "price_1": 13.02,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 13.02,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 13.02,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 13.02,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 12.6,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 12.6,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 12.6,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 12.6,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 12.32,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 12.32,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 12.32,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 12.32,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 11.13,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 11.13,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 11.13,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 11.13,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "9b6297e1-b79f-40b9-9635-242a0c1c0cf8",
        "code": "9b6297e1-b79f-40b9-9635-242a0c1c0cf8",
        "name": "Pañuelo poliéster, este precio incluye grabación 6 colores",
        "technique_name": "Pañuelo poliéster, este precio incluye grabación 6 colores",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PA_90X90",
        "cifra_type": "Colores",
        "cifra_source_id": "9b6297e1-b79f-40b9-9635-242a0c1c0cf8",
        "section_1": 100,
        "price_1": 13.02,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 13.02,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 13.02,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 13.02,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 12.6,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 12.6,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 12.6,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 12.6,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 12.32,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 12.32,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 12.32,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 12.32,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 11.13,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 11.13,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 11.13,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 11.13,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_PA_AZ",
        "code": "CIFRA_PA_AZ",
        "name": "Pañoleta azafata",
        "technique_name": "Pañoleta azafata",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PA_AZ",
        "cifra_type": "Colores",
        "cifra_source_id": "f5c11c55-6e8b-43bf-a22b-be5be8ddc94a",
        "section_1": 100,
        "price_1": 10.15,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 10.15,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 10.15,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 10.15,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 7.07,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 7.07,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 7.07,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 7.07,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 6.146,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 6.146,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 6.146,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 6.146,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 4.865,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 4.865,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 4.865,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 4.865,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "f5c11c55-6e8b-43bf-a22b-be5be8ddc94a",
        "code": "f5c11c55-6e8b-43bf-a22b-be5be8ddc94a",
        "name": "Pañoleta azafata",
        "technique_name": "Pañoleta azafata",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PA_AZ",
        "cifra_type": "Colores",
        "cifra_source_id": "f5c11c55-6e8b-43bf-a22b-be5be8ddc94a",
        "section_1": 100,
        "price_1": 10.15,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 10.15,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 10.15,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 10.15,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 7.07,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 7.07,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 7.07,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 7.07,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 6.146,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 6.146,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 6.146,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 6.146,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 4.865,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 4.865,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 4.865,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 4.865,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_PAS_55X55",
        "code": "CIFRA_PAS_55X55",
        "name": "Pañuelo 100% seda, este precio incluye grab.6 colores",
        "technique_name": "Pañuelo 100% seda, este precio incluye grab.6 colores",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PAS_55X55",
        "cifra_type": "Colores",
        "cifra_source_id": "e878f56d-b582-43cc-80d7-451d748cb182",
        "section_1": 100,
        "price_1": 24.57,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 24.57,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 24.57,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 24.57,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 24.36,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 24.36,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 24.36,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 24.36,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 23.8,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 23.8,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 23.8,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 23.8,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 23.52,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 23.52,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 23.52,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 23.52,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "e878f56d-b582-43cc-80d7-451d748cb182",
        "code": "e878f56d-b582-43cc-80d7-451d748cb182",
        "name": "Pañuelo 100% seda, este precio incluye grab.6 colores",
        "technique_name": "Pañuelo 100% seda, este precio incluye grab.6 colores",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PAS_55X55",
        "cifra_type": "Colores",
        "cifra_source_id": "e878f56d-b582-43cc-80d7-451d748cb182",
        "section_1": 100,
        "price_1": 24.57,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 24.57,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 24.57,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 24.57,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 24.36,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 24.36,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 24.36,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 24.36,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 23.8,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 23.8,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 23.8,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 23.8,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 23.52,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 23.52,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 23.52,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 23.52,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_PAS_70X70",
        "code": "CIFRA_PAS_70X70",
        "name": "Pañuelo 100% seda, este precio incluye grab. 6 colores",
        "technique_name": "Pañuelo 100% seda, este precio incluye grab. 6 colores",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PAS_70X70",
        "cifra_type": "Colores",
        "cifra_source_id": "19f14984-20e6-4a2a-8125-31b5fd16e0a7",
        "section_1": 100,
        "price_1": 26.46,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 26.46,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 26.46,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 26.46,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 26.04,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 26.04,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 26.04,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 26.04,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 25.2,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 25.2,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 25.2,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 25.2,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 23.94,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 23.94,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 23.94,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 23.94,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "19f14984-20e6-4a2a-8125-31b5fd16e0a7",
        "code": "19f14984-20e6-4a2a-8125-31b5fd16e0a7",
        "name": "Pañuelo 100% seda, este precio incluye grab. 6 colores",
        "technique_name": "Pañuelo 100% seda, este precio incluye grab. 6 colores",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PAS_70X70",
        "cifra_type": "Colores",
        "cifra_source_id": "19f14984-20e6-4a2a-8125-31b5fd16e0a7",
        "section_1": 100,
        "price_1": 26.46,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 26.46,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 26.46,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 26.46,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 26.04,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 26.04,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 26.04,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 26.04,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 25.2,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 25.2,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 25.2,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 25.2,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 23.94,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 23.94,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 23.94,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 23.94,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_PAS_90X90",
        "code": "CIFRA_PAS_90X90",
        "name": "Pañuelo 100% seda, este precio incluye grab. 6 colores",
        "technique_name": "Pañuelo 100% seda, este precio incluye grab. 6 colores",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PAS_90X90",
        "cifra_type": "Colores",
        "cifra_source_id": "f972d03c-b479-48a2-8714-26299ebd5b22",
        "section_1": 100,
        "price_1": 40.88,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 40.88,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 40.88,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 40.88,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 38.92,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 38.92,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 38.92,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 38.92,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 38.36,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 38.36,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 38.36,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 38.36,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 36.19,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 36.19,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 36.19,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 36.19,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "f972d03c-b479-48a2-8714-26299ebd5b22",
        "code": "f972d03c-b479-48a2-8714-26299ebd5b22",
        "name": "Pañuelo 100% seda, este precio incluye grab. 6 colores",
        "technique_name": "Pañuelo 100% seda, este precio incluye grab. 6 colores",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PAS_90X90",
        "cifra_type": "Colores",
        "cifra_source_id": "f972d03c-b479-48a2-8714-26299ebd5b22",
        "section_1": 100,
        "price_1": 40.88,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 40.88,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 40.88,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 40.88,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 38.92,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 38.92,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 38.92,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 38.92,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 38.36,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 38.36,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 38.36,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 38.36,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 36.19,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 36.19,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 36.19,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 36.19,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_PULSERAS_JACQUARD",
        "code": "CIFRA_PULSERAS_JACQUARD",
        "name": "Pulseras personalizadas jacquard",
        "technique_name": "Pulseras personalizadas jacquard",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PULSERAS_JACQUARD",
        "cifra_type": "Area",
        "cifra_source_id": "bb685d46-1cc3-44b1-a58f-50bd16e72883",
        "section_1": 300,
        "price_1": 0.525,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.525,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.525,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.525,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.385,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.385,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.385,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.385,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.308,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.308,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.308,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.308,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.238,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.238,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.238,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.238,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.217,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.217,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.217,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.217,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 10000,
        "price_21": 0.168,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 10000,
        "price_22": 0.168,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 10000,
        "price_23": 0.168,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 10000,
        "price_24": 0.168,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "bb685d46-1cc3-44b1-a58f-50bd16e72883",
        "code": "bb685d46-1cc3-44b1-a58f-50bd16e72883",
        "name": "Pulseras personalizadas jacquard",
        "technique_name": "Pulseras personalizadas jacquard",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "PULSERAS_JACQUARD",
        "cifra_type": "Area",
        "cifra_source_id": "bb685d46-1cc3-44b1-a58f-50bd16e72883",
        "section_1": 300,
        "price_1": 0.525,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.525,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.525,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.525,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.385,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.385,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.385,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.385,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.308,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.308,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.308,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.308,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.238,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.238,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.238,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.238,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.217,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.217,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.217,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.217,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 10000,
        "price_21": 0.168,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 10000,
        "price_22": 0.168,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 10000,
        "price_23": 0.168,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 10000,
        "price_24": 0.168,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_R1",
        "code": "CIFRA_R1",
        "name": "Sublimación 100cm2",
        "technique_name": "Sublimación 100cm2",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R1",
        "cifra_type": "Area",
        "cifra_source_id": "7c59c859-17a9-449e-a201-a0ca350b874b",
        "section_1": 1,
        "price_1": 1.12,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.12,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.12,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.12,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 1.05,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.05,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 1.05,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 1.05,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 0.966,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 0.966,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 0.966,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 0.966,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.868,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.868,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.868,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.868,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "7c59c859-17a9-449e-a201-a0ca350b874b",
        "code": "7c59c859-17a9-449e-a201-a0ca350b874b",
        "name": "Sublimación 100cm2",
        "technique_name": "Sublimación 100cm2",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R1",
        "cifra_type": "Area",
        "cifra_source_id": "7c59c859-17a9-449e-a201-a0ca350b874b",
        "section_1": 1,
        "price_1": 1.12,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.12,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.12,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.12,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 1.05,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.05,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 1.05,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 1.05,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 0.966,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 0.966,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 0.966,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 0.966,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.868,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.868,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.868,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.868,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_R1_R1",
        "code": "CIFRA_R1_R1",
        "name": "Sublimación 100cm2",
        "technique_name": "Sublimación 100cm2",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R1_R1",
        "cifra_type": "Area",
        "cifra_source_id": "3ab98245-9232-451b-87dc-8ebcc76e09b2",
        "section_1": 1,
        "price_1": 2.24,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 2.24,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 2.24,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 2.24,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 2.1,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 2.1,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 2.1,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 2.1,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.932,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.932,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.932,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.932,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.736,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.736,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.736,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.736,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "3ab98245-9232-451b-87dc-8ebcc76e09b2",
        "code": "3ab98245-9232-451b-87dc-8ebcc76e09b2",
        "name": "Sublimación 100cm2",
        "technique_name": "Sublimación 100cm2",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R1_R1",
        "cifra_type": "Area",
        "cifra_source_id": "3ab98245-9232-451b-87dc-8ebcc76e09b2",
        "section_1": 1,
        "price_1": 2.24,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 2.24,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 2.24,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 2.24,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 2.1,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 2.1,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 2.1,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 2.1,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.932,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.932,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.932,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.932,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.736,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.736,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.736,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.736,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_R10",
        "code": "CIFRA_R10",
        "name": "Sublimación lanyards",
        "technique_name": "Sublimación lanyards",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R10",
        "cifra_type": "Area",
        "cifra_source_id": "33b371b6-9e6b-4651-927c-53e3db0eea79",
        "section_1": 100,
        "price_1": 1.19,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.19,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.19,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.19,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.98,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.98,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.98,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.98,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.924,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.924,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.924,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.924,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.882,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.882,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.882,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.882,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "33b371b6-9e6b-4651-927c-53e3db0eea79",
        "code": "33b371b6-9e6b-4651-927c-53e3db0eea79",
        "name": "Sublimación lanyards",
        "technique_name": "Sublimación lanyards",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R10",
        "cifra_type": "Area",
        "cifra_source_id": "33b371b6-9e6b-4651-927c-53e3db0eea79",
        "section_1": 100,
        "price_1": 1.19,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.19,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.19,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.19,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.98,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.98,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.98,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.98,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.924,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.924,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.924,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.924,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.882,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.882,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.882,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.882,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_R11",
        "code": "CIFRA_R11",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 84,
        "min_unit": null,
        "cifra_code": "R11",
        "cifra_type": "Area",
        "cifra_source_id": "f697f09c-4d38-4c1b-890b-fe314857178e",
        "section_1": 1,
        "price_1": 4.06,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 4.06,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 4.06,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 4.06,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 3.92,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 3.92,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 3.92,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 3.92,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 300,
        "price_9": 3.738,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 300,
        "price_10": 3.738,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 300,
        "price_11": 3.738,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 300,
        "price_12": 3.738,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 3.36,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 3.36,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 3.36,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 3.36,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "f697f09c-4d38-4c1b-890b-fe314857178e",
        "code": "f697f09c-4d38-4c1b-890b-fe314857178e",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 84,
        "min_unit": null,
        "cifra_code": "R11",
        "cifra_type": "Area",
        "cifra_source_id": "f697f09c-4d38-4c1b-890b-fe314857178e",
        "section_1": 1,
        "price_1": 4.06,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 4.06,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 4.06,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 4.06,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 3.92,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 3.92,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 3.92,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 3.92,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 300,
        "price_9": 3.738,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 300,
        "price_10": 3.738,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 300,
        "price_11": 3.738,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 300,
        "price_12": 3.738,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 3.36,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 3.36,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 3.36,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 3.36,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_R12",
        "code": "CIFRA_R12",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 63,
        "min_unit": null,
        "cifra_code": "R12",
        "cifra_type": "Colores",
        "cifra_source_id": "a04baf2a-5707-43b9-8a6f-0fab3fba85ec",
        "section_1": 100,
        "price_1": 1.162,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.162,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.162,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.162,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 1.078,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 1.078,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 1.078,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 1.078,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.05,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.05,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.05,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.05,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.022,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.022,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.022,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.022,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 0.994,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 0.994,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 0.994,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 0.994,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.966,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.966,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.966,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.966,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "a04baf2a-5707-43b9-8a6f-0fab3fba85ec",
        "code": "a04baf2a-5707-43b9-8a6f-0fab3fba85ec",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 63,
        "min_unit": null,
        "cifra_code": "R12",
        "cifra_type": "Colores",
        "cifra_source_id": "a04baf2a-5707-43b9-8a6f-0fab3fba85ec",
        "section_1": 100,
        "price_1": 1.162,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.162,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.162,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.162,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 1.078,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 1.078,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 1.078,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 1.078,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.05,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.05,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.05,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.05,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.022,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.022,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.022,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.022,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 0.994,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 0.994,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 0.994,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 0.994,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.966,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.966,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.966,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.966,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_R13",
        "code": "CIFRA_R13",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R13",
        "cifra_type": "Area",
        "cifra_source_id": "ba14f906-d1ae-4194-8bd7-f489222a8174",
        "section_1": 100,
        "price_1": 0.798,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.798,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.798,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.798,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 0.784,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 0.784,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 0.784,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 0.784,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 0.77,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 0.77,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 0.77,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 0.77,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.756,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.756,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.756,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.756,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 0.742,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 0.742,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 0.742,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 0.742,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.728,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.728,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.728,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.728,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "ba14f906-d1ae-4194-8bd7-f489222a8174",
        "code": "ba14f906-d1ae-4194-8bd7-f489222a8174",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R13",
        "cifra_type": "Area",
        "cifra_source_id": "ba14f906-d1ae-4194-8bd7-f489222a8174",
        "section_1": 100,
        "price_1": 0.798,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.798,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.798,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.798,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 0.784,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 0.784,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 0.784,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 0.784,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 0.77,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 0.77,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 0.77,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 0.77,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.756,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.756,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.756,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.756,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 0.742,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 0.742,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 0.742,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 0.742,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.728,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.728,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.728,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.728,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_R14",
        "code": "CIFRA_R14",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R14",
        "cifra_type": "Area",
        "cifra_source_id": "2207a1d2-663a-4e67-80b0-d5b4e1b28535",
        "section_1": 100,
        "price_1": 1.33,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.33,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.33,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.33,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 1.288,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 1.288,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 1.288,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 1.288,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.26,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.26,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.26,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.26,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.232,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.232,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.232,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.232,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 1.204,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 1.204,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 1.204,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 1.204,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 1.176,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 1.176,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 1.176,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 1.176,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "2207a1d2-663a-4e67-80b0-d5b4e1b28535",
        "code": "2207a1d2-663a-4e67-80b0-d5b4e1b28535",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R14",
        "cifra_type": "Area",
        "cifra_source_id": "2207a1d2-663a-4e67-80b0-d5b4e1b28535",
        "section_1": 100,
        "price_1": 1.33,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.33,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.33,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.33,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 1.288,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 1.288,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 1.288,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 1.288,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.26,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.26,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.26,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.26,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.232,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.232,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.232,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.232,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 1.204,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 1.204,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 1.204,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 1.204,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 1.176,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 1.176,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 1.176,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 1.176,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_R14_1",
        "code": "CIFRA_R14_1",
        "name": "Sublimación dos caras distinta grabación",
        "technique_name": "Sublimación dos caras distinta grabación",
        "cliche": 84,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R14_1",
        "cifra_type": "Area",
        "cifra_source_id": "77b40c04-46f2-4ee7-841c-5bb41ced8ec1",
        "section_1": 100,
        "price_1": 1.33,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.33,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.33,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.33,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 1.288,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 1.288,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 1.288,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 1.288,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.26,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.26,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.26,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.26,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.232,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.232,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.232,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.232,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 1.204,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 1.204,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 1.204,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 1.204,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 1.176,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 1.176,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 1.176,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 1.176,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "77b40c04-46f2-4ee7-841c-5bb41ced8ec1",
        "code": "77b40c04-46f2-4ee7-841c-5bb41ced8ec1",
        "name": "Sublimación dos caras distinta grabación",
        "technique_name": "Sublimación dos caras distinta grabación",
        "cliche": 84,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R14_1",
        "cifra_type": "Area",
        "cifra_source_id": "77b40c04-46f2-4ee7-841c-5bb41ced8ec1",
        "section_1": 100,
        "price_1": 1.33,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.33,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.33,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.33,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 1.288,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 1.288,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 1.288,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 1.288,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.26,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.26,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.26,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.26,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.232,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.232,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.232,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.232,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 1.204,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 1.204,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 1.204,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 1.204,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 1.176,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 1.176,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 1.176,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 1.176,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_R15",
        "code": "CIFRA_R15",
        "name": "Sublimación dos caras misma grabación",
        "technique_name": "Sublimación dos caras misma grabación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R15",
        "cifra_type": "Area",
        "cifra_source_id": "432ec768-fa2c-4d48-8b85-62181f06cfce",
        "section_1": 100,
        "price_1": 1.554,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.554,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.554,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.554,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 1.526,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 1.526,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 1.526,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 1.526,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.498,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.498,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.498,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.498,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.47,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.47,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.47,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.47,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 1.442,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 1.442,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 1.442,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 1.442,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 1.414,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 1.414,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 1.414,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 1.414,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "432ec768-fa2c-4d48-8b85-62181f06cfce",
        "code": "432ec768-fa2c-4d48-8b85-62181f06cfce",
        "name": "Sublimación dos caras misma grabación",
        "technique_name": "Sublimación dos caras misma grabación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R15",
        "cifra_type": "Area",
        "cifra_source_id": "432ec768-fa2c-4d48-8b85-62181f06cfce",
        "section_1": 100,
        "price_1": 1.554,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.554,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.554,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.554,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 1.526,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 1.526,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 1.526,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 1.526,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.498,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.498,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.498,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.498,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.47,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.47,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.47,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.47,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 1.442,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 1.442,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 1.442,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 1.442,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 1.414,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 1.414,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 1.414,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 1.414,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_R15_1",
        "code": "CIFRA_R15_1",
        "name": "Sublimación dos caras distinta grabación",
        "technique_name": "Sublimación dos caras distinta grabación",
        "cliche": 84,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R15_1",
        "cifra_type": "Area",
        "cifra_source_id": "eb43dceb-3402-4e5d-9f7f-611c21c6abdd",
        "section_1": 100,
        "price_1": 1.554,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.554,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.554,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.554,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 1.526,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 1.526,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 1.526,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 1.526,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.498,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.498,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.498,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.498,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.47,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.47,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.47,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.47,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 1.442,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 1.442,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 1.442,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 1.442,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 1.414,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 1.414,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 1.414,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 1.414,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "eb43dceb-3402-4e5d-9f7f-611c21c6abdd",
        "code": "eb43dceb-3402-4e5d-9f7f-611c21c6abdd",
        "name": "Sublimación dos caras distinta grabación",
        "technique_name": "Sublimación dos caras distinta grabación",
        "cliche": 84,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R15_1",
        "cifra_type": "Area",
        "cifra_source_id": "eb43dceb-3402-4e5d-9f7f-611c21c6abdd",
        "section_1": 100,
        "price_1": 1.554,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.554,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.554,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.554,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 1.526,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 300,
        "price_6": 1.526,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 300,
        "price_7": 1.526,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 300,
        "price_8": 1.526,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.498,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.498,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.498,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.498,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.47,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.47,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.47,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.47,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 1.442,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 1.442,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 1.442,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 1.442,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 1.414,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 1.414,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 1.414,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 1.414,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_R16",
        "code": "CIFRA_R16",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R16",
        "cifra_type": "Area",
        "cifra_source_id": "cbe1b9eb-919f-481b-998a-56793d9fd9a3",
        "section_1": 300,
        "price_1": 0.28,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.28,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.28,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.28,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.266,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.266,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.266,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.266,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.245,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.245,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.245,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.245,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.238,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.238,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.238,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.238,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "cbe1b9eb-919f-481b-998a-56793d9fd9a3",
        "code": "cbe1b9eb-919f-481b-998a-56793d9fd9a3",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R16",
        "cifra_type": "Area",
        "cifra_source_id": "cbe1b9eb-919f-481b-998a-56793d9fd9a3",
        "section_1": 300,
        "price_1": 0.28,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.28,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.28,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.28,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.266,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.266,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.266,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.266,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.245,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.245,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.245,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.245,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.238,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.238,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.238,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.238,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_R17",
        "code": "CIFRA_R17",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R17",
        "cifra_type": "Area",
        "cifra_source_id": "10074450-c91c-4866-bd82-1d1e9a10a289",
        "section_1": 300,
        "price_1": 0.392,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.392,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.392,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.392,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.378,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.378,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.378,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.378,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.364,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.364,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.364,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.364,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.35,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.35,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.35,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.35,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "10074450-c91c-4866-bd82-1d1e9a10a289",
        "code": "10074450-c91c-4866-bd82-1d1e9a10a289",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R17",
        "cifra_type": "Area",
        "cifra_source_id": "10074450-c91c-4866-bd82-1d1e9a10a289",
        "section_1": 300,
        "price_1": 0.392,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.392,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.392,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.392,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.378,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.378,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.378,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.378,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.364,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.364,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.364,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.364,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.35,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.35,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.35,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.35,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_R18",
        "code": "CIFRA_R18",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R18",
        "cifra_type": "Area",
        "cifra_source_id": "1376a387-6058-4c7f-8875-c555c9d07997",
        "section_1": 300,
        "price_1": 0.392,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.392,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.392,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.392,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.378,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.378,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.378,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.378,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.364,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.364,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.364,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.364,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.35,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.35,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.35,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.35,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "1376a387-6058-4c7f-8875-c555c9d07997",
        "code": "1376a387-6058-4c7f-8875-c555c9d07997",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "cifra_code": "R18",
        "cifra_type": "Area",
        "cifra_source_id": "1376a387-6058-4c7f-8875-c555c9d07997",
        "section_1": 300,
        "price_1": 0.392,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.392,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.392,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.392,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.378,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.378,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.378,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.378,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.364,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.364,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.364,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.364,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.35,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.35,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.35,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.35,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_R2",
        "code": "CIFRA_R2",
        "name": "Sublimación 400cm2",
        "technique_name": "Sublimación 400cm2",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R2",
        "cifra_type": "Area",
        "cifra_source_id": "f1e50d03-b7c0-43e6-a9fc-31a618685363",
        "section_1": 1,
        "price_1": 1.246,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.246,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.246,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.246,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 1.148,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.148,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 1.148,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 1.148,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.022,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.022,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.022,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.022,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.966,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.966,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.966,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.966,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "f1e50d03-b7c0-43e6-a9fc-31a618685363",
        "code": "f1e50d03-b7c0-43e6-a9fc-31a618685363",
        "name": "Sublimación 400cm2",
        "technique_name": "Sublimación 400cm2",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R2",
        "cifra_type": "Area",
        "cifra_source_id": "f1e50d03-b7c0-43e6-a9fc-31a618685363",
        "section_1": 1,
        "price_1": 1.246,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.246,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.246,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.246,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 1.148,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.148,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 1.148,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 1.148,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.022,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.022,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.022,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.022,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.966,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.966,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.966,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.966,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_R3",
        "code": "CIFRA_R3",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R3",
        "cifra_type": "Area",
        "cifra_source_id": "d26df677-d628-4bd0-8d69-73b6da577ec3",
        "section_1": 1,
        "price_1": 1.932,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.932,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.932,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.932,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 1.54,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.54,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 1.54,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 1.54,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.428,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.428,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.428,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.428,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.372,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.372,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.372,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.372,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "d26df677-d628-4bd0-8d69-73b6da577ec3",
        "code": "d26df677-d628-4bd0-8d69-73b6da577ec3",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R3",
        "cifra_type": "Area",
        "cifra_source_id": "d26df677-d628-4bd0-8d69-73b6da577ec3",
        "section_1": 1,
        "price_1": 1.932,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.932,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.932,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.932,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 1.54,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.54,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 1.54,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 1.54,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.428,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.428,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.428,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.428,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 1.372,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 1.372,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 1.372,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 1.372,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_R4",
        "code": "CIFRA_R4",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R4",
        "cifra_type": "Area",
        "cifra_source_id": "cebf4b27-9ade-43da-b2be-e2cc6a2484fd",
        "section_1": 1,
        "price_1": 0.84,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.84,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.84,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.84,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.77,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.77,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.77,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.77,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 300,
        "price_9": 0.686,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 300,
        "price_10": 0.686,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 300,
        "price_11": 0.686,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 300,
        "price_12": 0.686,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.63,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.63,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.63,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.63,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "cebf4b27-9ade-43da-b2be-e2cc6a2484fd",
        "code": "cebf4b27-9ade-43da-b2be-e2cc6a2484fd",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R4",
        "cifra_type": "Area",
        "cifra_source_id": "cebf4b27-9ade-43da-b2be-e2cc6a2484fd",
        "section_1": 1,
        "price_1": 0.84,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.84,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.84,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.84,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.77,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.77,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.77,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.77,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 300,
        "price_9": 0.686,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 300,
        "price_10": 0.686,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 300,
        "price_11": 0.686,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 300,
        "price_12": 0.686,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.63,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.63,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.63,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.63,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_R5",
        "code": "CIFRA_R5",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 63,
        "min_unit": null,
        "cifra_code": "R5",
        "cifra_type": "Colores",
        "cifra_source_id": "c7ef5190-e984-48aa-8d94-2621c2a3210e",
        "section_1": 1,
        "price_1": 0.56,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.56,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.56,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.56,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.56,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.56,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.56,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.56,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.378,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.378,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.378,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.378,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.35,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.35,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.35,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.35,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.336,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.336,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.336,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.336,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "c7ef5190-e984-48aa-8d94-2621c2a3210e",
        "code": "c7ef5190-e984-48aa-8d94-2621c2a3210e",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 63,
        "min_unit": null,
        "cifra_code": "R5",
        "cifra_type": "Colores",
        "cifra_source_id": "c7ef5190-e984-48aa-8d94-2621c2a3210e",
        "section_1": 1,
        "price_1": 0.56,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.56,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.56,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.56,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.56,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.56,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.56,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.56,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.378,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.378,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.378,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.378,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.35,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.35,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.35,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.35,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.336,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.336,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.336,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.336,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_R6",
        "code": "CIFRA_R6",
        "name": "Grabación sublimación",
        "technique_name": "Grabación sublimación",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R6",
        "cifra_type": "Area",
        "cifra_source_id": "acea320d-adc9-4bc9-a464-83922b0e461d",
        "section_1": 1,
        "price_1": 1.666,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.666,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.666,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.666,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.98,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.98,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.98,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.98,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 0.952,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 0.952,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 0.952,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 0.952,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.798,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.798,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.798,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.798,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 0.756,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 0.756,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 0.756,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 0.756,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.728,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.728,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.728,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.728,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "acea320d-adc9-4bc9-a464-83922b0e461d",
        "code": "acea320d-adc9-4bc9-a464-83922b0e461d",
        "name": "Grabación sublimación",
        "technique_name": "Grabación sublimación",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R6",
        "cifra_type": "Area",
        "cifra_source_id": "acea320d-adc9-4bc9-a464-83922b0e461d",
        "section_1": 1,
        "price_1": 1.666,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.666,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.666,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.666,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.98,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.98,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.98,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.98,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 0.952,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 0.952,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 0.952,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 0.952,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.798,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.798,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.798,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.798,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 0.756,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 0.756,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 0.756,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 0.756,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.728,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.728,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.728,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.728,
        "price_col_24": 0,
        "price_cm_24": 0
    },
    {
        "technique_ref": "CIFRA_R7",
        "code": "CIFRA_R7",
        "name": "Grabación sublimacion a todo color, precio par",
        "technique_name": "Grabación sublimacion a todo color, precio par",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R7",
        "cifra_type": "Area",
        "cifra_source_id": "b9081bce-ec7d-4b7b-98ad-3a4987f257ad",
        "section_1": 1,
        "price_1": 1.666,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.666,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.666,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.666,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 0.77,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0.77,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 0.77,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 0.77,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 0.686,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 0.686,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 0.686,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 0.686,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.658,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.658,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.658,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.658,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "b9081bce-ec7d-4b7b-98ad-3a4987f257ad",
        "code": "b9081bce-ec7d-4b7b-98ad-3a4987f257ad",
        "name": "Grabación sublimacion a todo color, precio par",
        "technique_name": "Grabación sublimacion a todo color, precio par",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R7",
        "cifra_type": "Area",
        "cifra_source_id": "b9081bce-ec7d-4b7b-98ad-3a4987f257ad",
        "section_1": 1,
        "price_1": 1.666,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.666,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.666,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.666,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 250,
        "price_5": 0.77,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0.77,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 250,
        "price_7": 0.77,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 250,
        "price_8": 0.77,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 0.686,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 0.686,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 0.686,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 0.686,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 1000,
        "price_13": 0.658,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 1000,
        "price_14": 0.658,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 1000,
        "price_15": 0.658,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 1000,
        "price_16": 0.658,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_R8",
        "code": "CIFRA_R8",
        "name": "Grabación sublimación 1 cara del llavero a todo color",
        "technique_name": "Grabación sublimación 1 cara del llavero a todo color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R8",
        "cifra_type": "Area",
        "cifra_source_id": "3738b03a-4f86-44a1-85eb-b5b81803339a",
        "section_1": 50,
        "price_1": 0.448,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.448,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 50,
        "price_3": 0.448,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 0.448,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.434,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.434,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.434,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.434,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 300,
        "price_9": 0.42,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 300,
        "price_10": 0.42,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 300,
        "price_11": 0.42,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 300,
        "price_12": 0.42,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.406,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.406,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.406,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.406,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "3738b03a-4f86-44a1-85eb-b5b81803339a",
        "code": "3738b03a-4f86-44a1-85eb-b5b81803339a",
        "name": "Grabación sublimación 1 cara del llavero a todo color",
        "technique_name": "Grabación sublimación 1 cara del llavero a todo color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "R8",
        "cifra_type": "Area",
        "cifra_source_id": "3738b03a-4f86-44a1-85eb-b5b81803339a",
        "section_1": 50,
        "price_1": 0.448,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.448,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 50,
        "price_3": 0.448,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 0.448,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.434,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 0.434,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 0.434,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 0.434,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 300,
        "price_9": 0.42,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 300,
        "price_10": 0.42,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 300,
        "price_11": 0.42,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 300,
        "price_12": 0.42,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.406,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.406,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.406,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.406,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_R9",
        "code": "CIFRA_R9",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 49,
        "min_unit": null,
        "cifra_code": "R9",
        "cifra_type": "Area",
        "cifra_source_id": "e4f3fde6-bdb4-4b31-a25c-0acdca856e1c",
        "section_1": 1,
        "price_1": 1.82,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.82,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.82,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.82,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.68,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.68,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.68,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.68,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 200,
        "price_9": 1.54,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 200,
        "price_10": 1.54,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 200,
        "price_11": 1.54,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 200,
        "price_12": 1.54,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.26,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.26,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.26,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.26,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "e4f3fde6-bdb4-4b31-a25c-0acdca856e1c",
        "code": "e4f3fde6-bdb4-4b31-a25c-0acdca856e1c",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 49,
        "min_unit": null,
        "cifra_code": "R9",
        "cifra_type": "Area",
        "cifra_source_id": "e4f3fde6-bdb4-4b31-a25c-0acdca856e1c",
        "section_1": 1,
        "price_1": 1.82,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.82,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.82,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.82,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.68,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.68,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.68,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.68,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 200,
        "price_9": 1.54,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 200,
        "price_10": 1.54,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 200,
        "price_11": 1.54,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 200,
        "price_12": 1.54,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.26,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.26,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.26,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.26,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_SG",
        "code": "CIFRA_SG",
        "name": "Serigrafía (SG1)",
        "technique_name": "Serigrafía (SG1)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "SG",
        "cifra_type": "Area",
        "cifra_source_id": "fa4d24af-3c79-4283-bf7c-19f5f9969d49",
        "section_1": 1,
        "price_1": 0.546,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.546,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.546,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.546,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.462,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.462,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.462,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.462,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.392,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.392,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.392,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.392,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.336,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.336,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.336,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.336,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "fa4d24af-3c79-4283-bf7c-19f5f9969d49",
        "code": "fa4d24af-3c79-4283-bf7c-19f5f9969d49",
        "name": "Serigrafía (SG1)",
        "technique_name": "Serigrafía (SG1)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "SG",
        "cifra_type": "Area",
        "cifra_source_id": "fa4d24af-3c79-4283-bf7c-19f5f9969d49",
        "section_1": 1,
        "price_1": 0.546,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.546,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.546,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.546,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.462,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.462,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.462,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.462,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.392,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.392,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.392,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.392,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.336,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.336,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.336,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.336,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_SG_1",
        "code": "CIFRA_SG_1",
        "name": "Serigrafía (SG2)",
        "technique_name": "Serigrafía (SG2)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "SG_1",
        "cifra_type": "Area",
        "cifra_source_id": "0813c50f-887e-40ab-a7f6-c19d4c70e5ea",
        "section_1": 1,
        "price_1": 0.7,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.7,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.7,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.7,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.658,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.658,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.658,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.658,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.63,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.63,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.63,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.63,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.588,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.588,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.588,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.588,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "0813c50f-887e-40ab-a7f6-c19d4c70e5ea",
        "code": "0813c50f-887e-40ab-a7f6-c19d4c70e5ea",
        "name": "Serigrafía (SG2)",
        "technique_name": "Serigrafía (SG2)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "SG_1",
        "cifra_type": "Area",
        "cifra_source_id": "0813c50f-887e-40ab-a7f6-c19d4c70e5ea",
        "section_1": 1,
        "price_1": 0.7,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.7,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.7,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.7,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.658,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.658,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.658,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.658,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.63,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.63,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.63,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.63,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.588,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.588,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.588,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.588,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_SGA",
        "code": "CIFRA_SGA",
        "name": "SERIGRAFÍA 1 color cinta algodón (SGA)",
        "technique_name": "SERIGRAFÍA 1 color cinta algodón (SGA)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 21,
        "min_unit": null,
        "cifra_code": "SGA",
        "cifra_type": "Colores",
        "cifra_source_id": "358fd84e-2152-4a19-9a30-2e2415c02fa6",
        "section_1": 100,
        "price_1": 0.623,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.623,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.623,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.623,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.595,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.595,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.595,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.595,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.574,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.574,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.574,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.574,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.546,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.546,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.546,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.546,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "358fd84e-2152-4a19-9a30-2e2415c02fa6",
        "code": "358fd84e-2152-4a19-9a30-2e2415c02fa6",
        "name": "SERIGRAFÍA 1 color cinta algodón (SGA)",
        "technique_name": "SERIGRAFÍA 1 color cinta algodón (SGA)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 21,
        "min_unit": null,
        "cifra_code": "SGA",
        "cifra_type": "Colores",
        "cifra_source_id": "358fd84e-2152-4a19-9a30-2e2415c02fa6",
        "section_1": 100,
        "price_1": 0.623,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.623,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.623,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.623,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.595,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.595,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.595,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.595,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.574,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.574,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.574,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.574,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.546,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.546,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.546,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.546,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_SGC",
        "code": "CIFRA_SGC",
        "name": "SERIGRAFÍA 1 color cinta corcho (SGC)",
        "technique_name": "SERIGRAFÍA 1 color cinta corcho (SGC)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "SGC",
        "cifra_type": "Colores",
        "cifra_source_id": "4cc81326-6aca-4860-8605-65ed7dd852ed",
        "section_1": 100,
        "price_1": 0.756,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.756,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.756,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.756,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.728,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.728,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.728,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.728,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.693,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.693,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.693,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.693,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.665,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.665,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.665,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.665,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "4cc81326-6aca-4860-8605-65ed7dd852ed",
        "code": "4cc81326-6aca-4860-8605-65ed7dd852ed",
        "name": "SERIGRAFÍA 1 color cinta corcho (SGC)",
        "technique_name": "SERIGRAFÍA 1 color cinta corcho (SGC)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "SGC",
        "cifra_type": "Colores",
        "cifra_source_id": "4cc81326-6aca-4860-8605-65ed7dd852ed",
        "section_1": 100,
        "price_1": 0.756,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.756,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.756,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.756,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.728,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.728,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.728,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.728,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.693,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.693,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.693,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.693,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.665,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.665,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.665,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.665,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_SGN",
        "code": "CIFRA_SGN",
        "name": "Serigrafía cinta non woven (sgn)",
        "technique_name": "Serigrafía cinta non woven (sgn)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 21,
        "min_unit": null,
        "cifra_code": "SGN",
        "cifra_type": "Colores",
        "cifra_source_id": "bdd9bc67-c6f1-4c81-aca5-ad25142ce221",
        "section_1": 100,
        "price_1": 0.371,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.371,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.371,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.371,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.364,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.364,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.364,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.364,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.35,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.35,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.35,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.35,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.343,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.343,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.343,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.343,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "bdd9bc67-c6f1-4c81-aca5-ad25142ce221",
        "code": "bdd9bc67-c6f1-4c81-aca5-ad25142ce221",
        "name": "Serigrafía cinta non woven (sgn)",
        "technique_name": "Serigrafía cinta non woven (sgn)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 21,
        "min_unit": null,
        "cifra_code": "SGN",
        "cifra_type": "Colores",
        "cifra_source_id": "bdd9bc67-c6f1-4c81-aca5-ad25142ce221",
        "section_1": 100,
        "price_1": 0.371,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.371,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.371,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.371,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.364,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.364,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.364,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.364,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.35,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.35,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.35,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.35,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.343,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.343,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.343,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.343,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_SGP",
        "code": "CIFRA_SGP",
        "name": "Serigrafía cinta en poliéster (sgp)",
        "technique_name": "Serigrafía cinta en poliéster (sgp)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 21,
        "min_unit": null,
        "cifra_code": "SGP",
        "cifra_type": "Colores",
        "cifra_source_id": "fba72194-1f78-4602-8ff6-54b265d9b80a",
        "section_1": 100,
        "price_1": 0.49,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.49,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.49,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.49,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.476,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.476,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.476,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.476,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.448,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.448,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.448,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.448,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.434,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.434,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.434,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.434,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "fba72194-1f78-4602-8ff6-54b265d9b80a",
        "code": "fba72194-1f78-4602-8ff6-54b265d9b80a",
        "name": "Serigrafía cinta en poliéster (sgp)",
        "technique_name": "Serigrafía cinta en poliéster (sgp)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 21,
        "min_unit": null,
        "cifra_code": "SGP",
        "cifra_type": "Colores",
        "cifra_source_id": "fba72194-1f78-4602-8ff6-54b265d9b80a",
        "section_1": 100,
        "price_1": 0.49,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.49,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.49,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.49,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.476,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.476,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.476,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.476,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.448,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.448,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.448,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.448,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.434,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.434,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.434,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.434,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_SP",
        "code": "CIFRA_SP",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 70,
        "cliche_repetition": 42,
        "min": 84,
        "min_unit": null,
        "cifra_code": "SP",
        "cifra_type": "Colores",
        "cifra_source_id": "dcd670f1-02a5-4775-9d31-708407c9d406",
        "section_1": 100,
        "price_1": 0.84,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.84,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.84,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.84,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 200,
        "price_5": 0.812,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 200,
        "price_6": 0.812,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 200,
        "price_7": 0.812,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 200,
        "price_8": 0.812,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 0.714,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 0.714,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 0.714,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 0.714,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.63,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.63,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.63,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.63,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.574,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.574,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.574,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.574,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "dcd670f1-02a5-4775-9d31-708407c9d406",
        "code": "dcd670f1-02a5-4775-9d31-708407c9d406",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 70,
        "cliche_repetition": 42,
        "min": 84,
        "min_unit": null,
        "cifra_code": "SP",
        "cifra_type": "Colores",
        "cifra_source_id": "dcd670f1-02a5-4775-9d31-708407c9d406",
        "section_1": 100,
        "price_1": 0.84,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.84,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.84,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.84,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 200,
        "price_5": 0.812,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 200,
        "price_6": 0.812,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 200,
        "price_7": 0.812,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 200,
        "price_8": 0.812,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 0.714,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 0.714,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 0.714,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 0.714,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 0.63,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 0.63,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 0.63,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 0.63,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.574,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.574,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.574,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.574,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_SP_SP",
        "code": "CIFRA_SP_SP",
        "name": "Serigrafía 1 color 2 posiciones diferentes",
        "technique_name": "Serigrafía 1 color 2 posiciones diferentes",
        "cliche": 140,
        "cliche_repetition": 42,
        "min": 168,
        "min_unit": null,
        "cifra_code": "SP_SP",
        "cifra_type": "Area",
        "cifra_source_id": "d81a43c0-f3b6-4b88-b416-d683bb12da38",
        "section_1": 100,
        "price_1": 1.68,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.68,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.68,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.68,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 200,
        "price_5": 1.624,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 200,
        "price_6": 1.624,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 200,
        "price_7": 1.624,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 200,
        "price_8": 1.624,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.428,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.428,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.428,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.428,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 1.26,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 1.26,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 1.26,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 1.26,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 1.148,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 1.148,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 1.148,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 1.148,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "d81a43c0-f3b6-4b88-b416-d683bb12da38",
        "code": "d81a43c0-f3b6-4b88-b416-d683bb12da38",
        "name": "Serigrafía 1 color 2 posiciones diferentes",
        "technique_name": "Serigrafía 1 color 2 posiciones diferentes",
        "cliche": 140,
        "cliche_repetition": 42,
        "min": 168,
        "min_unit": null,
        "cifra_code": "SP_SP",
        "cifra_type": "Area",
        "cifra_source_id": "d81a43c0-f3b6-4b88-b416-d683bb12da38",
        "section_1": 100,
        "price_1": 1.68,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.68,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.68,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.68,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 200,
        "price_5": 1.624,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 200,
        "price_6": 1.624,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 200,
        "price_7": 1.624,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 200,
        "price_8": 1.624,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.428,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.428,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.428,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.428,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 1.26,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 1.26,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 1.26,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 1.26,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 1.148,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 1.148,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 1.148,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 1.148,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_SP_SP_SP",
        "code": "CIFRA_SP_SP_SP",
        "name": "Serigrafía 1 color dos posiciones iguales",
        "technique_name": "Serigrafía 1 color dos posiciones iguales",
        "cliche": 140,
        "cliche_repetition": 42,
        "min": 168,
        "min_unit": null,
        "cifra_code": "SP_SP_SP",
        "cifra_type": "Area",
        "cifra_source_id": "9939bc58-2070-4657-9f8d-45fbaceafd62",
        "section_1": 100,
        "price_1": 1.68,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.68,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.68,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.68,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 200,
        "price_5": 1.624,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 200,
        "price_6": 1.624,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 200,
        "price_7": 1.624,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 200,
        "price_8": 1.624,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.428,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.428,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.428,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.428,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 1.26,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 1.26,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 1.26,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 1.26,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 1.148,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 1.148,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 1.148,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 1.148,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "9939bc58-2070-4657-9f8d-45fbaceafd62",
        "code": "9939bc58-2070-4657-9f8d-45fbaceafd62",
        "name": "Serigrafía 1 color dos posiciones iguales",
        "technique_name": "Serigrafía 1 color dos posiciones iguales",
        "cliche": 140,
        "cliche_repetition": 42,
        "min": 168,
        "min_unit": null,
        "cifra_code": "SP_SP_SP",
        "cifra_type": "Area",
        "cifra_source_id": "9939bc58-2070-4657-9f8d-45fbaceafd62",
        "section_1": 100,
        "price_1": 1.68,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 1.68,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.68,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 1.68,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 200,
        "price_5": 1.624,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 200,
        "price_6": 1.624,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 200,
        "price_7": 1.624,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 200,
        "price_8": 1.624,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 500,
        "price_9": 1.428,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 500,
        "price_10": 1.428,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 500,
        "price_11": 1.428,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 500,
        "price_12": 1.428,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 2000,
        "price_13": 1.26,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 2000,
        "price_14": 1.26,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 2000,
        "price_15": 1.26,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 2000,
        "price_16": 1.26,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 1.148,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 1.148,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 1.148,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 1.148,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_SUB1",
        "code": "CIFRA_SUB1",
        "name": "Sublimación (SUB1)",
        "technique_name": "Sublimación (SUB1)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 91,
        "min_unit": null,
        "cifra_code": "SUB1",
        "cifra_type": "Area",
        "cifra_source_id": "6bc63c65-7658-4c36-aec0-fb0f04e61690",
        "section_1": 1,
        "price_1": 1.498,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.498,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.498,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.498,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.33,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.33,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.33,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.33,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 1.246,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 1.246,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 1.246,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 1.246,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 1.148,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 1.148,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 1.148,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 1.148,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "6bc63c65-7658-4c36-aec0-fb0f04e61690",
        "code": "6bc63c65-7658-4c36-aec0-fb0f04e61690",
        "name": "Sublimación (SUB1)",
        "technique_name": "Sublimación (SUB1)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 91,
        "min_unit": null,
        "cifra_code": "SUB1",
        "cifra_type": "Area",
        "cifra_source_id": "6bc63c65-7658-4c36-aec0-fb0f04e61690",
        "section_1": 1,
        "price_1": 1.498,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.498,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.498,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.498,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.33,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.33,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.33,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.33,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 1.246,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 1.246,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 1.246,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 1.246,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 1.148,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 1.148,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 1.148,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 1.148,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_SUB2",
        "code": "CIFRA_SUB2",
        "name": "Sublimación (SUB2)",
        "technique_name": "Sublimación (SUB2)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 91,
        "min_unit": null,
        "cifra_code": "SUB2",
        "cifra_type": "Area",
        "cifra_source_id": "14f73416-63e0-4c4c-96b1-4b006b861894",
        "section_1": 1,
        "price_1": 1.596,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.596,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.596,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.596,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.372,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.372,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.372,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.372,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 1.302,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 1.302,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 1.302,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 1.302,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 1.26,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 1.26,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 1.26,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 1.26,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "14f73416-63e0-4c4c-96b1-4b006b861894",
        "code": "14f73416-63e0-4c4c-96b1-4b006b861894",
        "name": "Sublimación (SUB2)",
        "technique_name": "Sublimación (SUB2)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 91,
        "min_unit": null,
        "cifra_code": "SUB2",
        "cifra_type": "Area",
        "cifra_source_id": "14f73416-63e0-4c4c-96b1-4b006b861894",
        "section_1": 1,
        "price_1": 1.596,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.596,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.596,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.596,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.372,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 1.372,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.372,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.372,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 1.302,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 1.302,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 1.302,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 1.302,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 1.26,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 1.26,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 1.26,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 1.26,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_SUBP",
        "code": "CIFRA_SUBP",
        "name": "Sublimación cinta en poliéster (sgp)",
        "technique_name": "Sublimación cinta en poliéster (sgp)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 21,
        "min_unit": null,
        "cifra_code": "SUBP",
        "cifra_type": "Area",
        "cifra_source_id": "70a4197b-ae0e-4f00-ae02-6c26c97598e1",
        "section_1": 100,
        "price_1": 0.644,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.644,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.644,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.644,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.588,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.588,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.588,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.588,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.574,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.574,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.574,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.574,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.56,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.56,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.56,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.56,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "70a4197b-ae0e-4f00-ae02-6c26c97598e1",
        "code": "70a4197b-ae0e-4f00-ae02-6c26c97598e1",
        "name": "Sublimación cinta en poliéster (sgp)",
        "technique_name": "Sublimación cinta en poliéster (sgp)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 21,
        "min_unit": null,
        "cifra_code": "SUBP",
        "cifra_type": "Area",
        "cifra_source_id": "70a4197b-ae0e-4f00-ae02-6c26c97598e1",
        "section_1": 100,
        "price_1": 0.644,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.644,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.644,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 100,
        "price_4": 0.644,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.588,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.588,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.588,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.588,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.574,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.574,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.574,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.574,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 5000,
        "price_13": 0.56,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 5000,
        "price_14": 0.56,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 5000,
        "price_15": 0.56,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 5000,
        "price_16": 0.56,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_SUBT",
        "code": "CIFRA_SUBT",
        "name": "Sublimación Tazas (SUBT)",
        "technique_name": "Sublimación Tazas (SUBT)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 77,
        "min_unit": null,
        "cifra_code": "SUBT",
        "cifra_type": "Area",
        "cifra_source_id": "980d2e9d-537c-4509-833a-e93137c7316e"
    },
    {
        "technique_ref": "980d2e9d-537c-4509-833a-e93137c7316e",
        "code": "980d2e9d-537c-4509-833a-e93137c7316e",
        "name": "Sublimación Tazas (SUBT)",
        "technique_name": "Sublimación Tazas (SUBT)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 77,
        "min_unit": null,
        "cifra_code": "SUBT",
        "cifra_type": "Area",
        "cifra_source_id": "980d2e9d-537c-4509-833a-e93137c7316e"
    },
    {
        "technique_ref": "CIFRA_SUBT_1",
        "code": "CIFRA_SUBT_1",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 91,
        "min_unit": null,
        "cifra_code": "SUBT_1",
        "cifra_type": "Area",
        "cifra_source_id": "19019074-2fe1-41e0-8a67-9030f244f4d8",
        "section_1": 1,
        "price_1": 2.59,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 2.59,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 2.59,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 2.59,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 2.24,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 2.24,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 2.24,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 2.24,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 2.17,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 2.17,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 2.17,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 2.17,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.96,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.96,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.96,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.96,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "19019074-2fe1-41e0-8a67-9030f244f4d8",
        "code": "19019074-2fe1-41e0-8a67-9030f244f4d8",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 91,
        "min_unit": null,
        "cifra_code": "SUBT_1",
        "cifra_type": "Area",
        "cifra_source_id": "19019074-2fe1-41e0-8a67-9030f244f4d8",
        "section_1": 1,
        "price_1": 2.59,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 2.59,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 2.59,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 2.59,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 2.24,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 2.24,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 2.24,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 2.24,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 2.17,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 2.17,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 2.17,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 2.17,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 1.96,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 1.96,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 1.96,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 1.96,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_SUBT_2",
        "code": "CIFRA_SUBT_2",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 91,
        "min_unit": null,
        "cifra_code": "SUBT_2",
        "cifra_type": "Area",
        "cifra_source_id": "bb86e4fe-5009-453a-8371-6ae42e138d48",
        "section_1": 1,
        "price_1": 2.73,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 2.73,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 2.73,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 2.73,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 2.38,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 2.38,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 2.38,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 2.38,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 2.31,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 2.31,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 2.31,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 2.31,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 2.03,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 2.03,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 2.03,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 2.03,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "bb86e4fe-5009-453a-8371-6ae42e138d48",
        "code": "bb86e4fe-5009-453a-8371-6ae42e138d48",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 91,
        "min_unit": null,
        "cifra_code": "SUBT_2",
        "cifra_type": "Area",
        "cifra_source_id": "bb86e4fe-5009-453a-8371-6ae42e138d48",
        "section_1": 1,
        "price_1": 2.73,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 2.73,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 2.73,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 2.73,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 2.38,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 2.38,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 2.38,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 2.38,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 2.31,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 2.31,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 2.31,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 2.31,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 2.03,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 2.03,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 2.03,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 2.03,
        "price_col_16": 0,
        "price_cm_16": 0
    },
    {
        "technique_ref": "CIFRA_SUBTO_40X90",
        "code": "CIFRA_SUBTO_40X90",
        "name": "Sublimación toallas (SUBTO)",
        "technique_name": "Sublimación toallas (SUBTO)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 302.4,
        "min_unit": null,
        "cifra_code": "SUBTO_40X90",
        "cifra_type": "Area",
        "cifra_source_id": "95c1269e-e299-4619-ba40-51d244c209a6",
        "section_1": 1,
        "price_1": 30.24,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 30.24,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 30.24,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 30.24,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 10,
        "price_5": 19.6,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10,
        "price_6": 19.6,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10,
        "price_7": 19.6,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 10,
        "price_8": 19.6,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 20,
        "price_9": 12.04,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20,
        "price_10": 12.04,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 20,
        "price_11": 12.04,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 20,
        "price_12": 12.04,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 50,
        "price_13": 5.88,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 50,
        "price_14": 5.88,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 50,
        "price_15": 5.88,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 50,
        "price_16": 5.88,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 100,
        "price_17": 3.08,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 100,
        "price_18": 3.08,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 100,
        "price_19": 3.08,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 100,
        "price_20": 3.08,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "95c1269e-e299-4619-ba40-51d244c209a6",
        "code": "95c1269e-e299-4619-ba40-51d244c209a6",
        "name": "Sublimación toallas (SUBTO)",
        "technique_name": "Sublimación toallas (SUBTO)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 302.4,
        "min_unit": null,
        "cifra_code": "SUBTO_40X90",
        "cifra_type": "Area",
        "cifra_source_id": "95c1269e-e299-4619-ba40-51d244c209a6",
        "section_1": 1,
        "price_1": 30.24,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 30.24,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 30.24,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 30.24,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 10,
        "price_5": 19.6,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10,
        "price_6": 19.6,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10,
        "price_7": 19.6,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 10,
        "price_8": 19.6,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 20,
        "price_9": 12.04,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20,
        "price_10": 12.04,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 20,
        "price_11": 12.04,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 20,
        "price_12": 12.04,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 50,
        "price_13": 5.88,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 50,
        "price_14": 5.88,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 50,
        "price_15": 5.88,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 50,
        "price_16": 5.88,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 100,
        "price_17": 3.08,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 100,
        "price_18": 3.08,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 100,
        "price_19": 3.08,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 100,
        "price_20": 3.08,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_SUBTO_40X90_1",
        "code": "CIFRA_SUBTO_40X90_1",
        "name": "Sublimación toallas (SUBTO)",
        "technique_name": "Sublimación toallas (SUBTO)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 302.4,
        "min_unit": null,
        "cifra_code": "SUBTO_40X90_1",
        "cifra_type": "Area",
        "cifra_source_id": "649dfa66-9293-4175-b2f5-90cbe0b55fe0",
        "section_1": 1,
        "price_1": 60.48,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 60.48,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 60.48,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 60.48,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 10,
        "price_5": 39.2,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10,
        "price_6": 39.2,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10,
        "price_7": 39.2,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 10,
        "price_8": 39.2,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 20,
        "price_9": 24.08,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20,
        "price_10": 24.08,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 20,
        "price_11": 24.08,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 20,
        "price_12": 24.08,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 50,
        "price_13": 11.76,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 50,
        "price_14": 11.76,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 50,
        "price_15": 11.76,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 50,
        "price_16": 11.76,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 100,
        "price_17": 6.16,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 100,
        "price_18": 6.16,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 100,
        "price_19": 6.16,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 100,
        "price_20": 6.16,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "649dfa66-9293-4175-b2f5-90cbe0b55fe0",
        "code": "649dfa66-9293-4175-b2f5-90cbe0b55fe0",
        "name": "Sublimación toallas (SUBTO)",
        "technique_name": "Sublimación toallas (SUBTO)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 302.4,
        "min_unit": null,
        "cifra_code": "SUBTO_40X90_1",
        "cifra_type": "Area",
        "cifra_source_id": "649dfa66-9293-4175-b2f5-90cbe0b55fe0",
        "section_1": 1,
        "price_1": 60.48,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 60.48,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 60.48,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 60.48,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 10,
        "price_5": 39.2,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10,
        "price_6": 39.2,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10,
        "price_7": 39.2,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 10,
        "price_8": 39.2,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 20,
        "price_9": 24.08,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20,
        "price_10": 24.08,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 20,
        "price_11": 24.08,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 20,
        "price_12": 24.08,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 50,
        "price_13": 11.76,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 50,
        "price_14": 11.76,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 50,
        "price_15": 11.76,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 50,
        "price_16": 11.76,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 100,
        "price_17": 6.16,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 100,
        "price_18": 6.16,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 100,
        "price_19": 6.16,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 100,
        "price_20": 6.16,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_SUBTO_70X140",
        "code": "CIFRA_SUBTO_70X140",
        "name": "Sublimación toallas (SUBTO)",
        "technique_name": "Sublimación toallas (SUBTO)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 434,
        "min_unit": null,
        "cifra_code": "SUBTO_70X140",
        "cifra_type": "Area",
        "cifra_source_id": "6c08b4f4-0e64-4276-ad94-dbc79a01d7ce",
        "section_1": 1,
        "price_1": 43.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 43.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 43.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 43.4,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 10,
        "price_5": 28,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10,
        "price_6": 28,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10,
        "price_7": 28,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 10,
        "price_8": 28,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 20,
        "price_9": 17.5,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20,
        "price_10": 17.5,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 20,
        "price_11": 17.5,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 20,
        "price_12": 17.5,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 50,
        "price_13": 8.4,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 50,
        "price_14": 8.4,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 50,
        "price_15": 8.4,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 50,
        "price_16": 8.4,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 100,
        "price_17": 4.41,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 100,
        "price_18": 4.41,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 100,
        "price_19": 4.41,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 100,
        "price_20": 4.41,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "6c08b4f4-0e64-4276-ad94-dbc79a01d7ce",
        "code": "6c08b4f4-0e64-4276-ad94-dbc79a01d7ce",
        "name": "Sublimación toallas (SUBTO)",
        "technique_name": "Sublimación toallas (SUBTO)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 434,
        "min_unit": null,
        "cifra_code": "SUBTO_70X140",
        "cifra_type": "Area",
        "cifra_source_id": "6c08b4f4-0e64-4276-ad94-dbc79a01d7ce",
        "section_1": 1,
        "price_1": 43.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 43.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 43.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 43.4,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 10,
        "price_5": 28,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10,
        "price_6": 28,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10,
        "price_7": 28,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 10,
        "price_8": 28,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 20,
        "price_9": 17.5,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20,
        "price_10": 17.5,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 20,
        "price_11": 17.5,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 20,
        "price_12": 17.5,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 50,
        "price_13": 8.4,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 50,
        "price_14": 8.4,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 50,
        "price_15": 8.4,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 50,
        "price_16": 8.4,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 100,
        "price_17": 4.41,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 100,
        "price_18": 4.41,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 100,
        "price_19": 4.41,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 100,
        "price_20": 4.41,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_SUBTO_70X140_1",
        "code": "CIFRA_SUBTO_70X140_1",
        "name": "Sublimación toallas (SUBTO)",
        "technique_name": "Sublimación toallas (SUBTO)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 434,
        "min_unit": null,
        "cifra_code": "SUBTO_70X140_1",
        "cifra_type": "Area",
        "cifra_source_id": "3cc8b9b2-728b-4bd0-965a-29a999245197",
        "section_1": 1,
        "price_1": 86.8,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 86.8,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 86.8,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 86.8,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 10,
        "price_5": 56,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10,
        "price_6": 56,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10,
        "price_7": 56,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 10,
        "price_8": 56,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 20,
        "price_9": 35,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20,
        "price_10": 35,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 20,
        "price_11": 35,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 20,
        "price_12": 35,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 50,
        "price_13": 16.8,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 50,
        "price_14": 16.8,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 50,
        "price_15": 16.8,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 50,
        "price_16": 16.8,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 100,
        "price_17": 8.82,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 100,
        "price_18": 8.82,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 100,
        "price_19": 8.82,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 100,
        "price_20": 8.82,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "3cc8b9b2-728b-4bd0-965a-29a999245197",
        "code": "3cc8b9b2-728b-4bd0-965a-29a999245197",
        "name": "Sublimación toallas (SUBTO)",
        "technique_name": "Sublimación toallas (SUBTO)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 434,
        "min_unit": null,
        "cifra_code": "SUBTO_70X140_1",
        "cifra_type": "Area",
        "cifra_source_id": "3cc8b9b2-728b-4bd0-965a-29a999245197",
        "section_1": 1,
        "price_1": 86.8,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 86.8,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 86.8,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 86.8,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 10,
        "price_5": 56,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 10,
        "price_6": 56,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10,
        "price_7": 56,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 10,
        "price_8": 56,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 20,
        "price_9": 35,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20,
        "price_10": 35,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 20,
        "price_11": 35,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 20,
        "price_12": 35,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 50,
        "price_13": 16.8,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 50,
        "price_14": 16.8,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 50,
        "price_15": 16.8,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 50,
        "price_16": 16.8,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 100,
        "price_17": 8.82,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 100,
        "price_18": 8.82,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 100,
        "price_19": 8.82,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 100,
        "price_20": 8.82,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_T",
        "code": "CIFRA_T",
        "name": "Termograbado (T)",
        "technique_name": "Termograbado (T)",
        "cliche": 77,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "T",
        "cifra_type": "Area",
        "cifra_source_id": "172e61f5-1e5d-43dc-96c6-ce5e2a176c5f",
        "section_1": 1,
        "price_1": 0.56,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.56,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.56,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.56,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 150,
        "price_5": 0.49,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 150,
        "price_6": 0.49,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 150,
        "price_7": 0.49,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 150,
        "price_8": 0.49,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.42,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.42,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.42,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.42,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.35,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.35,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.35,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.35,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.308,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.308,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.308,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.308,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2000,
        "price_21": 0.252,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2000,
        "price_22": 0.252,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2000,
        "price_23": 0.252,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2000,
        "price_24": 0.252,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.21,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.21,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.21,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.21,
        "price_col_28": 0,
        "price_cm_28": 0
    },
    {
        "technique_ref": "172e61f5-1e5d-43dc-96c6-ce5e2a176c5f",
        "code": "172e61f5-1e5d-43dc-96c6-ce5e2a176c5f",
        "name": "Termograbado (T)",
        "technique_name": "Termograbado (T)",
        "cliche": 77,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "T",
        "cifra_type": "Area",
        "cifra_source_id": "172e61f5-1e5d-43dc-96c6-ce5e2a176c5f",
        "section_1": 1,
        "price_1": 0.56,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 0.56,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 0.56,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 0.56,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 150,
        "price_5": 0.49,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 150,
        "price_6": 0.49,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 150,
        "price_7": 0.49,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 150,
        "price_8": 0.49,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.42,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.42,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.42,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.42,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.35,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.35,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.35,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.35,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 1000,
        "price_17": 0.308,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 1000,
        "price_18": 0.308,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 1000,
        "price_19": 0.308,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 1000,
        "price_20": 0.308,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 2000,
        "price_21": 0.252,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 2000,
        "price_22": 0.252,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 2000,
        "price_23": 0.252,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 2000,
        "price_24": 0.252,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 5000,
        "price_25": 0.21,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 5000,
        "price_26": 0.21,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 5000,
        "price_27": 0.21,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 5000,
        "price_28": 0.21,
        "price_col_28": 0,
        "price_cm_28": 0
    },
    {
        "technique_ref": "CIFRA_TDB",
        "code": "CIFRA_TDB",
        "name": "Balon transfer digital full color",
        "technique_name": "Balon transfer digital full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "TDB",
        "cifra_type": "Area",
        "cifra_source_id": "7639a92f-dcfd-4524-af65-bea532e1590d"
    },
    {
        "technique_ref": "7639a92f-dcfd-4524-af65-bea532e1590d",
        "code": "7639a92f-dcfd-4524-af65-bea532e1590d",
        "name": "Balon transfer digital full color",
        "technique_name": "Balon transfer digital full color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "TDB",
        "cifra_type": "Area",
        "cifra_source_id": "7639a92f-dcfd-4524-af65-bea532e1590d"
    },
    {
        "technique_ref": "CIFRA_TRIP",
        "code": "CIFRA_TRIP",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "TRIP",
        "cifra_type": "Area",
        "cifra_source_id": "5bb13e2c-7c2e-49ec-8351-f510286fd783",
        "section_1": 500,
        "price_1": 0.1974,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.1974,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.1974,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.1974,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.1127,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.1127,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 1000,
        "price_7": 0.1127,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.1127,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.0959,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.0959,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.0959,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.0959,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.0889,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.0889,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.0889,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.0889,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 4000,
        "price_17": 0.0847,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 4000,
        "price_18": 0.0847,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 4000,
        "price_19": 0.0847,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 4000,
        "price_20": 0.0847,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.0819,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.0819,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.0819,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.0819,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 10000,
        "price_25": 0.0749,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 10000,
        "price_26": 0.0749,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 10000,
        "price_27": 0.0749,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 10000,
        "price_28": 0.0749,
        "price_col_28": 0,
        "price_cm_28": 0
    },
    {
        "technique_ref": "5bb13e2c-7c2e-49ec-8351-f510286fd783",
        "code": "5bb13e2c-7c2e-49ec-8351-f510286fd783",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "TRIP",
        "cifra_type": "Area",
        "cifra_source_id": "5bb13e2c-7c2e-49ec-8351-f510286fd783",
        "section_1": 500,
        "price_1": 0.1974,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.1974,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.1974,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.1974,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.1127,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.1127,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 1000,
        "price_7": 0.1127,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.1127,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2000,
        "price_9": 0.0959,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 2000,
        "price_10": 0.0959,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 2000,
        "price_11": 0.0959,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 2000,
        "price_12": 0.0959,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.0889,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.0889,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.0889,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.0889,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 4000,
        "price_17": 0.0847,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 4000,
        "price_18": 0.0847,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 4000,
        "price_19": 0.0847,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 4000,
        "price_20": 0.0847,
        "price_col_20": 0,
        "price_cm_20": 0,
        "section_21": 5000,
        "price_21": 0.0819,
        "price_col_21": 0,
        "price_cm_21": 0,
        "section_22": 5000,
        "price_22": 0.0819,
        "price_col_22": 0,
        "price_cm_22": 0,
        "section_23": 5000,
        "price_23": 0.0819,
        "price_col_23": 0,
        "price_cm_23": 0,
        "section_24": 5000,
        "price_24": 0.0819,
        "price_col_24": 0,
        "price_cm_24": 0,
        "section_25": 10000,
        "price_25": 0.0749,
        "price_col_25": 0,
        "price_cm_25": 0,
        "section_26": 10000,
        "price_26": 0.0749,
        "price_col_26": 0,
        "price_cm_26": 0,
        "section_27": 10000,
        "price_27": 0.0749,
        "price_col_27": 0,
        "price_cm_27": 0,
        "section_28": 10000,
        "price_28": 0.0749,
        "price_col_28": 0,
        "price_cm_28": 0
    },
    {
        "technique_ref": "CIFRA_TRL",
        "code": "CIFRA_TRL",
        "name": "Lanyard transfer full color",
        "technique_name": "Lanyard transfer full color",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "TRL",
        "cifra_type": "Colores",
        "cifra_source_id": "a831413c-bea3-45d5-b4f0-3de5803da9ec",
        "section_1": 1,
        "price_1": 1.19,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.19,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.19,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.19,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.19,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.19,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.19,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.19,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.98,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.98,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.98,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.98,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.924,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.924,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.924,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.924,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 0.882,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 0.882,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 0.882,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 0.882,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "a831413c-bea3-45d5-b4f0-3de5803da9ec",
        "code": "a831413c-bea3-45d5-b4f0-3de5803da9ec",
        "name": "Lanyard transfer full color",
        "technique_name": "Lanyard transfer full color",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "cifra_code": "TRL",
        "cifra_type": "Colores",
        "cifra_source_id": "a831413c-bea3-45d5-b4f0-3de5803da9ec",
        "section_1": 1,
        "price_1": 1.19,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 1,
        "price_2": 1.19,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 1,
        "price_3": 1.19,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1,
        "price_4": 1.19,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.19,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 1.19,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 100,
        "price_7": 1.19,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 100,
        "price_8": 1.19,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 250,
        "price_9": 0.98,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 250,
        "price_10": 0.98,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 250,
        "price_11": 0.98,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 250,
        "price_12": 0.98,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 500,
        "price_13": 0.924,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 500,
        "price_14": 0.924,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 500,
        "price_15": 0.924,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 500,
        "price_16": 0.924,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 2000,
        "price_17": 0.882,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 2000,
        "price_18": 0.882,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 2000,
        "price_19": 0.882,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 2000,
        "price_20": 0.882,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "CIFRA_TSB",
        "code": "CIFRA_TSB",
        "name": "Balon transfer serigrafico 1 color",
        "technique_name": "Balon transfer serigrafico 1 color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "TSB",
        "cifra_type": "Area",
        "cifra_source_id": "617b5a64-f492-444f-99ec-57a6a0d7714f"
    },
    {
        "technique_ref": "617b5a64-f492-444f-99ec-57a6a0d7714f",
        "code": "617b5a64-f492-444f-99ec-57a6a0d7714f",
        "name": "Balon transfer serigrafico 1 color",
        "technique_name": "Balon transfer serigrafico 1 color",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "cifra_code": "TSB",
        "cifra_type": "Area",
        "cifra_source_id": "617b5a64-f492-444f-99ec-57a6a0d7714f"
    },
    {
        "technique_ref": "CIFRA_VINILO",
        "code": "CIFRA_VINILO",
        "name": "Vinilo",
        "technique_name": "Vinilo",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "VINILO",
        "cifra_type": "Area",
        "cifra_source_id": "f95ac874-8846-413d-9d2f-4fbcb00998fa"
    },
    {
        "technique_ref": "f95ac874-8846-413d-9d2f-4fbcb00998fa",
        "code": "f95ac874-8846-413d-9d2f-4fbcb00998fa",
        "name": "Vinilo",
        "technique_name": "Vinilo",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "VINILO",
        "cifra_type": "Area",
        "cifra_source_id": "f95ac874-8846-413d-9d2f-4fbcb00998fa"
    },
    {
        "technique_ref": "CIFRA_Z",
        "code": "CIFRA_Z",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "Z",
        "cifra_type": "Area",
        "cifra_source_id": "021510ab-e4d4-444d-84a0-a3eb46f33dc5",
        "section_1": 300,
        "price_1": 0.427,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.427,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.427,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.427,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.385,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.385,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.385,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.385,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.357,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.357,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.357,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.357,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.343,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.343,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.343,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.343,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.336,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.336,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.336,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.336,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "021510ab-e4d4-444d-84a0-a3eb46f33dc5",
        "code": "021510ab-e4d4-444d-84a0-a3eb46f33dc5",
        "name": "Cuatricromía",
        "technique_name": "Cuatricromía",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "cifra_code": "Z",
        "cifra_type": "Area",
        "cifra_source_id": "021510ab-e4d4-444d-84a0-a3eb46f33dc5",
        "section_1": 300,
        "price_1": 0.427,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 300,
        "price_2": 0.427,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 300,
        "price_3": 0.427,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 0.427,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.385,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 500,
        "price_6": 0.385,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.385,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 0.385,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 0.357,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 1000,
        "price_10": 0.357,
        "price_col_10": 0,
        "price_cm_10": 0,
        "section_11": 1000,
        "price_11": 0.357,
        "price_col_11": 0,
        "price_cm_11": 0,
        "section_12": 1000,
        "price_12": 0.357,
        "price_col_12": 0,
        "price_cm_12": 0,
        "section_13": 3000,
        "price_13": 0.343,
        "price_col_13": 0,
        "price_cm_13": 0,
        "section_14": 3000,
        "price_14": 0.343,
        "price_col_14": 0,
        "price_cm_14": 0,
        "section_15": 3000,
        "price_15": 0.343,
        "price_col_15": 0,
        "price_cm_15": 0,
        "section_16": 3000,
        "price_16": 0.343,
        "price_col_16": 0,
        "price_cm_16": 0,
        "section_17": 5000,
        "price_17": 0.336,
        "price_col_17": 0,
        "price_cm_17": 0,
        "section_18": 5000,
        "price_18": 0.336,
        "price_col_18": 0,
        "price_cm_18": 0,
        "section_19": 5000,
        "price_19": 0.336,
        "price_col_19": 0,
        "price_cm_19": 0,
        "section_20": 5000,
        "price_20": 0.336,
        "price_col_20": 0,
        "price_cm_20": 0
    },
    {
        "technique_ref": "PFCONCEPT_D3D01",
        "code": "PFCONCEPT_D3D01",
        "name": "Digital print gloss 1",
        "technique_name": "Digital print gloss 1",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "D3D01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.19,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.84,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.714,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.602,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.546,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.462,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.42,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.392,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.378,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.364,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_D3D04",
        "code": "PFCONCEPT_D3D04",
        "name": "Digital print gloss 4",
        "technique_name": "Digital print gloss 4",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "D3D04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.142,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.624,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.232,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.078,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.952,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.84,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.812,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.77,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.77,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_D3D05",
        "code": "PFCONCEPT_D3D05",
        "name": "Digital print gloss 5",
        "technique_name": "Digital print gloss 5",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "D3D05",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.716,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.296,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.988,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.764,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.554,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.372,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.246,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.176,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.148,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.134,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DBP01",
        "code": "PFCONCEPT_DBP01",
        "name": "Digital box print 1",
        "technique_name": "Digital box print 1",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DBP01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 3.178,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.722,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.456,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.33,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.302,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.288,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.288,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.274,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.274,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.274,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DEB01",
        "code": "PFCONCEPT_DEB01",
        "name": "Termograbado",
        "technique_name": "Termograbado",
        "cliche": 53.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DEB01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.884,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.806,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.246,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.84,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.686,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.658,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.644,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.63,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.602,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.588,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DEB02",
        "code": "PFCONCEPT_DEB02",
        "name": "Termograbado",
        "technique_name": "Termograbado",
        "cliche": 53.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DEB02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 3.038,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.96,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.386,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.008,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.784,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.784,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.728,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.728,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.686,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.686,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DEB03",
        "code": "PFCONCEPT_DEB03",
        "name": "Termograbado",
        "technique_name": "Termograbado",
        "cliche": 53.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DEB03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 3.514,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.492,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.89,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.414,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.232,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.204,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.162,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.148,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.134,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.078,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DEB04",
        "code": "PFCONCEPT_DEB04",
        "name": "Termograbado",
        "technique_name": "Termograbado",
        "cliche": 53.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DEB04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 3.766,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.674,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.03,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.596,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.386,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.344,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.288,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.288,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.246,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.218,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DEB05",
        "code": "PFCONCEPT_DEB05",
        "name": "Termograbado",
        "technique_name": "Termograbado",
        "cliche": 53.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DEB05",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 4.942,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 3.794,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 3.206,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.618,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 2.45,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 2.436,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 2.394,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 2.394,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 2.338,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 2.254,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DHTS01",
        "code": "PFCONCEPT_DHTS01",
        "name": "Termograbado a color digital",
        "technique_name": "Termograbado a color digital",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DHTS01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.652,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.512,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.372,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.26,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.05,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.994,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.966,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.952,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.91,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.868,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DOM001",
        "code": "PFCONCEPT_DOM001",
        "name": "Gota de resina",
        "technique_name": "Gota de resina",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DOM001",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.59,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.624,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.26,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.148,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.98,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.798,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.714,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.63,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.602,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.588,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DOM004",
        "code": "PFCONCEPT_DOM004",
        "name": "Gota de resina",
        "technique_name": "Gota de resina",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DOM004",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.204,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.092,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.05,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.994,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.98,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.98,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.952,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.952,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.924,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.882,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DPP01",
        "code": "PFCONCEPT_DPP01",
        "name": "Impresión digital en papel",
        "technique_name": "Impresión digital en papel",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DPP01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.994,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.84,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.77,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.714,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.658,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.602,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.588,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.588,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.56,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.56,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DPP02",
        "code": "PFCONCEPT_DPP02",
        "name": "Impresión digital en papel",
        "technique_name": "Impresión digital en papel",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DPP02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.602,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.392,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.364,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.336,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.308,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.224,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.21,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.196,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.196,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.182,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DPP03",
        "code": "PFCONCEPT_DPP03",
        "name": "Impresión digital en papel",
        "technique_name": "Impresión digital en papel",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DPP03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.246,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.7,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.378,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.154,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.154,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.126,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.126,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.084,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.084,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DPRINT01",
        "code": "PFCONCEPT_DPRINT01",
        "name": "Impresión digital",
        "technique_name": "Impresión digital",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DPRINT01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.868,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.658,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.532,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.476,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.392,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.336,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.308,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.28,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.28,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.266,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DPRINT02",
        "code": "PFCONCEPT_DPRINT02",
        "name": "Impresión digital",
        "technique_name": "Impresión digital",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DPRINT02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.994,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.756,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.644,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.56,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.518,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.42,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.392,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.378,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.378,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.364,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DPRINT03",
        "code": "PFCONCEPT_DPRINT03",
        "name": "Impresión digital",
        "technique_name": "Impresión digital",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DPRINT03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.176,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.924,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.812,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.714,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.602,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.532,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.462,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.448,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.448,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.42,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DPRINT04",
        "code": "PFCONCEPT_DPRINT04",
        "name": "Impresión digital",
        "technique_name": "Impresión digital",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DPRINT04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.638,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.204,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.05,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.882,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.812,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.672,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.63,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.602,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.588,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.588,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DPRINT05",
        "code": "PFCONCEPT_DPRINT05",
        "name": "Impresión digital",
        "technique_name": "Impresión digital",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DPRINT05",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.1,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.736,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.512,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.302,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.134,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.994,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.924,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.854,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.84,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.812,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DPRINT06",
        "code": "PFCONCEPT_DPRINT06",
        "name": "Digital print 6 Plastic Pens",
        "technique_name": "Digital print 6 Plastic Pens",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DPRINT06",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.546,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.378,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.224,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.182,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.112,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.084,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.07,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.07,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.056,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.056,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DPRINT07",
        "code": "PFCONCEPT_DPRINT07",
        "name": "Digital print 7 Plastic Pens",
        "technique_name": "Digital print 7 Plastic Pens",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DPRINT07",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.644,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.462,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.266,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.21,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.196,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.154,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.07,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.07,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DRD01",
        "code": "PFCONCEPT_DRD01",
        "name": "Digital round drinkware 1",
        "technique_name": "Digital round drinkware 1",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DRD01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.862,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.218,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.938,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.826,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.798,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.784,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.77,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.756,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.728,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.728,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DRD02",
        "code": "PFCONCEPT_DRD02",
        "name": "Digital round drinkware 2",
        "technique_name": "Digital round drinkware 2",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DRD02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.086,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.442,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.204,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.078,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.05,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.036,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.022,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.008,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.994,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.994,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DRD03",
        "code": "PFCONCEPT_DRD03",
        "name": "Digital round drinkware 3",
        "technique_name": "Digital round drinkware 3",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DRD03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.226,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.778,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.54,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.414,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.386,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.33,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.288,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.288,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.274,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.246,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DRD04",
        "code": "PFCONCEPT_DRD04",
        "name": "Digital round drinkware 4",
        "technique_name": "Digital round drinkware 4",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DRD04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.548,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.778,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.582,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.47,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.47,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.47,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.456,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.442,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.428,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.428,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DRD05",
        "code": "PFCONCEPT_DRD05",
        "name": "Digital round drinkware 5",
        "technique_name": "Digital round drinkware 5",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DRD05",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 3.01,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.366,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.198,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.142,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 2.142,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 2.142,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 2.142,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 2.128,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 2.086,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 2.086,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DST01",
        "code": "PFCONCEPT_DST01",
        "name": "Etiqueta adhesiva digital",
        "technique_name": "Etiqueta adhesiva digital",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DST01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.98,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.644,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.602,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.546,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.476,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.434,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.42,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.406,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.392,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.378,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DST03",
        "code": "PFCONCEPT_DST03",
        "name": "Etiqueta adhesiva digital",
        "technique_name": "Etiqueta adhesiva digital",
        "cliche": 70,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DST03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 7.126,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 5.306,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 3.178,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.792,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.358,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.204,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.064,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.022,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.008,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.98,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DTF01",
        "code": "PFCONCEPT_DTF01",
        "name": "DTF Transfer 1",
        "technique_name": "DTF Transfer 1",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DTF01",
        "pfconcept_price_dependence": "Size",
        "section_1": 1,
        "price_1": 0.882,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.798,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.77,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.742,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.7,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.658,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.644,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.63,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.602,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.602,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DTF02",
        "code": "PFCONCEPT_DTF02",
        "name": "DTF Transfer 2",
        "technique_name": "DTF Transfer 2",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DTF02",
        "pfconcept_price_dependence": "Size",
        "section_1": 1,
        "price_1": 1.12,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.008,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.966,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.952,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.924,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.896,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.882,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.868,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.84,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.826,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DTR01",
        "code": "PFCONCEPT_DTR01",
        "name": "transfer digital fijo",
        "technique_name": "transfer digital fijo",
        "cliche": 50.4,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DTR01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.022,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.882,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.812,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.784,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.77,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.742,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.728,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.714,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.7,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.686,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DTR02",
        "code": "PFCONCEPT_DTR02",
        "name": "transfer digital fijo",
        "technique_name": "transfer digital fijo",
        "cliche": 50.4,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DTR02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.176,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.022,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.966,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.938,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.924,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.896,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.882,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.854,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.84,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.826,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DTR03",
        "code": "PFCONCEPT_DTR03",
        "name": "transfer digital fijo",
        "technique_name": "transfer digital fijo",
        "cliche": 50.4,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DTR03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.372,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.204,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.134,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.078,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.064,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.036,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.022,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.994,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.966,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.952,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DTR04",
        "code": "PFCONCEPT_DTR04",
        "name": "transfer digital fijo",
        "technique_name": "transfer digital fijo",
        "cliche": 50.4,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DTR04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.638,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.484,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.386,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.33,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.302,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.274,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.246,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.218,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.19,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.162,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DTR05",
        "code": "PFCONCEPT_DTR05",
        "name": "transfer digital fijo",
        "technique_name": "transfer digital fijo",
        "cliche": 50.4,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DTR05",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.932,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.876,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.75,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.68,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.638,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.568,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.526,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.498,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.47,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.428,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DTR06",
        "code": "PFCONCEPT_DTR06",
        "name": "transfer digital fijo",
        "technique_name": "transfer digital fijo",
        "cliche": 50.4,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DTR06",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.114,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.058,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.932,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.834,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.778,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.722,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.68,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.652,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.624,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.568,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DTR07",
        "code": "PFCONCEPT_DTR07",
        "name": "transfer digital fijo",
        "technique_name": "transfer digital fijo",
        "cliche": 50.4,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DTR07",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.338,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.268,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.156,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.044,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.974,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.904,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.862,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.82,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.792,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.75,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DTR08",
        "code": "PFCONCEPT_DTR08",
        "name": "transfer digital fijo",
        "technique_name": "transfer digital fijo",
        "cliche": 50.4,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DTR08",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.94,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.786,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.674,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.548,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 2.464,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 2.38,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 2.296,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 2.268,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 2.212,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 2.17,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DTR09",
        "code": "PFCONCEPT_DTR09",
        "name": "Digital transfer fixed 9",
        "technique_name": "Digital transfer fixed 9",
        "cliche": 50.4,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DTR09",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.932,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.778,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.68,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.596,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.512,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.442,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.414,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.344,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.33,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.302,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DTRS01",
        "code": "PFCONCEPT_DTRS01",
        "name": "Transfer digital",
        "technique_name": "Transfer digital",
        "cliche": 50.4,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DTRS01",
        "pfconcept_price_dependence": "Size",
        "section_1": 1,
        "price_1": 1.33,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.994,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.91,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.7,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.686,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.672,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.672,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.672,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.672,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.672,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_DTRTS01",
        "code": "PFCONCEPT_DTRTS01",
        "name": "Transfer digital",
        "technique_name": "Transfer digital",
        "cliche": 50.4,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "DTRTS01",
        "pfconcept_price_dependence": "Size",
        "section_1": 1,
        "price_1": 0.98,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.882,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.854,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.77,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.714,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.686,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.672,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.658,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.644,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.644,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_EMB001",
        "code": "PFCONCEPT_EMB001",
        "name": "Bordado",
        "technique_name": "Bordado",
        "cliche": 56,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "EMB001",
        "pfconcept_price_dependence": "Size",
        "section_1": 1,
        "price_1": 5.516,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 3.682,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.912,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.086,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.89,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.764,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.75,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.708,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.666,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.652,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_EMB3D01",
        "code": "PFCONCEPT_EMB3D01",
        "name": "3D Embroidery",
        "technique_name": "3D Embroidery",
        "cliche": 56,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "EMB3D01",
        "pfconcept_price_dependence": "Size",
        "section_1": 1,
        "price_1": 6.272,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 5.754,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 4.326,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 3.514,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 2.688,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 2.436,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 2.254,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 2.128,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 2.058,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.988,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_EMBF01",
        "code": "PFCONCEPT_EMBF01",
        "name": "Embroidery fixed 1",
        "technique_name": "Embroidery fixed 1",
        "cliche": 56,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "EMBF01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 5.642,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 3.752,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.996,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.128,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.946,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.806,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.792,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.764,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.736,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.722,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_EMBF02",
        "code": "PFCONCEPT_EMBF02",
        "name": "Embroidery fixed 2",
        "technique_name": "Embroidery fixed 2",
        "cliche": 56,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "EMBF02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 6.398,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 4.13,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 3.262,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.24,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 2.044,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.834,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.792,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.778,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.736,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.722,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_EMBF03",
        "code": "PFCONCEPT_EMBF03",
        "name": "Embroidery fixed 3",
        "technique_name": "Embroidery fixed 3",
        "cliche": 56,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "EMBF03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 7.14,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 4.494,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 3.724,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.618,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 2.548,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 2.52,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 2.45,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 2.436,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 2.408,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 2.394,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_EMBF04",
        "code": "PFCONCEPT_EMBF04",
        "name": "Embroidery fixed 4",
        "technique_name": "Embroidery fixed 4",
        "cliche": 56,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "EMBF04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 8.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 6.104,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 5.236,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 4.2,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 4.018,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 3.878,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 3.836,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 3.808,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 3.724,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 3.696,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_EMBF05",
        "code": "PFCONCEPT_EMBF05",
        "name": "Embroidery fixed 5",
        "technique_name": "Embroidery fixed 5",
        "cliche": 56,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "EMBF05",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 10.528,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 9.324,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 8.344,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 7.56,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 7.266,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 7.07,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 6.986,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 6.93,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 6.818,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 6.776,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_GPE01",
        "code": "PFCONCEPT_GPE01",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "GPE01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.778,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.33,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.812,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.658,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.518,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.406,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.392,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.336,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.336,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.308,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_GPE02",
        "code": "PFCONCEPT_GPE02",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "GPE02",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.96,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.456,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.008,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.742,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.672,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.532,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.476,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.448,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.434,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.406,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_GPE03",
        "code": "PFCONCEPT_GPE03",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "GPE03",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.974,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.568,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.022,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.812,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.7,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.56,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.518,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.462,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.448,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.434,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_GPE04",
        "code": "PFCONCEPT_GPE04",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "GPE04",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 2.296,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.82,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.26,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.05,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.91,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.784,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.756,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.714,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.658,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.644,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_GPE05",
        "code": "PFCONCEPT_GPE05",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "GPE05",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 2.912,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.38,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.876,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.54,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.4,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.218,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.204,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.148,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.092,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.036,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_GPE06",
        "code": "PFCONCEPT_GPE06",
        "name": "Screenprint A special 1",
        "technique_name": "Screenprint A special 1",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "GPE06",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 2.086,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.106,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.658,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.518,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.364,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.322,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.308,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.238,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.224,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.224,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_GPE07",
        "code": "PFCONCEPT_GPE07",
        "name": "Screenprint A special 2",
        "technique_name": "Screenprint A special 2",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "GPE07",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 2.086,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.106,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.658,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.518,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.364,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.322,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.308,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.238,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.224,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.224,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_GPE08",
        "code": "PFCONCEPT_GPE08",
        "name": "Screenprint A special 3",
        "technique_name": "Screenprint A special 3",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "GPE08",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.932,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.428,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.882,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.728,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.546,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.448,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.406,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.35,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.336,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.308,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_GPE2401",
        "code": "PFCONCEPT_GPE2401",
        "name": "Serigrafía circular",
        "technique_name": "Serigrafía circular",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "GPE2401",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.736,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.924,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.518,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.378,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.252,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.196,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.196,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.182,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.168,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.168,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_GPE2402",
        "code": "PFCONCEPT_GPE2402",
        "name": "Serigrafía circular",
        "technique_name": "Serigrafía circular",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "GPE2402",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.792,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.952,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.546,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.392,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.322,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.224,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.224,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.182,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.168,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.168,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_GPE2403",
        "code": "PFCONCEPT_GPE2403",
        "name": "Serigrafía circular",
        "technique_name": "Serigrafía circular",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "GPE2403",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.834,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.966,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.574,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.406,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.336,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.238,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.238,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.196,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.196,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.182,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_GPE2404",
        "code": "PFCONCEPT_GPE2404",
        "name": "Serigrafía circular",
        "technique_name": "Serigrafía circular",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "GPE2404",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.862,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.98,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.602,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.448,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.35,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.266,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.266,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.224,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.224,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.196,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_GPE2405",
        "code": "PFCONCEPT_GPE2405",
        "name": "Serigrafía circular",
        "technique_name": "Serigrafía circular",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "GPE2405",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.89,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.008,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.644,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.462,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.392,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.336,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.308,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.238,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.238,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.224,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_GPE24A2",
        "code": "PFCONCEPT_GPE24A2",
        "name": "Serigrafía circular",
        "technique_name": "Serigrafía circular",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "GPE24A2",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.638,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.602,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.322,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.224,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.14,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.126,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.056,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.056,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.056,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.056,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_HTS01",
        "code": "PFCONCEPT_HTS01",
        "name": "Termograbado en color",
        "technique_name": "Termograbado en color",
        "cliche": 53.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "HTS01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.856,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.792,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.232,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.84,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.672,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.644,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.63,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.616,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.602,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.588,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_HTS02",
        "code": "PFCONCEPT_HTS02",
        "name": "Termograbado en color",
        "technique_name": "Termograbado en color",
        "cliche": 53.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "HTS02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 3.024,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.96,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.386,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.008,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.784,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.784,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.714,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.714,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.672,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.658,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_HTS03",
        "code": "PFCONCEPT_HTS03",
        "name": "Termograbado en color",
        "technique_name": "Termograbado en color",
        "cliche": 53.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "HTS03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 3.514,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.52,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.89,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.414,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.218,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.19,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.148,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.134,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.106,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.064,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_HTS04",
        "code": "PFCONCEPT_HTS04",
        "name": "Termograbado en color",
        "technique_name": "Termograbado en color",
        "cliche": 53.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "HTS04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 3.752,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.646,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.016,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.582,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.386,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.358,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.302,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.274,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.246,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.204,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_HTS05",
        "code": "PFCONCEPT_HTS05",
        "name": "Termograbado en color",
        "technique_name": "Termograbado en color",
        "cliche": 53.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "HTS05",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 4.914,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 3.752,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 3.136,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.548,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 2.352,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 2.31,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 2.254,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 2.24,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 2.142,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 2.044,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_IMD01",
        "code": "PFCONCEPT_IMD01",
        "name": "Grabación en molde para recipientes",
        "technique_name": "Grabación en molde para recipientes",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "IMD01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 5.922,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 4.984,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 3.542,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.24,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.456,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.008,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.77,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.756,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.728,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.672,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_IMD02",
        "code": "PFCONCEPT_IMD02",
        "name": "Grabación en molde para recipientes",
        "technique_name": "Grabación en molde para recipientes",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "IMD02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 6.342,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 5.544,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 3.892,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.394,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.61,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.064,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.868,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.798,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.77,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.742,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LAS01",
        "code": "PFCONCEPT_LAS01",
        "name": "Grabado a láser",
        "technique_name": "Grabado a láser",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LAS01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.344,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.812,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.574,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.406,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.35,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.35,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.336,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.336,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.322,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.294,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LAS02",
        "code": "PFCONCEPT_LAS02",
        "name": "Grabado a láser",
        "technique_name": "Grabado a láser",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LAS02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.428,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.91,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.602,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.476,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.406,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.392,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.392,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.392,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.392,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.378,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LAS03",
        "code": "PFCONCEPT_LAS03",
        "name": "Grabado a láser",
        "technique_name": "Grabado a láser",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LAS03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.75,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.218,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.952,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.728,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.686,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.686,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.686,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.686,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.658,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.658,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LAS04",
        "code": "PFCONCEPT_LAS04",
        "name": "Grabado a láser",
        "technique_name": "Grabado a láser",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LAS04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.436,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.82,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.54,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.288,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.274,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.246,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.232,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.218,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.176,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.148,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LAS05",
        "code": "PFCONCEPT_LAS05",
        "name": "Grabado a láser",
        "technique_name": "Grabado a láser",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LAS05",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 3.416,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.73,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.436,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.114,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 2.114,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 2.044,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 2.03,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 2.016,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.988,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.946,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LAS06",
        "code": "PFCONCEPT_LAS06",
        "name": "Laser engraving premium",
        "technique_name": "Laser engraving premium",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LAS06",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 3.416,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.73,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.436,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.114,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 2.114,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 2.044,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 2.03,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 2.016,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.988,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.946,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LASR01",
        "code": "PFCONCEPT_LASR01",
        "name": "Laser engraving round 360 1",
        "technique_name": "Laser engraving round 360 1",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LASR01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.932,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.218,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.148,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.994,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.938,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.882,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.882,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.854,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.826,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.798,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LASR02",
        "code": "PFCONCEPT_LASR02",
        "name": "Laser engraving round 360 2",
        "technique_name": "Laser engraving round 360 2",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LASR02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.086,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.344,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.218,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.092,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.036,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.952,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.952,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.924,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.896,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.882,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LASR03",
        "code": "PFCONCEPT_LASR03",
        "name": "Laser engraving round 360 3",
        "technique_name": "Laser engraving round 360 3",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LASR03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.31,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.484,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.33,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.204,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.134,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.064,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.05,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.036,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.994,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.966,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LASR04",
        "code": "PFCONCEPT_LASR04",
        "name": "Laser engraving round 360 4",
        "technique_name": "Laser engraving round 360 4",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LASR04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.632,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.694,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.47,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.386,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.288,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.204,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.19,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.162,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.134,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.12,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LASR05",
        "code": "PFCONCEPT_LASR05",
        "name": "Laser engraving round 360 5",
        "technique_name": "Laser engraving round 360 5",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LASR05",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.996,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.946,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.708,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.582,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.47,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.456,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.428,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.4,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.372,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.344,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LASR06",
        "code": "PFCONCEPT_LASR06",
        "name": "Laser engraving round 360 6",
        "technique_name": "Laser engraving round 360 6",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LASR06",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 4.718,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 3.71,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 3.094,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.772,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 2.744,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 2.66,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 2.632,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 2.548,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 2.436,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 2.394,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LIT02",
        "code": "PFCONCEPT_LIT02",
        "name": "Impresión en papel",
        "technique_name": "Impresión en papel",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LIT02",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 120.638,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.436,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.12,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.532,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.266,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.112,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.084,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.084,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LIT03",
        "code": "PFCONCEPT_LIT03",
        "name": "Impresión en papel",
        "technique_name": "Impresión en papel",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LIT03",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 120.638,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.436,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.12,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.532,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.266,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.112,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.084,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.084,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LIT04",
        "code": "PFCONCEPT_LIT04",
        "name": "Impresión en papel",
        "technique_name": "Impresión en papel",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LIT04",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 100.618,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.26,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.714,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.49,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.252,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.112,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.084,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.084,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LIT05",
        "code": "PFCONCEPT_LIT05",
        "name": "Impresión en papel",
        "technique_name": "Impresión en papel",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LIT05",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 100.618,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.26,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.714,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.49,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.252,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.112,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.084,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.084,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LIT06",
        "code": "PFCONCEPT_LIT06",
        "name": "Impresión en papel",
        "technique_name": "Impresión en papel",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LIT06",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 86.212,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.078,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.616,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.448,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.252,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.112,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.084,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.084,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LIT07",
        "code": "PFCONCEPT_LIT07",
        "name": "Impresión en papel",
        "technique_name": "Impresión en papel",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LIT07",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 86.212,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.078,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.616,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.448,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.252,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.112,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.084,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.084,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LITFC01",
        "code": "PFCONCEPT_LITFC01",
        "name": "Litho full color 1",
        "technique_name": "Litho full color 1",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LITFC01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 223.524,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 4.326,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.1,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.896,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.462,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.224,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.126,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.112,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.112,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.112,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LITFC02",
        "code": "PFCONCEPT_LITFC02",
        "name": "Litho full color 2",
        "technique_name": "Litho full color 2",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LITFC02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 186.27,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 3.654,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.75,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.77,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.35,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.196,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.126,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.112,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.112,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.112,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_LITFC03",
        "code": "PFCONCEPT_LITFC03",
        "name": "Litho full color 3",
        "technique_name": "Litho full color 3",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "LITFC03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 159.67,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 3.164,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.54,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.63,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.35,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.196,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.126,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.112,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.112,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.112,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MPP01",
        "code": "PFCONCEPT_MPP01",
        "name": "Productos de papel mate",
        "technique_name": "Productos de papel mate",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MPP01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.574,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.35,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.252,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.21,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.21,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.196,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.196,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.168,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.154,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MPP02",
        "code": "PFCONCEPT_MPP02",
        "name": "Productos de papel mate",
        "technique_name": "Productos de papel mate",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MPP02",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.862,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.784,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.518,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.406,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.35,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.28,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.266,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.252,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.252,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.238,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MPP04",
        "code": "PFCONCEPT_MPP04",
        "name": "Productos de papel mate",
        "technique_name": "Productos de papel mate",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MPP04",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 3.01,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.456,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.05,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.756,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.714,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.602,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.574,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.462,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.462,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.434,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MPPFC01",
        "code": "PFCONCEPT_MPPFC01",
        "name": "Mat paper products full color 1",
        "technique_name": "Mat paper products full color 1",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MPPFC01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.058,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.176,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.952,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.784,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.364,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.364,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.28,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.238,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.224,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.21,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MPPFC02",
        "code": "PFCONCEPT_MPPFC02",
        "name": "Mat paper products full color 2",
        "technique_name": "Mat paper products full color 2",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MPPFC02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.576,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.414,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.134,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.98,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.49,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.476,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.448,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.35,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.35,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.336,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MPPFC03",
        "code": "PFCONCEPT_MPPFC03",
        "name": "Mat paper products full color 3",
        "technique_name": "Mat paper products full color 3",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MPPFC03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 3.052,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.638,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.344,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.148,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.784,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.616,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.532,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.476,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.476,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.448,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MR00",
        "code": "PFCONCEPT_MR00",
        "name": "Serigrafía circular",
        "technique_name": "Serigrafía circular",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MR00",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.274,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.91,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.7,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.644,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.546,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.406,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.364,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.336,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.336,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.336,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MR01",
        "code": "PFCONCEPT_MR01",
        "name": "Serigrafía circular",
        "technique_name": "Serigrafía circular",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MR01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.54,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.316,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.134,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.798,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.672,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.588,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.546,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.462,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.448,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.434,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MR02",
        "code": "PFCONCEPT_MR02",
        "name": "Serigrafía circular",
        "technique_name": "Serigrafía circular",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MR02",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.75,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.554,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.274,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.952,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.882,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.7,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.644,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.602,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.588,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.574,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MR03",
        "code": "PFCONCEPT_MR03",
        "name": "Serigrafía circular",
        "technique_name": "Serigrafía circular",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MR03",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.96,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.736,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.498,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.12,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.036,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.882,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.798,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.728,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.7,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.686,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MR04",
        "code": "PFCONCEPT_MR04",
        "name": "Serigrafía circular",
        "technique_name": "Serigrafía circular",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MR04",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 2.226,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.988,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.736,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.344,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.19,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.092,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.064,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.966,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.938,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.896,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MR05",
        "code": "PFCONCEPT_MR05",
        "name": "Serigrafía circular",
        "technique_name": "Serigrafía circular",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MR05",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 2.786,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.506,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.226,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.792,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.68,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.554,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.484,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.372,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.33,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.288,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MR06",
        "code": "PFCONCEPT_MR06",
        "name": "Screenprint B special 1",
        "technique_name": "Screenprint B special 1",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MR06",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.764,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.204,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.77,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.56,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.518,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.476,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.42,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.392,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.364,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.364,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MR07",
        "code": "PFCONCEPT_MR07",
        "name": "Screenprint B Textile 2",
        "technique_name": "Screenprint B Textile 2",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MR07",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.974,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.316,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.882,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.616,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.574,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.518,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.476,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.434,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.42,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.406,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_MRA8",
        "code": "PFCONCEPT_MRA8",
        "name": "Serigrafía",
        "technique_name": "Serigrafía",
        "cliche": 35,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "MRA8",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 3.108,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.792,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.162,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.938,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.784,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.742,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.686,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.686,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.644,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.644,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_PAD01",
        "code": "PFCONCEPT_PAD01",
        "name": "Tampografía",
        "technique_name": "Tampografía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "PAD01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.826,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.616,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.602,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.392,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.378,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.35,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.294,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.252,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.224,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.196,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_PAD02",
        "code": "PFCONCEPT_PAD02",
        "name": "Tampografía",
        "technique_name": "Tampografía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "PAD02",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.882,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.63,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.602,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.448,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.392,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.378,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.322,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.294,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.28,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.266,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_PAD03",
        "code": "PFCONCEPT_PAD03",
        "name": "Tampografía",
        "technique_name": "Tampografía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "PAD03",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.896,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.7,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.644,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.504,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.448,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.434,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.406,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.378,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.378,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.336,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_PAD04",
        "code": "PFCONCEPT_PAD04",
        "name": "Tampografía",
        "technique_name": "Tampografía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "PAD04",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.134,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.868,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.756,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.588,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.518,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.462,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.448,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.42,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.42,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.378,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_PAD05",
        "code": "PFCONCEPT_PAD05",
        "name": "Tampografía",
        "technique_name": "Tampografía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "PAD05",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.596,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.484,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.386,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.12,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.994,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.924,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.84,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.756,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.714,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.7,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_PADA2",
        "code": "PFCONCEPT_PADA2",
        "name": "Tampografía",
        "technique_name": "Tampografía",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "PADA2",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.7,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.532,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.322,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.224,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.196,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.182,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.14,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.14,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.126,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.112,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_PC02",
        "code": "PFCONCEPT_PC02",
        "name": "Personal card",
        "technique_name": "Personal card",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "PC02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.336,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.336,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.336,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.336,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.336,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.336,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.336,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.336,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.336,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.322,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_RFM01",
        "code": "PFCONCEPT_RFM01",
        "name": "Relief moulding 1",
        "technique_name": "Relief moulding 1",
        "cliche": 210,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "RFM01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 229.012,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 4.872,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.408,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.91,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.476,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.252,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.21,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.182,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.168,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.126,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_RFM02",
        "code": "PFCONCEPT_RFM02",
        "name": "Relief moulding 2",
        "technique_name": "Relief moulding 2",
        "cliche": 370.3,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "RFM02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 436.632,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 9.338,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 4.662,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.862,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.924,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.28,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.252,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.238,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.21,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.168,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_SUB01",
        "code": "PFCONCEPT_SUB01",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 50.4,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "SUB01",
        "pfconcept_price_dependence": "Size",
        "section_1": 1,
        "price_1": 4.62,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.17,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.526,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.148,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.05,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.994,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.952,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.924,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.868,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.84,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_SUBM01",
        "code": "PFCONCEPT_SUBM01",
        "name": "Sublimación",
        "technique_name": "Sublimación",
        "cliche": 50.4,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "SUBM01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.52,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.044,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.526,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.428,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.358,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.358,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.302,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.274,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.26,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.232,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_TRA01",
        "code": "PFCONCEPT_TRA01",
        "name": "Transfer serigráfico",
        "technique_name": "Transfer serigráfico",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "TRA01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 2.352,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.512,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.008,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.714,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.672,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.588,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.532,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.532,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.518,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.462,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_TRA02",
        "code": "PFCONCEPT_TRA02",
        "name": "Transfer serigráfico",
        "technique_name": "Transfer serigráfico",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "TRA02",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 2.786,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.89,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.288,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.064,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.952,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.854,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.826,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.784,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.742,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.728,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_TRA03",
        "code": "PFCONCEPT_TRA03",
        "name": "Transfer serigráfico",
        "technique_name": "Transfer serigráfico",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "TRA03",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 3.136,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.184,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.68,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.33,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.232,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.148,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.12,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.05,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.008,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.952,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_TRA04",
        "code": "PFCONCEPT_TRA04",
        "name": "Transfer serigráfico",
        "technique_name": "Transfer serigráfico",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "TRA04",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 3.542,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.604,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.03,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.68,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.596,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.456,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.442,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.372,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.316,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.246,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_TRA05",
        "code": "PFCONCEPT_TRA05",
        "name": "Transfer serigráfico",
        "technique_name": "Transfer serigráfico",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "TRA05",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 5.026,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 3.948,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 3.318,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 2.814,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 2.716,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 2.59,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 2.506,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 2.422,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 2.324,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 2.198,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_TRAT01",
        "code": "PFCONCEPT_TRAT01",
        "name": "Transfer serigráfico",
        "technique_name": "Transfer serigráfico",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "TRAT01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 2.31,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.484,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.064,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.784,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.714,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.672,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.658,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.63,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.602,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.588,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_TRAT02",
        "code": "PFCONCEPT_TRAT02",
        "name": "Transfer serigráfico",
        "technique_name": "Transfer serigráfico",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "TRAT02",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 2.422,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.582,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.106,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.882,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.77,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.742,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.714,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.714,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.672,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.658,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_TRAT03",
        "code": "PFCONCEPT_TRAT03",
        "name": "Transfer serigráfico",
        "technique_name": "Transfer serigráfico",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "TRAT03",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 2.534,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.932,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.68,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.288,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.148,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.05,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.952,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.882,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.812,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.784,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_TRAT04",
        "code": "PFCONCEPT_TRAT04",
        "name": "Transfer serigráfico",
        "technique_name": "Transfer serigráfico",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "TRAT04",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 2.688,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.24,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.918,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.54,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.372,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.246,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.19,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.092,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.064,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.994,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_TRAT05",
        "code": "PFCONCEPT_TRAT05",
        "name": "Transfer serigráfico",
        "technique_name": "Transfer serigráfico",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "TRAT05",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 3.682,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.828,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.31,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.988,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.876,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.806,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.778,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 1.764,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 1.708,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 1.624,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WEB02",
        "code": "PFCONCEPT_WEB02",
        "name": "Offset",
        "technique_name": "Offset",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "WEB02",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 117.558,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.184,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.05,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.448,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.434,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.336,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.336,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.336,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.336,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.322,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WEB03",
        "code": "PFCONCEPT_WEB03",
        "name": "Offset",
        "technique_name": "Offset",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "WEB03",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 117.558,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.184,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.05,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.448,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.252,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.112,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.07,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.07,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WEB04",
        "code": "PFCONCEPT_WEB04",
        "name": "Offset",
        "technique_name": "Offset",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "WEB04",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 117.558,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.184,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.05,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.448,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.252,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.112,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.07,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.07,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WEB05",
        "code": "PFCONCEPT_WEB05",
        "name": "Offset",
        "technique_name": "Offset",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "WEB05",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 97.986,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.848,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.924,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.364,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.238,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.112,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.07,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.07,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WEB06",
        "code": "PFCONCEPT_WEB06",
        "name": "Offset",
        "technique_name": "Offset",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "WEB06",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 97.986,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.848,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.924,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.364,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.238,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.112,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.07,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.07,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WEBFC01",
        "code": "PFCONCEPT_WEBFC01",
        "name": "Web offset full color 1",
        "technique_name": "Web offset full color 1",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "WEBFC01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 335.006,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 6.188,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 3.01,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.134,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.036,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.98,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.966,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.952,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.924,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.924,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WEBFC02",
        "code": "PFCONCEPT_WEBFC02",
        "name": "Web offset full color 2",
        "technique_name": "Web offset full color 2",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "WEBFC02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 335.006,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 6.188,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 3.01,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.134,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.574,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.294,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.112,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.07,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.07,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WEBFC03",
        "code": "PFCONCEPT_WEBFC03",
        "name": "Web offset full color 3",
        "technique_name": "Web offset full color 3",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "stock",
        "pfconcept_print_code": "WEBFC03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 279.174,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 5.222,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.548,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.952,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.518,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.28,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.112,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.07,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.07,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSALL01",
        "code": "PFCONCEPT_WSALL01",
        "name": "WS Alba Litho 1 S",
        "technique_name": "WS Alba Litho 1 S",
        "cliche": 77,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSALL01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.224,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.224,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.112,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.042,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.042,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.042,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.028,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.028,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.028,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSALL02",
        "code": "PFCONCEPT_WSALL02",
        "name": "WS Alba Litho 2 M",
        "technique_name": "WS Alba Litho 2 M",
        "cliche": 77,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSALL02",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.196,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.196,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.07,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.042,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.042,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.028,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.028,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.028,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.028,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSALL03",
        "code": "PFCONCEPT_WSALL03",
        "name": "WS Alba Litho 3 L",
        "technique_name": "WS Alba Litho 3 L",
        "cliche": 77,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSALL03",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.224,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.224,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.112,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.042,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.042,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.042,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.028,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.028,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.028,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSALL04",
        "code": "PFCONCEPT_WSALL04",
        "name": "WS Alba Litho 4 XL",
        "technique_name": "WS Alba Litho 4 XL",
        "cliche": 77,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSALL04",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.252,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.252,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.126,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.056,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.042,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.042,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.042,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.028,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.028,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSALL05",
        "code": "PFCONCEPT_WSALL05",
        "name": "WS Alba Litho 5 XXL",
        "technique_name": "WS Alba Litho 5 XXL",
        "cliche": 77,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSALL05",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.392,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.392,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.196,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.07,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.07,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.056,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.056,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.042,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.042,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSALL06",
        "code": "PFCONCEPT_WSALL06",
        "name": "WS Alba Litho 6 XXXL",
        "technique_name": "WS Alba Litho 6 XXXL",
        "cliche": 77,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSALL06",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.434,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.434,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.21,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.084,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.084,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.07,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.056,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.056,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.042,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSALLF01",
        "code": "PFCONCEPT_WSALLF01",
        "name": "WS Alba Litho full color (CMYK) 1 S",
        "technique_name": "WS Alba Litho full color (CMYK) 1 S",
        "cliche": 77,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSALLF01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.658,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.658,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.266,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.168,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.154,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.14,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.126,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.112,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.112,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSALLF02",
        "code": "PFCONCEPT_WSALLF02",
        "name": "WS Alba Litho full color (CMYK) 2 M",
        "technique_name": "WS Alba Litho full color (CMYK) 2 M",
        "cliche": 77,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSALLF02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.448,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.448,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.168,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.126,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.126,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.126,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.112,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.112,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.112,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSALLF03",
        "code": "PFCONCEPT_WSALLF03",
        "name": "WS Alba Litho full color (CMYK) 3 L",
        "technique_name": "WS Alba Litho full color (CMYK) 3 L",
        "cliche": 77,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSALLF03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.658,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.658,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.266,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.168,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.154,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.14,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.126,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.112,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.112,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSALLF04",
        "code": "PFCONCEPT_WSALLF04",
        "name": "WS Alba Litho full color (CMYK) 4 XL",
        "technique_name": "WS Alba Litho full color (CMYK) 4 XL",
        "cliche": 77,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSALLF04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.742,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.742,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.294,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.182,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.168,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.154,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.14,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.126,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.126,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSALLF05",
        "code": "PFCONCEPT_WSALLF05",
        "name": "WS Alba Litho full color (CMYK) 5 XXL",
        "technique_name": "WS Alba Litho full color (CMYK) 5 XXL",
        "cliche": 77,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSALLF05",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.316,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.316,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.448,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.28,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.252,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.238,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.21,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.196,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.182,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSALLF06",
        "code": "PFCONCEPT_WSALLF06",
        "name": "WS Alba Litho full color (CMYK) 6 XXXL",
        "technique_name": "WS Alba Litho full color (CMYK) 6 XXXL",
        "cliche": 77,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSALLF06",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.47,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.47,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.504,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.308,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.28,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.266,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.238,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.21,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.21,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSDST01",
        "code": "PFCONCEPT_WSDST01",
        "name": "WS Mykit Digital sticker",
        "technique_name": "WS Mykit Digital sticker",
        "cliche": 91,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSDST01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSEDP01",
        "code": "PFCONCEPT_WSEDP01",
        "name": "WS EQPack Digital print 1",
        "technique_name": "WS EQPack Digital print 1",
        "cliche": 21,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSEDP01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.266,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.266,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.238,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.224,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.224,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.224,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.21,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 0.196,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 25000,
        "price_9": 0.196,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 30000,
        "price_10": 0.196,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSESP01",
        "code": "PFCONCEPT_WSESP01",
        "name": "WS EQPack Screenprint 1",
        "technique_name": "WS EQPack Screenprint 1",
        "cliche": 28,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSESP01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.154,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.154,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.126,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.098,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.098,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.084,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 0.084,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 25000,
        "price_9": 0.084,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 30000,
        "price_10": 0.084,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSHPDBP1",
        "code": "PFCONCEPT_WSHPDBP1",
        "name": "WS Hey Pots Digital box print 1",
        "technique_name": "WS Hey Pots Digital box print 1",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSHPDBP1",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.316,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.316,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.204,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.092,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.994,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.966,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.7,
        "price_col_7": 0,
        "price_cm_7": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSHPDBP2",
        "code": "PFCONCEPT_WSHPDBP2",
        "name": "WS Hey Pots Digital box print 2",
        "technique_name": "WS Hey Pots Digital box print 2",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSHPDBP2",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.316,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.316,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.204,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.092,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.994,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.966,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.7,
        "price_col_7": 0,
        "price_cm_7": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSHPDBP3",
        "code": "PFCONCEPT_WSHPDBP3",
        "name": "WS Hey Pots Digital box print 3",
        "technique_name": "WS Hey Pots Digital box print 3",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSHPDBP3",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.554,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.554,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.414,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.302,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.162,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.148,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.826,
        "price_col_7": 0,
        "price_cm_7": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSHPDP1",
        "code": "PFCONCEPT_WSHPDP1",
        "name": "WS Hey Pots Digital print 1",
        "technique_name": "WS Hey Pots Digital print 1",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSHPDP1",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.994,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.994,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.896,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.812,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.742,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.714,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.518,
        "price_col_7": 0,
        "price_cm_7": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSHPDP2",
        "code": "PFCONCEPT_WSHPDP2",
        "name": "WS Hey Pots Digital print 2",
        "technique_name": "WS Hey Pots Digital print 2",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSHPDP2",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.658,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.658,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.602,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.56,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.504,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.49,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.35,
        "price_col_7": 0,
        "price_cm_7": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSHPDP3",
        "code": "PFCONCEPT_WSHPDP3",
        "name": "WS Hey Pots Digital print 3",
        "technique_name": "WS Hey Pots Digital print 3",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSHPDP3",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.988,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.988,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.806,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.694,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.512,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.456,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.05,
        "price_col_7": 0,
        "price_cm_7": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSHPDST2",
        "code": "PFCONCEPT_WSHPDST2",
        "name": "WS Hey Pots Digital sticker 2",
        "technique_name": "WS Hey Pots Digital sticker 2",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSHPDST2",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.658,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.658,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.602,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.56,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.504,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.49,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.35,
        "price_col_7": 0,
        "price_cm_7": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSHPDST3",
        "code": "PFCONCEPT_WSHPDST3",
        "name": "WS Hey Pots Digital sticker 3",
        "technique_name": "WS Hey Pots Digital sticker 3",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSHPDST3",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.988,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.988,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.806,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.694,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.512,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 1.456,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 1.05,
        "price_col_7": 0,
        "price_cm_7": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSMAL01",
        "code": "PFCONCEPT_WSMAL01",
        "name": "WS Magma Litho 1 S",
        "technique_name": "WS Magma Litho 1 S",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSMAL01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.112,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.112,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.07,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.056,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.056,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.042,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.028,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.028,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.028,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSMAL02",
        "code": "PFCONCEPT_WSMAL02",
        "name": "WS Magma Litho 2 M",
        "technique_name": "WS Magma Litho 2 M",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSMAL02",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.112,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.112,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.07,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.056,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.042,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.042,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.028,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.028,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.028,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSMAL03",
        "code": "PFCONCEPT_WSMAL03",
        "name": "WS Magma Litho 3 L",
        "technique_name": "WS Magma Litho 3 L",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSMAL03",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.126,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.126,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.084,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.056,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.056,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.042,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.042,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.028,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.028,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSMAL04",
        "code": "PFCONCEPT_WSMAL04",
        "name": "WS Magma Litho 4 XL",
        "technique_name": "WS Magma Litho 4 XL",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSMAL04",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.126,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.126,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.084,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.056,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.056,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.042,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.042,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.042,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.028,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSMAL05",
        "code": "PFCONCEPT_WSMAL05",
        "name": "WS Magma Litho 5 XXL",
        "technique_name": "WS Magma Litho 5 XXL",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSMAL05",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.126,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.126,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.084,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.056,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.056,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.056,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.042,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.042,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.028,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSMALF01",
        "code": "PFCONCEPT_WSMALF01",
        "name": "WS Magma Litho full color (CMYK) 1 S",
        "technique_name": "WS Magma Litho full color (CMYK) 1 S",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSMALF01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.336,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.336,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.014,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.014,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.014,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.014,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.014,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.014,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.014,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSMALF02",
        "code": "PFCONCEPT_WSMALF02",
        "name": "WS Magma Litho full color (CMYK) 2 M",
        "technique_name": "WS Magma Litho full color (CMYK) 2 M",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSMALF02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.364,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.364,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.196,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.126,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.098,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.07,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.056,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.042,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.042,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSMALF03",
        "code": "PFCONCEPT_WSMALF03",
        "name": "WS Magma Litho full color (CMYK) 3 L",
        "technique_name": "WS Magma Litho full color (CMYK) 3 L",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSMALF03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.364,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.364,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.196,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.126,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.112,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.084,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.056,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.056,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.042,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSMALF04",
        "code": "PFCONCEPT_WSMALF04",
        "name": "WS Magma Litho full color (CMYK) 4 XL",
        "technique_name": "WS Magma Litho full color (CMYK) 4 XL",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSMALF04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.392,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.392,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.21,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.14,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.112,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.084,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.07,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.056,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.056,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSMALF05",
        "code": "PFCONCEPT_WSMALF05",
        "name": "WS Magma Litho full color (CMYK) 5 XXL",
        "technique_name": "WS Magma Litho full color (CMYK) 5 XXL",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSMALF05",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.392,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.392,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.224,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.154,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1500,
        "price_5": 0.126,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.098,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.07,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.056,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.056,
        "price_col_9": 0,
        "price_cm_9": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSMD01",
        "code": "PFCONCEPT_WSMD01",
        "name": "WS MyKit Card printed card insert",
        "technique_name": "WS MyKit Card printed card insert",
        "cliche": 70,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSMD01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSMDP01",
        "code": "PFCONCEPT_WSMDP01",
        "name": "WS MyKit Digital print 1",
        "technique_name": "WS MyKit Digital print 1",
        "cliche": 91,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSMDP01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSMT02",
        "code": "PFCONCEPT_WSMT02",
        "name": "WS MyKit Transfer 2 200cm2",
        "technique_name": "WS MyKit Transfer 2 200cm2",
        "cliche": 70,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSMT02",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 3.752,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 25,
        "price_2": 3.752,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 2.198,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.372,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 1.302,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.938,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.798,
        "price_col_7": 0,
        "price_cm_7": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSPCP01",
        "code": "PFCONCEPT_WSPCP01",
        "name": "WS Powerbank Color print",
        "technique_name": "WS Powerbank Color print",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSPCP01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.07,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.07,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.07,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.07,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.028,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.028,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.028,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.014,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSPDOM01",
        "code": "PFCONCEPT_WSPDOM01",
        "name": "WS Powerbank Full color doming",
        "technique_name": "WS Powerbank Full color doming",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSPDOM01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.49,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.49,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.49,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.42,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.42,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.28,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.21,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.21,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSPDP01",
        "code": "PFCONCEPT_WSPDP01",
        "name": "WS Powerbank Digital print (offset)",
        "technique_name": "WS Powerbank Digital print (offset)",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSPDP01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.35,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.35,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.35,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.35,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.35,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.28,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.28,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.28,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSPLAS01",
        "code": "PFCONCEPT_WSPLAS01",
        "name": "WS Powerbank Laser engraving",
        "technique_name": "WS Powerbank Laser engraving",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSPLAS01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.07,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.07,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.07,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.07,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.07,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.07,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.07,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.07,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRDP01",
        "code": "PFCONCEPT_WSRDP01",
        "name": "WS Reflectors Digital print 1",
        "technique_name": "WS Reflectors Digital print 1",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRDP01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.098,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.098,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.098,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.098,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.098,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.098,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.098,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.098,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.098,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.07,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRDP02",
        "code": "PFCONCEPT_WSRDP02",
        "name": "WS Reflectors Digital print 2",
        "technique_name": "WS Reflectors Digital print 2",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRDP02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.252,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.252,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.252,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.252,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.252,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.238,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.238,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.238,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.224,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.14,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRDP03",
        "code": "PFCONCEPT_WSRDP03",
        "name": "WS Reflectors Digital print 3",
        "technique_name": "WS Reflectors Digital print 3",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRDP03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.126,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.126,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.126,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.126,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.112,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.112,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.112,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.112,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.112,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.07,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRDP04",
        "code": "PFCONCEPT_WSRDP04",
        "name": "WS Reflectors Digital print 4",
        "technique_name": "WS Reflectors Digital print 4",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRDP04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.07,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.07,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.07,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.07,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.07,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.07,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.07,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.07,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.07,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.056,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRDP05",
        "code": "PFCONCEPT_WSRDP05",
        "name": "WS Reflectors Digital print 5",
        "technique_name": "WS Reflectors Digital print 5",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRDP05",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.056,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.056,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.056,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.056,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.056,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.056,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.056,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.056,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.056,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.056,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRDP06",
        "code": "PFCONCEPT_WSRDP06",
        "name": "WS Reflectors Digital print 6",
        "technique_name": "WS Reflectors Digital print 6",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRDP06",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.224,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.224,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.224,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.224,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.224,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.224,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.224,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.224,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.224,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.224,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRSP01",
        "code": "PFCONCEPT_WSRSP01",
        "name": "WS Reflectors Screenprint 1",
        "technique_name": "WS Reflectors Screenprint 1",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRSP01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.756,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.756,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.756,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.756,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.728,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.364,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.224,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.182,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.154,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.154,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRSP02",
        "code": "PFCONCEPT_WSRSP02",
        "name": "WS Reflectors Screenprint 2",
        "technique_name": "WS Reflectors Screenprint 2",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRSP02",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.064,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.064,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.064,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 1.064,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.532,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.364,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.252,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.21,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.21,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.168,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRSP03",
        "code": "PFCONCEPT_WSRSP03",
        "name": "WS Reflectors Screenprint 3",
        "technique_name": "WS Reflectors Screenprint 3",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRSP03",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.532,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.532,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.532,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.532,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.266,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.182,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.126,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.112,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.112,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.084,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRSP04",
        "code": "PFCONCEPT_WSRSP04",
        "name": "WS Reflectors Screenprint 4",
        "technique_name": "WS Reflectors Screenprint 4",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRSP04",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.266,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.266,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.266,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.266,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.266,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.14,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.07,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.056,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.056,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRSP05",
        "code": "PFCONCEPT_WSRSP05",
        "name": "WS Reflectors Screenprint 5",
        "technique_name": "WS Reflectors Screenprint 5",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRSP05",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.224,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.224,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.224,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.224,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.21,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.21,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.056,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.056,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.042,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRSP06",
        "code": "PFCONCEPT_WSRSP06",
        "name": "WS Reflectors Screenprint 6",
        "technique_name": "WS Reflectors Screenprint 6",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRSP06",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.168,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.168,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.168,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.168,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.154,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.154,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.056,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.042,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.028,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.028,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRSP07",
        "code": "PFCONCEPT_WSRSP07",
        "name": "WS Reflectors Screenprint 7",
        "technique_name": "WS Reflectors Screenprint 7",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRSP07",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.49,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.49,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.49,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.49,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.462,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.448,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.182,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.182,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.182,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.098,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRSP12",
        "code": "PFCONCEPT_WSRSP12",
        "name": "WS Reflectors Screenprint 12",
        "technique_name": "WS Reflectors Screenprint 12",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRSP12",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.288,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.288,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.148,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.952,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.882,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.56,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.518,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.406,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.364,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.336,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSRTR01",
        "code": "PFCONCEPT_WSRTR01",
        "name": "WS Reflectors Transfer",
        "technique_name": "WS Reflectors Transfer",
        "cliche": 46.2,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSRTR01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.806,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.806,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.008,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.588,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.35,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.28,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.266,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.238,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.21,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 25000,
        "price_10": 0.21,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSDP01",
        "code": "PFCONCEPT_WSSDP01",
        "name": "WS SCX Digital print 1",
        "technique_name": "WS SCX Digital print 1",
        "cliche": 40.6,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSDP01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 4.2,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 4.2,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 4.2,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 3.99,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 3.78,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 3.57,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 3.36,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 2.94,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 2.52,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 2.52,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSEF01",
        "code": "PFCONCEPT_WSSEF01",
        "name": "WS SCX Embroidery fixed 1",
        "technique_name": "WS SCX Embroidery fixed 1",
        "cliche": 40.6,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSEF01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 4.2,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 4.2,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 4.2,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 3.99,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 3.78,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 3.57,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 3.36,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 2.94,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 2.52,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 2.52,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSEF02",
        "code": "PFCONCEPT_WSSEF02",
        "name": "WS SCX Embroidery fixed 2",
        "technique_name": "WS SCX Embroidery fixed 2",
        "cliche": 40.6,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSEF02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 1.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 1.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 1.33,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.26,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.19,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.12,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.98,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 0.84,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 0.84,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSLAS01",
        "code": "PFCONCEPT_WSSLAS01",
        "name": "WS SCX Laser engraving 1",
        "technique_name": "WS SCX Laser engraving 1",
        "cliche": 40.6,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSLAS01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSLAS02",
        "code": "PFCONCEPT_WSSLAS02",
        "name": "WS SCX Laser engraving 2",
        "technique_name": "WS SCX Laser engraving 2",
        "cliche": 40.6,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSLAS02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 1.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 1.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 1.33,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.26,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.19,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.12,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.98,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 0.84,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 0.84,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSLAS03",
        "code": "PFCONCEPT_WSSLAS03",
        "name": "WS SCX Laser engraving 3",
        "technique_name": "WS SCX Laser engraving 3",
        "cliche": 40.6,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSLAS03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 4.2,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 4.2,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 4.2,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 3.99,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 3.78,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 3.57,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 3.36,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 2.94,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 2.52,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 2.52,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSLF01",
        "code": "PFCONCEPT_WSSLF01",
        "name": "WS SCX Litho full color (CMYK) 1",
        "technique_name": "WS SCX Litho full color (CMYK) 1",
        "cliche": 40.6,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSLF01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 1.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 1.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 1.33,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.26,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.19,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.12,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.98,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 0.84,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 0.84,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSLU01",
        "code": "PFCONCEPT_WSSLU01",
        "name": "WS SCX Light up logo 1",
        "technique_name": "WS SCX Light up logo 1",
        "cliche": 40.6,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSLU01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSLU02",
        "code": "PFCONCEPT_WSSLU02",
        "name": "WS SCX Light up logo 2",
        "technique_name": "WS SCX Light up logo 2",
        "cliche": 40.6,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSLU02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 1.4,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 1.4,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 1.33,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.26,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.19,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.12,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.98,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 0.84,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 0.84,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSSS01",
        "code": "PFCONCEPT_WSSSS01",
        "name": "WS SCX Screenprint 1",
        "technique_name": "WS SCX Screenprint 1",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSSS01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 1.75,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 1.75,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 1.666,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 1.582,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.484,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.4,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.232,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 1.05,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 1.05,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 1.05,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSTD01",
        "code": "PFCONCEPT_WSSTD01",
        "name": "WS Tubyard digitalprint1",
        "technique_name": "WS Tubyard digitalprint1",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSTD01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.28,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.28,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.266,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.252,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.21,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2500,
        "price_6": 0.196,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 5000,
        "price_7": 0.182,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 10000,
        "price_8": 0.168,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSTT01",
        "code": "PFCONCEPT_WSSTT01",
        "name": "WS Tubyard transfer print",
        "technique_name": "WS Tubyard transfer print",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSTT01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB01",
        "code": "PFCONCEPT_WSSUB01",
        "name": "WS Lanyard Sublimation - Inclusive",
        "technique_name": "WS Lanyard Sublimation - Inclusive",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB02",
        "code": "PFCONCEPT_WSSUB02",
        "name": "WS Lanyard Sublimation - Bracelet",
        "technique_name": "WS Lanyard Sublimation - Bracelet",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.042,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.042,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.042,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.042,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.028,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.028,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.028,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 0.014,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB03",
        "code": "PFCONCEPT_WSSUB03",
        "name": "WS Lanyard Sublimation - Lanyard",
        "technique_name": "WS Lanyard Sublimation - Lanyard",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.084,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.084,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.07,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.07,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.042,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.042,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.028,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 0.028,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB04",
        "code": "PFCONCEPT_WSSUB04",
        "name": "WS Lanyard Sublimation - Cloth",
        "technique_name": "WS Lanyard Sublimation - Cloth",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.126,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.126,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.098,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.084,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.084,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.084,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.084,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 0.07,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB05",
        "code": "PFCONCEPT_WSSUB05",
        "name": "WS Lanyard Sublimation - Bag",
        "technique_name": "WS Lanyard Sublimation - Bag",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB05",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.322,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.322,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.28,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.266,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.266,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.252,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.252,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.238,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.224,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.224,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB06",
        "code": "PFCONCEPT_WSSUB06",
        "name": "WS Lanyard Sublimation - Scarf",
        "technique_name": "WS Lanyard Sublimation - Scarf",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB06",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.364,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.364,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.28,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.266,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.266,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.266,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.266,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.266,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.252,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.252,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB07",
        "code": "PFCONCEPT_WSSUB07",
        "name": "WS Lanyard Sublimation - Wearables",
        "technique_name": "WS Lanyard Sublimation - Wearables",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB07",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.266,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.266,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.21,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.182,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.182,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.168,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.168,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.168,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.154,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.154,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB08",
        "code": "PFCONCEPT_WSSUB08",
        "name": "WS Lanyard Sublimation 8",
        "technique_name": "WS Lanyard Sublimation 8",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB08",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.112,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.112,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.084,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.07,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.07,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.07,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.07,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.07,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.07,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.056,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB09",
        "code": "PFCONCEPT_WSSUB09",
        "name": "WS Lanyard Sublimation 9",
        "technique_name": "WS Lanyard Sublimation 9",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB09",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.294,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.294,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.28,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.196,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.14,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.098,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.098,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 0.098,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB10",
        "code": "PFCONCEPT_WSSUB10",
        "name": "WS Lanyard Sublimation 10",
        "technique_name": "WS Lanyard Sublimation 10",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB10",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.014,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.014,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.014,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.014,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.014,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.014,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.014,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 0.014,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB11",
        "code": "PFCONCEPT_WSSUB11",
        "name": "WS Lanyard sublimation 11 towel",
        "technique_name": "WS Lanyard sublimation 11 towel",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB11",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.406,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.406,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.308,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.28,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.266,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.266,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.238,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 0.238,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB12",
        "code": "PFCONCEPT_WSSUB12",
        "name": "WS Lanyard sublimation 12 towel",
        "technique_name": "WS Lanyard sublimation 12 towel",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB12",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.036,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.036,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.784,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.728,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.686,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.672,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.644,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 0.616,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB13",
        "code": "PFCONCEPT_WSSUB13",
        "name": "WS Lanyard sublimation 13 towel",
        "technique_name": "WS Lanyard sublimation 13 towel",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB13",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.198,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 2.198,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.666,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 1.54,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 1.456,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 1.4,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 1.372,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 1.316,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB14",
        "code": "PFCONCEPT_WSSUB14",
        "name": "WS Lanyard sublimation 14 towel",
        "technique_name": "WS Lanyard sublimation 14 towel",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB14",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.814,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 2.814,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 2.128,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 1.96,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 1.862,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 1.806,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 1.736,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 1.68,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUB15",
        "code": "PFCONCEPT_WSSUB15",
        "name": "WS Lanyard sublimation 15 bottle",
        "technique_name": "WS Lanyard sublimation 15 bottle",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUB15",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.168,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.168,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.112,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.112,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.112,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.098,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.098,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 0.098,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUF02",
        "code": "PFCONCEPT_WSSUF02",
        "name": "WS Lanyard Sublimation fitted - Bracelet",
        "technique_name": "WS Lanyard Sublimation fitted - Bracelet",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUF02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.056,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.056,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.056,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.056,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.042,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.042,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.042,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 0.028,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUF03",
        "code": "PFCONCEPT_WSSUF03",
        "name": "WS Lanyard Sublimation fitted - Lanyard",
        "technique_name": "WS Lanyard Sublimation fitted - Lanyard",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUF03",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.112,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.112,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.112,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.098,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.098,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.07,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.07,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 0.056,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUF04",
        "code": "PFCONCEPT_WSSUF04",
        "name": "WS Lanyard Sublimation fitted - Cloth",
        "technique_name": "WS Lanyard Sublimation fitted - Cloth",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUF04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.028,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.028,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.028,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.028,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.028,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.028,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.028,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 0.028,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUF05",
        "code": "PFCONCEPT_WSSUF05",
        "name": "WS Lanyard Sublimation fitted - Bag",
        "technique_name": "WS Lanyard Sublimation fitted - Bag",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUF05",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.448,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.448,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.35,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.308,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.308,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.28,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.28,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.28,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.266,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.252,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUF06",
        "code": "PFCONCEPT_WSSUF06",
        "name": "WS Lanyard Sublimation fitted - Scarf",
        "technique_name": "WS Lanyard Sublimation fitted - Scarf",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUF06",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.308,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.308,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 0.252,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 250,
        "price_4": 0.21,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 0.21,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 0.196,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 2500,
        "price_7": 0.196,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 0.196,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 10000,
        "price_9": 0.182,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 20000,
        "price_10": 0.182,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSSUF07",
        "code": "PFCONCEPT_WSSUF07",
        "name": "WS Lanyard sublimation fitted 7 bottle",
        "technique_name": "WS Lanyard sublimation fitted 7 bottle",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSSUF07",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.448,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 0.448,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 0.322,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.308,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.294,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.28,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.266,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 20000,
        "price_8": 0.266,
        "price_col_8": 0,
        "price_cm_8": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSUCP01",
        "code": "PFCONCEPT_WSUCP01",
        "name": "WS USB Color print",
        "technique_name": "WS USB Color print",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSUCP01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 0.07,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.07,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.07,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.042,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.028,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2500,
        "price_6": 0.028,
        "price_col_6": 0,
        "price_cm_6": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSUDOM01",
        "code": "PFCONCEPT_WSUDOM01",
        "name": "WS USB Full color doming",
        "technique_name": "WS USB Full color doming",
        "cliche": 84,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSUDOM01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.14,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.14,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.14,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.14,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.07,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2500,
        "price_6": 0.07,
        "price_col_6": 0,
        "price_cm_6": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSUDP01",
        "code": "PFCONCEPT_WSUDP01",
        "name": "WS USB Digital print",
        "technique_name": "WS USB Digital print",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSUDP01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.42,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.42,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.42,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.42,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.42,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2500,
        "price_6": 0.42,
        "price_col_6": 0,
        "price_cm_6": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSULAS01",
        "code": "PFCONCEPT_WSULAS01",
        "name": "WS USB Laser engraving",
        "technique_name": "WS USB Laser engraving",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSULAS01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.14,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 100,
        "price_2": 0.14,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 250,
        "price_3": 0.098,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.098,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.098,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2500,
        "price_6": 0.098,
        "price_col_6": 0,
        "price_cm_6": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSWCDP01",
        "code": "PFCONCEPT_WSWCDP01",
        "name": "WS Digital print 1",
        "technique_name": "WS Digital print 1",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSWCDP01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 3.64,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 3.64,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 3.612,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 3.15,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 2.604,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 2.254,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.806,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 1.806,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 1.806,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 1.806,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSWCDP02",
        "code": "PFCONCEPT_WSWCDP02",
        "name": "WS Digital print 2",
        "technique_name": "WS Digital print 2",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSWCDP02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 3.864,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 3.864,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 3.864,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 3.542,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 2.996,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 2.646,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 2.184,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 2.184,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 2.184,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 2.184,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSWCDP04",
        "code": "PFCONCEPT_WSWCDP04",
        "name": "WS Digital print 4",
        "technique_name": "WS Digital print 4",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSWCDP04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 3.234,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 3.234,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 3.192,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 3.094,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 2.17,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 2.03,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.764,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 1.652,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 1.652,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 1.652,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSWCEM01",
        "code": "PFCONCEPT_WSWCEM01",
        "name": "WS Embossing 1",
        "technique_name": "WS Embossing 1",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSWCEM01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.05,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 1.05,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 0.882,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 0.784,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.686,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0.574,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.504,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.434,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 0.406,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 0.364,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSWCHS01",
        "code": "PFCONCEPT_WSWCHS01",
        "name": "WS Hot Stamping 1",
        "technique_name": "WS Hot Stamping 1",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSWCHS01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 0.854,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 0.854,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 0.77,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 0.686,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.574,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0.504,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.434,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.406,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 0.364,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 0.364,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSWCLE01",
        "code": "PFCONCEPT_WSWCLE01",
        "name": "WS CGreen Laser engraving 1",
        "technique_name": "WS CGreen Laser engraving 1",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSWCLE01",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 2.716,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 2.716,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 2.604,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 2.072,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.96,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.904,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.82,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 1.82,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 1.82,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 1.82,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSWCLE02",
        "code": "PFCONCEPT_WSWCLE02",
        "name": "WS CGreen Laser engraving 2",
        "technique_name": "WS CGreen Laser engraving 2",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSWCLE02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.82,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 1.82,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 1.722,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 1.666,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.554,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.512,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.414,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 1.414,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 1.414,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 1.414,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSWCLE04",
        "code": "PFCONCEPT_WSWCLE04",
        "name": "WS CGreen Laser engraving 4",
        "technique_name": "WS CGreen Laser engraving 4",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSWCLE04",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.554,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 1.554,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 1.148,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 0.98,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.882,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0.826,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.742,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.742,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 0.742,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 0.742,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSWCPP02",
        "code": "PFCONCEPT_WSWCPP02",
        "name": "WS Pad print 2",
        "technique_name": "WS Pad print 2",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSWCPP02",
        "pfconcept_price_dependence": "None",
        "section_1": 1,
        "price_1": 1.022,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 1.022,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 0.98,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 0.91,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.616,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0.546,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.504,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.476,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 0.476,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 0.476,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSWCSP01",
        "code": "PFCONCEPT_WSWCSP01",
        "name": "WS CGreen Screenprint 1",
        "technique_name": "WS CGreen Screenprint 1",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSWCSP01",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 2.912,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 2.912,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 2.912,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 2.296,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.932,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.694,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.456,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 1.372,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 1.246,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 1.246,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSWCSP02",
        "code": "PFCONCEPT_WSWCSP02",
        "name": "WS CGreen Screenprint 2",
        "technique_name": "WS CGreen Screenprint 2",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSWCSP02",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 28,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 1.344,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 1.344,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 1.316,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 1.316,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 1.092,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.022,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 1.022,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 1.022,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 1.022,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "PFCONCEPT_WSWCSP03",
        "code": "PFCONCEPT_WSWCSP03",
        "name": "WS CGreen Screenprint 3",
        "technique_name": "WS CGreen Screenprint 3",
        "cliche": 49,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "pfconcept_assortment": "worldsource",
        "pfconcept_print_code": "WSWCSP03",
        "pfconcept_price_dependence": "Colors",
        "section_1": 1,
        "price_1": 28,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 10,
        "price_2": 1.12,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 25,
        "price_3": 1.12,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 50,
        "price_4": 1.05,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 100,
        "price_5": 0.966,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 250,
        "price_6": 0.742,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.672,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.672,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 2500,
        "price_9": 0.672,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 5000,
        "price_10": 0.672,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "999998",
        "code": "DTF10X10",
        "technique_name": "DTF 10x10",
        "section_1": 25,
        "price_1": 1.96,
        "price_col_1": 1.96,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.34,
        "price_col_2": 1.34,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.03,
        "price_col_3": 1.03,
        "price_cm_3": 0,
        "section_4": 200,
        "price_4": 1.03,
        "price_col_4": 1.03,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 0.81,
        "price_col_5": 0.81,
        "price_cm_5": 0,
        "section_6": 400,
        "price_6": 0.78,
        "price_col_6": 0.78,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.75,
        "price_col_7": 0.75,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.7,
        "price_col_8": 0.7,
        "price_cm_8": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null
    },
    {
        "technique_ref": "DTF10X10",
        "code": "DTF10X10",
        "technique_name": "DTF 10x10 (Code DTF10X10)",
        "section_1": 25,
        "price_1": 1.96,
        "price_col_1": 1.96,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 1.34,
        "price_col_2": 1.34,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.03,
        "price_col_3": 1.03,
        "price_cm_3": 0,
        "section_4": 200,
        "price_4": 1.03,
        "price_col_4": 1.03,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 0.81,
        "price_col_5": 0.81,
        "price_cm_5": 0,
        "section_6": 400,
        "price_6": 0.78,
        "price_col_6": 0.78,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 0.75,
        "price_col_7": 0.75,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 0.7,
        "price_col_8": 0.7,
        "price_cm_8": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null
    },
    {
        "technique_ref": "999999",
        "code": "DTF25X28",
        "technique_name": "DTF 25x28",
        "section_1": 25,
        "price_1": 2.85,
        "price_col_1": 2.85,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.22,
        "price_col_2": 2.22,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.88,
        "price_col_3": 1.88,
        "price_cm_3": 0,
        "section_4": 200,
        "price_4": 1.72,
        "price_col_4": 1.72,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 1.65,
        "price_col_5": 1.65,
        "price_cm_5": 0,
        "section_6": 400,
        "price_6": 1.61,
        "price_col_6": 1.61,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.56,
        "price_col_7": 1.56,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 1.5,
        "price_col_8": 1.5,
        "price_cm_8": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null
    },
    {
        "technique_ref": "DTF25X28",
        "code": "DTF25X28",
        "technique_name": "DTF 25x28 (Code DTF25X28)",
        "section_1": 25,
        "price_1": 2.85,
        "price_col_1": 2.85,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 2.22,
        "price_col_2": 2.22,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 1.88,
        "price_col_3": 1.88,
        "price_cm_3": 0,
        "section_4": 200,
        "price_4": 1.72,
        "price_col_4": 1.72,
        "price_cm_4": 0,
        "section_5": 300,
        "price_5": 1.65,
        "price_col_5": 1.65,
        "price_cm_5": 0,
        "section_6": 400,
        "price_6": 1.61,
        "price_col_6": 1.61,
        "price_cm_6": 0,
        "section_7": 500,
        "price_7": 1.56,
        "price_col_7": 1.56,
        "price_cm_7": 0,
        "section_8": 1000,
        "price_8": 1.5,
        "price_col_8": 1.5,
        "price_cm_8": 0,
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": null
    },
    {
        "technique_ref": "GP",
        "code": "GP",
        "technique_name": "GP (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.616,
        "price_col_1": 0.308,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.546,
        "price_col_2": 0.252,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.504,
        "price_col_3": 0.238,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.476,
        "price_col_4": 0.21,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.42,
        "price_col_5": 0.182,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.406,
        "price_col_6": 0.168,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "KP",
        "code": "KP",
        "technique_name": "KP (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 84,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.4,
        "price_col_1": 0.364,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 1.26,
        "price_col_2": 0.336,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 1.19,
        "price_col_3": 0.308,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 1.05,
        "price_col_4": 0.266,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.91,
        "price_col_5": 0.238,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.896,
        "price_col_6": 0.224,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "HP",
        "code": "HP",
        "technique_name": "HP (Roly)",
        "cliche": 42,
        "cliche_repetition": 35,
        "min": 70,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.77,
        "price_col_1": 0.322,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.686,
        "price_col_2": 0.28,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.644,
        "price_col_3": 0.252,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.616,
        "price_col_4": 0.224,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.546,
        "price_col_5": 0.196,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.532,
        "price_col_6": 0.182,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "F0",
        "code": "F0",
        "technique_name": "F0 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.42,
        "price_col_1": 0.224,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.364,
        "price_col_2": 0.168,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.336,
        "price_col_3": 0.112,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.308,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.28,
        "price_col_5": 0.084,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.273,
        "price_col_6": 0.07,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "F1",
        "code": "F1",
        "technique_name": "F1 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.49,
        "price_col_1": 0.224,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.434,
        "price_col_2": 0.168,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.406,
        "price_col_3": 0.112,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.378,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.35,
        "price_col_5": 0.084,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.336,
        "price_col_6": 0.07,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "F2",
        "code": "F2",
        "technique_name": "F2 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 70,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.56,
        "price_col_1": 0.224,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.504,
        "price_col_2": 0.168,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.476,
        "price_col_3": 0.112,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.448,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.42,
        "price_col_5": 0.084,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.406,
        "price_col_6": 0.07,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "F3",
        "code": "F3",
        "technique_name": "F3 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 70,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.7,
        "price_col_1": 0.224,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.616,
        "price_col_2": 0.168,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.56,
        "price_col_3": 0.112,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.532,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.49,
        "price_col_5": 0.084,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.476,
        "price_col_6": 0.07,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "F4",
        "code": "F4",
        "technique_name": "F4 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 70,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.77,
        "price_col_1": 0.224,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.686,
        "price_col_2": 0.168,
        "price_cm_2": 0,
        "section_3": 1000,
        "price_3": 0.63,
        "price_col_3": 0.112,
        "price_cm_3": 0,
        "section_4": 2000,
        "price_4": 0.602,
        "price_col_4": 0.098,
        "price_cm_4": 0,
        "section_5": 5000,
        "price_5": 0.56,
        "price_col_5": 0.084,
        "price_cm_5": 0,
        "section_6": 10000,
        "price_6": 0.546,
        "price_col_6": 0.07,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "N2",
        "code": "N2",
        "technique_name": "N2 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 300,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.91,
        "price_col_1": 0.14,
        "price_cm_1": 0,
        "section_2": 501,
        "price_2": 0.84,
        "price_col_2": 0.126,
        "price_cm_2": 0,
        "section_3": 2001,
        "price_3": 0.77,
        "price_col_3": 0.112,
        "price_cm_3": 0,
        "section_4": 5001,
        "price_4": 0.7,
        "price_col_4": 0.084,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "N3",
        "code": "N3",
        "technique_name": "N3 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 600,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.26,
        "price_col_1": 0.28,
        "price_cm_1": 0,
        "section_2": 501,
        "price_2": 1.12,
        "price_col_2": 0.238,
        "price_cm_2": 0,
        "section_3": 2001,
        "price_3": 1.05,
        "price_col_3": 0.196,
        "price_cm_3": 0,
        "section_4": 5001,
        "price_4": 0.91,
        "price_col_4": 0.168,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "N4",
        "code": "N4",
        "technique_name": "N4 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": -1,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.68,
        "price_col_1": 0.42,
        "price_cm_1": 0,
        "section_2": 501,
        "price_2": 1.54,
        "price_col_2": 0.392,
        "price_cm_2": 0,
        "section_3": 2001,
        "price_3": 1.4,
        "price_col_3": 0.364,
        "price_cm_3": 0,
        "section_4": 5001,
        "price_4": 1.26,
        "price_col_4": 0.336,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "O1",
        "code": "O1",
        "technique_name": "O1 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": true,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0.25,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0.00532,
        "section_2": 500,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0.00434,
        "section_3": 2000,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0.00378,
        "section_4": 5000,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0.00322,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "O2",
        "code": "O2",
        "technique_name": "O2 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": true,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0.4,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0.00532,
        "section_2": 500,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0.00434,
        "section_3": 2000,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0.00378,
        "section_4": 5000,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0.00322,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "O3",
        "code": "O3",
        "technique_name": "O3 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": true,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0.45,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0.00532,
        "section_2": 500,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0.00434,
        "section_3": 2000,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0.00378,
        "section_4": 5000,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0.00322,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "O4",
        "code": "O4",
        "technique_name": "O4 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.63,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.56,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.49,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.448,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "O5",
        "code": "O5",
        "technique_name": "O5 (Roly)",
        "cliche": 21,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 2.45,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 101,
        "price_2": 2.1,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 201,
        "price_3": 1.75,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 301,
        "price_4": 1.4,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "O6",
        "code": "O6",
        "technique_name": "O6 (Roly)",
        "cliche": 21,
        "cliche_repetition": 21,
        "min": 15.4,
        "min_unit": null,
        "roly_rangemode": "measures",
        "roly_colorprice": false,
        "roly_areaprice": true,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 15.4,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 5,
        "price_2": 12.6,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 10,
        "price_3": 11.9,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 25,
        "price_4": 11.2,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 50,
        "price_5": 9.8,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "R1",
        "code": "R1",
        "technique_name": "R1 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 42,
        "min_unit": 0.56,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": true,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 300,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 2.1,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 51,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0.0035,
        "section_3": 100,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0.00322,
        "section_4": 300,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0.00294,
        "section_5": 500,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0.00266,
        "section_6": 1000,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0.00238,
        "section_7": 3000,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0.00224,
        "section_8": 5000,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0.0021,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "R2",
        "code": "R2",
        "technique_name": "R2 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 42,
        "min_unit": 0.56,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": true,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 3.64,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 51,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0.00294,
        "section_3": 100,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0.00266,
        "section_4": 300,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0.00238,
        "section_5": 500,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0.00224,
        "section_6": 1000,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0.00196,
        "section_7": 3000,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0.00168,
        "section_8": 5000,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0.00154,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "R3",
        "code": "R3",
        "technique_name": "R3 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 42,
        "min_unit": 0.56,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 4.2,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 51,
        "price_2": 3.5,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 100,
        "price_3": 3.15,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 300,
        "price_4": 2.94,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 500,
        "price_5": 2.8,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 1000,
        "price_6": 2.66,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 3000,
        "price_7": 2.45,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 5000,
        "price_8": 2.24,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "R4",
        "code": "R4",
        "technique_name": "R4 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 42,
        "min_unit": 0.56,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": true,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 100,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 2.1,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 51,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0.021,
        "section_3": 100,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0.0182,
        "section_4": 300,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0.0168,
        "section_5": 500,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0.0154,
        "section_6": 1000,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0.014,
        "section_7": 3000,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0.0126,
        "section_8": 5000,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0.0112,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "R5",
        "code": "R5",
        "technique_name": "R5 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 42,
        "min_unit": 0.56,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": true,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0.000798,
        "section_2": 51,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0.000588,
        "section_3": 100,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0.000574,
        "section_4": 300,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0.00056,
        "section_5": 500,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0.000532,
        "section_6": 1000,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0.000504,
        "section_7": 3000,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0.000504,
        "section_8": 5000,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0.000504,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SLY1",
        "code": "SLY1",
        "technique_name": "SLY1 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": true,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.343,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.35,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.357,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.371,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SLY2",
        "code": "SLY2",
        "technique_name": "SLY2 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": true,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.329,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.336,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.343,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.357,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SLY3",
        "code": "SLY3",
        "technique_name": "SLY3 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": true,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.224,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.238,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.245,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.252,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SLY4",
        "code": "SLY4",
        "technique_name": "SLY4 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": true,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.602,
        "price_col_1": 0.28,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.616,
        "price_col_2": 0.28,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.637,
        "price_col_3": 0.28,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.651,
        "price_col_4": 0.28,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SLY5",
        "code": "SLY5",
        "technique_name": "SLY5 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": true,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.679,
        "price_col_1": 0.28,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.693,
        "price_col_2": 0.28,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.714,
        "price_col_3": 0.28,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.728,
        "price_col_4": 0.28,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SLY6",
        "code": "SLY6",
        "technique_name": "SLY6 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": true,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.378,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.392,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.42,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.434,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SLY7",
        "code": "SLY7",
        "technique_name": "SLY7 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": true,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.707,
        "price_col_1": 0.28,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.721,
        "price_col_2": 0.28,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.742,
        "price_col_3": 0.28,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.756,
        "price_col_4": 0.28,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "WR10",
        "code": "WR10",
        "technique_name": "WR10 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 350,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.596,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.498,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.33,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 1.288,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 1.232,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 1.148,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 1.092,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "WR11",
        "code": "WR11",
        "technique_name": "WR11 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 49,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 400,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 1.68,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.568,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.414,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 1.358,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 1.302,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 1.218,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 1.12,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "Y1",
        "code": "Y1",
        "technique_name": "Y1 (Roly)",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 100,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 9.45,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 2,
        "price_2": 5.67,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 10,
        "price_3": 4.914,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 20,
        "price_4": 4.256,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 50,
        "price_5": 3.584,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 3.024,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 200,
        "price_7": 2.744,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 1.792,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 1.708,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "Y2",
        "code": "Y2",
        "technique_name": "Y2 (Roly)",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 625,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 13.23,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 2,
        "price_2": 7.56,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 10,
        "price_3": 5.67,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 20,
        "price_4": 4.732,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 50,
        "price_5": 4.074,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 3.304,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 200,
        "price_7": 3.024,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 2.842,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 2.744,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "Y3",
        "code": "Y3",
        "technique_name": "Y3 (Roly)",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 1200,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 15.12,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 2,
        "price_2": 9.45,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 10,
        "price_3": 6.034,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 20,
        "price_4": 4.914,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 50,
        "price_5": 4.732,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 4.536,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 200,
        "price_7": 4.354,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 4.158,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 3.976,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "Y4",
        "code": "Y4",
        "technique_name": "Y4 (Roly)",
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 2000,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 18.9,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 2,
        "price_2": 11.34,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 10,
        "price_3": 8.974,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 20,
        "price_4": 8.316,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 50,
        "price_5": 7.364,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 100,
        "price_6": 6.146,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 200,
        "price_7": 6.034,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 500,
        "price_8": 5.95,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 1000,
        "price_9": 5.866,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SES1",
        "code": "SES1",
        "technique_name": "SES1 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 250,
        "price_1": 0.392,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.378,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.364,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.35,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SES2",
        "code": "SES2",
        "technique_name": "SES2 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 250,
        "price_1": 0.56,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.532,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.518,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.49,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SES3",
        "code": "SES3",
        "technique_name": "SES3 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 250,
        "price_1": 0.616,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.588,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.574,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.56,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SS1",
        "code": "SS1",
        "technique_name": "SS1 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 250,
        "price_1": 0.77,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.714,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.672,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.644,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "R12",
        "code": "R12",
        "technique_name": "R12 (Roly)",
        "cliche": 42,
        "cliche_repetition": 0,
        "min": 42,
        "min_unit": 0.56,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": true,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 300,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 2.1,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 51,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0.007,
        "section_3": 100,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0.00644,
        "section_4": 300,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0.00588,
        "section_5": 500,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0.00532,
        "section_6": 1000,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0.00476,
        "section_7": 3000,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0.00448,
        "section_8": 5000,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0.0042,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "O21",
        "code": "O21",
        "technique_name": "O21 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 42,
        "min_unit": 0.7,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": true,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0.8,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0.01064,
        "section_2": 500,
        "price_2": 0,
        "price_col_2": 0,
        "price_cm_2": 0.00868,
        "section_3": 2000,
        "price_3": 0,
        "price_col_3": 0,
        "price_cm_3": 0.00756,
        "section_4": 5000,
        "price_4": 0,
        "price_col_4": 0,
        "price_cm_4": 0.00644,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SS1-100",
        "code": "SS1-100",
        "technique_name": "SS1-100 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 100,
        "price_1": 0.77,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.714,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.672,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.644,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SS1-200",
        "code": "SS1-200",
        "technique_name": "SS1-200 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 200,
        "price_1": 0.77,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.714,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.672,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.644,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SES1-100",
        "code": "SES1-100",
        "technique_name": "SES1-100 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 100,
        "price_1": 0.392,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.378,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.364,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.35,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "SES1-200",
        "code": "SES1-200",
        "technique_name": "SES1-200 (Roly)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 0,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 200,
        "price_1": 0.392,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.378,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.364,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.35,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "N6",
        "code": "N",
        "technique_name": "N (Roly) (Alias N)",
        "cliche": 42,
        "cliche_repetition": 21,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": true,
        "roly_areaprice": false,
        "roly_requirebase": true,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.91,
        "price_col_1": 0.308,
        "price_cm_1": 0,
        "section_2": 500,
        "price_2": 0.728,
        "price_col_2": 0.252,
        "price_cm_2": 0,
        "section_3": 2000,
        "price_3": 0.56,
        "price_col_3": 0.21,
        "price_cm_3": 0,
        "section_4": 5000,
        "price_4": 0.49,
        "price_col_4": 0.168,
        "price_cm_4": 0,
        "section_5": 0,
        "price_5": 0,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 0,
        "price_6": 0,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "p",
        "code": "P",
        "technique_name": "P (Roly) (Alias P)",
        "cliche": 14,
        "cliche_repetition": 0,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": true,
        "roly_stitches": 1000,
        "roly_maxarea": 0,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 1,
        "price_1": 0.336,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 50,
        "price_2": 0.308,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 200,
        "price_3": 0.266,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 500,
        "price_4": 0.238,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 1000,
        "price_5": 0.21,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 2000,
        "price_6": 0.196,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 0,
        "price_7": 0,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    },
    {
        "technique_ref": "8",
        "code": "8",
        "technique_name": "8 (Sin tarifa)",
        "section_1": 1,
        "price_1": 0,
        "price_col_1": 0,
        "price_cm_1": 0,
        "cliche": 0,
        "cliche_repetition": 0,
        "min": 0,
        "min_unit": null
    },
    {
        "technique_ref": "V",
        "code": "V1",
        "technique_name": "V1 (Roly) (Alias V1)",
        "cliche": 42,
        "cliche_repetition": 35,
        "min": 56,
        "min_unit": null,
        "roly_rangemode": "quantity",
        "roly_colorprice": false,
        "roly_areaprice": false,
        "roly_requirebase": false,
        "roly_piercingprice": false,
        "roly_stitches": 0,
        "roly_maxarea": 5,
        "roly_sideprice": false,
        "roly_segmentprice": false,
        "roly_ironedprice": 0,
        "roly_handlingprice": 0,
        "section_1": 100,
        "price_1": 1.26,
        "price_col_1": 0,
        "price_cm_1": 0,
        "section_2": 250,
        "price_2": 1.092,
        "price_col_2": 0,
        "price_cm_2": 0,
        "section_3": 500,
        "price_3": 1.036,
        "price_col_3": 0,
        "price_cm_3": 0,
        "section_4": 1000,
        "price_4": 0.938,
        "price_col_4": 0,
        "price_cm_4": 0,
        "section_5": 2500,
        "price_5": 0.868,
        "price_col_5": 0,
        "price_cm_5": 0,
        "section_6": 5000,
        "price_6": 0.784,
        "price_col_6": 0,
        "price_cm_6": 0,
        "section_7": 10000,
        "price_7": 0.728,
        "price_col_7": 0,
        "price_cm_7": 0,
        "section_8": 0,
        "price_8": 0,
        "price_col_8": 0,
        "price_cm_8": 0,
        "section_9": 0,
        "price_9": 0,
        "price_col_9": 0,
        "price_cm_9": 0,
        "section_10": 0,
        "price_10": 0,
        "price_col_10": 0,
        "price_cm_10": 0
    }
];